import { ClosePopup as e, Dialog as t, Loading as n, Notify as r, QBar as i, QBtn as a, QBtnToggle as o, QCard as s, QCardActions as c, QCardSection as l, QCheckbox as u, QChip as d, QDate as f, QDialog as p, QField as m, QIcon as h, QImg as g, QInput as ee, QItem as _, QItemLabel as v, QItemSection as y, QList as b, QMenu as te, QPagination as ne, QPopupProxy as x, QSelect as re, QSeparator as ie, QSpinner as ae, QSpinnerDots as oe, QTab as se, QTabPanel as ce, QTabPanels as le, QTable as S, QTabs as ue, QTd as de, QTh as fe, QTime as pe, QToggle as me, QToolbarTitle as he, QTooltip as ge, Quasar as _e, copyToClipboard as ve, debounce as ye, format as be, useDialogPluginComponent as xe, useQuasar as Se } from "quasar";
import { Fragment as Ce, computed as C, createBlock as w, createCommentVNode as T, createElementBlock as E, createElementVNode as D, createSlots as we, createTextVNode as O, createVNode as k, defineAsyncComponent as Te, defineComponent as A, guardReactiveProps as Ee, h as De, inject as Oe, markRaw as ke, mergeModels as Ae, mergeProps as je, nextTick as Me, normalizeClass as Ne, normalizeProps as Pe, onBeforeMount as Fe, onBeforeUnmount as Ie, onMounted as Le, onUnmounted as Re, openBlock as j, provide as ze, reactive as Be, ref as M, renderList as Ve, renderSlot as He, resolveDynamicComponent as Ue, shallowRef as We, toDisplayString as N, unref as P, useAttrs as Ge, useModel as Ke, vShow as qe, watch as Je, withCtx as F, withDirectives as Ye, withKeys as Xe, withModifiers as Ze } from "vue";
import { defaultLocale as Qe, languages as $e } from "@editor/lib-i18n";
import et from "quasar/lang/de";
import tt from "quasar/lang/en-GB";
import nt from "quasar/lang/it";
import { createI18n as rt, useI18n as it } from "vue-i18n";
import { containsTransformableQuote as at, transformToGermanQuotes as ot } from "@utils/string-utils";
import { NavigationFailureType as st, isNavigationFailure as ct, onBeforeRouteLeave as lt, useRouter as ut } from "vue-router";
import { useMutation as dt, useQuery as ft, useQueryClient as pt } from "@tanstack/vue-query";
//#region \0rolldown/runtime.js
var mt = Object.create, ht = Object.defineProperty, gt = Object.getOwnPropertyDescriptor, _t = Object.getOwnPropertyNames, vt = Object.getPrototypeOf, yt = Object.prototype.hasOwnProperty, bt = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), xt = (e, t) => {
	let n = {};
	for (var r in e) ht(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || ht(n, Symbol.toStringTag, { value: "Module" }), n;
}, St = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = _t(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !yt.call(e, s) && s !== n && ht(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = gt(t, s)) || r.enumerable
	});
	return e;
}, Ct = (e, t, n) => (n = e == null ? {} : mt(vt(e)), St(t || !e || !e.__esModule ? ht(n, "default", {
	value: e,
	enumerable: !0
}) : n, e));
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/bind.js
function wt(e, t) {
	return function() {
		return e.apply(t, arguments);
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/utils.js
var { toString: Tt } = Object.prototype, { getPrototypeOf: Et } = Object, { iterator: Dt, toStringTag: Ot } = Symbol, kt = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), At = (e) => typeof e == "string" && (e === "__proto__" || e === "constructor" || e === "prototype"), jt = (e, t, n) => e === Object.prototype || !n && t === null, Mt = (e) => {
	if (!Object.isExtensible(e)) return !1;
	let t = Object.getOwnPropertyNames(e);
	return Object.getOwnPropertySymbols && t.push(...Object.getOwnPropertySymbols(e)), t.every((t) => {
		if (At(t)) return !1;
		let n = Object.getOwnPropertyDescriptor(e, t);
		return !!n && n.configurable && n.writable === !0;
	});
}, Nt = (e, t) => {
	let n = e, r = [];
	for (; n != null;) {
		if (r.indexOf(n) !== -1) return !1;
		r.push(n);
		let i = Et(n);
		if (jt(n, i, n === e)) return !1;
		if (kt(n, t)) return !0;
		n = i;
	}
	return !1;
}, Pt = (e, t) => e != null && Nt(e, t) ? e[t] : void 0, Ft = (e) => {
	if (e == null || typeof e != "object" && typeof e != "function") return e;
	let t = Et(e);
	if (t === null && Mt(e)) return e;
	let n = Object.create(null), r = Object.create(null), i = [], a = e;
	for (; a != null && i.indexOf(a) === -1;) {
		i.push(a);
		let o = a === e ? t : Et(a);
		if (jt(a, o, a === e)) break;
		let s = Object.getOwnPropertyNames(a);
		Object.getOwnPropertySymbols && s.push(...Object.getOwnPropertySymbols(a));
		for (let t of s) At(t) || kt(r, t) || (n[t] = e[t], r[t] = !0);
		a = o;
	}
	return n;
}, It = ((e) => (t) => {
	let n = Tt.call(t);
	return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(Object.create(null)), Lt = (e) => (e = e.toLowerCase(), (t) => It(t) === e), Rt = (e) => (t) => typeof t === e, { isArray: zt } = Array, Bt = Rt("undefined");
function Vt(e) {
	return e !== null && !Bt(e) && e.constructor !== null && !Bt(e.constructor) && Gt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
var Ht = Lt("ArrayBuffer");
function Ut(e) {
	let t;
	return t = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && Ht(e.buffer), t;
}
var Wt = Rt("string"), Gt = Rt("function"), Kt = Rt("number"), qt = (e) => typeof e == "object" && !!e, Jt = (e) => e === !0 || e === !1, Yt = (e) => {
	if (!qt(e)) return !1;
	let t = Et(e);
	return (t === null || t === Object.prototype || Et(t) === null) && !Nt(e, Ot) && !Nt(e, Dt);
}, Xt = (e) => {
	if (!qt(e) || Vt(e)) return !1;
	try {
		return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
	} catch {
		return !1;
	}
}, Zt = Lt("Date"), Qt = Lt("File"), $t = (e) => !!(e && e.uri !== void 0), en = (e) => e && e.getParts !== void 0, tn = Lt("Blob"), nn = Lt("FileList"), rn = Lt("Set"), an = (e) => qt(e) && Gt(e.pipe);
function on() {
	return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
var sn = on(), cn = sn.FormData === void 0 ? void 0 : sn.FormData, ln = (e) => {
	if (!e) return !1;
	if (cn && e instanceof cn) return !0;
	let t = Et(e);
	if (!t || t === Object.prototype || !Gt(e.append)) return !1;
	let n = It(e);
	return n === "formdata" || n === "object" && Gt(e.toString) && e.toString() === "[object FormData]";
}, un = Lt("URLSearchParams"), [dn, fn, pn, mn] = [
	"ReadableStream",
	"Request",
	"Response",
	"Headers"
].map(Lt), hn = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function gn(e, t, { allOwnKeys: n = !1 } = {}) {
	if (e == null) return;
	let r, i;
	if (typeof e != "object" && (e = [e]), zt(e)) for (r = 0, i = e.length; r < i; r++) t.call(null, e[r], r, e);
	else {
		if (Vt(e)) return;
		let i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length, o;
		for (r = 0; r < a; r++) o = i[r], t.call(null, e[o], o, e);
	}
}
function _n(e, t) {
	if (Vt(e)) return null;
	t = t.toLowerCase();
	let n = Object.keys(e), r = n.length, i;
	for (; r-- > 0;) if (i = n[r], t === i.toLowerCase()) return i;
	return null;
}
var vn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, yn = (e) => !Bt(e) && e !== vn;
function bn(...e) {
	let { caseless: t, skipUndefined: n } = yn(this) && this || {}, r = {}, i = (e, i) => {
		if (i === "__proto__" || i === "constructor" || i === "prototype") return;
		let a = t && typeof i == "string" && _n(r, i) || i, o = kt(r, a) ? r[a] : void 0;
		Yt(o) && Yt(e) ? r[a] = bn(o, e) : Yt(e) ? r[a] = bn({}, e) : zt(e) ? r[a] = e.slice() : (!n || !Bt(e)) && (r[a] = e);
	};
	for (let t = 0, n = e.length; t < n; t++) {
		let n = e[t];
		if (!n || Vt(n) || (gn(n, i), typeof n != "object" || zt(n))) continue;
		let r = Object.getOwnPropertySymbols(n);
		for (let e = 0; e < r.length; e++) {
			let t = r[e];
			Mn.call(n, t) && i(n[t], t);
		}
	}
	return r;
}
var xn = (e, t, n, { allOwnKeys: r } = {}) => (gn(t, (t, r) => {
	n && Gt(t) ? Object.defineProperty(e, r, {
		__proto__: null,
		value: wt(t, n),
		writable: !0,
		enumerable: !0,
		configurable: !0
	}) : Object.defineProperty(e, r, {
		__proto__: null,
		value: t,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}, { allOwnKeys: r }), e), Sn = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Cn = (e, t, n, r) => {
	e.prototype = Object.create(t.prototype, r), Object.defineProperty(e.prototype, "constructor", {
		__proto__: null,
		value: e,
		writable: !0,
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e, "super", {
		__proto__: null,
		value: t.prototype
	}), n && Object.assign(e.prototype, n);
}, wn = (e, t, n, r) => {
	let i, a, o, s = {};
	if (t ||= {}, e == null) return t;
	do {
		for (i = Object.getOwnPropertyNames(e), a = i.length; a-- > 0;) o = i[a], (!r || r(o, e, t)) && !s[o] && (t[o] = e[o], s[o] = !0);
		e = n !== !1 && Et(e);
	} while (e && (!n || n(e, t)) && e !== Object.prototype);
	return t;
}, Tn = (e, t, n) => {
	e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
	let r = e.indexOf(t, n);
	return r !== -1 && r === n;
}, En = (e) => {
	if (!e) return null;
	if (zt(e)) return e;
	let t = e.length;
	if (!Kt(t)) return null;
	let n = Array(t);
	for (; t-- > 0;) n[t] = e[t];
	return n;
}, Dn = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Et(Uint8Array)), On = (e, t) => {
	let n = (e && e[Dt]).call(e), r;
	for (; (r = n.next()) && !r.done;) {
		let n = r.value;
		t.call(e, n[0], n[1]);
	}
}, kn = (e, t) => {
	let n, r = [];
	for (; (n = e.exec(t)) !== null;) r.push(n);
	return r;
}, An = Lt("HTMLFormElement"), jn = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, t, n) {
	return t.toUpperCase() + n;
}), { propertyIsEnumerable: Mn } = Object.prototype, Nn = Lt("RegExp"), Pn = (e, t) => {
	let n = Object.getOwnPropertyDescriptors(e), r = {};
	gn(n, (n, i) => {
		let a;
		(a = t(n, i, e)) !== !1 && (r[i] = a || n);
	}), Object.defineProperties(e, r);
}, Fn = (e) => {
	Pn(e, (t, n) => {
		if (Gt(e) && [
			"arguments",
			"caller",
			"callee"
		].includes(n)) return !1;
		let r = e[n];
		if (Gt(r)) {
			if (t.enumerable = !1, "writable" in t) {
				t.writable = !1;
				return;
			}
			t.set ||= () => {
				throw Error("Can not rewrite read-only method '" + n + "'");
			};
		}
	});
}, In = (e, t) => {
	let n = {}, r = (e) => {
		e.forEach((e) => {
			n[e] = !0;
		});
	};
	return zt(e) ? r(e) : r(String(e).split(t)), n;
}, Ln = () => {}, Rn = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function zn(e) {
	return !!(e && Gt(e.append) && e[Ot] === "FormData" && e[Dt]);
}
var Bn = (e) => {
	let t = /* @__PURE__ */ new WeakSet(), n = (e) => {
		if (qt(e)) {
			if (t.has(e)) return;
			if (Vt(e)) return e;
			if (!("toJSON" in e)) {
				t.add(e);
				let r;
				if (rn(e)) {
					r = [];
					for (let t of e) {
						let e = n(t);
						!Bt(e) && r.push(e);
					}
				} else r = zt(e) ? [] : {}, gn(e, (e, t) => {
					let i = n(e);
					!Bt(i) && (r[t] = i);
				});
				return t.delete(e), r;
			}
		}
		return e;
	};
	return n(e);
}, Vn = Lt("AsyncFunction"), Hn = (e) => e && (qt(e) || Gt(e)) && Gt(e.then) && Gt(e.catch), Un = ((e, t) => e ? setImmediate : t ? ((e, t) => (vn.addEventListener("message", ({ source: n, data: r }) => {
	n === vn && r === e && t.length && t.shift()();
}, !1), (n) => {
	t.push(n), vn.postMessage(e, "*");
}))(`axios@${Math.random()}`, []) : (e) => setTimeout(e))(typeof setImmediate == "function", Gt(vn.postMessage)), Wn = typeof queueMicrotask < "u" ? queueMicrotask.bind(vn) : typeof process < "u" && process.nextTick || Un, Gn = (e) => e != null && Gt(e[Dt]), I = {
	isArray: zt,
	isArrayBuffer: Ht,
	isBuffer: Vt,
	isFormData: ln,
	isArrayBufferView: Ut,
	isString: Wt,
	isNumber: Kt,
	isBoolean: Jt,
	isObject: qt,
	isPlainObject: Yt,
	isEmptyObject: Xt,
	isReadableStream: dn,
	isRequest: fn,
	isResponse: pn,
	isHeaders: mn,
	isUndefined: Bt,
	isDate: Zt,
	isFile: Qt,
	isReactNativeBlob: $t,
	isReactNative: en,
	isBlob: tn,
	isRegExp: Nn,
	isFunction: Gt,
	isStream: an,
	isURLSearchParams: un,
	isTypedArray: Dn,
	isFileList: nn,
	forEach: gn,
	merge: bn,
	extend: xn,
	trim: hn,
	stripBOM: Sn,
	inherits: Cn,
	toFlatObject: wn,
	kindOf: It,
	kindOfTest: Lt,
	endsWith: Tn,
	toArray: En,
	forEachEntry: On,
	matchAll: kn,
	isHTMLForm: An,
	hasOwnProperty: kt,
	hasOwnProp: kt,
	hasOwnInPrototypeChain: Nt,
	getSafeProp: Pt,
	toSafeFlatObject: Ft,
	reduceDescriptors: Pn,
	freezeMethods: Fn,
	toObjectSet: In,
	toCamelCase: jn,
	noop: Ln,
	toFiniteNumber: Rn,
	findKey: _n,
	global: vn,
	isContextDefined: yn,
	isSpecCompliantForm: zn,
	toJSONObject: Bn,
	isAsyncFn: Vn,
	isThenable: Hn,
	setImmediate: Un,
	asap: Wn,
	isIterable: Gn,
	isSafeIterable: (e) => e != null && Nt(e, Dt) && Gn(e)
}, Kn = I.toObjectSet([
	"age",
	"authorization",
	"content-length",
	"content-type",
	"etag",
	"expires",
	"from",
	"host",
	"if-modified-since",
	"if-unmodified-since",
	"last-modified",
	"location",
	"max-forwards",
	"proxy-authorization",
	"referer",
	"retry-after",
	"user-agent"
]), qn = (e) => {
	let t = {}, n, r, i;
	return e && e.split("\n").forEach(function(e) {
		i = e.indexOf(":"), n = e.substring(0, i).trim().toLowerCase(), r = e.substring(i + 1).trim();
		let a = I.hasOwnProp(t, n);
		!n || a && I.hasOwnProp(Kn, n) || (n === "set-cookie" ? a ? t[n].push(r) : t[n] = [r] : t[n] = a ? t[n] + ", " + r : r);
	}), t;
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/sanitizeHeaderValue.js
function Jn(e) {
	let t = 0, n = e.length;
	for (; t < n;) {
		let n = e.charCodeAt(t);
		if (n !== 9 && n !== 32) break;
		t += 1;
	}
	for (; n > t;) {
		let t = e.charCodeAt(n - 1);
		if (t !== 9 && t !== 32) break;
		--n;
	}
	return t === 0 && n === e.length ? e : e.slice(t, n);
}
var Yn = /* @__PURE__ */ RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), Xn = /* @__PURE__ */ RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function Zn(e, t) {
	return I.isArray(e) ? e.map((e) => Zn(e, t)) : Jn(String(e).replace(t, ""));
}
var Qn = (e) => Zn(e, Yn), $n = (e) => Zn(e, Xn);
function er(e) {
	let t = Object.create(null);
	return I.forEach(e.toJSON(), (e, n) => {
		t[n] = $n(e);
	}), t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/AxiosHeaders.js
var tr = Symbol("internals");
function nr(e) {
	return e && String(e).trim().toLowerCase();
}
function rr(e) {
	return e === !1 || e == null ? e : I.isArray(e) ? e.map(rr) : Qn(String(e));
}
function ir(e) {
	let t = Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g, r;
	for (; r = n.exec(e);) t[r[1]] = r[2];
	return t;
}
var ar = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function or(e) {
	let t = 0, n = e.length;
	for (; t < n;) {
		let n = e.charCodeAt(t);
		if (n !== 9 && n !== 32) break;
		t += 1;
	}
	for (; n > t;) {
		let t = e.charCodeAt(n - 1);
		if (t !== 9 && t !== 32) break;
		--n;
	}
	return t === 0 && n === e.length ? e : e.slice(t, n);
}
function sr(e) {
	let t = e.length - 1;
	if (t < 1 || e.charCodeAt(0) !== 34 || e.charCodeAt(t) !== 34) return e;
	let n = "";
	for (let r = 1; r < t; r++) {
		let i = e.charCodeAt(r);
		if (i === 34 || i === 92 && (r += 1, r >= t)) return e;
		n += e[r];
	}
	return n;
}
function cr(e) {
	let t = Object.create(null), n = String(e), r = 0, i = !1, a = !1;
	function o(e) {
		let i = or(n.slice(r, e)), a = i.indexOf("=");
		if (a < 1) return;
		let o = or(i.slice(0, a));
		if (!ar.test(o)) return;
		let s = o.toLowerCase();
		s === "__proto__" || s === "constructor" || s === "prototype" || (t[s] = sr(or(i.slice(a + 1))));
	}
	for (let e = 0; e < n.length; e++) {
		let t = n.charCodeAt(e);
		i ? a ? a = !1 : t === 92 ? a = !0 : t === 34 && (i = !1) : t === 34 ? i = !0 : (t === 44 || t === 59) && (o(e), r = e + 1);
	}
	return o(n.length), t;
}
var lr = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ur(e, t, n, r, i) {
	if (I.isFunction(r)) return r.call(this, t, n);
	if (i && (t = n), I.isString(t)) {
		if (I.isString(r)) return t.indexOf(r) !== -1;
		if (I.isRegExp(r)) return r.test(t);
	}
}
function dr(e) {
	return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, n) => t.toUpperCase() + n);
}
function fr(e, t) {
	let n = I.toCamelCase(" " + t);
	[
		"get",
		"set",
		"has"
	].forEach((r) => {
		Object.defineProperty(e, r + n, {
			__proto__: null,
			value: function(e, n, i) {
				return this[r].call(this, t, e, n, i);
			},
			configurable: !0
		});
	});
}
var pr = class {
	constructor(e) {
		e && this.set(e);
	}
	set(e, t, n) {
		let r = this;
		function i(e, t, n) {
			let i = nr(t);
			if (!i) return;
			let a = I.findKey(r, i);
			(!a || r[a] === void 0 || n === !0 || n === void 0 && r[a] !== !1) && (r[a || t] = rr(e));
		}
		let a = (e, t) => I.forEach(e, (e, n) => i(e, n, t));
		if (I.isPlainObject(e) || e instanceof this.constructor) a(e, t);
		else if (I.isString(e) && (e = e.trim()) && !lr(e)) a(qn(e), t);
		else if (I.isObject(e) && I.isSafeIterable(e)) {
			let n = Object.create(null), r, i;
			for (let t of e) {
				if (!I.isArray(t)) throw TypeError("Object iterator must return a key-value pair");
				i = t[0], I.hasOwnProp(n, i) ? (r = n[i], n[i] = I.isArray(r) ? [...r, t[1]] : [r, t[1]]) : n[i] = t[1];
			}
			a(n, t);
		} else e != null && i(t, e, n);
		return this;
	}
	get(e, t) {
		if (e = nr(e), e) {
			let n = I.findKey(this, e);
			if (n) {
				let e = this[n];
				if (!t) return e;
				if (t === !0) return ir(e);
				if (I.isFunction(t)) return t.call(this, e, n);
				if (I.isRegExp(t)) return t.exec(e);
				throw TypeError("parser must be boolean|regexp|function");
			}
		}
	}
	has(e, t) {
		if (e = nr(e), e) {
			let n = I.findKey(this, e);
			return !!(n && this[n] !== void 0 && (!t || ur(this, this[n], n, t)));
		}
		return !1;
	}
	delete(e, t) {
		let n = this, r = !1;
		function i(e) {
			if (e = nr(e), e) {
				let i = I.findKey(n, e);
				i && (!t || ur(n, n[i], i, t)) && (delete n[i], r = !0);
			}
		}
		return I.isArray(e) ? e.forEach(i) : i(e), r;
	}
	clear(e) {
		let t = Object.keys(this), n = t.length, r = !1;
		for (; n--;) {
			let i = t[n];
			(!e || ur(this, this[i], i, e, !0)) && (delete this[i], r = !0);
		}
		return r;
	}
	normalize(e) {
		let t = this, n = {};
		return I.forEach(this, (r, i) => {
			let a = I.findKey(n, i);
			if (a) {
				t[a] = rr(r), delete t[i];
				return;
			}
			let o = e ? dr(i) : String(i).trim();
			o !== i && delete t[i], t[o] = rr(r), n[o] = !0;
		}), this;
	}
	concat(...e) {
		return this.constructor.concat(this, ...e);
	}
	toJSON(e) {
		let t = Object.create(null);
		return I.forEach(this, (n, r) => {
			n != null && n !== !1 && (t[r] = e && I.isArray(n) ? n.join(", ") : n);
		}), t;
	}
	[Symbol.iterator]() {
		return Object.entries(this.toJSON())[Symbol.iterator]();
	}
	toString() {
		return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join("\n");
	}
	getSetCookie() {
		let e = this.get("set-cookie");
		return I.isArray(e) ? e : e == null || e === !1 ? [] : [e];
	}
	get [Symbol.toStringTag]() {
		return "AxiosHeaders";
	}
	static from(e) {
		return e instanceof this ? e : new this(e);
	}
	static parseParameters(e) {
		return cr(e);
	}
	static concat(e, ...t) {
		let n = new this(e);
		return t.forEach((e) => n.set(e)), n;
	}
	static accessor(e) {
		let t = (this[tr] = this[tr] = { accessors: {} }).accessors, n = this.prototype;
		function r(e) {
			let r = nr(e);
			t[r] || (fr(n, e), t[r] = !0);
		}
		return I.isArray(e) ? e.forEach(r) : r(e), this;
	}
};
pr.accessor([
	"Content-Type",
	"Content-Length",
	"Accept",
	"Accept-Encoding",
	"User-Agent",
	"Authorization"
]), I.reduceDescriptors(pr.prototype, ({ value: e }, t) => {
	let n = t[0].toUpperCase() + t.slice(1);
	return {
		get: () => e,
		set(e) {
			this[n] = e;
		}
	};
}), I.freezeMethods(pr);
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/AxiosError.js
var mr = "[REDACTED ****]";
function hr(e) {
	if (I.hasOwnProp(e, "toJSON")) return !0;
	let t = Object.getPrototypeOf(e);
	for (; t && t !== Object.prototype;) {
		if (I.hasOwnProp(t, "toJSON")) return !0;
		t = Object.getPrototypeOf(t);
	}
	return !1;
}
function gr(e, t) {
	let n = new Set(t.map((e) => String(e).toLowerCase())), r = [], i = (e) => {
		if (typeof e != "object" || !e || I.isBuffer(e)) return e;
		if (r.indexOf(e) !== -1) return;
		e instanceof pr && (e = e.toJSON()), r.push(e);
		let t;
		if (I.isArray(e)) t = [], e.forEach((e, n) => {
			let r = i(e);
			I.isUndefined(r) || (t[n] = r);
		});
		else {
			if (!I.isPlainObject(e) && hr(e)) return r.pop(), e;
			t = Object.create(null);
			for (let [r, a] of Object.entries(e)) {
				let e = n.has(r.toLowerCase()) ? mr : i(a);
				I.isUndefined(e) || (t[r] = e);
			}
		}
		return r.pop(), t;
	};
	return i(e);
}
function _r(e) {
	try {
		return String(e);
	} catch {
		return "";
	}
}
function vr(e) {
	return e.errors.map((e) => {
		try {
			return e && e.message ? _r(e.message) : _r(e);
		} catch {
			return "";
		}
	}).filter(Boolean).join("; ") || e.name || "AggregateError";
}
var L = class e extends Error {
	static from(t, n, r, i, a, o) {
		let s = t.message;
		!s && I.isArray(t.errors) && t.errors.length && (s = vr(t));
		let c = new e(s, n || t.code, r, i, a);
		return Object.defineProperty(c, "cause", {
			__proto__: null,
			value: t,
			writable: !0,
			enumerable: !1,
			configurable: !0
		}), c.name = t.name, t.status != null && c.status == null && (c.status = t.status), o && Object.assign(c, o), c;
	}
	constructor(e, t, n, r, i) {
		super(e), Object.defineProperty(this, "message", {
			__proto__: null,
			value: e,
			enumerable: !0,
			writable: !0,
			configurable: !0
		}), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i, this.status = i.status);
	}
	toJSON() {
		let e = this.config, t = e && I.hasOwnProp(e, "redact") ? e.redact : void 0, n = I.isArray(t) && t.length > 0 ? gr(e, t) : I.toJSONObject(e);
		return {
			message: this.message,
			name: this.name,
			description: this.description,
			number: this.number,
			fileName: this.fileName,
			lineNumber: this.lineNumber,
			columnNumber: this.columnNumber,
			stack: this.stack,
			config: n,
			code: this.code,
			status: this.status
		};
	}
};
L.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE", L.ERR_BAD_OPTION = "ERR_BAD_OPTION", L.ECONNABORTED = "ECONNABORTED", L.ETIMEDOUT = "ETIMEDOUT", L.ECONNREFUSED = "ECONNREFUSED", L.ERR_NETWORK = "ERR_NETWORK", L.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS", L.ERR_DEPRECATED = "ERR_DEPRECATED", L.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE", L.ERR_BAD_REQUEST = "ERR_BAD_REQUEST", L.ERR_CANCELED = "ERR_CANCELED", L.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT", L.ERR_INVALID_URL = "ERR_INVALID_URL", L.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
function yr(e) {
	return I.isPlainObject(e) || I.isArray(e);
}
function br(e) {
	return I.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function xr(e, t, n) {
	return e ? e.concat(t).map(function(e, t) {
		return e = br(e), !n && t ? "[" + e + "]" : e;
	}).join(n ? "." : "") : t;
}
function Sr(e) {
	return I.isArray(e) && !e.some(yr);
}
var Cr = I.toFlatObject(I, {}, null, function(e) {
	return /^is[A-Z]/.test(e);
});
function wr(e, t, n) {
	if (!I.isObject(e)) throw TypeError("target must be an object");
	t ||= new FormData();
	let r = (e, t) => {
		let r = I.getSafeProp(n, e);
		return I.isUndefined(r) ? t : r;
	}, i = r("metaTokens", !0), a = r("visitor") || h, o = r("dots", !1), s = r("indexes", !1), c = r("Blob") || typeof Blob < "u" && Blob, l = r("maxDepth", 100), u = c && I.isSpecCompliantForm(t), d = [];
	if (!I.isFunction(a)) throw TypeError("visitor must be a function");
	function f(e) {
		if (e === null) return "";
		if (I.isDate(e)) return e.toISOString();
		if (I.isBoolean(e)) return e.toString();
		if (!u && I.isBlob(e)) throw new L("Blob is not supported. Use a Buffer instead.");
		if (I.isArrayBuffer(e) || I.isTypedArray(e)) {
			if (u && typeof c == "function") return new c([e]);
			throw new L("Blob is not supported. Use a Buffer instead.", L.ERR_NOT_SUPPORT);
		}
		return e;
	}
	function p(e) {
		if (e > l) throw new L("Object is too deeply nested (" + e + " levels). Max depth: " + l, L.ERR_FORM_DATA_DEPTH_EXCEEDED);
	}
	function m(e, t) {
		if (l === Infinity) return JSON.stringify(e);
		let n = [];
		return JSON.stringify(e, function(e, r) {
			if (!I.isObject(r)) return r;
			for (; n.length && n[n.length - 1] !== this;) n.pop();
			return n.push(r), p(t + n.length - 1), r;
		});
	}
	function h(e, n, r) {
		let a = e;
		if (I.isReactNative(t) && I.isReactNativeBlob(e)) return t.append(xr(r, n, o), f(e)), !1;
		if (e && !r && typeof e == "object") {
			if (I.endsWith(n, "{}")) n = i ? n : n.slice(0, -2), e = m(e, 1);
			else if (I.isArray(e) && Sr(e) || (I.isFileList(e) || I.endsWith(n, "[]")) && (a = I.toArray(e))) return n = br(n), a.forEach(function(e, r) {
				!(I.isUndefined(e) || e === null) && t.append(s === !0 ? xr([n], r, o) : s === null ? n : n + "[]", f(e));
			}), !1;
		}
		return yr(e) ? !0 : (t.append(xr(r, n, o), f(e)), !1);
	}
	let g = Object.assign(Cr, {
		defaultVisitor: h,
		convertValue: f,
		isVisitable: yr
	});
	function ee(e, n, r = 0) {
		if (!I.isUndefined(e)) {
			if (p(r), d.indexOf(e) !== -1) throw Error("Circular reference detected in " + n.join("."));
			d.push(e), I.forEach(e, function(e, i) {
				(!(I.isUndefined(e) || e === null) && a.call(t, e, I.isString(i) ? i.trim() : i, n, g)) === !0 && ee(e, n ? n.concat(i) : [i], r + 1);
			}), d.pop();
		}
	}
	if (!I.isObject(e)) throw TypeError("data must be an object");
	return ee(e), t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/AxiosURLSearchParams.js
function Tr(e) {
	let t = {
		"!": "%21",
		"'": "%27",
		"(": "%28",
		")": "%29",
		"~": "%7E",
		"%20": "+"
	};
	return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(e) {
		return t[e];
	});
}
function Er(e, t) {
	this._pairs = [], e && wr(e, this, t);
}
var Dr = Er.prototype;
Dr.append = function(e, t) {
	this._pairs.push([e, t]);
}, Dr.toString = function(e) {
	let t = e ? (t) => e.call(this, t, Tr) : Tr;
	return this._pairs.map(function(e) {
		return t(e[0]) + "=" + t(e[1]);
	}, "").join("&");
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/buildURL.js
function Or(e) {
	return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function kr(e, t, n) {
	if (!t) return e;
	e ||= "";
	let r = I.isFunction(n) ? { serialize: n } : n, i = I.getSafeProp(r, "encode") || Or, a = I.getSafeProp(r, "serialize"), o;
	if (o = a ? a(t, r) : I.isURLSearchParams(t) ? t.toString() : new Er(t, r).toString(i), o) {
		let t = e.indexOf("#");
		t !== -1 && (e = e.slice(0, t)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
	}
	return e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/InterceptorManager.js
var Ar = Symbol("internals");
function jr(e) {
	return e ? e.length : 0;
}
function Mr(e) {
	if (e) for (; e.length && e[e.length - 1] === null;) e.pop();
}
function Nr(e, t) {
	let n = e.handlers, r = jr(n);
	n === t.handlersRef ? r !== t.handlersLength && (r ? t.handlerEntries.forEach(function(e, r) {
		n[e.index] !== e.handler && t.handlerEntries.delete(r);
	}) : t.handlerEntries.clear()) : (t.handlersRef = n, t.handlerEntries.clear()), t.handlersLength = r;
}
var Pr = class {
	constructor() {
		this.handlers = [], this[Ar] = {
			handlersRef: this.handlers,
			handlersLength: this.handlers.length,
			handlerEntries: /* @__PURE__ */ new Map(),
			iterationDepth: 0,
			nextId: 0
		};
	}
	use(e, t, n) {
		let r = {
			fulfilled: e,
			rejected: t,
			synchronous: n ? n.synchronous : !1,
			runWhen: n ? n.runWhen : null
		}, i = this[Ar];
		this.handlers ??= [], Nr(this, i);
		let a = i.nextId++;
		return this.handlers.push(r), i.handlerEntries.set(a, {
			handler: r,
			index: this.handlers.length - 1
		}), i.handlersLength = this.handlers.length, a;
	}
	eject(e) {
		let t = this[Ar];
		Nr(this, t);
		let n = t.handlerEntries.get(e);
		if (n) {
			if (t.handlerEntries.delete(e), this.handlers[n.index] !== n.handler) return;
			this.handlers[n.index] = null, t.iterationDepth || (Mr(this.handlers), t.handlersLength = this.handlers.length);
		}
	}
	clear() {
		this.handlers && (this.handlers = [], Nr(this, this[Ar]));
	}
	forEach(e) {
		let t = this[Ar];
		Nr(this, t), t.iterationDepth++;
		try {
			I.forEach(this.handlers, function(t) {
				t !== null && e(t);
			});
		} finally {
			--t.iterationDepth || (Nr(this, t), Mr(this.handlers), t.handlersLength = jr(this.handlers));
		}
	}
}, Fr = {
	silentJSONParsing: !0,
	forcedJSONParsing: !0,
	clarifyTimeoutError: !1,
	legacyInterceptorReqResOrdering: !0,
	advertiseZstdAcceptEncoding: !1,
	validateStatusUndefinedResolves: !0
}, Ir = {
	isBrowser: !0,
	classes: {
		URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : Er,
		FormData: typeof FormData < "u" ? FormData : null,
		Blob: typeof Blob < "u" ? Blob : null
	},
	protocols: [
		"http",
		"https",
		"file",
		"blob",
		"url",
		"data"
	]
}, Lr = /* @__PURE__ */ xt({
	hasBrowserEnv: () => Rr,
	hasStandardBrowserEnv: () => Br,
	hasStandardBrowserWebWorkerEnv: () => Vr,
	navigator: () => zr,
	origin: () => Hr
}), Rr = typeof window < "u" && typeof document < "u", zr = typeof navigator == "object" && navigator || void 0, Br = Rr && (!zr || [
	"ReactNative",
	"NativeScript",
	"NS"
].indexOf(zr.product) < 0), Vr = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Hr = Rr && window.location.href || "http://localhost", Ur = {
	...Lr,
	...Ir
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/toURLEncodedForm.js
function Wr(e, t) {
	return wr(e, new Ur.classes.URLSearchParams(), {
		visitor: function(e, t, n, r) {
			return Ur.isNode && I.isBuffer(e) ? (this.append(t, e.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
		},
		...t
	});
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/formDataToJSON.js
var Gr = 100;
function Kr(e) {
	if (e > Gr) throw new L("FormData field is too deeply nested (" + e + " levels). Max depth: " + Gr, L.ERR_FORM_DATA_DEPTH_EXCEEDED);
}
function qr(e) {
	let t = [], n = /[^.[\]]+|\[([^.[\]]*)]/g, r;
	for (; (r = n.exec(e)) !== null;) Kr(t.length), t.push(r[0] === "[]" ? "" : r[1] || r[0]);
	return t;
}
function Jr(e) {
	let t = {}, n = Object.keys(e), r, i = n.length, a;
	for (r = 0; r < i; r++) a = n[r], t[a] = e[a];
	return t;
}
function Yr(e) {
	function t(e, n, r, i) {
		Kr(i);
		let a = e[i++];
		if (a === "__proto__") return !0;
		let o = Number.isFinite(+a), s = i >= e.length;
		return a = !a && I.isArray(r) ? r.length : a, s ? (I.hasOwnProp(r, a) ? r[a] = I.isArray(r[a]) ? r[a].concat(n) : [r[a], n] : r[a] = n, !o) : ((!I.hasOwnProp(r, a) || !I.isObject(r[a])) && (r[a] = []), t(e, n, r[a], i) && I.isArray(r[a]) && (r[a] = Jr(r[a])), !o);
	}
	if (I.isFormData(e) && I.isFunction(e.entries)) {
		let n = {};
		return I.forEachEntry(e, (e, r) => {
			t(qr(e), r, n, 0);
		}), n;
	}
	return null;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/methodList.js
var Xr = Object.freeze([
	"get",
	"delete",
	"head",
	"options",
	"post",
	"put",
	"patch",
	"purge",
	"link",
	"unlink",
	"query"
]), Zr = (e, t) => e != null && I.hasOwnProp(e, t) ? e[t] : void 0;
function Qr(e, t, n) {
	if (I.isString(e)) try {
		return (t || JSON.parse)(e), I.trim(e);
	} catch (e) {
		if (e.name !== "SyntaxError") throw e;
	}
	return (n || JSON.stringify)(e);
}
var $r = {
	transitional: Fr,
	adapter: [
		"xhr",
		"http",
		"fetch"
	],
	transformRequest: [function(e, t) {
		let n = t.getContentType() || "", r = n.indexOf("application/json") > -1, i = I.isObject(e);
		if (i && I.isHTMLForm(e) && (e = new FormData(e)), I.isFormData(e)) return r ? JSON.stringify(Yr(e)) : e;
		if (I.isArrayBuffer(e) || I.isBuffer(e) || I.isStream(e) || I.isFile(e) || I.isBlob(e) || I.isReadableStream(e)) return e;
		if (I.isArrayBufferView(e)) return e.buffer;
		if (I.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
		let a;
		if (i) {
			let t = Zr(this, "formSerializer");
			if (n.indexOf("application/x-www-form-urlencoded") > -1) return Wr(e, t).toString();
			if ((a = I.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
				let n = Zr(this, "env"), r = n && n.FormData;
				return wr(a ? { "files[]": e } : e, r && new r(), t);
			}
		}
		return i || r ? (t.setContentType("application/json", !1), Qr(e)) : e;
	}],
	transformResponse: [function(e) {
		let t = Zr(this, "transitional") || $r.transitional, n = t && t.forcedJSONParsing, r = Zr(this, "responseType"), i = r === "json";
		if (I.isResponse(e) || I.isReadableStream(e)) return e;
		if (e && I.isString(e) && (n && !r || i)) {
			let n = !(t && t.silentJSONParsing) && i;
			try {
				return JSON.parse(e, Zr(this, "parseReviver"));
			} catch (e) {
				if (n) throw e.name === "SyntaxError" ? L.from(e, L.ERR_BAD_RESPONSE, this, null, Zr(this, "response")) : e;
			}
		}
		return e;
	}],
	timeout: 0,
	xsrfCookieName: "XSRF-TOKEN",
	xsrfHeaderName: "X-XSRF-TOKEN",
	maxContentLength: -1,
	maxBodyLength: -1,
	env: {
		FormData: Ur.classes.FormData,
		Blob: Ur.classes.Blob
	},
	validateStatus: function(e) {
		return e >= 200 && e < 300;
	},
	headers: { common: {
		Accept: "application/json, text/plain, */*",
		"Content-Type": void 0
	} }
};
I.forEach(Xr, (e) => {
	$r.headers[e] = {};
});
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/transformData.js
function ei(e, t) {
	let n = this || $r, r = t || n, i = pr.from(r.headers), a = r.data;
	return I.forEach(e, function(e) {
		a = e.call(n, a, i.normalize(), t ? t.status : void 0);
	}), i.normalize(), a;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/cancel/isCancel.js
function ti(e) {
	return !!(e && e.__CANCEL__);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/cancel/CanceledError.js
var ni = class extends L {
	constructor(e, t, n) {
		super(e ?? "canceled", L.ERR_CANCELED, t, n), this.name = "CanceledError", this.__CANCEL__ = !0;
	}
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/settle.js
function ri(e, t, n) {
	let r = n.config.validateStatus;
	!n.status || !r || r(n.status) ? e(n) : t(new L("Request failed with status code " + n.status, n.status >= 400 && n.status < 500 ? L.ERR_BAD_REQUEST : L.ERR_BAD_RESPONSE, n.config, n.request, n));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/normalizeURLForProtocolCheck.js
var ii = /[\t\n\r]/g;
function ai(e) {
	if (typeof e != "string") return e;
	let t = 0;
	for (; t < e.length && e.charCodeAt(t) <= 32;) t++;
	return e.slice(t).replace(ii, "");
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/parseProtocol.js
function oi(e) {
	let t = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
	return t && t[1] || "";
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/speedometer.js
function si(e, t) {
	e ||= 10;
	let n = Array(e), r = Array(e), i = 0, a = 0, o;
	return t = t === void 0 ? 1e3 : t, function(s) {
		let c = Date.now(), l = r[a];
		o ||= c, n[i] = s, r[i] = c;
		let u = a, d = 0;
		for (; u !== i;) d += n[u++], u %= e;
		if (i = (i + 1) % e, i === a && (a = (a + 1) % e), c - o < t) return;
		let f = l && c - l;
		return f ? Math.round(d * 1e3 / f) : void 0;
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/throttle.js
function ci(e, t) {
	let n = 0, r = 1e3 / t, i, a, o = (t, r = Date.now()) => {
		n = r, i = null, a &&= (clearTimeout(a), null), e(...t);
	};
	return [
		(...e) => {
			let t = Date.now(), s = t - n;
			s >= r ? o(e, t) : (i = e, a ||= setTimeout(() => {
				a = null, o(i);
			}, r - s));
		},
		() => i && o(i),
		(...e) => o(e)
	];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/progressEventReducer.js
var li = (e, t, n = 3) => {
	let r = 0, i = si(50, 250);
	return ci((n) => {
		if (!n || !I.isNumber(n.loaded)) return;
		let a = n.loaded, o = n.lengthComputable ? n.total : void 0, s = Math.max(0, o == null ? a : Math.min(a, o)), c = Math.max(0, s - r), l = i(c);
		r = Math.max(r, s), e({
			loaded: s,
			total: o,
			progress: o ? s / o : void 0,
			bytes: c,
			rate: l || void 0,
			estimated: l && o ? (o - s) / l : void 0,
			event: n,
			lengthComputable: o != null,
			[t ? "download" : "upload"]: !0
		});
	}, n);
}, ui = (e, t) => {
	let n = e != null;
	return [(r) => t[0]({
		lengthComputable: n,
		total: e,
		loaded: r
	}), t[1]];
}, di = (e, t = I.asap) => (...n) => t(() => e(...n)), fi = Ur.hasStandardBrowserEnv ? ((e, t) => (n) => (n = new URL(n, Ur.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(new URL(Ur.origin), Ur.navigator && /(msie|trident)/i.test(Ur.navigator.userAgent)) : () => !0, pi = Ur.hasStandardBrowserEnv ? {
	write(e, t, n, r, i, a, o) {
		if (typeof document > "u") return;
		let s = [`${e}=${encodeURIComponent(t)}`];
		I.isNumber(n) && s.push(`expires=${new Date(n).toUTCString()}`), I.isString(r) && s.push(`path=${r}`), I.isString(i) && s.push(`domain=${i}`), a === !0 && s.push("secure"), I.isString(o) && s.push(`SameSite=${o}`), document.cookie = s.join("; ");
	},
	read(e) {
		if (typeof document > "u") return null;
		let t = document.cookie.split(";");
		for (let n = 0; n < t.length; n++) {
			let r = t[n].replace(/^\s+/, ""), i = r.indexOf("=");
			if (i !== -1 && r.slice(0, i) === e) try {
				return decodeURIComponent(r.slice(i + 1));
			} catch {
				return r.slice(i + 1);
			}
		}
		return null;
	},
	remove(e) {
		this.write(e, "", Date.now() - 864e5, "/");
	}
} : {
	write() {},
	read() {
		return null;
	},
	remove() {}
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/isAbsoluteURL.js
function mi(e) {
	return typeof e == "string" ? /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e) : !1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/combineURLs.js
function hi(e, t) {
	if (!t) return e;
	let n = e.length;
	for (; n > 0 && e.charCodeAt(n - 1) === 47;) n--;
	return e.slice(0, n) + "/" + t.replace(/^\/+/, "");
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/buildFullPath.js
var gi = /^https?:(?!\/\/)/i;
function _i(e) {
	return e && e.replace(/(^|&)([^=&]*=)?[^&]+/g, (e, t, n = "") => `${t}${n}${mr}`);
}
function vi(e) {
	let t = e.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${mr}@`), n = t.indexOf("#"), r = (n === -1 ? t : t.slice(0, n)).replace(/([?&][^=&#]*=)[^&#]*/g, `$1${mr}`);
	return n === -1 ? r : `${r}#${_i(t.slice(n + 1))}`;
}
function yi(e, t) {
	if (typeof e == "string") {
		let n = ai(e);
		if (gi.test(n)) throw new L(`Invalid URL ${JSON.stringify(vi(n))}: missing "//" after protocol`, L.ERR_INVALID_URL, t);
	}
}
function bi(e, t, n, r) {
	yi(t, r);
	let i = !mi(t);
	return e && (i || n === !1) ? (yi(e, r), hi(e, t)) : t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/mergeConfig.js
var xi = (e) => e instanceof pr ? { ...e } : e, Si = (e) => Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor ? Object.keys(e).concat(Object.getOwnPropertySymbols(e).filter((t) => Object.getOwnPropertyDescriptor(e, t).enumerable)) : Object.keys(e);
function Ci(e, t) {
	e ||= {}, t ||= {};
	let n = Object.create(null);
	Object.defineProperty(n, "hasOwnProperty", {
		__proto__: null,
		value: Object.prototype.hasOwnProperty,
		enumerable: !1,
		writable: !0,
		configurable: !0
	});
	function r(e, t, n, r) {
		return I.isPlainObject(e) && I.isPlainObject(t) ? I.merge.call({ caseless: r }, e, t) : I.isPlainObject(t) ? I.merge({}, t) : I.isArray(t) ? t.slice() : t;
	}
	function i(e, t, n, i) {
		if (!I.isUndefined(t)) return r(e, t, n, i);
		if (!I.isUndefined(e)) return r(void 0, e, n, i);
	}
	function a(e, t) {
		if (!I.isUndefined(t)) return r(void 0, t);
	}
	function o(e, t) {
		if (!I.isUndefined(t)) return r(void 0, t);
		if (!I.isUndefined(e)) return r(void 0, e);
	}
	function s(n) {
		let r = I.hasOwnProp(t, "transitional") ? t.transitional : void 0;
		if (!I.isUndefined(r)) if (I.isPlainObject(r)) {
			if (I.hasOwnProp(r, n)) return r[n];
		} else return;
		let i = I.hasOwnProp(e, "transitional") ? e.transitional : void 0;
		if (I.isPlainObject(i) && I.hasOwnProp(i, n)) return i[n];
	}
	function c(n, i, a) {
		if (I.hasOwnProp(t, a)) return r(n, i);
		if (I.hasOwnProp(e, a)) return r(void 0, n);
	}
	let l = {
		url: a,
		method: a,
		data: a,
		baseURL: o,
		transformRequest: o,
		transformResponse: o,
		paramsSerializer: o,
		timeout: o,
		timeoutErrorMessage: o,
		withCredentials: o,
		withXSRFToken: o,
		adapter: o,
		responseType: o,
		xsrfCookieName: o,
		xsrfHeaderName: o,
		onUploadProgress: o,
		onDownloadProgress: o,
		decompress: o,
		maxContentLength: o,
		maxBodyLength: o,
		beforeRedirect: o,
		transport: o,
		httpAgent: o,
		httpsAgent: o,
		cancelToken: o,
		socketPath: o,
		allowedSocketPaths: o,
		responseEncoding: o,
		validateStatus: c,
		headers: (e, t, n) => i(xi(e), xi(t), n, !0)
	};
	return I.forEach(Si({
		...e,
		...t
	}), function(r) {
		if (r === "__proto__" || r === "constructor" || r === "prototype") return;
		let a = I.hasOwnProp(l, r) ? l[r] : i, o = a(I.hasOwnProp(e, r) ? e[r] : void 0, I.hasOwnProp(t, r) ? t[r] : void 0, r);
		I.isUndefined(o) && a !== c || (n[r] = o);
	}), I.hasOwnProp(t, "validateStatus") && I.isUndefined(t.validateStatus) && s("validateStatusUndefinedResolves") === !1 && (I.hasOwnProp(e, "validateStatus") ? n.validateStatus = r(void 0, e.validateStatus) : delete n.validateStatus), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/setFormDataHeaders.js
var wi = ["content-type", "content-length"];
function Ti(e, t, n) {
	if (n !== "content-only") {
		e.set(t);
		return;
	}
	Object.entries(t || {}).forEach(([t, n]) => {
		wi.includes(t.toLowerCase()) && e.set(t, n);
	});
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/resolveConfig.js
var Ei = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16)));
function Di(e) {
	let t = Ci({}, e), n = (e) => I.hasOwnProp(t, e) ? t[e] : void 0, r = n("data"), i = n("withXSRFToken"), a = n("xsrfHeaderName"), o = n("xsrfCookieName"), s = n("headers"), c = n("auth"), l = n("baseURL"), u = n("allowAbsoluteUrls"), d = n("url");
	if (t.headers = s = pr.from(s), t.url = kr(bi(l, d, u, t), n("params"), n("paramsSerializer")), c) {
		let t = I.getSafeProp(c, "username") || "", n = I.getSafeProp(c, "password") || "";
		try {
			s.set("Authorization", "Basic " + btoa(t + ":" + (n ? Ei(n) : "")));
		} catch (t) {
			throw L.from(t, L.ERR_BAD_OPTION_VALUE, e);
		}
	}
	if (I.isFormData(r)) {
		let e = I.getSafeProp(r, "getHeaders");
		Ur.hasStandardBrowserEnv || Ur.hasStandardBrowserWebWorkerEnv || I.isReactNative(r) ? s.setContentType(void 0) : I.isFunction(e) && Ti(s, e.call(r), n("formDataHeaderPolicy"));
	}
	if (Ur.hasStandardBrowserEnv && (I.isFunction(i) && (i = i(t)), i === !0 || i == null && fi(t.url))) {
		let e = a && o && pi.read(o);
		e && s.set(a, e);
	}
	return t;
}
var Oi = typeof XMLHttpRequest < "u" && function(e) {
	return new Promise(function(t, n) {
		let r = Di(e), i = r.data, a = pr.from(r.headers).normalize(), { responseType: o, onUploadProgress: s, onDownloadProgress: c } = r, l, u, d, f, p, m;
		function h() {
			f && f(), p && p(), r.cancelToken && r.cancelToken.unsubscribe(l), r.signal && r.signal.removeEventListener("abort", l);
		}
		let g = new XMLHttpRequest();
		g.open(r.method.toUpperCase(), r.url, !0), g.timeout = r.timeout;
		function ee(i) {
			if (!g) return;
			if (g.status === 0 && (oi(ai(r.url)) || oi(Ur.origin)) !== "file" && !(g.responseURL && g.responseURL.startsWith("file:"))) {
				n(new L("Request aborted", L.ECONNABORTED, e, g)), h(), g = null;
				return;
			}
			try {
				i ? m && m(i) : p && p();
			} catch (e) {
				setTimeout(() => {
					throw e;
				});
			}
			if (!g) return;
			let a = pr.from("getAllResponseHeaders" in g && g.getAllResponseHeaders());
			ri(function(e) {
				t(e), h();
			}, function(e) {
				n(e), h();
			}, {
				data: !o || o === "text" || o === "json" ? g.responseText : g.response,
				status: g.status,
				statusText: g.statusText,
				headers: a,
				config: e,
				request: g
			}), g = null;
		}
		"onloadend" in g ? g.onloadend = ee : g.onreadystatechange = function() {
			!g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.startsWith("file:")) || setTimeout(ee);
		}, g.onabort = function() {
			g &&= (n(new L("Request aborted", L.ECONNABORTED, e, g)), h(), null);
		}, g.onerror = function(t) {
			let r = new L(t && t.message ? t.message : "Network Error", L.ERR_NETWORK, e, g);
			r.event = t || null, n(r), h(), g = null;
		}, g.ontimeout = function() {
			let t = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded", i = r.transitional || Fr;
			r.timeoutErrorMessage && (t = r.timeoutErrorMessage), n(new L(t, i.clarifyTimeoutError ? L.ETIMEDOUT : L.ECONNABORTED, e, g)), h(), g = null;
		}, i === void 0 && a.setContentType(null), "setRequestHeader" in g && I.forEach(er(a), function(e, t) {
			g.setRequestHeader(t, e);
		}), I.isUndefined(r.withCredentials) || (g.withCredentials = !!r.withCredentials), o && o !== "json" && (g.responseType = r.responseType), c && ([d, p, m] = li(c, !0), g.addEventListener("progress", d)), s && g.upload && ([u, f] = li(s), g.upload.addEventListener("progress", u), g.upload.addEventListener("loadend", f)), (r.cancelToken || r.signal) && (l = (t) => {
			g &&= (n(!t || t.type ? new ni(null, e, g) : t), g.abort(), h(), null);
		}, r.cancelToken && r.cancelToken.subscribe(l), r.signal && (r.signal.aborted ? l() : r.signal.addEventListener("abort", l)));
		let _ = oi(r.url);
		if (_ && !Ur.protocols.includes(_)) {
			n(new L("Unsupported protocol " + _ + ":", L.ERR_BAD_REQUEST, e)), h();
			return;
		}
		g.send(i || null);
	});
}, ki = (e, t) => {
	if (e = e ? e.filter(Boolean) : [], !t && !e.length) return;
	let n = new AbortController(), r = !1, i = function(e) {
		if (!r) {
			r = !0, o();
			let t = e instanceof Error ? e : this.reason;
			n.abort(t instanceof L ? t : new ni(t instanceof Error ? t.message : t));
		}
	}, a = t && setTimeout(() => {
		a = null, i(new L(`timeout of ${t}ms exceeded`, L.ETIMEDOUT));
	}, t), o = () => {
		e &&= (a && clearTimeout(a), a = null, e.forEach((e) => {
			e.unsubscribe ? e.unsubscribe(i) : e.removeEventListener("abort", i);
		}), null);
	};
	e.forEach((e) => {
		if (!r) {
			if (e.aborted) {
				i.call(e);
				return;
			}
			e.addEventListener("abort", i, { once: !0 });
		}
	});
	let { signal: s } = n;
	return s.unsubscribe = () => I.asap(o), s;
}, Ai = function* (e, t) {
	let n = e.byteLength;
	if (!t || n < t) {
		yield e;
		return;
	}
	let r = 0, i;
	for (; r < n;) i = r + t, yield e.slice(r, i), r = i;
}, ji = async function* (e, t) {
	for await (let n of Mi(e)) yield* Ai(n, t);
}, Mi = async function* (e) {
	if (e[Symbol.asyncIterator]) {
		yield* e;
		return;
	}
	let t = e.getReader();
	try {
		for (;;) {
			let { done: e, value: n } = await t.read();
			if (e) break;
			yield n;
		}
	} finally {
		await t.cancel();
	}
}, Ni = (e, t, n, r) => {
	let i = ji(e, t), a = 0, o, s = (e) => {
		o || (o = !0, r && r(e));
	};
	return new ReadableStream({
		async pull(e) {
			try {
				let { done: t, value: r } = await i.next();
				if (t) {
					s(), e.close();
					return;
				}
				let o = r.byteLength;
				n && n(a += o), e.enqueue(new Uint8Array(r));
			} catch (e) {
				throw s(e), e;
			}
		},
		cancel(e) {
			return s(e), i.return();
		}
	}, { highWaterMark: 2 });
}, Pi = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, Fi = (e, t, n) => t + 2 < n && Pi(e.charCodeAt(t + 1)) && Pi(e.charCodeAt(t + 2)), Ii = (e) => e <= 57 ? e - 48 : (e & 223) - 55, Li = (e) => e >= 65 && e <= 90 || e >= 97 && e <= 122 || e >= 48 && e <= 57 || e === 43 || e === 47 || e === 45 || e === 95, Ri = (e) => e === 9 || e === 10 || e === 12 || e === 13 || e === 32, zi = (e) => {
	let t = Math.floor(e / 4), n = e % 4;
	return t * 3 + (n === 2 ? 1 : n === 3 ? 2 : 0);
}, Bi = (e) => {
	let t = e.length, n = 0;
	return t > 0 && e.charCodeAt(t - 1) === 61 && (n++, t > 1 && e.charCodeAt(t - 2) === 61 && n++), Math.floor((t - n) * 3 / 4);
}, Vi = (e) => {
	let t = e.length, n = 0, r = 0, i = !1;
	for (let a = 0; a < t; a++) {
		let o = e.charCodeAt(a);
		if (o === 37 && Fi(e, a, t) && (o = Ii(e.charCodeAt(a + 1)) * 16 + Ii(e.charCodeAt(a + 2)), a += 2), !Ri(o)) {
			if (o === 61) {
				r++;
				continue;
			}
			if (!Li(o) || r > 0) {
				i = !0;
				continue;
			}
			n++;
		}
	}
	return i || r > 2 || r > 0 && (n + r) % 4 != 0 || n % 4 == 1 ? Bi(e) : zi(n);
}, Hi = (e, t) => {
	if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
	let n = e.indexOf(",");
	if (n < 0) return 0;
	let r = e.slice(5, n), i = e.slice(n + 1);
	if (/;base64/i.test(r)) return t(i);
	let a = 0;
	for (let e = 0, t = i.length; e < t; e++) {
		let n = i.charCodeAt(e);
		if (n === 37 && Fi(i, e, t)) a += 1, e += 2;
		else if (n < 128) a += 1;
		else if (n < 2048) a += 2;
		else if (n >= 55296 && n <= 56319 && e + 1 < t) {
			let t = i.charCodeAt(e + 1);
			t >= 56320 && t <= 57343 ? (a += 4, e++) : a += 3;
		} else a += 3;
	}
	return a;
};
function Ui(e) {
	let t = typeof e == "string" ? e.indexOf("#") : -1;
	return Hi(t === -1 ? e : e.slice(0, t), Vi);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/env/data.js
var Wi = "1.20.0", Gi = 64 * 1024, Ki = {
	cache: "default",
	redirect: "follow",
	referrer: "about:client",
	referrerPolicy: "",
	mode: "cors",
	integrity: "",
	keepalive: !1,
	priority: "auto",
	window: null
}, { isFunction: qi } = I, Ji = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16))), Yi = (e) => {
	if (!I.isString(e)) return e;
	try {
		return decodeURIComponent(e);
	} catch {
		return e;
	}
}, Xi = (e, ...t) => {
	try {
		return !!e(...t);
	} catch {
		return !1;
	}
}, Zi = (e) => {
	let t = e.indexOf("://"), n = e;
	return t !== -1 && (n = n.slice(t + 3)), n.includes("@") || n.includes(":");
}, Qi = (e) => {
	let t = I.global !== void 0 && I.global !== null ? I.global : globalThis, { ReadableStream: n, TextEncoder: r } = t;
	e = I.merge.call({ skipUndefined: !0 }, {
		Request: t.Request,
		Response: t.Response
	}, e);
	let { fetch: i, Request: a, Response: o } = e, s = i ? qi(i) : typeof fetch == "function", c = qi(a), l = qi(o);
	if (!s) return !1;
	let u = s && qi(n), d = s && (typeof r == "function" ? ((e) => (t) => e.encode(t))(new r()) : async (e) => new Uint8Array(await new a(e).arrayBuffer())), f = c && u && Xi(() => {
		let e = !1, t = new a(Ur.origin, {
			body: new n(),
			method: "POST",
			get duplex() {
				return e = !0, "half";
			}
		}), r = t.headers.has("Content-Type");
		return t.body != null && t.body.cancel(), e && !r;
	}), p = l && u && Xi(() => I.isReadableStream(new o("").body)), m = { stream: p && ((e) => e.body) };
	s && [
		"text",
		"arrayBuffer",
		"blob",
		"formData",
		"stream"
	].forEach((e) => {
		!m[e] && (m[e] = (t, n) => {
			let r = t && t[e];
			if (r) return r.call(t);
			throw new L(`Response type '${e}' is not supported`, L.ERR_NOT_SUPPORT, n);
		});
	});
	let h = async (e) => {
		if (e == null) return 0;
		if (I.isBlob(e)) return e.size;
		if (I.isSpecCompliantForm(e)) return (await new a(Ur.origin, {
			method: "POST",
			body: e
		}).arrayBuffer()).byteLength;
		if (I.isArrayBufferView(e) || I.isArrayBuffer(e)) return e.byteLength;
		if (I.isURLSearchParams(e) && (e += ""), I.isString(e)) return (await d(e)).byteLength;
	}, g = async (e, t) => I.toFiniteNumber(e.getContentLength()) ?? h(t);
	return async (e) => {
		let { url: t, method: n, data: s, signal: l, cancelToken: d, timeout: ee, onDownloadProgress: _, onUploadProgress: v, responseType: y, headers: b, withCredentials: te = "same-origin", fetchOptions: ne, maxContentLength: x, maxBodyLength: re, maxRedirects: ie } = Di(e), ae = I.isNumber(x) && x > -1, oe = I.isNumber(re) && re > -1, se = (t) => I.hasOwnProp(e, t) ? e[t] : void 0, ce = i || fetch;
		y = y ? (y + "").toLowerCase() : "text";
		let le = ki([l, d && d.toAbortSignal()], ee), S = null, ue = le && le.unsubscribe && (() => {
			le.unsubscribe();
		}), de, fe = null, pe = () => new L("Request body larger than maxBodyLength limit", L.ERR_BAD_REQUEST, e, S);
		try {
			let i, l = se("auth");
			if (l && (i = {
				username: I.getSafeProp(l, "username") || "",
				password: I.getSafeProp(l, "password") || ""
			}), Zi(t)) {
				let e = new URL(t, Ur.origin);
				!i && (e.username || e.password) && (i = {
					username: Yi(e.username),
					password: Yi(e.password)
				}), (e.username || e.password) && (e.username = "", e.password = "", t = e.href);
			}
			if (i && (b.delete("authorization"), b.set("Authorization", "Basic " + btoa(Ji((i.username || "") + ":" + (i.password || ""))))), ae && typeof t == "string" && t.startsWith("data:") && Ui(t) > x) throw new L("maxContentLength size of " + x + " exceeded", L.ERR_BAD_RESPONSE, e, S);
			if (oe && n !== "get" && n !== "head") {
				let e = await h(s);
				if (typeof e == "number" && isFinite(e) && (de = e, e > re)) throw pe();
			}
			let d = oe && (I.isReadableStream(s) || I.isStream(s)), ee = (e, t, n) => Ni(e, Gi, (e) => {
				if (oe && e > re) throw fe = pe();
				t && t(e);
			}, n);
			if (f && n !== "get" && n !== "head" && (v || d)) {
				if (de ??= await g(b, s), de !== 0 || d) {
					let e = new a(t, {
						method: "POST",
						body: s,
						duplex: "half"
					}), n;
					if (I.isFormData(s) && (n = e.headers.get("content-type")) && b.setContentType(n), e.body) {
						let [t, n] = v && ui(de, li(di(v))) || [];
						s = ee(e.body, t, n);
					}
				}
			} else if (d && !c && u && n !== "get" && n !== "head") s = ee(s);
			else if (d && c && !f && n !== "get" && n !== "head") throw new L("Stream request bodies are not supported by the current fetch implementation", L.ERR_NOT_SUPPORT, e, S);
			I.isString(te) || (te = te ? "include" : "omit");
			let me = c && "credentials" in a.prototype;
			if (I.isFormData(s)) {
				let e = b.getContentType();
				e && /^multipart\/form-data/i.test(e) && !/boundary=/i.test(e) && b.delete("content-type");
			}
			b.set("User-Agent", "axios/" + Wi, !1);
			let he = ne == null ? ne : Object.assign(Object.create(null), ne);
			he && (delete he.body, delete he.headers, delete he.method, delete he.signal, delete he.duplex, delete he.credentials);
			let ge = Object.assign(Object.create(null), he, {
				signal: le,
				method: n.toUpperCase(),
				headers: er(b.normalize()),
				body: s,
				duplex: "half",
				credentials: me ? te : void 0
			});
			c && (I.forEach(Ki, (e, t) => {
				ge[t] === void 0 && (ge[t] = e);
			}), ge.signal === void 0 && (ge.signal = null), ge.body === void 0 && (ge.body = null)), ie === 0 && (ge.redirect = "manual", he && (he.redirect = "manual")), S = c && new a(t, ge);
			let _e = await (c ? ce(S, he) : ce(t, ge)), ve = pr.from(_e.headers);
			if (ae) {
				let t = I.toFiniteNumber(ve.getContentLength());
				if (t != null && t > x) throw new L("maxContentLength size of " + x + " exceeded", L.ERR_BAD_RESPONSE, e, S);
			}
			let ye = p && (y === "stream" || y === "response");
			if (p && _e.body && (_ || ae || ye && ue)) {
				let t = {};
				[
					"status",
					"statusText",
					"headers"
				].forEach((e) => {
					t[e] = _e[e];
				});
				let n = I.toFiniteNumber(ve.getContentLength()), [r, i] = _ && ui(n, li(di(_), !0)) || [], a = 0;
				_e = new o(Ni(_e.body, Gi, (t) => {
					if (ae && (a = t, a > x)) throw new L("maxContentLength size of " + x + " exceeded", L.ERR_BAD_RESPONSE, e, S);
					r && r(t);
				}, () => {
					i && i(), ue && ue();
				}), t);
			}
			y ||= "text";
			let be = await m[I.findKey(m, y) || "text"](_e, e);
			if (ae && !p && !ye) {
				let t;
				if (be != null && (typeof be.byteLength == "number" ? t = be.byteLength : typeof be.size == "number" ? t = be.size : typeof be == "string" && (t = typeof r == "function" ? new r().encode(be).byteLength : be.length)), typeof t == "number" && t > x) throw new L("maxContentLength size of " + x + " exceeded", L.ERR_BAD_RESPONSE, e, S);
			}
			return !ye && ue && ue(), await new Promise((t, n) => {
				ri(t, n, {
					data: be,
					headers: pr.from(_e.headers),
					status: _e.status,
					statusText: _e.statusText,
					config: e,
					request: S
				});
			});
		} catch (t) {
			if (ue && ue(), le && le.aborted && le.reason instanceof L) {
				let n = le.reason;
				throw n.config = e, S && (n.request = S), t !== n && Object.defineProperty(n, "cause", {
					__proto__: null,
					value: t,
					writable: !0,
					enumerable: !1,
					configurable: !0
				}), n;
			}
			if (fe) throw S && !fe.request && (fe.request = S), fe;
			if (t instanceof L) throw S && !t.request && (t.request = S), t;
			if (t && t.name === "TypeError" && /Load failed|fetch/i.test(t.message)) {
				let n = new L("Network Error", L.ERR_NETWORK, e, S, t && t.response);
				throw Object.defineProperty(n, "cause", {
					__proto__: null,
					value: t.cause || t,
					writable: !0,
					enumerable: !1,
					configurable: !0
				}), n;
			}
			throw L.from(t, t && t.code, e, S, t && t.response);
		}
	};
}, $i = /* @__PURE__ */ new Map(), ea = (e) => {
	let t = e && e.env || {}, { fetch: n, Request: r, Response: i } = t, a = [
		r,
		i,
		n
	], o = a.length, s, c, l = $i;
	for (; o--;) s = a[o], c = l.get(s), c === void 0 && l.set(s, c = o ? /* @__PURE__ */ new Map() : Qi(t)), l = c;
	return c;
};
ea();
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/adapters/adapters.js
var ta = {
	http: null,
	xhr: Oi,
	fetch: { get: ea }
};
I.forEach(ta, (e, t) => {
	if (e) {
		try {
			Object.defineProperty(e, "name", {
				__proto__: null,
				value: t
			});
		} catch {}
		Object.defineProperty(e, "adapterName", {
			__proto__: null,
			value: t
		});
	}
});
var na = (e) => `- ${e}`, ra = (e) => I.isFunction(e) || e === null || e === !1;
function ia(e, t) {
	e = I.isArray(e) ? e : [e];
	let { length: n } = e, r, i, a = {};
	for (let o = 0; o < n; o++) {
		r = e[o];
		let n;
		if (i = r, !ra(r) && (i = ta[(n = String(r)).toLowerCase()], i === void 0)) throw new L(`Unknown adapter '${n}'`);
		if (i && (I.isFunction(i) || (i = i.get(t)))) break;
		a[n || "#" + o] = i;
	}
	if (!i) {
		let e = Object.entries(a).map(([e, t]) => `adapter ${e} ` + (t === !1 ? "is not supported by the environment" : "is not available in the build"));
		throw new L("There is no suitable adapter to dispatch the request " + (n ? e.length > 1 ? "since :\n" + e.map(na).join("\n") : " " + na(e[0]) : "as no adapter specified"), L.ERR_NOT_SUPPORT);
	}
	return i;
}
var aa = {
	getAdapter: ia,
	adapters: ta
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/dispatchRequest.js
function oa(e) {
	if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new ni(null, e);
}
function sa(e) {
	let t = I.toSafeFlatObject(e);
	return oa(t), t.headers = pr.from(I.getSafeProp(t, "headers")), t.data = ei.call(t, t.transformRequest), [
		"post",
		"put",
		"patch"
	].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), aa.getAdapter(t.adapter || $r.adapter, t)(t).then(function(e) {
		oa(t), t.response = e;
		try {
			e.data = ei.call(t, t.transformResponse, e);
		} finally {
			delete t.response;
		}
		return e.headers = pr.from(e.headers), e;
	}, function(e) {
		if (!ti(e) && (oa(t), e && e.response)) {
			t.response = e.response;
			try {
				e.response.data = ei.call(t, t.transformResponse, e.response);
			} finally {
				delete t.response;
			}
			e.response.headers = pr.from(e.response.headers);
		}
		return Promise.reject(e);
	});
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/validator.js
var ca = {};
[
	"object",
	"boolean",
	"number",
	"function",
	"string",
	"symbol"
].forEach((e, t) => {
	ca[e] = function(n) {
		return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
	};
});
var la = {};
ca.transitional = function(e, t, n) {
	function r(e, t) {
		return "[Axios v" + Wi + "] Transitional option '" + e + "'" + t + (n ? ". " + n : "");
	}
	return (n, i, a) => {
		if (e === !1) throw new L(r(i, " has been removed" + (t ? " in " + t : "")), L.ERR_DEPRECATED);
		return t && !la[i] && (la[i] = !0, console.warn(r(i, " has been deprecated since v" + t + " and will be removed in the near future"))), e ? e(n, i, a) : !0;
	};
}, ca.spelling = function(e) {
	return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function ua(e, t, n) {
	if (typeof e != "object" || !e) throw new L("options must be an object", L.ERR_BAD_OPTION_VALUE);
	let r = Object.keys(e), i = r.length;
	for (; i-- > 0;) {
		let a = r[i], o = Object.prototype.hasOwnProperty.call(t, a) ? t[a] : void 0;
		if (o) {
			let t = e[a], n = t === void 0 || o(t, a, e);
			if (n !== !0) throw new L("option " + a + " must be " + n, L.ERR_BAD_OPTION_VALUE);
			continue;
		}
		if (n !== !0) throw new L("Unknown option " + a, L.ERR_BAD_OPTION);
	}
}
var da = {
	assertOptions: ua,
	validators: ca
}, fa = da.validators, pa = class {
	constructor(e) {
		this.defaults = e || {}, this.interceptors = {
			request: new Pr(),
			response: new Pr()
		};
	}
	async request(e, t) {
		try {
			return await this._request(e, t);
		} catch (e) {
			if (e instanceof Error) try {
				let t = {};
				Error.captureStackTrace ? Error.captureStackTrace(t) : t = /* @__PURE__ */ Error();
				let n = t.stack, r = "";
				if (typeof n == "string") {
					let e = n.indexOf("\n");
					r = e === -1 ? "" : n.slice(e + 1);
				}
				if (!e.stack) e.stack = r;
				else if (r) {
					let t = r.indexOf("\n"), n = t === -1 ? -1 : r.indexOf("\n", t + 1), i = n === -1 ? "" : r.slice(n + 1);
					String(e.stack).endsWith(i) || (e.stack += "\n" + r);
				}
			} catch {}
			throw e;
		}
	}
	_request(e, t) {
		typeof e == "string" ? (t ||= {}, t.url = e) : t = e || {}, t = Ci(this.defaults, t);
		let { transitional: n, paramsSerializer: r, headers: i } = t;
		n !== void 0 && da.assertOptions(n, {
			silentJSONParsing: fa.transitional(fa.boolean),
			forcedJSONParsing: fa.transitional(fa.boolean),
			clarifyTimeoutError: fa.transitional(fa.boolean),
			legacyInterceptorReqResOrdering: fa.transitional(fa.boolean),
			advertiseZstdAcceptEncoding: fa.transitional(fa.boolean),
			validateStatusUndefinedResolves: fa.transitional(fa.boolean)
		}, !1), r != null && (I.isFunction(r) ? t.paramsSerializer = { serialize: r } : da.assertOptions(r, {
			encode: fa.function,
			serialize: fa.function
		}, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls === void 0 ? t.allowAbsoluteUrls = !0 : t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls), da.assertOptions(t, {
			baseUrl: fa.spelling("baseURL"),
			withXsrfToken: fa.spelling("withXSRFToken")
		}, !0), t.method = (I.getSafeProp(t, "method") || I.getSafeProp(this.defaults, "method") || "get").toLowerCase();
		let a = i && I.merge(i.common, i[t.method]);
		i && I.forEach(Xr.concat("common"), (e) => {
			delete i[e];
		}), t.headers = pr.concat(a, i);
		let o = [], s = !0;
		this.interceptors.request.forEach(function(e) {
			if (typeof e.runWhen == "function" && e.runWhen(t) === !1) return;
			s &&= e.synchronous;
			let n = t.transitional || Fr;
			n && n.legacyInterceptorReqResOrdering ? o.unshift(e.fulfilled, e.rejected) : o.push(e.fulfilled, e.rejected);
		});
		let c = [];
		this.interceptors.response.forEach(function(e) {
			c.push(e.fulfilled, e.rejected);
		});
		let l, u = 0, d;
		if (!s) {
			let e = [sa.bind(this), void 0];
			for (e.unshift(...o), e.push(...c), d = e.length, l = Promise.resolve(t); u < d;) l = l.then(e[u++], e[u++]);
			return l;
		}
		d = o.length;
		let f = t;
		for (; u < d;) {
			let e = o[u++], t = o[u++];
			try {
				f = e ? e(f) : f;
			} catch (e) {
				if (!t) {
					l = Promise.reject(e);
					break;
				}
				try {
					let n = t.call(this, e);
					I.isThenable(n) && (l = Promise.resolve(n).then(() => sa.call(this, f)));
				} catch (e) {
					l = Promise.reject(e);
				}
				break;
			}
		}
		if (!l) try {
			l = sa.call(this, f);
		} catch (e) {
			l = Promise.reject(e);
		}
		for (u = 0, d = c.length; u < d;) l = l.then(c[u++], c[u++]);
		return l;
	}
	getUri(e) {
		return e = Ci(this.defaults, e), kr(bi(e.baseURL, e.url, e.allowAbsoluteUrls, e), e.params, e.paramsSerializer);
	}
};
I.forEach([
	"delete",
	"get",
	"head",
	"options"
], function(e) {
	pa.prototype[e] = function(t, n) {
		return this.request(Ci(n || {}, {
			method: e,
			url: t,
			data: n && I.hasOwnProp(n, "data") ? n.data : void 0
		}));
	};
}), I.forEach([
	"post",
	"put",
	"patch",
	"query"
], function(e) {
	function t(t) {
		return function(n, r, i) {
			return this.request(Ci(i || {}, {
				method: e,
				headers: t ? { "Content-Type": "multipart/form-data" } : {},
				url: n,
				data: r
			}));
		};
	}
	pa.prototype[e] = t(), e !== "query" && (pa.prototype[e + "Form"] = t(!0));
});
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/cancel/CancelToken.js
var ma = class e {
	constructor(e) {
		if (typeof e != "function") throw TypeError("executor must be a function.");
		let t;
		this.promise = new Promise(function(e) {
			t = e;
		});
		let n = this;
		this.promise.then((e) => {
			if (!n._listeners) return;
			let t = n._listeners.length;
			for (; t-- > 0;) n._listeners[t](e);
			n._listeners = null;
		}), this.promise.then = (e) => {
			let t, r = new Promise((e) => {
				n.subscribe(e), t = e;
			}).then(e);
			return r.cancel = function() {
				n.unsubscribe(t);
			}, r;
		}, e(function(e, r, i) {
			n.reason || (n.reason = new ni(e, r, i), t(n.reason));
		});
	}
	throwIfRequested() {
		if (this.reason) throw this.reason;
	}
	subscribe(e) {
		if (this.reason) {
			e(this.reason);
			return;
		}
		this._listeners ? this._listeners.push(e) : this._listeners = [e];
	}
	unsubscribe(e) {
		if (!this._listeners) return;
		let t = this._listeners.indexOf(e);
		t !== -1 && this._listeners.splice(t, 1);
	}
	toAbortSignal() {
		let e = new AbortController(), t = (t) => {
			e.abort(t);
		};
		return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
	}
	static source() {
		let t;
		return {
			token: new e(function(e) {
				t = e;
			}),
			cancel: t
		};
	}
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/spread.js
function ha(e) {
	return function(t) {
		return e.apply(null, t);
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/isAxiosError.js
function ga(e) {
	return I.isObject(e) && e.isAxiosError === !0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/HttpStatusCode.js
var _a = {
	Continue: 100,
	SwitchingProtocols: 101,
	Processing: 102,
	EarlyHints: 103,
	Ok: 200,
	Created: 201,
	Accepted: 202,
	NonAuthoritativeInformation: 203,
	NoContent: 204,
	ResetContent: 205,
	PartialContent: 206,
	MultiStatus: 207,
	AlreadyReported: 208,
	ImUsed: 226,
	MultipleChoices: 300,
	MovedPermanently: 301,
	Found: 302,
	SeeOther: 303,
	NotModified: 304,
	UseProxy: 305,
	Unused: 306,
	TemporaryRedirect: 307,
	PermanentRedirect: 308,
	BadRequest: 400,
	Unauthorized: 401,
	PaymentRequired: 402,
	Forbidden: 403,
	NotFound: 404,
	MethodNotAllowed: 405,
	NotAcceptable: 406,
	ProxyAuthenticationRequired: 407,
	RequestTimeout: 408,
	Conflict: 409,
	Gone: 410,
	LengthRequired: 411,
	PreconditionFailed: 412,
	PayloadTooLarge: 413,
	ContentTooLarge: 413,
	UriTooLong: 414,
	UnsupportedMediaType: 415,
	RangeNotSatisfiable: 416,
	ExpectationFailed: 417,
	ImATeapot: 418,
	MisdirectedRequest: 421,
	UnprocessableEntity: 422,
	UnprocessableContent: 422,
	Locked: 423,
	FailedDependency: 424,
	TooEarly: 425,
	UpgradeRequired: 426,
	PreconditionRequired: 428,
	TooManyRequests: 429,
	RequestHeaderFieldsTooLarge: 431,
	UnavailableForLegalReasons: 451,
	InternalServerError: 500,
	NotImplemented: 501,
	BadGateway: 502,
	ServiceUnavailable: 503,
	GatewayTimeout: 504,
	HttpVersionNotSupported: 505,
	VariantAlsoNegotiates: 506,
	InsufficientStorage: 507,
	LoopDetected: 508,
	NotExtended: 510,
	NetworkAuthenticationRequired: 511,
	WebServerReturnsAnUnknownError: 520,
	WebServerIsDown: 521,
	ConnectionTimedOut: 522,
	OriginIsUnreachable: 523,
	TimeoutOccurred: 524,
	SslHandshakeFailed: 525,
	InvalidSslCertificate: 526
};
Object.entries(_a).forEach(([e, t]) => {
	_a[t] === void 0 && (_a[t] = e);
});
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/axios.js
function va(e) {
	let t = new pa(e), n = wt(pa.prototype.request, t);
	return I.extend(n, pa.prototype, t, { allOwnKeys: !0 }), I.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(t) {
		return va(Ci(e, t));
	}, n;
}
var R = va($r);
R.Axios = pa, R.CanceledError = ni, R.CancelToken = ma, R.isCancel = ti, R.VERSION = Wi, R.toFormData = wr, R.AxiosError = L, R.Cancel = R.CanceledError, R.all = function(e) {
	return Promise.all(e);
}, R.spread = ha, R.isAxiosError = ga, R.mergeConfig = Ci, R.AxiosHeaders = pr, R.formToJSON = (e) => Yr(I.isHTMLForm(e) ? new FormData(e) : e), R.getAdapter = aa.getAdapter, R.HttpStatusCode = _a, R.default = R;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/index.js
var { Axios: ya, AxiosError: ba, CanceledError: xa, isCancel: Sa, CancelToken: Ca, VERSION: wa, all: Ta, Cancel: Ea, isAxiosError: Da, spread: Oa, toFormData: ka, AxiosHeaders: Aa, HttpStatusCode: ja, formToJSON: Ma, getAdapter: Na, mergeConfig: Pa, create: Fa } = R, z = {
	articles: {
		path: "articles",
		hasTitlePropagation: !0
	},
	images: {
		path: "images",
		hasTitlePropagation: !0
	},
	videos: {
		path: "videos",
		hasTitlePropagation: !0
	},
	galleries: {
		path: "galleries",
		hasTitlePropagation: !0
	},
	staticPages: {
		path: "static-page",
		hasTitlePropagation: !0
	},
	articleList: {
		path: "article-list",
		hasTitlePropagation: !0
	},
	channels: {
		path: "channels",
		hasTitlePropagation: !0
	},
	assembler: {
		path: "assembler",
		hasTitlePropagation: !1
	},
	catTool: {
		path: "cat-tool",
		hasTitlePropagation: !1
	},
	pushes: {
		path: "article-push",
		hasTitlePropagation: !1
	},
	kim: {
		path: "kim",
		hasTitlePropagation: !1
	},
	videoPages: {
		path: "video-page",
		hasTitlePropagation: !0
	},
	abHeadlineTest: {
		path: "ab-headline-test",
		hasTitlePropagation: !0
	}
}, Ia = /* @__PURE__ */ Ct((/* @__PURE__ */ bt(((e, t) => {
	var n = function(e) {
		return r(e) && !i(e);
	};
	function r(e) {
		return !!e && typeof e == "object";
	}
	function i(e) {
		var t = Object.prototype.toString.call(e);
		return t === "[object RegExp]" || t === "[object Date]" || o(e);
	}
	var a = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.element") : 60103;
	function o(e) {
		return e.$$typeof === a;
	}
	function s(e) {
		return Array.isArray(e) ? [] : {};
	}
	function c(e, t) {
		return t.clone !== !1 && t.isMergeableObject(e) ? g(s(e), e, t) : e;
	}
	function l(e, t, n) {
		return e.concat(t).map(function(e) {
			return c(e, n);
		});
	}
	function u(e, t) {
		if (!t.customMerge) return g;
		var n = t.customMerge(e);
		return typeof n == "function" ? n : g;
	}
	function d(e) {
		return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
			return e.propertyIsEnumerable(t);
		}) : [];
	}
	function f(e) {
		return Object.keys(e).concat(d(e));
	}
	function p(e, t) {
		try {
			return t in e;
		} catch {
			return !1;
		}
	}
	function m(e, t) {
		return p(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
	}
	function h(e, t, n) {
		var r = {};
		return n.isMergeableObject(e) && f(e).forEach(function(t) {
			r[t] = c(e[t], n);
		}), f(t).forEach(function(i) {
			m(e, i) || (p(e, i) && n.isMergeableObject(t[i]) ? r[i] = u(i, n)(e[i], t[i], n) : r[i] = c(t[i], n));
		}), r;
	}
	function g(e, t, r) {
		r ||= {}, r.arrayMerge = r.arrayMerge || l, r.isMergeableObject = r.isMergeableObject || n, r.cloneUnlessOtherwiseSpecified = c;
		var i = Array.isArray(t);
		return i === Array.isArray(e) ? i ? r.arrayMerge(e, t, r) : h(e, t, r) : c(t, r);
	}
	g.all = function(e, t) {
		if (!Array.isArray(e)) throw Error("first argument should be an array");
		return e.reduce(function(e, n) {
			return g(e, n, t);
		}, {});
	}, t.exports = g;
})))(), 1), La = () => {
	let e = navigator.language;
	return /^en\b/.test(e) ? "en" : "de";
}, Ra = window.innerWidth > 960, za = "cms_language", Ba = "cms_color_scheme", Va = () => {
	let e = localStorage.getItem(Ba);
	return e === "light" || e === "dark" || e === "system" ? e : "light";
}, Ha = 257, Ua = 56, Wa = () => {
	let e = localStorage.getItem(za);
	return e === "en" || e === "de" || e === "it" ? e : La();
};
function Ga() {
	return [];
}
var Ka = Be({
	sidebarNavigationWidth: 257,
	sidebarNavigationOpen: JSON.parse(localStorage.getItem("sidebarNavigationOpen") || JSON.stringify(Ra)),
	language: Wa(),
	colorScheme: Va(),
	internalLinks: Ga(),
	toggleSidebarNavigation() {
		this.sidebarNavigationOpen = !this.sidebarNavigationOpen;
	},
	setLanguage(e) {
		this.language = e, localStorage.setItem(za, e);
	},
	setColorScheme(e) {
		this.colorScheme = e, localStorage.setItem(Ba, e);
	}
});
Je(() => Ka.sidebarNavigationOpen, (e) => {
	localStorage.setItem("sidebarNavigationOpen", JSON.stringify(e)), Ka.sidebarNavigationWidth = Ka.sidebarNavigationOpen ? 257 : 56;
}, { immediate: !0 });
var qa = () => Ka, Ja = {
	messages: {
		copyErrorToClipboard: "Details in die Zwischenablage kopieren",
		copiedToClipboard: "In die Zwischenablage kopiert"
	},
	changesWatch: { dialog: {
		title: "Es gibt ungespeicherte Änderungen.",
		text: "Willst du wirklich alle Änderungen verwerfen und die Seite verlassen?",
		inspect: "Untersuchen",
		downloadInitial: "Anfangswert herunterladen",
		downloadCurrent: "Aktuellen Wert herunterladen",
		stay: "Nein, bleiben",
		leave: "Ja, verwerfen"
	} },
	common: {
		error: "Unbekannter Fehler",
		close: "Schließen",
		scheduleBannerText: "Geplante Änderungen dieses Artikels sind vorgesehen für",
		doneBy: "Durchgeführt von",
		removeChange: "Änderung entfernen",
		editChange: "Änderung bearbeiten",
		yes: "Ja",
		no: "Nein",
		all: "Alle"
	},
	scheduledChanges: {
		remove: {
			changesTitle: "Geplante Änderung entfernen",
			changesText: "Willst du die geplanten Änderungen wirklich entfernen?"
		},
		edit: {
			changesTitle: "Geplante Änderung",
			changesText: {
				articleScheduledOn: "Dieser Artikel enthält geplante Änderungen, geplant für",
				warningScheduledChangesPresent: "Alle Änderungen, die jetzt vorgenommen werden, überschreiben die geplanten Änderungen.",
				questionScheduledChangesWillBeOverwritten: "Willst du die geplanten Änderungen wirklich bearbeiten?",
				editingBannerInfo: "Du bearbeitest eine Änderung, die geplant ist für"
			}
		}
	},
	entityState: {
		status: "Status",
		dpAll: "Alle",
		dpDraft: "Entwurf",
		dpSchedule: "Geplant",
		dpPublished: "Veröffentlicht",
		dpExpired: "Depubliziert",
		dpRescheduled: "Änderungen geplant"
	},
	login: { newUserNotification: "Willkommen im Vibe-Editor. Du hast derzeit nur das Recht zur Ansicht, nicht zum Schreiben. Schau dich um, du kannst nichts kaputt machen." },
	pathSelector: {
		pathAutogenerate: "Pfad automatisch generieren",
		pathAutoselect: "Wird automatisch ausgefüllt",
		pathCopiedToClipboard: "Pfad in die Zwischenablage kopiert",
		pathInvalid: "Ungültiger Pfad",
		pathInputLabel: "Pfad"
	},
	cmsSelector: {
		label: "Ursprungs-CMS",
		hint: "CMS, in dem der Artikel erstellt wurde",
		dpAll: "Alle"
	},
	legacySelector: {
		hint: "CMS, in dem der Inhalt ursprünglich erstellt wurde",
		dpAll: "Alle",
		yes: "Ja",
		no: "Nein"
	},
	noEditTooltip: { label: "Dieser {{record}} stammt ursprünglich aus dem {{source}}-Editor" },
	dateTimeSelector: { nowLabel: "Auf jetzt einstellen" },
	aiFieldAssist: {
		fieldFallback: "Text",
		buttonTooltip: "Mit KI verbessern",
		original: "Original",
		result: "Ergebnis",
		resultPlaceholder: "Das generierte Ergebnis erscheint hier.",
		loading: "Wird generiert…",
		promptLabel: "Prompt",
		generate: "Generieren",
		regenerate: "Neu generieren",
		accept: "Übernehmen",
		cancel: "Abbrechen",
		error: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
		showChanges: "Änderungen anzeigen",
		useContext: "Artikelinhalt zusätzlich als Kontext verwenden",
		useContextHint: "Der Artikelinhalt dient nur als zusätzlicher Kontext für ein besseres Ergebnis – er wird nicht verändert.",
		actions: {
			basic: "Verbessern",
			correct: "Rechtschreibung",
			seo: "SEO"
		},
		actionHints: {
			basic: "Verbessert Wortwahl und Lesbarkeit, ohne die Bedeutung zu verändern.",
			correct: "Korrigiert nur Rechtschreibung, Grammatik und Zeichensetzung – Bedeutung und Stil bleiben gleich.",
			seo: "Optimiert den Text für Suchmaschinen und hält ihn dabei natürlich und lesbar."
		},
		formatChanged: "Formatierung geändert: {marks}",
		diffTooLarge: "Text zu lang, um Änderungen anzuzeigen",
		marks: {
			bold: "Fett",
			italic: "Kursiv",
			link: "Link",
			heading: "Überschrift"
		}
	},
	[z.articles.path]: {
		routeTitle: "Artikel",
		routeTitleDetail: "A: "
	},
	[z.images.path]: {
		routeTitle: "Bilder",
		routeTitleDetail: "B: "
	},
	[z.videos.path]: {
		routeTitle: "Videos",
		routeTitleDetail: "V: "
	},
	[z.galleries.path]: {
		routeTitle: "Galerien",
		routeTitleDetail: "G: "
	},
	[z.channels.path]: {
		routeTitle: "Channels",
		routeTitleDetail: "C: "
	},
	[z.staticPages.path]: {
		routeTitle: "Statische Seiten",
		routeTitleDetail: "S: "
	},
	[z.articleList.path]: {
		routeTitle: "Listen",
		routeTitleDetail: "L: "
	},
	[z.assembler.path]: {
		routeTitle: "Partner-Content",
		routeTitleDetail: "P: "
	},
	[z.catTool.path]: {
		routeTitle: "Cat-Tool",
		routeTitleDetail: "C: "
	},
	[z.abHeadlineTest.path]: {
		routeTitle: "A/B-Headline-Test",
		routeTitleDetail: "AB: "
	},
	[z.pushes.path]: {
		routeTitle: "Pushes",
		routeTitleDetail: "P: "
	},
	[z.kim.path]: {
		routeTitle: "Kim",
		routeTitleDetail: "K: "
	}
}, Ya = {
	messages: {
		copyErrorToClipboard: "Copy details to clipboard",
		copiedToClipboard: "Copied to clipboard"
	},
	changesWatch: { dialog: {
		title: "There are unsaved changes.",
		text: "Are you sure you want to discard all changes and leave the page?",
		inspect: "Inspect",
		downloadInitial: "Download initial value",
		downloadCurrent: "Download current value",
		stay: "No, stay",
		leave: "Yes, discard"
	} },
	common: {
		error: "Unknown error",
		close: "Close",
		scheduleBannerText: "Scheduled updates to this article are set for",
		doneBy: "Done by",
		removeChange: "Remove change",
		editChange: "Edit change",
		yes: "Yes",
		no: "No",
		all: "All"
	},
	scheduledChanges: {
		remove: {
			changesTitle: "Remove scheduled change",
			changesText: "Are you sure you want to discard the scheduled changes?"
		},
		edit: {
			changesTitle: "Scheduled change",
			changesText: {
				articleScheduledOn: "This article has changes scheduled for",
				warningScheduledChangesPresent: "Any changes you make now will overwrite the changes scheduled for that time.",
				questionScheduledChangesWillBeOverwritten: "Are you sure you want to edit the scheduled changes?",
				editingBannerInfo: "You are editing the change that was scheduled for"
			}
		}
	},
	entityState: {
		status: "Status",
		dpAll: "All",
		dpDraft: "Draft",
		dpSchedule: "Scheduled",
		dpPublished: "Published",
		dpExpired: "Unpublished",
		dpRescheduled: "Rescheduled"
	},
	login: { newUserNotification: "Welcome to the Vibe editor. You have view-only access. Feel free to look around without worrying about breaking anything." },
	pathSelector: {
		pathAutogenerate: "Automatically generate path",
		pathAutoselect: "Will be filled automatically",
		pathCopiedToClipboard: "Path copied to clipboard",
		pathInvalid: "Invalid path",
		pathInputLabel: "Path"
	},
	cmsSelector: {
		label: "CMS of origin",
		hint: "CMS in which article was created",
		dpAll: "All"
	},
	legacySelector: {
		hint: "Original CMS the content was created in",
		dpAll: "All",
		yes: "Yes",
		no: "No"
	},
	noEditTooltip: { label: "This {{record}} is originally from the {{source}} editor" },
	dateTimeSelector: { nowLabel: "Set to now" },
	aiFieldAssist: {
		fieldFallback: "Text",
		buttonTooltip: "Improve with AI",
		original: "Original",
		result: "Result",
		resultPlaceholder: "The generated result will appear here.",
		loading: "Generating…",
		promptLabel: "Prompt",
		generate: "Generate",
		regenerate: "Regenerate",
		accept: "Accept",
		cancel: "Cancel",
		error: "Something went wrong. Please try again.",
		showChanges: "Show changes",
		useContext: "Use article content as background",
		useContextHint: "The article text is used only as background information to inform the result — it is not returned.",
		actions: {
			basic: "Improve",
			correct: "Spell check",
			seo: "SEO"
		},
		actionHints: {
			basic: "Improves wording and readability while keeping the original meaning.",
			correct: "Fixes spelling, grammar and punctuation only — meaning and style stay the same.",
			seo: "Optimizes the text for search engines while keeping it natural and readable."
		},
		formatChanged: "Formatting changed: {marks}",
		diffTooLarge: "Text too long to show changes",
		marks: {
			bold: "bold",
			italic: "italic",
			link: "link",
			heading: "heading"
		}
	},
	[z.articles.path]: {
		routeTitle: "Articles",
		routeTitleDetail: "A: "
	},
	[z.images.path]: {
		routeTitle: "Images",
		routeTitleDetail: "I: "
	},
	[z.videos.path]: {
		routeTitle: "Videos",
		routeTitleDetail: "V: "
	},
	[z.galleries.path]: {
		routeTitle: "Galleries",
		routeTitleDetail: "G: "
	},
	[z.channels.path]: {
		routeTitle: "Channels",
		routeTitleDetail: "C: "
	},
	[z.staticPages.path]: {
		routeTitle: "Static Pages",
		routeTitleDetail: "S: "
	},
	[z.articleList.path]: {
		routeTitle: "Lists",
		routeTitleDetail: "L: "
	},
	[z.assembler.path]: {
		routeTitle: "Partner content",
		routeTitleDetail: "P: "
	},
	[z.catTool.path]: {
		routeTitle: "CAT tool",
		routeTitleDetail: "C: "
	},
	[z.abHeadlineTest.path]: {
		routeTitle: "A/B headline test",
		routeTitleDetail: "AB: "
	},
	[z.pushes.path]: {
		routeTitle: "Pushes",
		routeTitleDetail: "P: "
	},
	[z.kim.path]: {
		routeTitle: "Kim",
		routeTitleDetail: "K: "
	},
	[z.videoPages.path]: {
		routeTitle: "Video pages",
		routeTitleDetail: "VP: "
	}
}, Xa = {
	en: tt,
	de: et,
	it: nt
}, Za = qa(), Qa = () => Xa[Za.language], $a = (e) => rt({
	locale: Za.language,
	legacy: !1,
	fallbackLocale: Qe,
	messages: (0, Ia.default)({
		de: Ja,
		en: Ya,
		it: {}
	}, (0, Ia.default)($e, e))
}), eo, to = (e) => (eo = $a(e), eo), B = () => {
	if (!eo) throw Error("I18n is not initialized yet!");
	return eo.global;
};
Je(Za, (e) => {
	eo && (eo.global.locale.value = e.language);
});
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/rng.js
var no, ro = new Uint8Array(16);
function io() {
	if (!no && (no = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !no)) throw Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
	return no(ro);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/stringify.js
var ao = [];
for (let e = 0; e < 256; ++e) ao.push((e + 256).toString(16).slice(1));
function oo(e, t = 0) {
	return ao[e[t + 0]] + ao[e[t + 1]] + ao[e[t + 2]] + ao[e[t + 3]] + "-" + ao[e[t + 4]] + ao[e[t + 5]] + "-" + ao[e[t + 6]] + ao[e[t + 7]] + "-" + ao[e[t + 8]] + ao[e[t + 9]] + "-" + ao[e[t + 10]] + ao[e[t + 11]] + ao[e[t + 12]] + ao[e[t + 13]] + ao[e[t + 14]] + ao[e[t + 15]];
}
var so = { randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto) };
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/v4.js
function co(e, t, n) {
	if (so.randomUUID && !t && !e) return so.randomUUID();
	e ||= {};
	let r = e.random || (e.rng || io)();
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		n ||= 0;
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return oo(r);
}
//#endregion
//#region src/stores/notification.store.ts
var lo = class e {
	static DEFAULT_TIMEOUT = 1e4;
	static NO_TIMEOUT = 0;
	message;
	timestamp;
	severity;
	dismissible;
	callbackFunc;
	callbackLabel;
	callbackDataQa;
	callbackNoDismiss;
	callbackHref;
	callbackTarget;
	multiLine;
	timeout;
	progress;
	position;
	html;
	color;
	badgeStyle;
	onDismiss;
	id;
	constructor(t = B().t("common.error"), n = "negative", r) {
		let i = {
			dismissible: !0,
			callbackFunc: void 0,
			callbackLabel: "Action",
			callbackNoDismiss: !1,
			timeout: e.DEFAULT_TIMEOUT,
			progress: !0,
			position: "top",
			multiLine: !1,
			html: !1,
			badgeStyle: void 0,
			color: n,
			id: co(),
			...r
		};
		this.message = t, this.timestamp = Date.now(), this.severity = n, this.dismissible = i.dismissible, this.callbackFunc = i.callbackFunc, this.callbackLabel = i.callbackLabel, this.callbackDataQa = i.callbackDataQa, this.callbackNoDismiss = i.callbackNoDismiss, this.callbackHref = i.callbackHref, this.callbackTarget = i.callbackTarget, this.timeout = e._resolveTimeoutSettings(i.timeout), this.progress = i.progress, this.position = i.position, this.multiLine = i.multiLine, this.html = i.html, this.color = i.color, this.badgeStyle = i.badgeStyle, this.onDismiss = i.onDismiss, this.id = i.id || co();
	}
	static _resolveTimeoutSettings(t) {
		return t === null ? e.NO_TIMEOUT : t === void 0 ? e.DEFAULT_TIMEOUT : t;
	}
};
function uo(e = null) {
	return e;
}
function fo(e) {
	return e;
}
var po = Be({
	notifications: /* @__PURE__ */ new Map(),
	latestNotification: uo(),
	notify: fo(),
	clearAndShowNotification(e) {
		this.clearNotification(), this.showNotification(e);
	},
	showNotification(e) {
		let t = {
			label: e.callbackLabel,
			handler: e.callbackFunc,
			noDismiss: e.callbackNoDismiss,
			"data-qa-notification-action": e.callbackDataQa || "",
			...e.callbackHref ? {
				href: e.callbackHref,
				target: e.callbackTarget,
				rel: "noopener"
			} : {}
		}, n = [];
		if ((e.callbackFunc || e.callbackHref) && n.push(t), e.dismissible) {
			let e = {
				label: B().t("common.close"),
				"data-qa-notification-close": ""
			};
			n.push(e);
		}
		let i = {
			message: e.message,
			timeout: e?.timeout ?? lo.DEFAULT_TIMEOUT,
			type: e?.severity,
			classes: e?.severity,
			closeBtn: !1,
			progress: e?.progress,
			position: e?.position,
			multiLine: e.multiLine,
			html: e.html,
			badgeStyle: e.badgeStyle,
			color: e?.color,
			onDismiss: e.onDismiss,
			actions: n
		}, a = r.create(i);
		return this.notifications.has(e.id) || this.notifications.set(e.id, []), this.notifications.get(e.id)?.push(a), this.latestNotification = e, a;
	},
	clearNotification() {
		for (let [e, t] of this.notifications) t.forEach((e) => e());
		this.notifications.clear(), this.latestNotification = null;
	},
	isNotificationVisible(e) {
		return this.notifications.has(e);
	},
	hideNotification(e) {
		let t = this.notifications.get(e);
		if (!t) {
			console.error(`Attempted to hide notification with id ${e} that does not exist in notification store`);
			return;
		}
		t.forEach((e) => e()), this.notifications.delete(e);
	}
});
po.clearNotification = po.clearNotification.bind(po), po.showNotification = po.showNotification.bind(po), po.clearAndShowNotification = po.clearAndShowNotification.bind(po), po.hideNotification = po.hideNotification.bind(po), po.isNotificationVisible = po.isNotificationVisible.bind(po);
var mo = () => po;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/toInteger/index.js
function V(e) {
	if (e === null || e === !0 || e === !1) return NaN;
	var t = Number(e);
	return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/requiredArgs/index.js
function H(e, t) {
	if (t.length < e) throw TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/toDate/index.js
function ho(e) {
	H(1, arguments);
	var t = Object.prototype.toString.call(e);
	return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn((/* @__PURE__ */ Error()).stack)), /* @__PURE__ */ new Date(NaN));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/addMilliseconds/index.js
function go(e, t) {
	H(2, arguments);
	var n = ho(e).getTime(), r = V(t);
	return new Date(n + r);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
function _o(e) {
	var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
	return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/startOfDay/index.js
function vo(e) {
	H(1, arguments);
	var t = ho(e);
	return t.setHours(0, 0, 0, 0), t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/isDate/index.js
function yo(e) {
	return H(1, arguments), e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/isValid/index.js
function bo(e) {
	if (H(1, arguments), !yo(e) && typeof e != "number") return !1;
	var t = ho(e);
	return !isNaN(Number(t));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/endOfDay/index.js
function xo(e) {
	H(1, arguments);
	var t = ho(e);
	return t.setHours(23, 59, 59, 999), t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var So = {
	lessThanXSeconds: {
		one: "less than a second",
		other: "less than {{count}} seconds"
	},
	xSeconds: {
		one: "1 second",
		other: "{{count}} seconds"
	},
	halfAMinute: "half a minute",
	lessThanXMinutes: {
		one: "less than a minute",
		other: "less than {{count}} minutes"
	},
	xMinutes: {
		one: "1 minute",
		other: "{{count}} minutes"
	},
	aboutXHours: {
		one: "about 1 hour",
		other: "about {{count}} hours"
	},
	xHours: {
		one: "1 hour",
		other: "{{count}} hours"
	},
	xDays: {
		one: "1 day",
		other: "{{count}} days"
	},
	aboutXWeeks: {
		one: "about 1 week",
		other: "about {{count}} weeks"
	},
	xWeeks: {
		one: "1 week",
		other: "{{count}} weeks"
	},
	aboutXMonths: {
		one: "about 1 month",
		other: "about {{count}} months"
	},
	xMonths: {
		one: "1 month",
		other: "{{count}} months"
	},
	aboutXYears: {
		one: "about 1 year",
		other: "about {{count}} years"
	},
	xYears: {
		one: "1 year",
		other: "{{count}} years"
	},
	overXYears: {
		one: "over 1 year",
		other: "over {{count}} years"
	},
	almostXYears: {
		one: "almost 1 year",
		other: "almost {{count}} years"
	}
}, Co = function(e, t, n) {
	var r, i = So[e];
	return r = typeof i == "string" ? i : t === 1 ? i.one : i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function wo(e) {
	return function() {
		var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth;
		return e.formats[n] || e.formats[e.defaultWidth];
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js
var To = {
	date: wo({
		formats: {
			full: "EEEE, MMMM do, y",
			long: "MMMM do, y",
			medium: "MMM d, y",
			short: "MM/dd/yyyy"
		},
		defaultWidth: "full"
	}),
	time: wo({
		formats: {
			full: "h:mm:ss a zzzz",
			long: "h:mm:ss a z",
			medium: "h:mm:ss a",
			short: "h:mm a"
		},
		defaultWidth: "full"
	}),
	dateTime: wo({
		formats: {
			full: "{{date}} 'at' {{time}}",
			long: "{{date}} 'at' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
}, Eo = {
	lastWeek: "'last' eeee 'at' p",
	yesterday: "'yesterday at' p",
	today: "'today at' p",
	tomorrow: "'tomorrow at' p",
	nextWeek: "eeee 'at' p",
	other: "P"
}, Do = function(e, t, n, r) {
	return Eo[e];
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function Oo(e) {
	return function(t, n) {
		var r = n || {}, i = r.context ? String(r.context) : "standalone", a;
		if (i === "formatting" && e.formattingValues) {
			var o = e.defaultFormattingWidth || e.defaultWidth, s = r.width ? String(r.width) : o;
			a = e.formattingValues[s] || e.formattingValues[o];
		} else {
			var c = e.defaultWidth, l = r.width ? String(r.width) : e.defaultWidth;
			a = e.values[l] || e.values[c];
		}
		var u = e.argumentCallback ? e.argumentCallback(t) : t;
		return a[u];
	};
}
var ko = {
	ordinalNumber: function(e, t) {
		var n = Number(e), r = n % 100;
		if (r > 20 || r < 10) switch (r % 10) {
			case 1: return n + "st";
			case 2: return n + "nd";
			case 3: return n + "rd";
		}
		return n + "th";
	},
	era: Oo({
		values: {
			narrow: ["B", "A"],
			abbreviated: ["BC", "AD"],
			wide: ["Before Christ", "Anno Domini"]
		},
		defaultWidth: "wide"
	}),
	quarter: Oo({
		values: {
			narrow: [
				"1",
				"2",
				"3",
				"4"
			],
			abbreviated: [
				"Q1",
				"Q2",
				"Q3",
				"Q4"
			],
			wide: [
				"1st quarter",
				"2nd quarter",
				"3rd quarter",
				"4th quarter"
			]
		},
		defaultWidth: "wide",
		argumentCallback: function(e) {
			return e - 1;
		}
	}),
	month: Oo({
		values: {
			narrow: [
				"J",
				"F",
				"M",
				"A",
				"M",
				"J",
				"J",
				"A",
				"S",
				"O",
				"N",
				"D"
			],
			abbreviated: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec"
			],
			wide: [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December"
			]
		},
		defaultWidth: "wide"
	}),
	day: Oo({
		values: {
			narrow: [
				"S",
				"M",
				"T",
				"W",
				"T",
				"F",
				"S"
			],
			short: [
				"Su",
				"Mo",
				"Tu",
				"We",
				"Th",
				"Fr",
				"Sa"
			],
			abbreviated: [
				"Sun",
				"Mon",
				"Tue",
				"Wed",
				"Thu",
				"Fri",
				"Sat"
			],
			wide: [
				"Sunday",
				"Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			]
		},
		defaultWidth: "wide"
	}),
	dayPeriod: Oo({
		values: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			}
		},
		defaultWidth: "wide",
		formattingValues: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			}
		},
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function Ao(e) {
	return function(t) {
		var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
		if (!a) return null;
		var o = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? Mo(s, function(e) {
			return e.test(o);
		}) : jo(s, function(e) {
			return e.test(o);
		}), l = e.valueCallback ? e.valueCallback(c) : c;
		l = n.valueCallback ? n.valueCallback(l) : l;
		var u = t.slice(o.length);
		return {
			value: l,
			rest: u
		};
	};
}
function jo(e, t) {
	for (var n in e) if (e.hasOwnProperty(n) && t(e[n])) return n;
}
function Mo(e, t) {
	for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function No(e) {
	return function(t) {
		var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
		if (!r) return null;
		var i = r[0], a = t.match(e.parsePattern);
		if (!a) return null;
		var o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
		o = n.valueCallback ? n.valueCallback(o) : o;
		var s = t.slice(i.length);
		return {
			value: o,
			rest: s
		};
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/en-US/index.js
var Po = {
	code: "en-US",
	formatDistance: Co,
	formatLong: To,
	formatRelative: Do,
	localize: ko,
	match: {
		ordinalNumber: No({
			matchPattern: /^(\d+)(th|st|nd|rd)?/i,
			parsePattern: /\d+/i,
			valueCallback: function(e) {
				return parseInt(e, 10);
			}
		}),
		era: Ao({
			matchPatterns: {
				narrow: /^(b|a)/i,
				abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
				wide: /^(before christ|before common era|anno domini|common era)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^b/i, /^(a|c)/i] },
			defaultParseWidth: "any"
		}),
		quarter: Ao({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](th|st|nd|rd)? quarter/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: function(e) {
				return e + 1;
			}
		}),
		month: Ao({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
				wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^may/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: Ao({
			matchPatterns: {
				narrow: /^[smtwf]/i,
				short: /^(su|mo|tu|we|th|fr|sa)/i,
				abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
				wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^s/i,
					/^m/i,
					/^t/i,
					/^w/i,
					/^t/i,
					/^f/i,
					/^s/i
				],
				any: [
					/^su/i,
					/^m/i,
					/^tu/i,
					/^w/i,
					/^th/i,
					/^f/i,
					/^sa/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: Ao({
			matchPatterns: {
				narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
				any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mi/i,
				noon: /^no/i,
				morning: /morning/i,
				afternoon: /afternoon/i,
				evening: /evening/i,
				night: /night/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 0,
		firstWeekContainsDate: 1
	}
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/subMilliseconds/index.js
function Fo(e, t) {
	return H(2, arguments), go(e, -V(t));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function U(e, t) {
	for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t;) r = "0" + r;
	return n + r;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/format/lightFormatters/index.js
var Io = {
	y: function(e, t) {
		var n = e.getUTCFullYear(), r = n > 0 ? n : 1 - n;
		return U(t === "yy" ? r % 100 : r, t.length);
	},
	M: function(e, t) {
		var n = e.getUTCMonth();
		return t === "M" ? String(n + 1) : U(n + 1, 2);
	},
	d: function(e, t) {
		return U(e.getUTCDate(), t.length);
	},
	a: function(e, t) {
		var n = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.toUpperCase();
			case "aaa": return n;
			case "aaaaa": return n[0];
			default: return n === "am" ? "a.m." : "p.m.";
		}
	},
	h: function(e, t) {
		return U(e.getUTCHours() % 12 || 12, t.length);
	},
	H: function(e, t) {
		return U(e.getUTCHours(), t.length);
	},
	m: function(e, t) {
		return U(e.getUTCMinutes(), t.length);
	},
	s: function(e, t) {
		return U(e.getUTCSeconds(), t.length);
	},
	S: function(e, t) {
		var n = t.length, r = e.getUTCMilliseconds();
		return U(Math.floor(r * 10 ** (n - 3)), t.length);
	}
}, Lo = 864e5;
function Ro(e) {
	H(1, arguments);
	var t = ho(e), n = t.getTime();
	t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
	var r = n - t.getTime();
	return Math.floor(r / Lo) + 1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
function zo(e) {
	H(1, arguments);
	var t = 1, n = ho(e), r = n.getUTCDay(), i = (r < t ? 7 : 0) + r - t;
	return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
function Bo(e) {
	H(1, arguments);
	var t = ho(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
	r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
	var i = zo(r), a = /* @__PURE__ */ new Date(0);
	a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
	var o = zo(a);
	return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js
function Vo(e) {
	H(1, arguments);
	var t = Bo(e), n = /* @__PURE__ */ new Date(0);
	return n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0), zo(n);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js
var Ho = 6048e5;
function Uo(e) {
	H(1, arguments);
	var t = ho(e), n = zo(t).getTime() - Vo(t).getTime();
	return Math.round(n / Ho) + 1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
function Wo(e, t) {
	H(1, arguments);
	var n = t || {}, r = n.locale, i = r && r.options && r.options.weekStartsOn, a = i == null ? 0 : V(i), o = n.weekStartsOn == null ? a : V(n.weekStartsOn);
	if (!(o >= 0 && o <= 6)) throw RangeError("weekStartsOn must be between 0 and 6 inclusively");
	var s = ho(e), c = s.getUTCDay(), l = (c < o ? 7 : 0) + c - o;
	return s.setUTCDate(s.getUTCDate() - l), s.setUTCHours(0, 0, 0, 0), s;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
function Go(e, t) {
	H(1, arguments);
	var n = ho(e, t), r = n.getUTCFullYear(), i = t || {}, a = i.locale, o = a && a.options && a.options.firstWeekContainsDate, s = o == null ? 1 : V(o), c = i.firstWeekContainsDate == null ? s : V(i.firstWeekContainsDate);
	if (!(c >= 1 && c <= 7)) throw RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
	var l = /* @__PURE__ */ new Date(0);
	l.setUTCFullYear(r + 1, 0, c), l.setUTCHours(0, 0, 0, 0);
	var u = Wo(l, t), d = /* @__PURE__ */ new Date(0);
	d.setUTCFullYear(r, 0, c), d.setUTCHours(0, 0, 0, 0);
	var f = Wo(d, t);
	return n.getTime() >= u.getTime() ? r + 1 : n.getTime() >= f.getTime() ? r : r - 1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js
function Ko(e, t) {
	H(1, arguments);
	var n = t || {}, r = n.locale, i = r && r.options && r.options.firstWeekContainsDate, a = i == null ? 1 : V(i), o = n.firstWeekContainsDate == null ? a : V(n.firstWeekContainsDate), s = Go(e, t), c = /* @__PURE__ */ new Date(0);
	return c.setUTCFullYear(s, 0, o), c.setUTCHours(0, 0, 0, 0), Wo(c, t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/getUTCWeek/index.js
var qo = 6048e5;
function Jo(e, t) {
	H(1, arguments);
	var n = ho(e), r = Wo(n, t).getTime() - Ko(n, t).getTime();
	return Math.round(r / qo) + 1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/format/formatters/index.js
var Yo = {
	am: "am",
	pm: "pm",
	midnight: "midnight",
	noon: "noon",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
}, Xo = {
	G: function(e, t, n) {
		var r = +(e.getUTCFullYear() > 0);
		switch (t) {
			case "G":
			case "GG":
			case "GGG": return n.era(r, { width: "abbreviated" });
			case "GGGGG": return n.era(r, { width: "narrow" });
			default: return n.era(r, { width: "wide" });
		}
	},
	y: function(e, t, n) {
		if (t === "yo") {
			var r = e.getUTCFullYear(), i = r > 0 ? r : 1 - r;
			return n.ordinalNumber(i, { unit: "year" });
		}
		return Io.y(e, t);
	},
	Y: function(e, t, n, r) {
		var i = Go(e, r), a = i > 0 ? i : 1 - i;
		return t === "YY" ? U(a % 100, 2) : t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : U(a, t.length);
	},
	R: function(e, t) {
		return U(Bo(e), t.length);
	},
	u: function(e, t) {
		return U(e.getUTCFullYear(), t.length);
	},
	Q: function(e, t, n) {
		var r = Math.ceil((e.getUTCMonth() + 1) / 3);
		switch (t) {
			case "Q": return String(r);
			case "QQ": return U(r, 2);
			case "Qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "QQQ": return n.quarter(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "QQQQQ": return n.quarter(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	q: function(e, t, n) {
		var r = Math.ceil((e.getUTCMonth() + 1) / 3);
		switch (t) {
			case "q": return String(r);
			case "qq": return U(r, 2);
			case "qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "qqq": return n.quarter(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "qqqqq": return n.quarter(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	M: function(e, t, n) {
		var r = e.getUTCMonth();
		switch (t) {
			case "M":
			case "MM": return Io.M(e, t);
			case "Mo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "MMM": return n.month(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "MMMMM": return n.month(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.month(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	L: function(e, t, n) {
		var r = e.getUTCMonth();
		switch (t) {
			case "L": return String(r + 1);
			case "LL": return U(r + 1, 2);
			case "Lo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "LLL": return n.month(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "LLLLL": return n.month(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.month(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	w: function(e, t, n, r) {
		var i = Jo(e, r);
		return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : U(i, t.length);
	},
	I: function(e, t, n) {
		var r = Uo(e);
		return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : U(r, t.length);
	},
	d: function(e, t, n) {
		return t === "do" ? n.ordinalNumber(e.getUTCDate(), { unit: "date" }) : Io.d(e, t);
	},
	D: function(e, t, n) {
		var r = Ro(e);
		return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : U(r, t.length);
	},
	E: function(e, t, n) {
		var r = e.getUTCDay();
		switch (t) {
			case "E":
			case "EE":
			case "EEE": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "EEEEE": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEEE": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	e: function(e, t, n, r) {
		var i = e.getUTCDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "e": return String(a);
			case "ee": return U(a, 2);
			case "eo": return n.ordinalNumber(a, { unit: "day" });
			case "eee": return n.day(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "eeeee": return n.day(i, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeeee": return n.day(i, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	c: function(e, t, n, r) {
		var i = e.getUTCDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "c": return String(a);
			case "cc": return U(a, t.length);
			case "co": return n.ordinalNumber(a, { unit: "day" });
			case "ccc": return n.day(i, {
				width: "abbreviated",
				context: "standalone"
			});
			case "ccccc": return n.day(i, {
				width: "narrow",
				context: "standalone"
			});
			case "cccccc": return n.day(i, {
				width: "short",
				context: "standalone"
			});
			default: return n.day(i, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	i: function(e, t, n) {
		var r = e.getUTCDay(), i = r === 0 ? 7 : r;
		switch (t) {
			case "i": return String(i);
			case "ii": return U(i, t.length);
			case "io": return n.ordinalNumber(i, { unit: "day" });
			case "iii": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "iiiii": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "iiiiii": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	a: function(e, t, n) {
		var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "aaa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "aaaaa": return n.dayPeriod(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	b: function(e, t, n) {
		var r = e.getUTCHours(), i = r === 12 ? Yo.noon : r === 0 ? Yo.midnight : r / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "b":
			case "bb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "bbb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "bbbbb": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	B: function(e, t, n) {
		var r = e.getUTCHours(), i = r >= 17 ? Yo.evening : r >= 12 ? Yo.afternoon : r >= 4 ? Yo.morning : Yo.night;
		switch (t) {
			case "B":
			case "BB":
			case "BBB": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "BBBBB": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	h: function(e, t, n) {
		if (t === "ho") {
			var r = e.getUTCHours() % 12;
			return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
		}
		return Io.h(e, t);
	},
	H: function(e, t, n) {
		return t === "Ho" ? n.ordinalNumber(e.getUTCHours(), { unit: "hour" }) : Io.H(e, t);
	},
	K: function(e, t, n) {
		var r = e.getUTCHours() % 12;
		return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : U(r, t.length);
	},
	k: function(e, t, n) {
		var r = e.getUTCHours();
		return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : U(r, t.length);
	},
	m: function(e, t, n) {
		return t === "mo" ? n.ordinalNumber(e.getUTCMinutes(), { unit: "minute" }) : Io.m(e, t);
	},
	s: function(e, t, n) {
		return t === "so" ? n.ordinalNumber(e.getUTCSeconds(), { unit: "second" }) : Io.s(e, t);
	},
	S: function(e, t) {
		return Io.S(e, t);
	},
	X: function(e, t, n, r) {
		var i = (r._originalDate || e).getTimezoneOffset();
		if (i === 0) return "Z";
		switch (t) {
			case "X": return Qo(i);
			case "XXXX":
			case "XX": return $o(i);
			default: return $o(i, ":");
		}
	},
	x: function(e, t, n, r) {
		var i = (r._originalDate || e).getTimezoneOffset();
		switch (t) {
			case "x": return Qo(i);
			case "xxxx":
			case "xx": return $o(i);
			default: return $o(i, ":");
		}
	},
	O: function(e, t, n, r) {
		var i = (r._originalDate || e).getTimezoneOffset();
		switch (t) {
			case "O":
			case "OO":
			case "OOO": return "GMT" + Zo(i, ":");
			default: return "GMT" + $o(i, ":");
		}
	},
	z: function(e, t, n, r) {
		var i = (r._originalDate || e).getTimezoneOffset();
		switch (t) {
			case "z":
			case "zz":
			case "zzz": return "GMT" + Zo(i, ":");
			default: return "GMT" + $o(i, ":");
		}
	},
	t: function(e, t, n, r) {
		var i = r._originalDate || e;
		return U(Math.floor(i.getTime() / 1e3), t.length);
	},
	T: function(e, t, n, r) {
		return U((r._originalDate || e).getTime(), t.length);
	}
};
function Zo(e, t) {
	var n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.floor(r / 60), a = r % 60;
	if (a === 0) return n + String(i);
	var o = t || "";
	return n + String(i) + o + U(a, 2);
}
function Qo(e, t) {
	return e % 60 == 0 ? (e > 0 ? "-" : "+") + U(Math.abs(e) / 60, 2) : $o(e, t);
}
function $o(e, t) {
	var n = t || "", r = e > 0 ? "-" : "+", i = Math.abs(e), a = U(Math.floor(i / 60), 2), o = U(i % 60, 2);
	return r + a + n + o;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/format/longFormatters/index.js
function es(e, t) {
	switch (e) {
		case "P": return t.date({ width: "short" });
		case "PP": return t.date({ width: "medium" });
		case "PPP": return t.date({ width: "long" });
		default: return t.date({ width: "full" });
	}
}
function ts(e, t) {
	switch (e) {
		case "p": return t.time({ width: "short" });
		case "pp": return t.time({ width: "medium" });
		case "ppp": return t.time({ width: "long" });
		default: return t.time({ width: "full" });
	}
}
function ns(e, t) {
	var n = e.match(/(P+)(p+)?/), r = n[1], i = n[2];
	if (!i) return es(e, t);
	var a;
	switch (r) {
		case "P":
			a = t.dateTime({ width: "short" });
			break;
		case "PP":
			a = t.dateTime({ width: "medium" });
			break;
		case "PPP":
			a = t.dateTime({ width: "long" });
			break;
		default:
			a = t.dateTime({ width: "full" });
			break;
	}
	return a.replace("{{date}}", es(r, t)).replace("{{time}}", ts(i, t));
}
var rs = {
	p: ts,
	P: ns
}, is = ["D", "DD"], as = ["YY", "YYYY"];
function os(e) {
	return is.indexOf(e) !== -1;
}
function ss(e) {
	return as.indexOf(e) !== -1;
}
function cs(e, t, n) {
	if (e === "YYYY") throw RangeError(`Use \`yyyy\` instead of \`YYYY\` (in \`${t}\`) for formatting years to the input \`${n}\`; see: https://git.io/fxCyr`);
	if (e === "YY") throw RangeError(`Use \`yy\` instead of \`YY\` (in \`${t}\`) for formatting years to the input \`${n}\`; see: https://git.io/fxCyr`);
	if (e === "D") throw RangeError(`Use \`d\` instead of \`D\` (in \`${t}\`) for formatting days of the month to the input \`${n}\`; see: https://git.io/fxCyr`);
	if (e === "DD") throw RangeError(`Use \`dd\` instead of \`DD\` (in \`${t}\`) for formatting days of the month to the input \`${n}\`; see: https://git.io/fxCyr`);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/format/index.js
var ls = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, us = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ds = /^'([^]*?)'?$/, fs = /''/g, ps = /[a-zA-Z]/;
function ms(e, t, n) {
	H(2, arguments);
	var r = String(t), i = n || {}, a = i.locale || Po, o = a.options && a.options.firstWeekContainsDate, s = o == null ? 1 : V(o), c = i.firstWeekContainsDate == null ? s : V(i.firstWeekContainsDate);
	if (!(c >= 1 && c <= 7)) throw RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
	var l = a.options && a.options.weekStartsOn, u = l == null ? 0 : V(l), d = i.weekStartsOn == null ? u : V(i.weekStartsOn);
	if (!(d >= 0 && d <= 6)) throw RangeError("weekStartsOn must be between 0 and 6 inclusively");
	if (!a.localize) throw RangeError("locale must contain localize property");
	if (!a.formatLong) throw RangeError("locale must contain formatLong property");
	var f = ho(e);
	if (!bo(f)) throw RangeError("Invalid time value");
	var p = Fo(f, _o(f)), m = {
		firstWeekContainsDate: c,
		weekStartsOn: d,
		locale: a,
		_originalDate: f
	};
	return r.match(us).map(function(e) {
		var t = e[0];
		if (t === "p" || t === "P") {
			var n = rs[t];
			return n(e, a.formatLong, m);
		}
		return e;
	}).join("").match(ls).map(function(n) {
		if (n === "''") return "'";
		var r = n[0];
		if (r === "'") return hs(n);
		var o = Xo[r];
		if (o) return !i.useAdditionalWeekYearTokens && ss(n) && cs(n, t, e), !i.useAdditionalDayOfYearTokens && os(n) && cs(n, t, e), o(p, n, a.localize, m);
		if (r.match(ps)) throw RangeError("Format string contains an unescaped latin alphabet character `" + r + "`");
		return n;
	}).join("");
}
function hs(e) {
	return e.match(ds)[1].replace(fs, "'");
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/assign/index.js
function gs(e, t) {
	if (e == null) throw TypeError("assign requires that input parameter not be null or undefined");
	for (var n in t ||= {}, t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
	return e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/setUTCDay/index.js
function _s(e, t, n) {
	H(2, arguments);
	var r = n || {}, i = r.locale, a = i && i.options && i.options.weekStartsOn, o = a == null ? 0 : V(a), s = r.weekStartsOn == null ? o : V(r.weekStartsOn);
	if (!(s >= 0 && s <= 6)) throw RangeError("weekStartsOn must be between 0 and 6 inclusively");
	var c = ho(e), l = V(t), u = c.getUTCDay(), d = ((l % 7 + 7) % 7 < s ? 7 : 0) + l - u;
	return c.setUTCDate(c.getUTCDate() + d), c;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/setUTCISODay/index.js
function vs(e, t) {
	H(2, arguments);
	var n = V(t);
	n % 7 == 0 && (n -= 7);
	var r = 1, i = ho(e), a = i.getUTCDay(), o = ((n % 7 + 7) % 7 < r ? 7 : 0) + n - a;
	return i.setUTCDate(i.getUTCDate() + o), i;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js
function ys(e, t) {
	H(2, arguments);
	var n = ho(e), r = V(t), i = Uo(n) - r;
	return n.setUTCDate(n.getUTCDate() - i * 7), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/setUTCWeek/index.js
function bs(e, t, n) {
	H(2, arguments);
	var r = ho(e), i = V(t), a = Jo(r, n) - i;
	return r.setUTCDate(r.getUTCDate() - a * 7), r;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/parse/_lib/parsers/index.js
var xs = 36e5, Ss = 6e4, Cs = 1e3, W = {
	month: /^(1[0-2]|0?\d)/,
	date: /^(3[0-1]|[0-2]?\d)/,
	dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	week: /^(5[0-3]|[0-4]?\d)/,
	hour23h: /^(2[0-3]|[0-1]?\d)/,
	hour24h: /^(2[0-4]|[0-1]?\d)/,
	hour11h: /^(1[0-1]|0?\d)/,
	hour12h: /^(1[0-2]|0?\d)/,
	minute: /^[0-5]?\d/,
	second: /^[0-5]?\d/,
	singleDigit: /^\d/,
	twoDigits: /^\d{1,2}/,
	threeDigits: /^\d{1,3}/,
	fourDigits: /^\d{1,4}/,
	anyDigitsSigned: /^-?\d+/,
	singleDigitSigned: /^-?\d/,
	twoDigitsSigned: /^-?\d{1,2}/,
	threeDigitsSigned: /^-?\d{1,3}/,
	fourDigitsSigned: /^-?\d{1,4}/
}, ws = {
	basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	basic: /^([+-])(\d{2})(\d{2})|Z/,
	basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	extended: /^([+-])(\d{2}):(\d{2})|Z/,
	extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function G(e, t, n) {
	var r = t.match(e);
	if (!r) return null;
	var i = parseInt(r[0], 10);
	return {
		value: n ? n(i) : i,
		rest: t.slice(r[0].length)
	};
}
function Ts(e, t) {
	var n = t.match(e);
	if (!n) return null;
	if (n[0] === "Z") return {
		value: 0,
		rest: t.slice(1)
	};
	var r = n[1] === "+" ? 1 : -1, i = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
	return {
		value: r * (i * xs + a * Ss + o * Cs),
		rest: t.slice(n[0].length)
	};
}
function Es(e, t) {
	return G(W.anyDigitsSigned, e, t);
}
function K(e, t, n) {
	switch (e) {
		case 1: return G(W.singleDigit, t, n);
		case 2: return G(W.twoDigits, t, n);
		case 3: return G(W.threeDigits, t, n);
		case 4: return G(W.fourDigits, t, n);
		default: return G(RegExp("^\\d{1," + e + "}"), t, n);
	}
}
function Ds(e, t, n) {
	switch (e) {
		case 1: return G(W.singleDigitSigned, t, n);
		case 2: return G(W.twoDigitsSigned, t, n);
		case 3: return G(W.threeDigitsSigned, t, n);
		case 4: return G(W.fourDigitsSigned, t, n);
		default: return G(RegExp("^-?\\d{1," + e + "}"), t, n);
	}
}
function Os(e) {
	switch (e) {
		case "morning": return 4;
		case "evening": return 17;
		case "pm":
		case "noon":
		case "afternoon": return 12;
		default: return 0;
	}
}
function ks(e, t) {
	var n = t > 0, r = n ? t : 1 - t, i;
	if (r <= 50) i = e || 100;
	else {
		var a = r + 50, o = Math.floor(a / 100) * 100, s = e >= a % 100;
		i = e + o - (s ? 100 : 0);
	}
	return n ? i : 1 - i;
}
var As = [
	31,
	28,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
], js = [
	31,
	29,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
];
function Ms(e) {
	return e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
}
var Ns = {
	G: {
		priority: 140,
		parse: function(e, t, n, r) {
			switch (t) {
				case "G":
				case "GG":
				case "GGG": return n.era(e, { width: "abbreviated" }) || n.era(e, { width: "narrow" });
				case "GGGGG": return n.era(e, { width: "narrow" });
				default: return n.era(e, { width: "wide" }) || n.era(e, { width: "abbreviated" }) || n.era(e, { width: "narrow" });
			}
		},
		set: function(e, t, n, r) {
			return t.era = n, e.setUTCFullYear(n, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"R",
			"u",
			"t",
			"T"
		]
	},
	y: {
		priority: 130,
		parse: function(e, t, n, r) {
			var i = function(e) {
				return {
					year: e,
					isTwoDigitYear: t === "yy"
				};
			};
			switch (t) {
				case "y": return K(4, e, i);
				case "yo": return n.ordinalNumber(e, {
					unit: "year",
					valueCallback: i
				});
				default: return K(t.length, e, i);
			}
		},
		validate: function(e, t, n) {
			return t.isTwoDigitYear || t.year > 0;
		},
		set: function(e, t, n, r) {
			var i = e.getUTCFullYear();
			if (n.isTwoDigitYear) {
				var a = ks(n.year, i);
				return e.setUTCFullYear(a, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
			}
			var o = !("era" in t) || t.era === 1 ? n.year : 1 - n.year;
			return e.setUTCFullYear(o, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"u",
			"w",
			"I",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	Y: {
		priority: 130,
		parse: function(e, t, n, r) {
			var i = function(e) {
				return {
					year: e,
					isTwoDigitYear: t === "YY"
				};
			};
			switch (t) {
				case "Y": return K(4, e, i);
				case "Yo": return n.ordinalNumber(e, {
					unit: "year",
					valueCallback: i
				});
				default: return K(t.length, e, i);
			}
		},
		validate: function(e, t, n) {
			return t.isTwoDigitYear || t.year > 0;
		},
		set: function(e, t, n, r) {
			var i = Go(e, r);
			if (n.isTwoDigitYear) {
				var a = ks(n.year, i);
				return e.setUTCFullYear(a, 0, r.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), Wo(e, r);
			}
			var o = !("era" in t) || t.era === 1 ? n.year : 1 - n.year;
			return e.setUTCFullYear(o, 0, r.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), Wo(e, r);
		},
		incompatibleTokens: [
			"y",
			"R",
			"u",
			"Q",
			"q",
			"M",
			"L",
			"I",
			"d",
			"D",
			"i",
			"t",
			"T"
		]
	},
	R: {
		priority: 130,
		parse: function(e, t, n, r) {
			return Ds(t === "R" ? 4 : t.length, e);
		},
		set: function(e, t, n, r) {
			var i = /* @__PURE__ */ new Date(0);
			return i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0), zo(i);
		},
		incompatibleTokens: [
			"G",
			"y",
			"Y",
			"u",
			"Q",
			"q",
			"M",
			"L",
			"w",
			"d",
			"D",
			"e",
			"c",
			"t",
			"T"
		]
	},
	u: {
		priority: 130,
		parse: function(e, t, n, r) {
			return Ds(t === "u" ? 4 : t.length, e);
		},
		set: function(e, t, n, r) {
			return e.setUTCFullYear(n, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"G",
			"y",
			"Y",
			"R",
			"w",
			"I",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	Q: {
		priority: 120,
		parse: function(e, t, n, r) {
			switch (t) {
				case "Q":
				case "QQ": return K(t.length, e);
				case "Qo": return n.ordinalNumber(e, { unit: "quarter" });
				case "QQQ": return n.quarter(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.quarter(e, {
					width: "narrow",
					context: "formatting"
				});
				case "QQQQQ": return n.quarter(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.quarter(e, {
					width: "wide",
					context: "formatting"
				}) || n.quarter(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.quarter(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 4;
		},
		set: function(e, t, n, r) {
			return e.setUTCMonth((n - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"q",
			"M",
			"L",
			"w",
			"I",
			"d",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	q: {
		priority: 120,
		parse: function(e, t, n, r) {
			switch (t) {
				case "q":
				case "qq": return K(t.length, e);
				case "qo": return n.ordinalNumber(e, { unit: "quarter" });
				case "qqq": return n.quarter(e, {
					width: "abbreviated",
					context: "standalone"
				}) || n.quarter(e, {
					width: "narrow",
					context: "standalone"
				});
				case "qqqqq": return n.quarter(e, {
					width: "narrow",
					context: "standalone"
				});
				default: return n.quarter(e, {
					width: "wide",
					context: "standalone"
				}) || n.quarter(e, {
					width: "abbreviated",
					context: "standalone"
				}) || n.quarter(e, {
					width: "narrow",
					context: "standalone"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 4;
		},
		set: function(e, t, n, r) {
			return e.setUTCMonth((n - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"Q",
			"M",
			"L",
			"w",
			"I",
			"d",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	M: {
		priority: 110,
		parse: function(e, t, n, r) {
			var i = function(e) {
				return e - 1;
			};
			switch (t) {
				case "M": return G(W.month, e, i);
				case "MM": return K(2, e, i);
				case "Mo": return n.ordinalNumber(e, {
					unit: "month",
					valueCallback: i
				});
				case "MMM": return n.month(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.month(e, {
					width: "narrow",
					context: "formatting"
				});
				case "MMMMM": return n.month(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.month(e, {
					width: "wide",
					context: "formatting"
				}) || n.month(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.month(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 11;
		},
		set: function(e, t, n, r) {
			return e.setUTCMonth(n, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"q",
			"Q",
			"L",
			"w",
			"I",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	L: {
		priority: 110,
		parse: function(e, t, n, r) {
			var i = function(e) {
				return e - 1;
			};
			switch (t) {
				case "L": return G(W.month, e, i);
				case "LL": return K(2, e, i);
				case "Lo": return n.ordinalNumber(e, {
					unit: "month",
					valueCallback: i
				});
				case "LLL": return n.month(e, {
					width: "abbreviated",
					context: "standalone"
				}) || n.month(e, {
					width: "narrow",
					context: "standalone"
				});
				case "LLLLL": return n.month(e, {
					width: "narrow",
					context: "standalone"
				});
				default: return n.month(e, {
					width: "wide",
					context: "standalone"
				}) || n.month(e, {
					width: "abbreviated",
					context: "standalone"
				}) || n.month(e, {
					width: "narrow",
					context: "standalone"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 11;
		},
		set: function(e, t, n, r) {
			return e.setUTCMonth(n, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"q",
			"Q",
			"M",
			"w",
			"I",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	w: {
		priority: 100,
		parse: function(e, t, n, r) {
			switch (t) {
				case "w": return G(W.week, e);
				case "wo": return n.ordinalNumber(e, { unit: "week" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 53;
		},
		set: function(e, t, n, r) {
			return Wo(bs(e, n, r), r);
		},
		incompatibleTokens: [
			"y",
			"R",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"I",
			"d",
			"D",
			"i",
			"t",
			"T"
		]
	},
	I: {
		priority: 100,
		parse: function(e, t, n, r) {
			switch (t) {
				case "I": return G(W.week, e);
				case "Io": return n.ordinalNumber(e, { unit: "week" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 53;
		},
		set: function(e, t, n, r) {
			return zo(ys(e, n, r), r);
		},
		incompatibleTokens: [
			"y",
			"Y",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"w",
			"d",
			"D",
			"e",
			"c",
			"t",
			"T"
		]
	},
	d: {
		priority: 90,
		subPriority: 1,
		parse: function(e, t, n, r) {
			switch (t) {
				case "d": return G(W.date, e);
				case "do": return n.ordinalNumber(e, { unit: "date" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			var r = Ms(e.getUTCFullYear()), i = e.getUTCMonth();
			return r ? t >= 1 && t <= js[i] : t >= 1 && t <= As[i];
		},
		set: function(e, t, n, r) {
			return e.setUTCDate(n), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"q",
			"Q",
			"w",
			"I",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	D: {
		priority: 90,
		subPriority: 1,
		parse: function(e, t, n, r) {
			switch (t) {
				case "D":
				case "DD": return G(W.dayOfYear, e);
				case "Do": return n.ordinalNumber(e, { unit: "date" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return Ms(e.getUTCFullYear()) ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
		},
		set: function(e, t, n, r) {
			return e.setUTCMonth(0, n), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"q",
			"Q",
			"M",
			"L",
			"w",
			"I",
			"d",
			"E",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	E: {
		priority: 90,
		parse: function(e, t, n, r) {
			switch (t) {
				case "E":
				case "EE":
				case "EEE": return n.day(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.day(e, {
					width: "short",
					context: "formatting"
				}) || n.day(e, {
					width: "narrow",
					context: "formatting"
				});
				case "EEEEE": return n.day(e, {
					width: "narrow",
					context: "formatting"
				});
				case "EEEEEE": return n.day(e, {
					width: "short",
					context: "formatting"
				}) || n.day(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.day(e, {
					width: "wide",
					context: "formatting"
				}) || n.day(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.day(e, {
					width: "short",
					context: "formatting"
				}) || n.day(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 6;
		},
		set: function(e, t, n, r) {
			return e = _s(e, n, r), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	e: {
		priority: 90,
		parse: function(e, t, n, r) {
			var i = function(e) {
				var t = Math.floor((e - 1) / 7) * 7;
				return (e + r.weekStartsOn + 6) % 7 + t;
			};
			switch (t) {
				case "e":
				case "ee": return K(t.length, e, i);
				case "eo": return n.ordinalNumber(e, {
					unit: "day",
					valueCallback: i
				});
				case "eee": return n.day(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.day(e, {
					width: "short",
					context: "formatting"
				}) || n.day(e, {
					width: "narrow",
					context: "formatting"
				});
				case "eeeee": return n.day(e, {
					width: "narrow",
					context: "formatting"
				});
				case "eeeeee": return n.day(e, {
					width: "short",
					context: "formatting"
				}) || n.day(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.day(e, {
					width: "wide",
					context: "formatting"
				}) || n.day(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.day(e, {
					width: "short",
					context: "formatting"
				}) || n.day(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 6;
		},
		set: function(e, t, n, r) {
			return e = _s(e, n, r), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"y",
			"R",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"I",
			"d",
			"D",
			"E",
			"i",
			"c",
			"t",
			"T"
		]
	},
	c: {
		priority: 90,
		parse: function(e, t, n, r) {
			var i = function(e) {
				var t = Math.floor((e - 1) / 7) * 7;
				return (e + r.weekStartsOn + 6) % 7 + t;
			};
			switch (t) {
				case "c":
				case "cc": return K(t.length, e, i);
				case "co": return n.ordinalNumber(e, {
					unit: "day",
					valueCallback: i
				});
				case "ccc": return n.day(e, {
					width: "abbreviated",
					context: "standalone"
				}) || n.day(e, {
					width: "short",
					context: "standalone"
				}) || n.day(e, {
					width: "narrow",
					context: "standalone"
				});
				case "ccccc": return n.day(e, {
					width: "narrow",
					context: "standalone"
				});
				case "cccccc": return n.day(e, {
					width: "short",
					context: "standalone"
				}) || n.day(e, {
					width: "narrow",
					context: "standalone"
				});
				default: return n.day(e, {
					width: "wide",
					context: "standalone"
				}) || n.day(e, {
					width: "abbreviated",
					context: "standalone"
				}) || n.day(e, {
					width: "short",
					context: "standalone"
				}) || n.day(e, {
					width: "narrow",
					context: "standalone"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 6;
		},
		set: function(e, t, n, r) {
			return e = _s(e, n, r), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"y",
			"R",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"I",
			"d",
			"D",
			"E",
			"i",
			"e",
			"t",
			"T"
		]
	},
	i: {
		priority: 90,
		parse: function(e, t, n, r) {
			var i = function(e) {
				return e === 0 ? 7 : e;
			};
			switch (t) {
				case "i":
				case "ii": return K(t.length, e);
				case "io": return n.ordinalNumber(e, { unit: "day" });
				case "iii": return n.day(e, {
					width: "abbreviated",
					context: "formatting",
					valueCallback: i
				}) || n.day(e, {
					width: "short",
					context: "formatting",
					valueCallback: i
				}) || n.day(e, {
					width: "narrow",
					context: "formatting",
					valueCallback: i
				});
				case "iiiii": return n.day(e, {
					width: "narrow",
					context: "formatting",
					valueCallback: i
				});
				case "iiiiii": return n.day(e, {
					width: "short",
					context: "formatting",
					valueCallback: i
				}) || n.day(e, {
					width: "narrow",
					context: "formatting",
					valueCallback: i
				});
				default: return n.day(e, {
					width: "wide",
					context: "formatting",
					valueCallback: i
				}) || n.day(e, {
					width: "abbreviated",
					context: "formatting",
					valueCallback: i
				}) || n.day(e, {
					width: "short",
					context: "formatting",
					valueCallback: i
				}) || n.day(e, {
					width: "narrow",
					context: "formatting",
					valueCallback: i
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 7;
		},
		set: function(e, t, n, r) {
			return e = vs(e, n, r), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"y",
			"Y",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"w",
			"d",
			"D",
			"E",
			"e",
			"c",
			"t",
			"T"
		]
	},
	a: {
		priority: 80,
		parse: function(e, t, n, r) {
			switch (t) {
				case "a":
				case "aa":
				case "aaa": return n.dayPeriod(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
				case "aaaaa": return n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.dayPeriod(e, {
					width: "wide",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		set: function(e, t, n, r) {
			return e.setUTCHours(Os(n), 0, 0, 0), e;
		},
		incompatibleTokens: [
			"b",
			"B",
			"H",
			"K",
			"k",
			"t",
			"T"
		]
	},
	b: {
		priority: 80,
		parse: function(e, t, n, r) {
			switch (t) {
				case "b":
				case "bb":
				case "bbb": return n.dayPeriod(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
				case "bbbbb": return n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.dayPeriod(e, {
					width: "wide",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		set: function(e, t, n, r) {
			return e.setUTCHours(Os(n), 0, 0, 0), e;
		},
		incompatibleTokens: [
			"a",
			"B",
			"H",
			"K",
			"k",
			"t",
			"T"
		]
	},
	B: {
		priority: 80,
		parse: function(e, t, n, r) {
			switch (t) {
				case "B":
				case "BB":
				case "BBB": return n.dayPeriod(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
				case "BBBBB": return n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.dayPeriod(e, {
					width: "wide",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		set: function(e, t, n, r) {
			return e.setUTCHours(Os(n), 0, 0, 0), e;
		},
		incompatibleTokens: [
			"a",
			"b",
			"t",
			"T"
		]
	},
	h: {
		priority: 70,
		parse: function(e, t, n, r) {
			switch (t) {
				case "h": return G(W.hour12h, e);
				case "ho": return n.ordinalNumber(e, { unit: "hour" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 12;
		},
		set: function(e, t, n, r) {
			var i = e.getUTCHours() >= 12;
			return i && n < 12 ? e.setUTCHours(n + 12, 0, 0, 0) : !i && n === 12 ? e.setUTCHours(0, 0, 0, 0) : e.setUTCHours(n, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"H",
			"K",
			"k",
			"t",
			"T"
		]
	},
	H: {
		priority: 70,
		parse: function(e, t, n, r) {
			switch (t) {
				case "H": return G(W.hour23h, e);
				case "Ho": return n.ordinalNumber(e, { unit: "hour" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 23;
		},
		set: function(e, t, n, r) {
			return e.setUTCHours(n, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"a",
			"b",
			"h",
			"K",
			"k",
			"t",
			"T"
		]
	},
	K: {
		priority: 70,
		parse: function(e, t, n, r) {
			switch (t) {
				case "K": return G(W.hour11h, e);
				case "Ko": return n.ordinalNumber(e, { unit: "hour" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 11;
		},
		set: function(e, t, n, r) {
			return e.getUTCHours() >= 12 && n < 12 ? e.setUTCHours(n + 12, 0, 0, 0) : e.setUTCHours(n, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"a",
			"b",
			"h",
			"H",
			"k",
			"t",
			"T"
		]
	},
	k: {
		priority: 70,
		parse: function(e, t, n, r) {
			switch (t) {
				case "k": return G(W.hour24h, e);
				case "ko": return n.ordinalNumber(e, { unit: "hour" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 24;
		},
		set: function(e, t, n, r) {
			var i = n <= 24 ? n % 24 : n;
			return e.setUTCHours(i, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"a",
			"b",
			"h",
			"H",
			"K",
			"t",
			"T"
		]
	},
	m: {
		priority: 60,
		parse: function(e, t, n, r) {
			switch (t) {
				case "m": return G(W.minute, e);
				case "mo": return n.ordinalNumber(e, { unit: "minute" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 59;
		},
		set: function(e, t, n, r) {
			return e.setUTCMinutes(n, 0, 0), e;
		},
		incompatibleTokens: ["t", "T"]
	},
	s: {
		priority: 50,
		parse: function(e, t, n, r) {
			switch (t) {
				case "s": return G(W.second, e);
				case "so": return n.ordinalNumber(e, { unit: "second" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 59;
		},
		set: function(e, t, n, r) {
			return e.setUTCSeconds(n, 0), e;
		},
		incompatibleTokens: ["t", "T"]
	},
	S: {
		priority: 30,
		parse: function(e, t, n, r) {
			return K(t.length, e, function(e) {
				return Math.floor(e * 10 ** (-t.length + 3));
			});
		},
		set: function(e, t, n, r) {
			return e.setUTCMilliseconds(n), e;
		},
		incompatibleTokens: ["t", "T"]
	},
	X: {
		priority: 10,
		parse: function(e, t, n, r) {
			switch (t) {
				case "X": return Ts(ws.basicOptionalMinutes, e);
				case "XX": return Ts(ws.basic, e);
				case "XXXX": return Ts(ws.basicOptionalSeconds, e);
				case "XXXXX": return Ts(ws.extendedOptionalSeconds, e);
				default: return Ts(ws.extended, e);
			}
		},
		set: function(e, t, n, r) {
			return t.timestampIsSet ? e : new Date(e.getTime() - n);
		},
		incompatibleTokens: [
			"t",
			"T",
			"x"
		]
	},
	x: {
		priority: 10,
		parse: function(e, t, n, r) {
			switch (t) {
				case "x": return Ts(ws.basicOptionalMinutes, e);
				case "xx": return Ts(ws.basic, e);
				case "xxxx": return Ts(ws.basicOptionalSeconds, e);
				case "xxxxx": return Ts(ws.extendedOptionalSeconds, e);
				default: return Ts(ws.extended, e);
			}
		},
		set: function(e, t, n, r) {
			return t.timestampIsSet ? e : new Date(e.getTime() - n);
		},
		incompatibleTokens: [
			"t",
			"T",
			"X"
		]
	},
	t: {
		priority: 40,
		parse: function(e, t, n, r) {
			return Es(e);
		},
		set: function(e, t, n, r) {
			return [/* @__PURE__ */ new Date(n * 1e3), { timestampIsSet: !0 }];
		},
		incompatibleTokens: "*"
	},
	T: {
		priority: 20,
		parse: function(e, t, n, r) {
			return Es(e);
		},
		set: function(e, t, n, r) {
			return [new Date(n), { timestampIsSet: !0 }];
		},
		incompatibleTokens: "*"
	}
}, Ps = 10, Fs = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Is = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ls = /^'([^]*?)'?$/, Rs = /''/g, zs = /\S/, Bs = /[a-zA-Z]/;
function Vs(e, t, n, r) {
	H(3, arguments);
	var i = String(e), a = String(t), o = r || {}, s = o.locale || Po;
	if (!s.match) throw RangeError("locale must contain match property");
	var c = s.options && s.options.firstWeekContainsDate, l = c == null ? 1 : V(c), u = o.firstWeekContainsDate == null ? l : V(o.firstWeekContainsDate);
	if (!(u >= 1 && u <= 7)) throw RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
	var d = s.options && s.options.weekStartsOn, f = d == null ? 0 : V(d), p = o.weekStartsOn == null ? f : V(o.weekStartsOn);
	if (!(p >= 0 && p <= 6)) throw RangeError("weekStartsOn must be between 0 and 6 inclusively");
	if (a === "") return i === "" ? ho(n) : /* @__PURE__ */ new Date(NaN);
	var m = {
		firstWeekContainsDate: u,
		weekStartsOn: p,
		locale: s
	}, h = [{
		priority: Ps,
		subPriority: -1,
		set: Hs,
		index: 0
	}], g, ee = a.match(Is).map(function(e) {
		var t = e[0];
		if (t === "p" || t === "P") {
			var n = rs[t];
			return n(e, s.formatLong, m);
		}
		return e;
	}).join("").match(Fs), _ = [];
	for (g = 0; g < ee.length; g++) {
		var v = ee[g];
		!o.useAdditionalWeekYearTokens && ss(v) && cs(v, a, e), !o.useAdditionalDayOfYearTokens && os(v) && cs(v, a, e);
		var y = v[0], b = Ns[y];
		if (b) {
			var te = b.incompatibleTokens;
			if (Array.isArray(te)) {
				for (var ne = void 0, x = 0; x < _.length; x++) {
					var re = _[x].token;
					if (te.indexOf(re) !== -1 || re === y) {
						ne = _[x];
						break;
					}
				}
				if (ne) throw RangeError(`The format string mustn't contain \`${ne.fullToken}\` and \`${v}\` at the same time`);
			} else if (b.incompatibleTokens === "*" && _.length) throw RangeError(`The format string mustn't contain \`${v}\` and any other token at the same time`);
			_.push({
				token: y,
				fullToken: v
			});
			var ie = b.parse(i, v, s.match, m);
			if (!ie) return /* @__PURE__ */ new Date(NaN);
			h.push({
				priority: b.priority,
				subPriority: b.subPriority || 0,
				set: b.set,
				validate: b.validate,
				value: ie.value,
				index: h.length
			}), i = ie.rest;
		} else {
			if (y.match(Bs)) throw RangeError("Format string contains an unescaped latin alphabet character `" + y + "`");
			if (v === "''" ? v = "'" : y === "'" && (v = Us(v)), i.indexOf(v) === 0) i = i.slice(v.length);
			else return /* @__PURE__ */ new Date(NaN);
		}
	}
	if (i.length > 0 && zs.test(i)) return /* @__PURE__ */ new Date(NaN);
	var ae = h.map(function(e) {
		return e.priority;
	}).sort(function(e, t) {
		return t - e;
	}).filter(function(e, t, n) {
		return n.indexOf(e) === t;
	}).map(function(e) {
		return h.filter(function(t) {
			return t.priority === e;
		}).sort(function(e, t) {
			return t.subPriority - e.subPriority;
		});
	}).map(function(e) {
		return e[0];
	}), oe = ho(n);
	if (isNaN(oe)) return /* @__PURE__ */ new Date(NaN);
	var se = Fo(oe, _o(oe)), ce = {};
	for (g = 0; g < ae.length; g++) {
		var le = ae[g];
		if (le.validate && !le.validate(se, le.value, m)) return /* @__PURE__ */ new Date(NaN);
		var S = le.set(se, ce, le.value, m);
		S[0] ? (se = S[0], gs(ce, S[1])) : se = S;
	}
	return se;
}
function Hs(e, t) {
	if (t.timestampIsSet) return e;
	var n = /* @__PURE__ */ new Date(0);
	return n.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), n.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), n;
}
function Us(e) {
	return e.match(Ls)[1].replace(Rs, "'");
}
//#endregion
//#region src/utils/date.util.ts
var Ws = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(Z|([+-])(\d{2}):(\d{2}))$/, Gs = (e) => e ? ms(new Date(e), "dd-MM-yy HH:mm") : "-", Ks = (e) => e ? ms(new Date(e), "dd.MM.yy HH:mm") : "-", qs = (e) => e ? ms(new Date(e), "dd.MM.yy") : "-", Js = (e) => e ? ms(new Date(e), "dd.MM.yyyy") : "-", Ys = (e) => e ? ms(new Date(e), "HH:mm") : "-", Xs = (e) => e ? ms(new Date(e), "dd.MM.yy HH:mm:ss") : "-", Zs = (e) => e instanceof Date ? e.toISOString() : typeof e == "boolean" ? e ? "true" : "false" : e, Qs = (e, t = ["second", "millisecond"]) => (t.includes("hour") && e.setHours(0), t.includes("minute") && e.setMinutes(0), t.includes("second") && e.setSeconds(0), t.includes("millisecond") && e.setMilliseconds(0), e), $s = (e) => Qs(e, ["second", "millisecond"]), ec = (e) => {
	function t(e) {
		let n = {};
		for (let r of Object.keys(e)) {
			let i = e[r];
			typeof i == "string" && Ws.test(i) ? n[r] = new Date(i) : typeof i == "object" && i ? n[r] = t(i) : n[r] = i;
		}
		return Object.assign(e, n), e;
	}
	return t(e);
}, tc = (e) => `${Math.floor(e / 60).toString().padStart(2, "0")}:${(e % 60).toString().padStart(2, "0")}`, nc = qa(), rc = {}, ic = {}, ac = (e = GLOBAL_CONFIG.API_BASE_URL) => ({
	withCredentials: !0,
	baseURL: e,
	withXSRFToken: !0,
	xsrfCookieName: "XSRF-TOKEN",
	xsrfHeaderName: "x-xsrf-token",
	headers: {
		"Content-Type": "application/json",
		"Accept-Language": nc.language ?? navigator.language
	},
	paramsSerializer: { serialize: (e) => Object.entries(e).map(([e, t]) => {
		if (!(t === void 0 || t === "")) return Array.isArray(t) ? t.map((t) => `${encodeURIComponent(e)}[]=${encodeURIComponent(`${Zs(t)}`)}`).join("&") : `${encodeURIComponent(e)}=${encodeURIComponent(`${Zs(t)}`)}`;
	}).filter(Boolean).join("&") }
}), oc = (e) => {
	if (R.isCancel(e) || e.config?.handleError === !1) return Promise.reject(e);
	let t = mo();
	if (((t) => e.isAxiosError)(e)) {
		if (e.response?.status === 401 && e.response.data?.type === "UnauthenticatedInCMSError") return Promise.reject(e);
		let { t: n } = B(), r = e.response?.status === 404 ? "warning" : "negative";
		t.showNotification(new lo(e.message + (e.response?.data.message ? `: ${e.response?.data.message}` : ""), r, {
			multiLine: !0,
			timeout: null,
			dismissible: !0,
			callbackLabel: n("messages.copyErrorToClipboard"),
			async callbackFunc() {
				await ve(e.response ? JSON.stringify(e.response, void 0, 2) : JSON.stringify(e, void 0, 2)), t.showNotification(new lo(n("messages.copiedToClipboard"), "info"));
			}
		}));
	}
	return Promise.reject(e);
}, sc = (e) => {
	let t = e.data;
	return typeof t != "object" || !t || (e.data = ec(t)), e;
}, cc = (e) => {
	let t = Object.values(z).filter((e) => e.hasTitlePropagation).map((e) => e.path), n = location.pathname.split("/").filter((e) => e.length > 0), r = n[0], { _id: i, title: a, image: o } = e.data, s = i || o?._id, c = a || o?.title, l = r ? t.includes(r) : !1, u = B().te(`${r}.routeTitleDetail`);
	if (l && c && u && s === n.pop()) {
		let e = B().t(`${r}.routeTitleDetail`);
		document.title = `${e} ${c}`;
	}
	return e;
}, lc = [oc], uc = (e) => {
	let t = R.create(e);
	for (let e of lc) t.interceptors.response.use(void 0, e);
	return t.interceptors.response.use(sc), t.interceptors.response.use(cc), t;
}, dc = (e) => {
	lc.push(e);
}, fc, pc = (e) => {
	let t = rc[e];
	if (!t) throw Error(`Entity "${e}" has no registered endpoint!`);
	let n = ic[e];
	return n ||= ic[e] = t(), n;
}, mc = () => (fc ||= uc(ac()), fc), hc = async (e, t, n) => {
	if (!rc[e]) throw Error(`Entity "${e}" has no registered endpoint!`);
	return (await pc(e).get(`/${t}`, n)).data;
}, gc = async (e, t, n) => {
	if (!rc[e]) throw Error(`Entity "${e}" has no registered endpoint!`);
	return (await pc(e).post("", t, n)).data;
}, _c = async (e, t, n, r) => {
	if (!rc[e]) throw Error(`Entity "${e}" has no registered endpoint!`);
	return (await pc(e).put(`/${t}`, n, r)).data;
}, vc = async (e, t, n) => {
	if (!rc[e]) throw Error(`Entity "${e}" has no registered endpoint!`);
	return (await pc(e).delete(`/${t}`, n)).data;
}, yc = async (e, t) => {
	if (!rc[e]) throw Error(`Entity "${e}" has no registered endpoint!`);
	return (await pc(e).get("", t)).data;
}, bc = (e, t = `/cms/${e.toLowerCase()}`) => (rc[e] = () => uc(ac(`${GLOBAL_CONFIG.API_BASE_URL}${t}`)), {
	getEntity: (t, n) => hc(e, t, n),
	listEntities: (t) => yc(e, t),
	postEntity: (t, n) => gc(e, t, n),
	putEntity: (t, n, r) => _c(e, t, n, r),
	deleteEntity: (t, n) => vc(e, t, n),
	getEntityAPIClient: () => pc(e)
}), xc = /* @__PURE__ */ A({
	__name: "bf-checkbox",
	props: { modelValue: {
		type: [Boolean, null],
		default: void 0
	} },
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = C({
			get() {
				return !!n.modelValue;
			},
			set(e) {
				r("update:modelValue", e);
			}
		});
		return (e, t) => (j(), w(P(u), je({
			modelValue: i.value,
			"onUpdate:modelValue": t[0] ||= (e) => i.value = e
		}, e.$attrs), {
			default: F(() => [He(e.$slots, "default")]),
			_: 3
		}, 16, ["modelValue"]));
	}
}), Sc = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%3e%3csymbol%20id='javascript'%20viewBox='0%200%2024%2024'%20fill='currentColor'%3e%3cpath%20d='M14%201a1.01%201.01%200%200%201%20.25.031l.03.009c.03.009.061.02.091.031l.027.012a.914.914%200%200%201%20.195.112c.04.03.078.062.114.098l-.093-.082.011.009.082.073%206%206a1.006%201.006%200%200%201%20.21.309l.012.027c.012.03.022.06.031.091l.008.03A.921.921%200%200%201%2021%208l-.008-.126.001.01L21%208v12a3%203%200%200%201-3%203H6a3%203%200%200%201-3-3V4a3%203%200%200%201%203-3h8zm-1%202H6a1%201%200%200%200-1%201v16a1%201%200%200%200%201%201h12a1%201%200%200%200%201-1V9h-5a1%201%200%200%201-.993-.883L13%208V3zm-2.155%207.2v6.744c0%201.504-.675%202.256-2.026%202.256-.299%200-.525-.009-.679-.026v-1.282c.103.009.265.013.487.013.257%200%20.455-.062.596-.186.141-.124.212-.348.212-.673V10.2h1.41zm3.135-.112c.67%200%201.177.19%201.521.572.344.381.515.928.515%201.64v.277H14.71v-.365c0-.301-.059-.521-.176-.66-.117-.138-.289-.207-.515-.207-.227%200-.398.07-.516.207-.117.139-.176.359-.176.66%200%20.369.099.692.296.968.197.277.492.591.886.943.327.302.59.568.792.798.201.23.373.51.515.836.143.327.214.7.214%201.119%200%20.712-.176%201.259-.528%201.64-.352.381-.863.572-1.534.572-.67%200-1.181-.19-1.533-.572-.352-.381-.528-.928-.528-1.64v-.54h1.307v.628c0%20.57.24.854.717.854s.716-.284.716-.854c0-.369-.098-.692-.295-.968-.197-.277-.492-.591-.886-.943-.327-.302-.591-.568-.792-.798a3.212%203.212%200%200%201-.516-.836%202.775%202.775%200%200%201-.213-1.119c0-.712.171-1.259.515-1.64s.85-.572%201.521-.572zM15%204.415V7h2.585L15%204.415z'/%3e%3c/symbol%3e%3csymbol%20id='gallery'%20viewBox='0%200%2024%2024'%20fill='currentColor'%3e%3cpath%20d='M2%207a1%201%200%200%201%20.993.883L3%208v12a1%201%200%200%200%20.883.993L4%2021h12a1%201%200%200%201%20.117%201.993L16%2023H4a3%203%200%200%201-2.995-2.824L1%2020V8a1%201%200%200%201%201-1zm18-6a3%203%200%200%201%203%203v12a3%203%200%200%201-3%203H8a3.05%203.05%200%200%201-.14-.003%201.005%201.005%200%200%201-.375-.04A3.002%203.002%200%200%201%205%2016V4a3%203%200%200%201%203-3zm-2.445%208.636L10.191%2017H20a1%201%200%200%200%20.993-.883L21%2016v-2.919l-3.445-3.445zM20%203H8a1%201%200%200%200-1%201v12a1%201%200%200%200%20.498.865l9.35-9.35a1%201%200%200%201%201.32-.083l.095.083L21%2010.252V4a1%201%200%200%200-.883-.993L20%203zm-9.111%201.556a2.333%202.333%200%201%201%200%204.666%202.333%202.333%200%200%201%200-4.666zm0%202a.333.333%200%201%200%200%20.666.333.333%200%200%200%200-.666z'%20/%3e%3c/symbol%3e%3csymbol%20id='video-performance'%20viewBox='0%200%2024%2024'%20stroke='currentColor'%20fill='none'%3e%3cpath%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='2'%20d='M1%204v6h6M23%2020v-6h-6'/%3e%3cpath%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='2'%20d='M23%2014l-4.64%204.36c-1.075%201.075-2.405%201.86-3.865%202.283-1.46.423-3.004.468-4.487.133-1.483-.336-2.856-1.041-3.993-2.051C4.88%2017.715%204.017%2016.433%203.51%2015M2%208.998l4.64-4.36c1.075-1.076%202.405-1.861%203.865-2.284%201.46-.422%203.004-.468%204.487-.132%201.483.335%202.856%201.041%203.993%202.051%201.136%201.01%201.998%202.291%202.505%203.725'/%3e%3cpath%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='2'%20d='M11%209l4.5%203-4.5%203V9z'/%3e%3c/symbol%3e%3csymbol%20id='flag-de'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M0%200H24V24H0V0Z'%20fill='black'/%3e%3cpath%20d='M0%208H24V24H0V8Z'%20fill='%23DD0000'/%3e%3cpath%20d='M0%2016H24V24H0V16Z'%20fill='%23FFCE00'/%3e%3c/symbol%3e%3csymbol%20id='flag-en'%20viewBox='0%200%2024%2024'%3e%3cg%20clip-path='url(%23clip_a)'%3e%3cg%20clip-path='url(%23clip_b)'%3e%3cpath%20d='M-12%200V24H36V0H-12Z'%20fill='%23012169'/%3e%3cpath%20d='M-12%200L36%2024L-12%200ZM36%200L-12%2024Z'%20fill='black'/%3e%3cpath%20d='M36%200L-12%2024M-12%200L36%2024L-12%200Z'%20stroke='white'%20stroke-width='6'/%3e%3cpath%20d='M-12%200L36%2024L-12%200ZM36%200L-12%2024Z'%20fill='black'/%3e%3cpath%20d='M36%200L-12%2024M-12%200L36%2024L-12%200Z'%20stroke='%23C8102E'%20stroke-width='4'/%3e%3cpath%20d='M12%200V24V0ZM-12%2012H36Z'%20fill='black'/%3e%3cpath%20d='M-12%2012H36M12%200V24V0Z'%20stroke='white'%20stroke-width='10'/%3e%3cpath%20d='M12%200V24V0ZM-12%2012H36Z'%20fill='black'/%3e%3cpath%20d='M-12%2012H36M12%200V24V0Z'%20stroke='%23C8102E'%20stroke-width='6'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip_a'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip_b'%3e%3crect%20width='48'%20height='24'%20fill='white'%20transform='translate(-12)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/symbol%3e%3csymbol%20id='flag-it'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M0%200H8V24H0V0Z'%20fill='%23008C45'/%3e%3cpath%20d='M8%200H16V24H8V0Z'%20fill='white'/%3e%3cpath%20d='M16%200H24V24H16V0Z'%20fill='%23CD212A'/%3e%3c/symbol%3e%3c/svg%3e", Cc = { key: 0 }, wc = /* @__PURE__ */ A({
	__name: "language-selector",
	props: {
		showLabel: {
			type: Boolean,
			default: !0
		},
		menuPosition: { default: "top" },
		shrinked: {
			type: Boolean,
			default: !1
		},
		flat: {
			type: Boolean,
			default: !1
		}
	},
	setup(t) {
		let n = qa(), { t: r } = it(), i = t, o = {
			en: ["English", "flag-en"],
			de: ["Deutsch", "flag-de"]
		}, s = Se(), c = (e) => {
			switch (e) {
				case "de":
				case "en":
					n.setLanguage(e), s.lang.set(Xa[e]);
					break;
				default: break;
			}
		}, l = C(() => `dropdown-menu dropdown-menu-${i.menuPosition}`);
		return (n, i) => (j(), w(P(a), je({
			class: t.shrinked && "shrinked",
			depressed: "",
			text: "",
			flat: t.flat
		}, n.$attrs), {
			default: F(() => [
				k(P(h), { name: "globe" }),
				t.showLabel ? (j(), E("span", Cc, N(P(r)("common.language")), 1)) : T("", !0),
				k(P(te), {
					bottom: t.menuPosition === "bottom",
					"content-class": l.value,
					top: t.menuPosition === "top",
					left: "",
					"offset-y": ""
				}, {
					default: F(() => [k(P(b), { class: "text-body1" }, {
						default: F(() => [(j(), E(Ce, null, Ve(o, (t, n) => Ye(k(P(_), {
							key: n,
							clickable: "",
							ripple: "",
							onClick: (e) => c(n)
						}, {
							default: F(() => [k(P(y), { avatar: "" }, {
								default: F(() => [k(P(h), {
									"custom-icon": !0,
									name: t[1],
									src: P(Sc),
									class: "icon"
								}, null, 8, ["name", "src"])]),
								_: 2
							}, 1024), k(P(y), null, {
								default: F(() => [O(N(t[0]), 1)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1032, ["onClick"]), [[P(e)]])), 64))]),
						_: 1
					})]),
					_: 1
				}, 8, [
					"bottom",
					"content-class",
					"top"
				])
			]),
			_: 1
		}, 16, ["class", "flat"]));
	}
}), Tc = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, Ec = /* @__PURE__ */ Tc(wc, [["__scopeId", "data-v-d6dcb9e8"]]), Dc = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2023.1.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Ebene_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20800%20118.2'%20style='enable-background:new%200%200%20800%20118.2;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%2395C11F;}%20.st1{fill:%23F39200;}%20.st2{fill:%231D1D1B;}%20%3c/style%3e%3cpath%20class='st0'%20d='M0,0h344.1v118.2H0V0z'/%3e%3cpath%20class='st1'%20d='M344.1,0H800v118.2H344.1V0z'/%3e%3cpath%20class='st2'%20d='M41.7,20.2h39.2c7.5,0,12.9,1.9,17,4.8c4.7,3.6,7.3,9,7.2,14.9c0,7.2-3.1,11.8-9.5,14.5v0.3%20c7.9,2.5,13.4,10,13.1,18.2c0,8.1-3.3,14.3-8.7,18.2c-4.5,3.1-10.6,4.8-18.4,4.8h-40C41.7,96.1,41.7,20.2,41.7,20.2L41.7,20.2z%20M77.3,49.8c4.2,0,7.2-2,7.2-6.1s-3-6.2-7.2-6.2H63.6v12.3L77.3,49.8L77.3,49.8z%20M79.3,78.9c4.8,0,8.1-2.8,8.1-7.5%20c0-4.8-3.6-7.3-8.1-7.3H63.6v14.8C63.6,78.9,79.3,78.9,79.3,78.9z%20M149.5,96.1v-7h-0.3c-3.7,5.6-10.1,8.9-16.8,8.6%20c-12.9,0-19.3-8.6-19.3-20.8V42h20.1v30.2c0,5.6,2.5,8.6,7.2,8.6c5.1,0,8.2-3.7,8.2-9.5V42.1h20.1v54L149.5,96.1L149.5,96.1z%20M194.8,50.2h0.3c4.4-6.8,9.5-9.3,16.5-9.3c1.1,0,2.2,0.2,3.3,0.5v17.1h-0.5c-11.8-2-18.7,3.3-18.7,15.6V96h-20.1V42h19.1%20L194.8,50.2L194.8,50.2z%20M217,69.1c0-17,9.8-28.6,24.1-28.6c7.8,0,11.5,2.8,15.1,7.5h0.3V20.3h20.1v75.8h-19.1v-7.5h-0.2%20c-3.1,5.8-9.3,9.3-15.9,9.3C227.5,97.8,217,87.7,217,69.1z%20M257.2,68.7c0-7.8-4-13.8-10-13.8s-9.8,5.6-9.8,13.8%20c0,8.2,3.7,14.2,9.8,14.2S257.2,76.5,257.2,68.7z%20M316.9,89.9h-0.2c-3.4,4.8-9,7.6-17.3,7.6c-10.4,0-18-5.6-18-16.2%20c0-12,9.2-15.6,19.6-16.6c11.5-1.2,14.5-2.6,14.5-6.1c0-3-1.4-5.1-5.8-5.1s-6.5,2.5-7.2,6.5h-19c0.5-10.7,8.7-19.4,25.7-19.4%20c8.2,0,15.2,1.7,19.6,5c4.5,3.3,6.5,7.6,6.5,14.8v20.4c0,3.4,1.4,3.9,3.4,3.4h0.3v11.4c-2.8,1.1-5.8,1.6-8.9,1.6%20C322.4,97.1,318.2,94.9,316.9,89.9L316.9,89.9z%20M316.1,76.5v-4.8c-2.5,1.2-5.1,2-7.8,2.5c-5.9,1.2-7.6,3-7.6,6.2%20c0,3.6,3,5.1,6.2,5.1C311.6,85.5,316.1,83.1,316.1,76.5L316.1,76.5z%20M344.1,20.2h58.5v18.7h-36.3v12.4h30v17.1h-30v27.5h-22.1%20C344.1,96.1,344.1,20.2,344.1,20.2z%20M401.4,69.2c0-16.5,11.7-28.8,29.7-28.8s29.6,12.3,29.6,28.8s-11.5,28.6-29.6,28.6%20S401.4,85.5,401.4,69.2z%20M440.3,69.2c0-9.2-3.1-15.2-9.3-15.2c-6.2,0-9.2,6.2-9.2,15.2s3,15.2,9.2,15.2%20C437.2,84.5,440.3,78.4,440.3,69.2z%20M484.6,50.2h0.3c4.4-6.8,9.5-9.3,16.5-9.3c1.1,0,2.2,0.2,3.3,0.5v17.1h-0.3%20c-11.8-2-18.7,3.3-18.7,15.6v22h-20.1V42h19.1L484.6,50.2L484.6,50.2z%20M507.2,42h20.7l5.3,19.6c1.2,4.2,2.5,10.9,2.5,10.9h0.2%20c0,0,1.4-6.7,2.5-11.2l4.6-19.2h17l4.7,19.1c1.2,4.7,2.5,11.5,2.5,11.5h0.2c0,0,1.6-6.8,2.6-11l5-19.6h20.2l-17.1,54.1h-19.3%20l-5.4-22.6c-1.1-4.2-2.2-10.1-2.2-10.1H551c0,0-1.2,5.9-2.2,10.1L543.4,96h-19L507.2,42L507.2,42z%20M629.5,89.9h-0.2%20c-3.4,4.8-9,7.6-17.3,7.6c-10.4,0-18-5.6-18-16.2c0-12,9.2-15.6,19.6-16.6c11.5-1.2,14.5-2.6,14.5-6.1c0-3-1.4-5.1-5.8-5.1%20s-6.5,2.5-7.2,6.5h-19c0.5-10.7,8.7-19.4,25.7-19.4c8.2,0,15.2,1.7,19.6,5c4.5,3.3,6.5,7.6,6.5,14.8v20.4c0,3.4,1.4,3.9,3.4,3.4h0.3%20v11.4c-2.8,1.1-5.8,1.6-8.9,1.6C635.1,97.1,630.9,94.9,629.5,89.9L629.5,89.9z%20M628.7,76.5v-4.8c-2.5,1.2-5.1,2-7.8,2.5%20c-5.9,1.2-7.6,3-7.6,6.2c0,3.6,3,5.1,6.2,5.1C624.2,85.5,628.7,83.1,628.7,76.5L628.7,76.5z%20M674.8,50.2h0.3%20c4.4-6.8,9.5-9.3,16.5-9.3c1.1,0,2.2,0.2,3.3,0.5v17.1h-0.5c-11.8-2-18.7,3.3-18.7,15.6v22h-20.1V42h19.1L674.8,50.2L674.8,50.2z%20M697,69.1c0-17,9.8-28.6,24.1-28.6c7.8,0,11.5,2.8,15.1,7.5h0.3V20.3h20.1v75.8h-19.1v-7.5h-0.2c-3.1,5.8-9.3,9.3-15.9,9.3%20C707.4,97.8,697,87.7,697,69.1L697,69.1z%20M737.1,68.7c0-7.8-4-13.8-10-13.8s-9.8,5.6-9.8,13.8s3.7,14.2,9.8,14.2%20S737.1,76.5,737.1,68.7z'/%3e%3c/svg%3e", Oc = { class: "d-flex flex-column justify-center align-center" }, kc = ["src"], Ac = { class: "text-center mb-4" }, jc = /* @__PURE__ */ A({
	__name: "modal-reload",
	props: {
		reloadMsg: { default: "" },
		offline: {
			type: Boolean,
			default: !1
		},
		forceUpdate: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["close"],
	setup(e, { emit: t }) {
		let n = t, { t: r } = it(), o = () => window.location.reload(), u = () => n("close");
		return (t, n) => (j(), E("div", Oc, [k(P(s), {
			class: "pa-8",
			style: { width: "435px" }
		}, {
			default: F(() => [
				k(P(i), { class: "text-center bg-white" }, {
					default: F(() => [e.offline ? T("", !0) : (j(), w(P(he), { key: 0 }, {
						default: F(() => [D("img", {
							src: P(Dc),
							style: { height: "40px" },
							class: "align-self-center"
						}, null, 8, kc)]),
						_: 1
					})), !e.offline && !e.forceUpdate ? (j(), w(P(a), {
						key: 1,
						class: "float-right",
						flat: "",
						round: "",
						dense: "",
						icon: "close",
						onClick: u
					})) : T("", !0)]),
					_: 1
				}),
				k(P(l), { class: "pt-4 text-center" }, {
					default: F(() => [D("h2", Ac, N(e.reloadMsg), 1)]),
					_: 1
				}),
				k(P(c), { align: "center" }, {
					default: F(() => [e.offline ? T("", !0) : (j(), w(P(a), {
						key: 0,
						color: "primary",
						block: "",
						onClick: o
					}, {
						default: F(() => [O(N(P(r)("pingApi.reload")), 1)]),
						_: 1
					}))]),
					_: 1
				})
			]),
			_: 1
		})]));
	}
}), Mc = (e, t) => e === t ? !0 : t.startsWith(`${e}:`), Nc = (e, t) => {
	for (let n of e) if (Mc(n, t)) return !0;
	return !1;
}, Pc, Fc = (e) => Pc = e, Ic = () => {
	if (!Pc) throw Error("Router not yet initialized!");
	return Pc;
}, Lc = bc("CmsUserModelName ", "/cms/users"), { getEntity: Rc, listEntities: zc, putEntity: Bc } = Lc, Vc = async (e) => Rc(e), Hc = async (e) => zc({ params: {
	search: e,
	page: 1
} }), Uc = async (e = !0) => (await mc().get("/cms/session/currentUser", { handleError: e })).data, Wc = async (e) => {
	let { _id: t, ...n } = e;
	return Bc(t, n);
}, Gc = async (e, t) => (await mc().put(`/cms/users/${e}/additional-rights`, { additionalRights: t })).data, Kc = async () => (await mc().get("/cms/session/rights-meta")).data, qc = "authentik:", Jc = "vibe_sso_provider", Yc = "vibe_sso_redirect_uri", Xc = "vibe_sso_oauth_state", Zc = "vibe_sso_code_in_flight", Qc = "vibe_sso_code_in_flight_at", $c = () => `${qc}${crypto.randomUUID()}`, el = (e) => !!e?.startsWith(qc), tl = (e) => {
	if (!el(e)) return !1;
	let t = sessionStorage.getItem(Xc);
	return !!(t && e === t);
}, nl = async (e, t = "cognito", n, r) => (await mc().post("/cms/session/authenticate", {
	code: e,
	provider: t,
	...n ? { redirectUri: n } : {},
	...r ? { oauthClientId: r } : {}
}, { handleError: !1 })).data, rl = async () => (await mc().delete("/cms/session/logout")).data, { getEntity: il } = bc("authors"), al = mo(), ol = {
	loaded: !1,
	loggedIn: !1,
	name: "",
	userId: "",
	group: "External",
	isEnabled: !1,
	avatarUuid: "",
	authorUuid: "",
	email: "",
	rights: [],
	wasLoggedIn: !1,
	expiredToken: !1,
	seenUpdateModal: !1,
	get fullName() {
		return this.name;
	},
	hasRight(e) {
		return (Array.isArray(e) ? e : [e]).every((e) => Nc(this.rights, e));
	},
	resetCurrentUser(e = !1) {
		Object.assign(sl, ol), e && (this.expiredToken = !0), this.wasLoggedIn = !0;
	},
	async loadAvatarUuid(e) {
		let t = await il(e);
		this.avatarUuid = t.imageUuid || "";
	},
	async loadCurrentUser() {
		try {
			this.loaded = !1;
			let e = await Uc(!1);
			this.loaded = !0, this.wasLoggedIn = !0, this.loggedIn = !0, this.expiredToken = !1, this.applyUser(e), this.group === "NewUser" && al.showNotification(new lo(B().t("login.newUserNotification"), "info", { multiLine: !0 })), e.authorUuid && (this.authorUuid = e.authorUuid, await this.loadAvatarUuid(e.authorUuid));
		} catch (e) {
			console.error(e), this.loaded = !0;
		}
		return this;
	},
	async logoutCurrentUser() {
		await rl(), this.userId = "", this.loggedIn = !1, this.wasLoggedIn = !1, this.name = "", this.email = "", this.group = "External", window.localStorage.clear(), await Ic().replace("/login");
	},
	async authenticate(e, t = "cognito", n, r) {
		let i = await nl(e, t, n, r);
		this.applyUser(i), this.loggedIn = !0;
	},
	applyUser(e) {
		this.isEnabled = e.isEnabled, this.name = e.name, this.email = e.email, this.group = e.group, this.userId = e._id, this.rights = e.rights;
	}
}, sl = Be({ ...ol }), cl = () => sl, ll = (e) => {
	if (e.config?.handleError === !1) return Promise.reject(e);
	if (e instanceof ba) {
		let t = mo();
		((t) => e.response?.status === 401 && e.response?.data.type === "UnauthenticatedInCMSError")(e) && !sl.expiredToken && sl.loggedIn && (t.showNotification(new lo(B().t("login.sessionExpired"), "negative", { timeout: lo.NO_TIMEOUT })), sl.resetCurrentUser(!0), sl.loaded = !0), e.response?.status === 403 && t.showNotification(new lo(e.response?.data.message));
	}
	return Promise.reject(e);
}, ul = "/brands", dl = "/logos", q = (e) => `${ul}/${e}`, fl = (e) => `${dl}/${e}`, pl = (e) => e.replace(/\s/g, "-").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ä/g, "ae").replace(/Ö/g, "Oe").replace(/Ü/g, "Ue").replace(/Ä/g, "Ae").replace(/ß/g, "ss").replace(/[^\w\d\s-]/g, "").replace(/-+/g, "-").replace(/-+$/g, "");
//#endregion
//#region src/utils/validation.ts
function ml(e) {
	return /^(?:(?:[^<>()[\]\\.,;:\s@"]+(?:\.[^<>()[\]\\.,;:\s@"]+)*)|(?:".+"))@(?:(?:\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(?:(?:[a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(e).toLowerCase());
}
function hl(e) {
	return /\d/.test(e);
}
function gl(e) {
	return /[A-Z]/.test(e);
}
function _l(e) {
	return /[a-z]/.test(e);
}
function vl(e) {
	return /^[\w\d/-]+$/g.test(e);
}
function yl(e) {
	return /^\d+$/.test(e);
}
function bl(e) {
	return /^\/.*$/.test(e);
}
function xl(e) {
	return /^\d+$/.test(e) && parseInt(e) < 11;
}
function Sl(e) {
	return /^\d+$/.test(e) && parseInt(e) > -1;
}
function Cl(e) {
	return e ? /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(e) : !0;
}
function wl(e) {
	return bo(Vs(e, "dd.MM.yyyy", 0));
}
function Tl(e) {
	let t = Vs(e, "dd.MM.yyyy", 0), n = /* @__PURE__ */ new Date();
	return bo(t) && t <= n;
}
function El(e) {
	return bo(Vs(e, "dd.MM.yyyy HH:mm", 0));
}
function Dl(e) {
	return e[0] !== " ";
}
function Ol(e) {
	return Array.isArray(e) ? !!e?.length : typeof e == "object" ? !!e?.uuid || !!e?._id : !!e?.length;
}
var kl = (e, t) => !e || !t || t.includes(e);
function Al(e, t) {
	return !t || t.trim().length >= e;
}
function jl(e) {
	return !e || e.trim().length >= 1;
}
function J(e, t) {
	return Object.assign(e, { aiHint: t });
}
var Ml = {
	required: J((e) => Ol(e) || B().t("validation.required"), "Must not be empty."),
	validateRequiredRichTextValue: J((e) => !!e && e.trim() !== "<p></p>", "Must contain non-empty content."),
	numberRequired: J((e) => !!e || B().t("validation.required"), "A number is required."),
	equalOrMoreThan: (e) => J((t) => t >= e || `${B().t("validation.moreThan")} ${e}`, `Must be greater than or equal to ${e}.`),
	equalOrLessThan: (e) => J((t) => t <= e || `${B().t("validation.lessThan")} ${e}`, `Must be less than or equal to ${e}.`),
	minLength: (e) => J((t) => t.length >= e || `${B().t("validation.minLength1")} ${e} ${B().t("validation.minLength2")}`, `Minimum ${e} characters.`),
	maxLength: (e) => J((t) => !t || t.length <= e || `${B().t("validation.maxLength1")} ${e} ${B().t("validation.maxLength2")}`, `Maximum ${e} characters.`),
	exactLengthNumbers: (e) => J((t) => t.length >= e || `${B().t("validation.exactLengthNumber1")} ${e} ${B().t("validation.exactLengthNumber2")}`, `Minimum ${e} characters.`),
	containNumber: J((e) => hl(e) || B().t("validation.containNumber"), "Must contain at least one number."),
	containLowercase: J((e) => _l(e) || B().t("validation.containLowercase"), "Must contain at least one lowercase letter."),
	containUppercase: J((e) => gl(e) || B().t("validation.containUppercase"), "Must contain at least one uppercase letter."),
	containSubstring: (e, t) => J((n) => kl(e, n) || B().t(t || "validation.containSubstring"), `Must contain the substring "${e ?? ""}".`),
	validEmail: J((e) => ml(e) || B().t("validation.validEmail"), "Must be a valid email address."),
	validEmailOptional: J((e) => !e || ml(e) || B().t("validation.validEmail"), "Must be a valid email address if provided."),
	validPath: J((e) => vl(e) || B().t("validation.validPath"), "Must be a valid path."),
	validDate: J((e) => wl(e) || B().t("validation.validDate"), "Must be a valid date (dd.MM.yyyy)."),
	validateDateNotInFuture: J((e) => !e || Tl(e) || B().t("validation.validDateNotInFuture"), "Must be a valid date not in the future."),
	validDateTime: J((e) => El(e) || B().t("validation.validDateTime"), "Must be a valid date and time (dd.MM.yyyy HH:mm)."),
	validDateTimeOptional: J((e) => !e || El(e) || B().t("validation.validDateTime"), "Must be a valid date and time if provided."),
	notContainHTML: J((e) => !e.includes(".html") || B().t("validation.notContainHTML"), "Must not contain \".html\"."),
	isNumeric: J((e) => yl(e) || B().t("validation.isNumeric"), "Must contain only digits."),
	isRelativePath: J((e) => bl(e) || B().t("validation.isRelativePath"), "Must be a relative path starting with \"/\"."),
	lessThan11: J((e) => xl(e) || B().t("validation.lessThan11"), "Must be a number less than 11."),
	validUrl: J((e) => Cl(e) || B().t("validation.validURL"), "Must be a valid URL."),
	higherorEqualto0: J((e) => Sl(e) || B().t("validation.higherEqual0"), "Must be a number greater than or equal to 0."),
	positiveNumberOrUndefined: J((e) => !e || Sl(e) || B().t("validation.higherEqual0"), "Must be a number greater than or equal to 0 if provided."),
	noStartingWhiteSpace: J((e) => Dl(e) || B().t("channels.checkWhiteSpace"), "Must not start with a whitespace character."),
	requiredCharsCount: (e) => J((t) => Al(e, t) || `${B().t("validation.required")}`, `Minimum ${e} non-whitespace characters.`),
	noBlankString: J((e) => jl(e) || B().t("validation.required"), "Must not consist only of whitespace."),
	hasCorrectBrandLicense: J((e, t) => !t || !e?._id || e?.license?.includes(t) || e?.brand === t || B().t("articles.errorAssetLicense"), "Must have the correct brand license."),
	slugValidation: J((e, t) => t.isRootChannel ? !0 : !!e || B().t("validation.required"), "Must be a valid slug (required unless the channel is a root channel)."),
	validPublishState: J((e) => e?.state === "publish" || B().t("validation.validPublishState"), "Must be in the published state.")
}, Nl = new Set([
	"script",
	"style",
	"iframe",
	"object",
	"embed",
	"link",
	"meta",
	"base",
	"form",
	"input",
	"button",
	"textarea"
]), Pl = new Set([
	"href",
	"src",
	"xlink:href"
]);
function Fl(e) {
	let t = e.replace(/[\u0000-\u0020]+/g, "").toLowerCase();
	return t.startsWith("javascript:") || t.startsWith("data:") || t.startsWith("vbscript:");
}
function Il(e) {
	let t = e.parentNode;
	if (t) {
		for (; e.firstChild;) t.insertBefore(e.firstChild, e);
		t.removeChild(e);
	}
}
function Ll(e, t) {
	if (typeof document > "u" || typeof document.createElement != "function") return e.replace(/<[^>]*>/g, "");
	let n = t ? new Set(t.map((e) => e.toLowerCase())) : void 0, r = document.createElement("template");
	r.innerHTML = e;
	for (let e of Array.from(r.content.querySelectorAll("*"))) {
		let t = e.tagName.toLowerCase();
		if (Nl.has(t)) {
			e.remove();
			continue;
		}
		for (let t of Array.from(e.attributes)) {
			let n = t.name.toLowerCase();
			(n.startsWith("on") || Pl.has(n) && Fl(t.value)) && e.removeAttribute(t.name);
		}
		n && !n.has(t) && Il(e);
	}
	return r.innerHTML;
}
//#endregion
//#region src/ai-assist/textDiff.ts
var Rl = 1e7;
function zl(e) {
	return e.replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"");
}
function Bl(e) {
	return zl(e.replace(/<\s*br\s*\/?\s*>/gi, "\n").replace(/<\s*\/\s*(p|div|li|h[1-6]|blockquote)\s*>/gi, "\n").replace(/<[^>]*>/g, "")).replace(/[ \t]+/g, " ").replace(/ *\n */g, "\n").replace(/\n{3,}/g, "\n\n").trim();
}
function Vl(e) {
	return e.split(/(\s+)/).filter((e) => e.length > 0);
}
function Hl(e, t, n) {
	let r = e.length, i = t.length, a = e.map(n), o = t.map(n), s = Math.min(r, i), c = 0;
	for (; c < s && a[c] === o[c];) c++;
	let l = 0;
	for (; l < s - c && a[r - 1 - l] === o[i - 1 - l];) l++;
	let u = r - c - l, d = i - c - l;
	if (u * d > Rl) return null;
	let f = [];
	for (let n = 0; n < c; n++) f.push({
		type: "equal",
		a: e[n],
		b: t[n]
	});
	let p = d + 1, m = new Int32Array((u + 1) * p);
	for (let e = u - 1; e >= 0; e--) {
		let t = a[c + e];
		for (let n = d - 1; n >= 0; n--) m[e * p + n] = t === o[c + n] ? (m[(e + 1) * p + n + 1] ?? 0) + 1 : Math.max(m[(e + 1) * p + n] ?? 0, m[e * p + n + 1] ?? 0);
	}
	let h = 0, g = 0;
	for (; h < u && g < d;) a[c + h] === o[c + g] ? (f.push({
		type: "equal",
		a: e[c + h],
		b: t[c + g]
	}), h++, g++) : (m[(h + 1) * p + g] ?? 0) >= (m[h * p + g + 1] ?? 0) ? (f.push({
		type: "delete",
		a: e[c + h]
	}), h++) : (f.push({
		type: "insert",
		b: t[c + g]
	}), g++);
	for (; h < u;) f.push({
		type: "delete",
		a: e[c + h]
	}), h++;
	for (; g < d;) f.push({
		type: "insert",
		b: t[c + g]
	}), g++;
	for (let n = 0; n < l; n++) f.push({
		type: "equal",
		a: e[r - l + n],
		b: t[i - l + n]
	});
	return f;
}
function Ul(e, t, n) {
	let r = e[e.length - 1];
	r && r.type === t ? r.text += n : e.push({
		type: t,
		text: n
	});
}
function Wl(e, t) {
	let n = Vl(e), r = Vl(t);
	if (n.length === 0 && r.length === 0) return [];
	let i = Hl(n, r, (e) => e);
	if (i === null) return t ? [{
		type: "insert",
		text: t
	}] : [];
	let a = [];
	for (let e of i) e.type === "delete" ? Ul(a, "delete", e.a ?? "") : e.type === "insert" ? Ul(a, "insert", e.b ?? "") : Ul(a, "equal", e.b ?? "");
	return a;
}
var Gl = new Set(["strong", "b"]), Kl = new Set(["em", "i"]), ql = new Set([
	"p",
	"div",
	"li",
	"blockquote",
	"ul",
	"ol",
	"tr",
	"section",
	"article"
]);
function Jl(e, t) {
	return e.bold === t.bold && e.italic === t.italic && e.link === t.link && e.heading === t.heading;
}
function Yl(e, t) {
	let n = [];
	return e.bold !== t.bold && n.push("bold"), e.italic !== t.italic && n.push("italic"), e.link !== t.link && n.push("link"), e.heading !== t.heading && n.push("heading"), n;
}
function Xl(e, t) {
	return !e && !t ? !0 : !e || !t || e.length !== t.length ? !1 : e.every((e, n) => e === t[n]);
}
function Zl(e) {
	let t = [], n = 0, r = 0, i = [], a = [], o = () => ({
		bold: n > 0,
		italic: r > 0,
		link: i.length ? i[i.length - 1] ?? null : null,
		heading: a.length ? a[a.length - 1] ?? 0 : 0
	}), s = () => {
		t.push({
			text: "\n",
			marks: o()
		});
	}, c = /<[^>]+>|[^<]+/g, l;
	for (; (l = c.exec(e)) !== null;) {
		let e = l[0];
		if (e.startsWith("<")) {
			let t = /^<\s*(\/)?\s*([a-zA-Z][a-zA-Z0-9]*)\b([^>]*?)\/?>$/.exec(e);
			if (!t) continue;
			let o = t[1] === "/", c = (t[2] ?? "").toLowerCase(), l = t[3] ?? "", u = /^h([1-6])$/.exec(c);
			if (c === "br") s();
			else if (Gl.has(c)) n = Math.max(0, n + (o ? -1 : 1));
			else if (Kl.has(c)) r = Math.max(0, r + (o ? -1 : 1));
			else if (c === "a") if (o) i.pop();
			else {
				let e = /href\s*=\s*("([^"]*)"|'([^']*)')/i.exec(l);
				i.push(e ? e[2] ?? e[3] ?? "" : "");
			}
			else u ? o ? (a.pop(), s()) : a.push(Number(u[1])) : o && ql.has(c) && s();
			continue;
		}
		for (let n of zl(e).split(/(\s+)/)) n.length > 0 && t.push({
			text: n,
			marks: o()
		});
	}
	return t;
}
function Ql(e, t) {
	let n = e[e.length - 1];
	n && n.type === t.type && Jl(n.marks, t.marks) && Xl(n.changed, t.changed) ? n.text += t.text : e.push(t);
}
function $l(e) {
	let t = [], n = [];
	for (let r of e) n.push(r), r.text === "\n" && (t.push(n), n = []);
	return n.length && t.push(n), t;
}
function eu(e, t, n) {
	let r = Hl(e, t, (e) => e.text);
	if (r === null) return !1;
	for (let e of r) if (e.type === "insert" && e.b) Ql(n, {
		type: "insert",
		text: e.b.text,
		marks: e.b.marks
	});
	else if (e.type === "delete" && e.a) Ql(n, {
		type: "delete",
		text: e.a.text,
		marks: e.a.marks
	});
	else if (e.a && e.b) {
		let { text: t } = e.b;
		t.trim() && !Jl(e.a.marks, e.b.marks) ? Ql(n, {
			type: "format",
			text: t,
			marks: e.b.marks,
			changed: Yl(e.a.marks, e.b.marks)
		}) : Ql(n, {
			type: "equal",
			text: t,
			marks: e.b.marks
		});
	}
	return !0;
}
function tu(e, t) {
	let n = Zl(e), r = Zl(t);
	if (n.length === 0 && r.length === 0) return {
		tooLarge: !1,
		segments: []
	};
	let i = Hl($l(n), $l(r), (e) => e.map((e) => e.text).join(""));
	if (i === null) return {
		tooLarge: !0,
		segments: []
	};
	let a = [], o = [], s = [], c = () => {
		if (o.length === 0 && s.length === 0) return !0;
		let e = !0;
		if (o.length === s.length) for (let t = 0; t < o.length && e; t++) e = eu(o[t] ?? [], s[t] ?? [], a);
		else e = eu(o.flat(), s.flat(), a);
		return o = [], s = [], e;
	};
	for (let e of i) if (e.type === "delete" && e.a) o.push(e.a);
	else if (e.type === "insert" && e.b) s.push(e.b);
	else if (e.a && e.b && (!c() || !eu(e.a, e.b, a))) return {
		tooLarge: !0,
		segments: []
	};
	return c() ? {
		tooLarge: !1,
		segments: a
	} : {
		tooLarge: !0,
		segments: []
	};
}
//#endregion
//#region src/ai-assist/types.ts
var nu = [
	"basic",
	"correct",
	"seo"
], ru = {
	class: "vaibe-lockup",
	role: "img",
	"aria-label": "VAIBE"
}, iu = /* @__PURE__ */ Tc(/* @__PURE__ */ A({
	__name: "vaibe-lockup",
	setup(e) {
		return (e, t) => (j(), E("span", ru, [k(P(h), {
			name: "ai-generated-icon",
			size: "17px",
			class: "vaibe-lockup__icon"
		}), t[0] ||= D("svg", {
			class: "vaibe-lockup__wordmark",
			width: "52.05",
			height: "17.488",
			viewBox: "0 0 53 18",
			fill: "none",
			"aria-hidden": "true",
			focusable: "false"
		}, [
			D("path", {
				d: "M7.14844 14.4727L12.1758 0H14.625L8.30859 17.0625H6.5625L7.14844 14.4727ZM2.44922 0L7.42969 14.4727L8.05078 17.0625H6.30469L0 0H2.44922Z",
				fill: "currentColor"
			}),
			D("path", {
				d: "M17.5955 2.58984L12.7322 17.0625H9.32203L15.697 0H17.8767L17.5955 2.58984ZM21.6619 17.0625L16.7752 2.58984L16.4822 0H18.6736L25.0837 17.0625H21.6619ZM21.4392 10.7227V13.2656H12.2869V10.7227H21.4392Z",
				fill: "#00636C"
			}),
			D("path", {
				d: "M26.6452 0V17.0625H26.1602L24.6602 13.0625V0H26.6452Z",
				fill: "#00636C"
			}),
			D("path", {
				d: "M28.8642 0V17.0625H26.6452V0H28.8642Z",
				fill: "currentColor"
			}),
			D("path", {
				d: "M35.4595 9.08203H31.1353L31.1119 7.26563H35.0377C35.6861 7.26563 36.2525 7.15625 36.7369 6.9375C37.2213 6.71875 37.5963 6.40625 37.8619 6C38.1353 5.58594 38.272 5.09375 38.272 4.52344C38.272 3.89844 38.1509 3.39063 37.9088 3C37.6744 2.60156 37.3111 2.3125 36.8189 2.13281C36.3345 1.94531 35.7173 1.85156 34.9673 1.85156H31.6392V17.0625H29.3775V0H34.9673C35.8423 0 36.6236 0.0898438 37.3111 0.269531C37.9986 0.441406 38.5806 0.714844 39.0572 1.08984C39.5416 1.45703 39.9088 1.92578 40.1588 2.49609C40.4088 3.06641 40.5338 3.75 40.5338 4.54688C40.5338 5.25 40.3541 5.88672 39.9947 6.45703C39.6353 7.01953 39.1353 7.48047 38.4947 7.83984C37.8619 8.19922 37.1197 8.42969 36.2681 8.53125L35.4595 9.08203ZM35.3541 17.0625H30.2447L31.522 15.2227H35.3541C36.0728 15.2227 36.6822 15.0977 37.1822 14.8477C37.69 14.5977 38.0767 14.2461 38.3423 13.793C38.608 13.332 38.7408 12.7891 38.7408 12.1641C38.7408 11.5312 38.6275 10.9844 38.4009 10.5234C38.1744 10.0625 37.8189 9.70703 37.3345 9.45703C36.8502 9.20703 36.2252 9.08203 35.4595 9.08203H32.2369L32.2603 7.26563H36.6666L37.147 7.92187C37.9673 7.99219 38.6627 8.22656 39.233 8.625C39.8033 9.01562 40.2369 9.51562 40.5338 10.125C40.8384 10.7344 40.9908 11.4062 40.9908 12.1406C40.9908 13.2031 40.7564 14.1016 40.2877 14.8359C39.8267 15.5625 39.1744 16.1172 38.3306 16.5C37.4869 16.875 36.4947 17.0625 35.3541 17.0625Z",
				fill: "currentColor"
			}),
			D("path", {
				d: "M52.0505 15.2227V17.0625H43.0153V15.2227H52.0505ZM43.4723 0V17.0625H41.2106V0H43.4723ZM50.8552 7.33594V9.17578H43.0153V7.33594H50.8552ZM51.9333 0V1.85156H43.0153V0H51.9333Z",
				fill: "currentColor"
			})
		], -1)]));
	}
}), [["__scopeId", "data-v-de309827"]]), au = { class: "col ellipsis" }, ou = { class: "text-h6 ellipsis" }, su = { class: "row q-col-gutter-md" }, cu = { class: "col-6" }, lu = { class: "text-subtitle2 text-grey-7 q-mb-xs" }, uu = {
	class: "ai-assist-panel",
	"data-qa-ai-field-assist-original": ""
}, du = ["innerHTML"], fu = { class: "col-6" }, pu = { class: "row items-center justify-between no-wrap q-mb-xs" }, mu = { class: "text-subtitle2 text-grey-7" }, hu = {
	key: 0,
	class: "relative-position"
}, gu = {
	class: "ai-assist-panel",
	"data-qa-ai-field-assist-result": ""
}, _u = {
	key: 0,
	class: "column items-center justify-center full-height"
}, vu = { class: "text-grey-6 q-mt-sm" }, yu = {
	key: 1,
	class: "text-negative"
}, bu = {
	key: 0,
	class: "ai-diff"
}, xu = ["title"], Su = ["innerHTML"], Cu = {
	key: 3,
	class: "text-grey-5"
}, wu = { class: "row q-gutter-xs q-mb-sm" }, Tu = {
	key: 0,
	class: "q-mb-sm"
}, Eu = { class: "text-caption text-grey-6 q-ml-lg" }, Du = /* @__PURE__ */ Tc(/* @__PURE__ */ A({
	__name: "ai-assist.dialog",
	props: {
		descriptor: {},
		engine: {}
	},
	emits: [...xe.emits],
	setup(t) {
		let n = t, { dialogRef: r, onDialogHide: i, onDialogOK: o } = xe(), { t: f } = it(), m = M(""), h = M(void 0), g = M(!1), _ = M(void 0), v = M(void 0), y = M(!1), b = M(!1), te = C(() => n.descriptor.label || f("aiFieldAssist.fieldFallback")), ne = C(() => n.descriptor.rules.format === "html"), x = C(() => _.value !== void 0), re = C(() => !!m.value.trim() || !!h.value), ie = C(() => Ll(n.descriptor.value, n.descriptor.rules.allowedTags)), ae = C(() => _.value === void 0 ? "" : Ll(_.value, n.descriptor.rules.allowedTags)), se = C(() => n.descriptor.offeredContext ?? []), ce = M(!1), le = C(() => ne.value && b.value && _.value !== void 0 ? tu(n.descriptor.value, _.value) : {
			tooLarge: !1,
			segments: []
		}), S = C(() => le.value.segments);
		Je(le, (e) => {
			e.tooLarge && (ce.value = !0, b.value = !1);
		});
		let ue = C(() => ne.value && x.value && !g.value), de = C(() => ue.value && ce.value);
		function fe(e) {
			let t = e.text.trim().length > 0;
			return [
				`ai-diff__${e.type}`,
				t && e.marks.bold && "ai-diff__bold",
				t && e.marks.italic && "ai-diff__italic",
				t && !!e.marks.link && "ai-diff__link",
				t && e.marks.heading > 0 && "ai-diff__heading"
			];
		}
		function pe(e) {
			if (!(e.type !== "format" || !e.changed?.length)) return f("aiFieldAssist.formatChanged", { marks: e.changed.map((e) => f(`aiFieldAssist.marks.${e}`)).join(", ") });
		}
		let he = C(() => (n.descriptor.actions ?? nu).map((e) => ({
			value: e,
			label: f(`aiFieldAssist.actions.${e}`),
			hint: f(`aiFieldAssist.actionHints.${e}`)
		})));
		function _e(e) {
			h.value = h.value === e ? void 0 : e;
		}
		let ve;
		async function ye() {
			if (!re.value || g.value) return;
			ve?.abort(), ve = new AbortController();
			let { signal: e } = ve;
			g.value = !0, v.value = void 0, b.value = !1, ce.value = !1;
			try {
				let t = await n.engine.run({
					value: n.descriptor.value,
					rules: n.descriptor.rules,
					context: y.value && se.value.length ? se.value : void 0,
					action: h.value,
					freePrompt: m.value.trim() || void 0
				}, { signal: e });
				if (e.aborted) return;
				t.status === "completed" && t.result !== void 0 ? _.value = t.result : v.value = f("aiFieldAssist.error");
			} catch {
				e.aborted || (v.value = f("aiFieldAssist.error"));
			} finally {
				g.value = !1;
			}
		}
		Ie(() => ve?.abort());
		function be() {
			_.value !== void 0 && (n.descriptor.apply(_.value), o());
		}
		return (n, o) => (j(), w(P(p), {
			ref_key: "dialogRef",
			ref: r,
			"data-qa-ai-field-assist-dialog": "",
			onHide: P(i)
		}, {
			default: F(() => [k(P(s), { class: "ai-assist-dialog" }, {
				default: F(() => [
					k(P(l), { class: "row items-center q-pb-none no-wrap" }, {
						default: F(() => [
							D("div", au, [D("div", ou, N(te.value), 1)]),
							k(iu, { class: "q-mx-sm" }),
							Ye(k(P(a), {
								"data-qa-ai-field-assist-dismiss-button": "",
								icon: "close",
								flat: "",
								round: "",
								dense: ""
							}, null, 512), [[P(e)]])
						]),
						_: 1
					}),
					k(P(l), null, {
						default: F(() => [D("div", su, [D("div", cu, [D("div", lu, N(P(f)("aiFieldAssist.original")), 1), D("div", uu, [ne.value ? (j(), E("div", {
							key: 0,
							innerHTML: ie.value
						}, null, 8, du)) : (j(), E(Ce, { key: 1 }, [O(N(t.descriptor.value), 1)], 64))])]), D("div", fu, [D("div", pu, [D("div", mu, N(P(f)("aiFieldAssist.result")), 1), ue.value ? (j(), E("div", hu, [k(P(me), {
							modelValue: b.value,
							"onUpdate:modelValue": o[0] ||= (e) => b.value = e,
							"data-qa-ai-field-assist-diff-toggle": "",
							dense: "",
							size: "sm",
							disable: de.value,
							label: P(f)("aiFieldAssist.showChanges")
						}, null, 8, [
							"modelValue",
							"disable",
							"label"
						]), de.value ? (j(), w(P(ge), {
							key: 0,
							anchor: "top middle",
							self: "bottom middle",
							"data-qa-ai-field-assist-diff-too-large": ""
						}, {
							default: F(() => [O(N(P(f)("aiFieldAssist.diffTooLarge")), 1)]),
							_: 1
						})) : T("", !0)])) : T("", !0)]), D("div", gu, [g.value ? (j(), E("div", _u, [k(P(oe), {
							color: "primary",
							size: "40px"
						}), D("div", vu, N(P(f)("aiFieldAssist.loading")), 1)])) : v.value ? (j(), E("div", yu, N(v.value), 1)) : _.value === void 0 ? (j(), E("div", Cu, N(P(f)("aiFieldAssist.resultPlaceholder")), 1)) : (j(), E(Ce, { key: 2 }, [b.value && !de.value ? (j(), E("div", bu, [(j(!0), E(Ce, null, Ve(S.value, (e, t) => (j(), E("span", {
							key: t,
							class: Ne(fe(e)),
							title: pe(e)
						}, N(e.text), 11, xu))), 128))])) : ne.value ? (j(), E("div", {
							key: 1,
							innerHTML: ae.value
						}, null, 8, Su)) : (j(), E(Ce, { key: 2 }, [O(N(_.value), 1)], 64))], 64))])])])]),
						_: 1
					}),
					k(P(l), { class: "q-pt-none" }, {
						default: F(() => [
							D("div", wu, [(j(!0), E(Ce, null, Ve(he.value, (e) => (j(), w(P(d), {
								key: e.value,
								"data-qa-ai-field-assist-action": e.value,
								clickable: "",
								color: h.value === e.value ? "primary" : "cyan-1",
								"text-color": h.value === e.value ? "white" : "dark",
								disable: g.value,
								onClick: (t) => _e(e.value)
							}, {
								default: F(() => [O(N(e.label) + " ", 1), k(P(ge), {
									anchor: "top middle",
									self: "bottom middle"
								}, {
									default: F(() => [O(N(e.hint), 1)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1032, [
								"data-qa-ai-field-assist-action",
								"color",
								"text-color",
								"disable",
								"onClick"
							]))), 128))]),
							se.value.length ? (j(), E("div", Tu, [k(P(u), {
								modelValue: y.value,
								"onUpdate:modelValue": o[1] ||= (e) => y.value = e,
								"data-qa-ai-field-assist-context-checkbox": "",
								dense: "",
								size: "sm",
								disable: g.value,
								label: P(f)("aiFieldAssist.useContext")
							}, null, 8, [
								"modelValue",
								"disable",
								"label"
							]), D("div", Eu, N(P(f)("aiFieldAssist.useContextHint")), 1)])) : T("", !0),
							k(P(ee), {
								modelValue: m.value,
								"onUpdate:modelValue": o[2] ||= (e) => m.value = e,
								"data-qa-ai-field-assist-prompt-input": "",
								type: "textarea",
								autogrow: "",
								outlined: "",
								dense: "",
								disable: g.value,
								label: P(f)("aiFieldAssist.promptLabel"),
								onKeyup: Xe(Ze(ye, ["ctrl"]), ["enter"])
							}, null, 8, [
								"modelValue",
								"disable",
								"label",
								"onKeyup"
							])
						]),
						_: 1
					}),
					k(P(c), { class: "q-px-md q-pb-md" }, {
						default: F(() => [
							x.value ? (j(), w(P(a), {
								key: 0,
								"data-qa-ai-field-assist-retry-button": "",
								color: "primary",
								icon: "refresh",
								label: P(f)("aiFieldAssist.regenerate"),
								disable: g.value || !re.value,
								onClick: ye
							}, null, 8, ["label", "disable"])) : (j(), w(P(a), {
								key: 1,
								"data-qa-ai-field-assist-generate-button": "",
								color: "primary",
								icon: "ai-prompt",
								label: P(f)("aiFieldAssist.generate"),
								disable: g.value || !re.value,
								onClick: ye
							}, null, 8, ["label", "disable"])),
							Ye(k(P(a), {
								"data-qa-ai-field-assist-cancel-button": "",
								outline: "",
								color: "secondary",
								icon: "close",
								label: P(f)("aiFieldAssist.cancel")
							}, null, 8, ["label"]), [[P(e)]]),
							x.value ? (j(), w(P(a), {
								key: 2,
								"data-qa-ai-field-assist-accept-button": "",
								color: "positive",
								icon: "check",
								label: P(f)("aiFieldAssist.accept"),
								disable: g.value,
								onClick: be
							}, null, 8, ["label", "disable"])) : T("", !0)
						]),
						_: 1
					})
				]),
				_: 1
			})]),
			_: 1
		}, 8, ["onHide"]));
	}
}), [["__scopeId", "data-v-05bc86b3"]]), Ou = Symbol("AiEngine");
function ku(e) {
	ze(Ou, e);
}
function Au() {
	return Oe(Ou, void 0);
}
var ju = Symbol("AiContextResolver");
function Mu(e) {
	ze(ju, e);
}
function Nu() {
	return Oe(ju, void 0);
}
//#endregion
//#region src/ai-assist/useAiAssist.ts
function Pu() {
	let e = Au(), n = C(() => !!e);
	function r(n) {
		e && t.create({
			component: Du,
			componentProps: {
				descriptor: n,
				engine: e
			}
		});
	}
	return {
		isAvailable: n,
		openAiAssist: r
	};
}
//#endregion
//#region src/ai-assist/ai-assist.button.vue
var Fu = /* @__PURE__ */ A({
	__name: "ai-assist.button",
	props: { getDescriptor: { type: Function } },
	setup(e) {
		let t = e, { t: n } = it(), { isAvailable: r, openAiAssist: i } = Pu();
		function o() {
			i(t.getDescriptor());
		}
		return (e, t) => P(r) ? (j(), w(P(a), {
			key: 0,
			"data-qa-ai-field-assist-button": "",
			flat: "",
			dense: "",
			round: "",
			size: "md",
			icon: "ai-prompt",
			color: "primary",
			onClick: Ze(o, ["stop"])
		}, {
			default: F(() => [k(P(ge), {
				anchor: "top middle",
				self: "bottom middle"
			}, {
				default: F(() => [O(N(P(n)("aiFieldAssist.buttonTooltip")), 1)]),
				_: 1
			})]),
			_: 1
		})) : T("", !0);
	}
}), Iu = "You edit a single content field for a CMS editor.\nReturn ONLY the resulting field value.\nDo not add explanations, comments, labels, surrounding quotes, or follow-up questions.\nKeep the same language as the input unless the instruction explicitly asks to translate.\n\nSafety rules (always apply; they override stylistic goals):\n\n1) Sources & attribution\n- Keep all source references, citations, links, footnotes, and attribution markers.\n- Do not remove, rewrite, or relocate them unless the editor instruction explicitly asks to change sources.\n\n2) Facts & meaning\n- Preserve factual meaning, names, numbers, products, and specific terms (e.g. do not turn \"Autobahn\" into \"Bahn\").\n- Prefer leaving a constraint unmet over changing meaning to fit length or style.\n\n3) Length changes\n- Do not shorten or lengthen the text unless the selected action or editor instruction asks for it.\n- If asked to shorten and you cannot without losing facts or sources, keep meaning intact and shorten only what is safe — never invent filler or distort terms to hit a length.\n\n4) Grammar quality\n- Do not introduce new spelling, grammar, or punctuation errors.\n- Prefer a slightly less elegant phrasing over an incorrect one. Preserve correct constructions (including valid German word order).\n\n5) Scope of changes\n- Only perform changes required by the selected action and/or the editor instruction.\n- Do not add extra rewrites, synonyms, restructuring, or formatting beyond that scope (e.g. if asked only to bold passages, bold only — do not reword).", Lu = {
	basic: "Improve wording and readability while keeping the original meaning, facts, and sources. Do not shorten or expand unless asked. Do not introduce grammatical errors.",
	correct: "Fix spelling, grammar and punctuation only. Do not change the meaning or the style.",
	seo: "Optimize for search engines while keeping meaning, facts, and sources intact. Do not drop attributions. Do not introduce grammatical errors. Do not shorten solely to fit a limit if that would change meaning."
};
function Ru(e) {
	if (e.rules.format === "html") {
		let t = e.rules.allowedTags?.length ? ` using only these tags: ${e.rules.allowedTags.join(", ")}` : "";
		return e.rules.inline ? [
			`Return inline HTML only${t}.`,
			"Do not add block-level tags (p, div, h1-h6, ul, ol, li, blockquote), and do not wrap the result in a paragraph.",
			"Do not use markdown or code fences."
		].join(" ") : [
			`Return valid HTML${t}.`,
			"Preserve the existing formatting and block structure of the input.",
			"Do not use wrapper tags (html, body, article), markdown, or code fences."
		].join(" ");
	}
	return "Return plain text only, without markdown or HTML tags.";
}
function zu(e) {
	let t = [Iu, Ru(e)];
	if (e.action && t.push(Lu[e.action]), e.rules.language && t.push(e.rules.language), e.rules.constraints.length && t.push(`Constraints to follow:\n${e.rules.constraints.map((e) => `- ${e}`).join("\n")}`), e.freePrompt && t.push(`Editor instruction: ${e.freePrompt}`), e.context?.length) {
		let n = e.context.map((e) => `<${e.key}>\n${e.value}\n</${e.key}>`).join("\n");
		t.push(`Reference context (do not return this, use it only to inform the result):\n${n}`);
	}
	return t.join("\n\n");
}
//#endregion
//#region src/ai-assist/createAiFieldEngine.ts
var Bu = 2e3, Vu = 45;
function Hu(e) {
	let t = e.trim(), n = t.match(/^```(?:html|markdown|md|text)?\s*\r?\n([\s\S]*?)\r?\n```$/i);
	return n?.[1] ? n[1].trim() : t;
}
function Uu(e) {
	let t = bc(`AiFieldAssist-${e}`, `/cms/ai-assist/${e}`).getEntityAPIClient();
	async function n(e, n) {
		for (let r = 1; r <= Vu; r++) {
			if (n?.aborted) return {
				status: "failed",
				error: "aborted"
			};
			try {
				let { data: n } = await t.get(`transform/${e}`);
				if (n.status === "completed") return {
					status: "completed",
					result: Hu(n.result ?? "")
				};
				if (n.status === "failed") return {
					status: "failed",
					error: n.error ?? void 0
				};
			} catch (e) {
				console.error("AI field-assist: failed to fetch transform result, retrying", e);
			}
			r < Vu && await new Promise((e) => setTimeout(e, Bu));
		}
		return {
			status: "failed",
			error: "timeout"
		};
	}
	return { async run(e, r) {
		let { data: i } = await t.post("transform", {
			prompt: { system_prompt: zu(e) },
			data: e.value
		});
		return i.job_id ? n(i.job_id, r?.signal) : {
			status: "failed",
			error: "init failed"
		};
	} };
}
//#endregion
//#region src/ai-assist/harvestAiHints.ts
function Wu(e) {
	if (typeof e != "function" || !("aiHint" in e)) return;
	let { aiHint: t } = e;
	return typeof t == "string" && t.trim().length > 0 ? t : void 0;
}
function Gu(e) {
	return Array.isArray(e) ? e.map(Wu).filter((e) => e !== void 0) : [];
}
function Ku({ rules: e, targetLength: t, maxLength: n, minLength: r }) {
	let i = Gu(e);
	return typeof n == "number" && typeof t == "number" ? i.push(`Aim for about ${t} characters, and never exceed ${n} characters.`) : typeof n == "number" ? i.push(`Maximum ${n} characters.`) : typeof t == "number" && i.push(`Aim for about ${t} characters.`), typeof r == "number" && i.push(`Minimum ${r} characters.`), [...new Set(i)];
}
//#endregion
//#region src/ai-assist/useAiFieldDescriptor.ts
function qu(e) {
	let t = Nu();
	function n() {
		let n = e.getTargetLength?.(), r = e.getMaxLength?.(), i = e.getMinLength?.(), a = e.getContextScope?.() ?? [], o = t && a.length ? t(a) : void 0;
		return {
			value: e.getValue(),
			label: e.getLabel?.(),
			apply: e.apply,
			actions: e.getActions?.(),
			offeredContext: o?.length ? o : void 0,
			rules: {
				format: e.format,
				targetLength: n,
				maxLength: r,
				minLength: i,
				language: e.getLanguage?.(),
				allowedTags: e.allowedTags,
				inline: e.getInline?.() ?? !1,
				constraints: Ku({
					rules: e.getRules?.(),
					targetLength: n,
					maxLength: r,
					minLength: i
				})
			}
		};
	}
	return { getDescriptor: n };
}
//#endregion
//#region src/components/bf-brand.icon.vue?vue&type=script&setup=true&lang.ts
var Ju = [
	"src",
	"alt",
	"title"
], Yu = /* @__PURE__ */ Tc(/* @__PURE__ */ A({
	__name: "bf-brand.icon",
	props: {
		brand: {},
		small: {
			type: Boolean,
			default: !1
		},
		style: { default: "text" }
	},
	setup(e) {
		let t = q("bunte-logo.svg"), n = q("chip.svg"), r = q("fitforfun-logo.svg"), i = q("focus-online.svg"), a = q("finanzen100-logo.svg"), o = q("mittier-logo.svg"), s = q("mitsternen-logo-rectangular.svg"), c = q("mitbeziehung-logo-rectangular.svg"), l = q("tvtoday.svg"), u = q("tvspielfilm-logo.svg"), d = q("bunte_color.png"), f = q("chip_color.png"), p = q("fitforfun_color.png"), m = q("focus_color.png"), h = q("finanzen100_color.svg"), g = q("mittier_color.svg"), ee = q("mitsternen-logo.svg"), _ = q("mitbeziehung-square.svg"), v = q("tvspielfilm_color.png"), y = q("tvtoday_color.png"), b = e, te = {
			bunte: {
				brandTitle: "BUNTE.de",
				textLogo: t,
				colorLogo: d
			},
			chip: {
				brandTitle: "CHIP",
				textLogo: n,
				colorLogo: f
			},
			focus: {
				brandTitle: "FOCUS online",
				textLogo: i,
				colorLogo: m
			},
			fitforfun: {
				brandTitle: "FIT FOR FUN",
				textLogo: r,
				colorLogo: p
			},
			finanzen100: {
				brandTitle: "Finanzen100",
				textLogo: a,
				colorLogo: h
			},
			mittier: {
				brandTitle: "Mit Tier",
				textLogo: o,
				colorLogo: g
			},
			mitsternen: {
				brandTitle: "Mit Sternen",
				textLogo: s,
				colorLogo: ee
			},
			mitbeziehung: {
				brandTitle: "Mit Beziehung",
				textLogo: c,
				colorLogo: _
			},
			tvspielfilm: {
				brandTitle: "TV Spielfilm",
				textLogo: u,
				colorLogo: v
			},
			tvtoday: {
				brandTitle: "TV Today",
				textLogo: l,
				colorLogo: y
			}
		}, ne = C(() => {
			let e = te[b.brand];
			if (!e) throw Error(`Brand icon configuration not found for: ${b.brand}`);
			return e;
		}), x = C(() => ne.value?.brandTitle ?? b.brand), re = C(() => b.style === "text" ? ne.value?.textLogo ?? "" : ne.value?.colorLogo ?? ""), ie = C(() => ({
			small: b.small,
			big: !b.small
		}));
		return (t, n) => (j(), E("img", je({
			src: re.value,
			alt: e.brand,
			class: ie.value
		}, t.$attrs, { title: x.value }), null, 16, Ju));
	}
}), [["__scopeId", "data-v-373bbdcc"]]), Xu = /* @__PURE__ */ Tc(/* @__PURE__ */ A({
	__name: "bf-brand-based-state",
	props: {
		brandStates: {},
		brandIconSizePx: { default: 35 },
		iconsPerRow: { default: void 0 }
	},
	emits: ["brand:click"],
	setup(e) {
		let t = q("bunte_bw.png"), n = q("bunte_color.png"), r = q("chip_bw.png"), i = q("chip_color.png"), a = q("finanzen100_color.svg"), o = q("finanzen100_w.svg"), s = q("fitforfun_bw.png"), c = q("fitforfun_color.png"), l = q("focus_bw.png"), u = q("focus_color.png"), d = q("mitbeziehung-bw.svg"), f = q("mitbeziehung-square.svg"), p = q("mitsternen-logo.svg"), m = q("mitsternen-logo-black.svg"), h = q("mittier_bw.svg"), ee = {
			bunteDisabled: t,
			bunteActive: n,
			chipDisabled: r,
			chipActive: i,
			fitforfunDisabled: s,
			fitforfunActive: c,
			focusDisabled: l,
			focusActive: u,
			finanzen100Disabled: o,
			finanzen100Active: a,
			mittierActive: q("mittier_color.svg"),
			mittierDisabled: h,
			mitsternenDisabled: m,
			mitsternenActive: p,
			mitbeziehungDisabled: d,
			mitbeziehungActive: f,
			tvspielfilmDisabled: q("tvspielfilm_bw.png"),
			tvspielfilmActive: q("tvspielfilm_color.png"),
			tvtodayDisabled: q("tvtoday_bw.png"),
			tvtodayActive: q("tvtoday_color.png")
		}, _ = e, v = C(() => _.iconsPerRow ? "bf-brand-based-state--grid" : "bf-brand-based-state--inline"), y = C(() => _.iconsPerRow ? { gridTemplateColumns: `repeat(${_.iconsPerRow}, auto)` } : void 0), b = C(() => _.brandStates.map((e) => ({
			image: ee[e.active ? `${e.brand}Active` : `${e.brand}Disabled`],
			brand: e.brand,
			isActive: e.active
		})).filter((e) => e.image));
		return (t, n) => (j(), E("div", je({
			class: ["bf-brand-based-state", v.value],
			style: y.value
		}, t.$attrs), [(j(!0), E(Ce, null, Ve(b.value, (n) => (j(), w(P(g), {
			key: n.image,
			src: n.image,
			position: "center",
			width: `${e.brandIconSizePx}px`,
			height: `${e.brandIconSizePx}px`,
			"data-qa-state-icon-active": `${n.brand}:${n.isActive}`,
			fit: "cover",
			ratio: "1/1",
			class: Ne({ "q-mr-xs": !e.iconsPerRow }),
			onClick: (e) => t.$emit("brand:click", n.brand)
		}, null, 8, [
			"src",
			"width",
			"height",
			"data-qa-state-icon-active",
			"class",
			"onClick"
		]))), 128))], 16));
	}
}), [["__scopeId", "data-v-e39537c7"]]), Zu = /* @__PURE__ */ A({
	__name: "bf-entity-no-edit-icon",
	props: { tooltipLabel: {} },
	setup(e) {
		return (t, n) => (j(), w(P(h), je({
			color: "primary",
			name: "mdi-pencil-off-outline",
			size: "x-large"
		}, t.$attrs), {
			default: F(() => [e.tooltipLabel ? (j(), w(P(ge), {
				key: 0,
				anchor: "top middle",
				class: "text-caption",
				self: "center left",
				style: { backgroundColor: "var(--tooltip-bg)" }
			}, {
				default: F(() => [O(N(e.tooltipLabel), 1)]),
				_: 1
			})) : T("", !0)]),
			_: 1
		}, 16));
	}
}), Qu = /* @__PURE__ */ A({
	__name: "bf-entity-state.icon",
	props: { state: { default: "draft" } },
	setup(e) {
		let t = e, n = {
			draft: "grey-7",
			schedule: "blue",
			publish: "green",
			unpublish: "red"
		}, r = {
			draft: "edit",
			schedule: "clock",
			publish: "check-circle",
			unpublish: "minus-circle"
		}, i = C(() => r[t.state]);
		return (e, r) => (j(), w(P(h), je({
			name: i.value,
			color: n[t.state]
		}, e.$attrs), null, 16, ["name", "color"]));
	}
}), $u = /* @__PURE__ */ A({
	__name: "bf-entity-state.selector",
	props: {
		modelValue: {},
		showRescheduledOption: { type: Boolean },
		states: {}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = C({
			get: () => n.modelValue ?? "",
			set: (e) => r("update:modelValue", e || void 0)
		}), { t: a } = B(), o = () => {
			let e = [
				{
					label: a("entityState.dpAll"),
					value: ""
				},
				{
					label: a("entityState.dpDraft"),
					value: "draft"
				},
				{
					label: a("entityState.dpSchedule"),
					value: "schedule"
				},
				{
					label: a("entityState.dpPublished"),
					value: "publish"
				},
				{
					label: a("entityState.dpExpired"),
					value: "unpublish"
				},
				{
					label: a("entityState.dpRescheduled"),
					value: "rescheduled"
				}
			];
			return n.states ? n.states.map((t) => e.find((e) => e.value === t)).filter((e) => e !== void 0) : e.filter((e) => e.value !== "rescheduled" || n.showRescheduledOption);
		};
		return (e, t) => (j(), w(P(re), je({
			modelValue: i.value,
			"onUpdate:modelValue": t[0] ||= (e) => i.value = e,
			"data-qa-state-dropdown": i.value,
			options: o(),
			label: P(a)("entityState.status"),
			"dropdown-icon": "expand_more",
			"emit-value": "",
			"map-options": "",
			outlined: "",
			dense: ""
		}, e.$attrs), {
			option: F((e) => [k(P(_), je(e.itemProps, { "data-qa-state-dropdown-option": e.opt.value }), {
				default: F(() => [k(P(y), null, {
					default: F(() => [O(N(e.opt.label), 1)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1040, ["data-qa-state-dropdown-option"])]),
			_: 1
		}, 16, [
			"modelValue",
			"data-qa-state-dropdown",
			"options",
			"label"
		]));
	}
}), ed = 100;
function td(e) {
	let t = e.querySelector("input, textarea");
	return t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement ? t : null;
}
function nd(e, t, n) {
	if (!(t == null || n == null)) try {
		e.setSelectionRange(t, n);
	} catch {}
}
function rd(e) {
	if (e.__germanQuotes__) return;
	let t = td(e);
	if (!t) return;
	let n = ye(() => {
		if (t.readOnly || t.disabled || !at(t.value)) return;
		let e = t.selectionStart, n = t.selectionEnd, r = ot(t.value);
		r !== t.value && (t.value = r, t.dispatchEvent(new Event("input", { bubbles: !0 })), requestAnimationFrame(() => nd(t, e, n)));
	}, ed), r = () => n();
	t.addEventListener("input", r), e.__germanQuotes__ = {
		input: t,
		handler: r
	};
}
function id(e) {
	let t = e.__germanQuotes__;
	t && (t.input.removeEventListener("input", t.handler), delete e.__germanQuotes__);
}
var ad = {
	mounted(e, t) {
		t.value !== !1 && rd(e);
	},
	updated(e, t) {
		let n = e.__germanQuotes__ != null, r = t.value !== !1;
		r && !n && rd(e), !r && n && id(e);
	},
	unmounted(e) {
		id(e);
	}
}, od = ["textContent"], sd = /* @__PURE__ */ Tc(/* @__PURE__ */ A({
	__name: "bf-limited-text.input",
	props: /* @__PURE__ */ Ae({
		maxPerfectLength: { default: void 0 },
		maxLength: { default: void 0 },
		hasGermanQuotes: {
			type: Boolean,
			default: !0
		},
		aiAssist: {
			type: Boolean,
			default: !1
		},
		aiAssistContextScope: { default: void 0 },
		aiAssistActions: { default: void 0 }
	}, {
		modelValue: { default: "" },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let { t } = it(), n = e, r = Ke(e, "modelValue"), i = Ge(), a = C(() => !!(i.disable ?? i.disabled ?? i.readonly));
		function o(e) {
			if (e !== void 0) return Array.isArray(e) ? e : [e];
		}
		let { getDescriptor: s } = qu({
			getValue: () => r.value,
			format: "plain",
			apply: (e) => {
				r.value = e.trim();
			},
			getRules: () => i.rules,
			getTargetLength: () => n.maxPerfectLength,
			getMaxLength: () => n.maxLength,
			getLanguage: () => n.hasGermanQuotes ? "If the text already contains quotation marks, format them as German typographic quotes („ … “). Do not add surrounding or extra quotation marks." : void 0,
			getContextScope: () => o(n.aiAssistContextScope),
			getLabel: () => typeof i.label == "string" ? i.label : void 0,
			getActions: () => n.aiAssistActions
		}), c = C(() => !n.maxPerfectLength && !n.maxLength ? {
			state: "normal",
			text: `${t("articlesEdit.length")}:`
		} : n.maxPerfectLength && r.value.length <= n.maxPerfectLength ? {
			state: "perfect",
			icon: "check-circle",
			text: t("articlesEdit.seoPerfect")
		} : n.maxLength && r.value.length <= n.maxLength ? {
			state: "okay",
			icon: "check",
			text: t("articlesEdit.seoOkay")
		} : {
			state: "long",
			icon: "alert-circle",
			text: t("articlesEdit.seoLong")
		}), l = C(() => {
			let e = n.maxPerfectLength ? `(${r.value.length}/${n.maxPerfectLength})` : `${r.value.length}`;
			return `${c.value.text} ${e}`;
		});
		return (t, n) => Ye((j(), w(P(ee), je(t.$attrs, {
			modelValue: r.value,
			"onUpdate:modelValue": n[0] ||= (e) => r.value = e,
			"bottom-slots": ""
		}), we({
			counter: F(() => [D("div", { class: Ne(["text-length-info q-mt-xxs", c.value?.state]) }, [k(P(h), { name: c.value.icon }, null, 8, ["name"]), D("span", {
				"data-qa-article-word-counter": "",
				class: "text-length-info__message",
				textContent: N(l.value)
			}, null, 8, od)], 2)]),
			_: 2
		}, [e.aiAssist && !a.value ? {
			name: "append",
			fn: F(() => [k(Fu, { "get-descriptor": P(s) }, null, 8, ["get-descriptor"])]),
			key: "0"
		} : void 0]), 1040, ["modelValue"])), [[P(ad), e.hasGermanQuotes]]);
	}
}), [["__scopeId", "data-v-7560643a"]]), Y;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.FITFORFUN = "fitforfun", e.FINANZEN100 = "finanzen100", e.MITTIER = "mittier", e.MITSTERNEN = "mitsternen", e.MITBEZIEHUNG = "mitbeziehung", e.TVTODAY = "tvtoday", e.TVSPIELFILM = "tvspielfilm";
})(Y ||= {}), Object.freeze(Y);
var cd;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.PRAXISTIPPS = "praxistipps";
})(cd ||= {}), Object.freeze(cd), Object.freeze([
	Y.MITTIER,
	Y.MITSTERNEN,
	Y.MITBEZIEHUNG,
	Y.TVTODAY,
	Y.TVSPIELFILM
]), Object.freeze({
	[Y.BUNTE]: "bunte",
	[Y.CHIP]: "chip",
	[Y.FOCUS]: "focus",
	[Y.FITFORFUN]: "fitforfun",
	[Y.FINANZEN100]: "finanzen100",
	[Y.MITTIER]: "default-verticals",
	[Y.MITSTERNEN]: "default-verticals",
	[Y.MITBEZIEHUNG]: "default-verticals",
	[Y.TVTODAY]: "default",
	[Y.TVSPIELFILM]: "default"
}), Object.freeze(Object.values(Y)), Object.freeze(Object.values(cd)), Y.BUNTE, Y.CHIP, Y.FOCUS, Y.FITFORFUN, Y.TVSPIELFILM, Y.TVTODAY, Y.BUNTE, Y.CHIP, Y.FOCUS, Y.FITFORFUN, Y.TVSPIELFILM, Y.TVTODAY;
//#endregion
//#region src/components/bf-logo.icon.vue?vue&type=script&setup=true&lang.ts
var ld = ["src", "alt"], ud = /* @__PURE__ */ Tc(/* @__PURE__ */ A({
	__name: "bf-logo.icon",
	props: { brands: {} },
	setup(e) {
		let t = fl("bunte.svg"), n = fl("bunte-unused.svg"), r = fl("chip.svg"), i = fl("chip-unused.svg"), a = fl("focus.svg"), o = fl("focus-unused.svg"), s = fl("mitsternen.svg"), c = fl("mitsternen-unused.svg"), l = fl("mittier.svg"), u = fl("unused-mittier.svg"), d = e, f = {
			bunte: t,
			chip: r,
			focus: a,
			mittier: l,
			mitsternen: s
		}, p = {
			bunte: n,
			chip: i,
			focus: o,
			mittier: u,
			mitsternen: c
		}, m = [
			Y.FOCUS,
			Y.BUNTE,
			Y.CHIP,
			Y.MITTIER,
			Y.MITSTERNEN
		], h = (e) => (d.brands.includes(e) ? f[e] : p[e]) || "";
		return (e, t) => (j(), E("div", null, [(j(), E(Ce, null, Ve(m, (t) => D("img", je({
			key: t,
			src: h(t),
			alt: t,
			class: "big q-mr-sm"
		}, { ref_for: !0 }, e.$attrs), null, 16, ld)), 64))]));
	}
}), [["__scopeId", "data-v-48e3daee"]]), dd = /* @__PURE__ */ A({
	__name: "bf-scheduled-change-icon",
	props: {
		scheduleDate: {},
		index: {},
		entity: {}
	},
	setup(e) {
		let { t } = it();
		return (n, r) => (j(), w(P(h), Pe({
			size: "16px",
			[`scheduled-lock-${e.entity}` || ""]: e.index,
			name: "schedule-lock"
		}), {
			default: F(() => [k(P(ge), {
				anchor: "top middle",
				self: "top middle",
				offset: [0, 35],
				class: "bg-grey-10 text-white shadow-4 text-caption"
			}, {
				default: F(() => [O(N(P(t)("newsArticleList.scheduledChangeToolTipMessage")) + " " + N(e.scheduleDate), 1)]),
				_: 1
			})]),
			_: 1
		}, 16));
	}
}), fd;
(function(e) {
	e.LOCAL = "local", e.LOCAL_K8S = "local_k8s", e.LOCAL_E2E = "local_e2e", e.SANDBOX = "sandbox", e.DEVELOPMENT = "development", e.STAGING = "staging", e.PRODUCTION = "production", e.TEST = "test";
})(fd ||= {});
//#endregion
//#region ../../../ctf-config/dist/configHelper.js
function pd(e) {
	return md(e);
}
function md(e) {
	return Object.getOwnPropertyNames(e).forEach((t) => {
		let n = e[t];
		n && (typeof n == "object" || typeof n == "function") && !Object.isFrozen(n) && md(n);
	}), Object.freeze(e);
}
function hd(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
function gd(e) {
	return hd(e);
}
function _d(e) {
	return hd(e);
}
function vd(e) {
	return typeof e == "function";
}
function yd(e) {
	return Object.fromEntries(Object.entries(e));
}
function bd(e, t) {
	let n = {}, r = yd(t), i = yd(e);
	for (let e of Object.keys({
		...r,
		...i
	})) {
		let t = r[e], a = i[e];
		hd(t) && _d(a) ? n[e] = bd(a, t) : vd(a) ? n[e] = a.bind(n) : vd(t) ? n[e] = t.bind(n) : e in i ? n[e] = a : n[e] = t;
	}
	if (!gd(n)) throw Error("merged config is not an object");
	return n;
}
function xd(e) {
	return Object.values(fd).find((t) => t === e) !== void 0;
}
function Sd() {
	let e = process.env.APP_ENV;
	if (e === void 0) throw Error("APP_ENV is undefined.\nHint: configuration should be initialized lazily during runtime and not during build time.");
	if (!xd(e)) throw Error(`APP_ENV=${e}. Allowed values=${Object.values(fd).join(", ")}`);
	return e;
}
var Cd = /* @__PURE__ */ new WeakMap(), wd = /* @__PURE__ */ new WeakMap();
function Td(e, t) {
	let n = Cd.get(e), r = n?.get(t);
	if (gd(r)) return r;
	let { base: i, ...a } = e, o;
	o = typeof process > "u" ? a.local : a[Sd()];
	let s = wd.get(e), c = gd(s) ? s : void 0;
	c === void 0 && (c = o ? bd(o, i) : i, wd.set(e, c));
	let { _: l, ...u } = c, d = u[t], f = pd(d ? bd(d, l) : l);
	return n || (n = /* @__PURE__ */ new Map(), Cd.set(e, n)), n.set(t, f), f;
}
function X() {
	return typeof process > "u" ? "" : process.env.BRANCH_SANDBOX_NAME ? `${process.env.BRANCH_SANDBOX_NAME}.` : "";
}
//#endregion
//#region ../../../ctf-config/dist/configs/rendering.brand.config.js
var Ed;
(function(e) {
	e.PageNavigation = "pageNavigation", e.MoreButton = "moreButton";
})(Ed ||= {});
var Dd;
(function(e) {
	e.AQUA = "aqua", e.BLACK = "black", e.BLUE = "blue", e.RED = "red", e.GRAY = "gray", e.BRAND = "brand", e.TRANSPARENT = "transparent";
})(Dd ||= {});
var Od = 3600, kd = {
	recentArticle: 60,
	oldArticle: 600
}, Ad = {
	recentArticle: Od,
	oldArticle: Od
}, jd = {
	recentArticle: 60,
	oldArticle: 60
}, Md = {
	base: {
		_: {
			hostname: "",
			origin: "",
			legacyOrigin: "",
			brandPrefix: "",
			brandDescription: "",
			brandSocialLinks: [],
			brandAboutText: "",
			brandLogo: {
				url: "",
				width: 0,
				height: 0
			},
			CWCUrl: "",
			f100ChartWidget: {
				isEnabled: !1,
				webBaseUrl: "https://stage-www.finanzen100.de",
				apiBaseUrl: "https://stage-chart.widget.finanzen100.de"
			},
			mostReadArticleTitlePlaceholder: "Leere meistgelesene Artikel der Woche",
			newsletterSubscriptionApi: "https://api.bf-bfnewsletter-sandbox.aws.bfops.io",
			newsletterLdsApi: "https://lds.bf-lds-production.aws.bfops.io:8000",
			newsletterLdsSlug: "nl_p1_bf_nleinwilligung",
			pagination: {
				author: {
					isEnabled: !0,
					pageLimit: 20,
					teasersPerPage: 50,
					startOffset: 0,
					paginationButtonName: Ed.PageNavigation
				},
				channel: {
					isEnabled: !1,
					pageLimit: 20,
					teasersPerPage: 50,
					startOffset: 0,
					paginationButtonName: Ed.PageNavigation
				},
				tags: {
					isEnabled: !1,
					pageLimit: 20,
					teasersPerPage: 16,
					startOffset: 6,
					paginationButtonName: Ed.PageNavigation
				},
				hubPages: {
					isEnabled: !0,
					pageLimit: 20,
					teasersPerPage: 16,
					startOffset: 6,
					paginationButtonName: Ed.PageNavigation
				},
				partner: {
					isEnabled: !0,
					pageLimit: 20,
					teasersPerPage: 20,
					startOffset: 0,
					paginationButtonName: Ed.PageNavigation
				}
			},
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "week"
				},
				image: {
					isEnabled: !0,
					interval: "week"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			},
			feed: {
				rss: { isEnabled: !0 },
				yahoo: { isEnabled: !0 },
				msn: { isEnabled: !0 },
				msnGallery: { isEnabled: !0 },
				msnVideo: { isEnabled: !0 },
				pushedArticles: { isEnabled: !0 },
				videoPages: { isEnabled: !0 }
			},
			specialChannelSettings: { defaultColor: Dd.AQUA },
			appView: { isEnabled: !1 },
			cacheTTL: kd
		},
		focus: {
			hostname: "focus.de",
			brandPrefix: "fol",
			brandTitle: "FOCUS online",
			brandDescription: "Aktuelle Nachrichten und Analysen aus Politik, Wirtschaft, Sport und Gesellschaft - unabhängig, schnell, informativ",
			brandSocialLinks: [
				"https://www.facebook.com/focus.de",
				"https://www.twitter.com/focusonline",
				"https://de.linkedin.com/company/focus-online-news",
				"https://www.youtube.com/user/focusonline",
				"https://www.xing.com/pages/focus-online-karriere",
				"https://de.wikipedia.org/wiki/Focus_Online"
			],
			brandAboutText: "Nachrichtenportal mit aktuellen Themen zu Politik, Wirtschaft, Sport und Gesellschaft",
			brandLogo: {
				url: "/ctf/focus/favicon/fol-logo.png",
				width: 512,
				height: 240
			},
			f100ChartWidget: {
				isEnabled: !0,
				webBaseUrl: "https://stage-www.finanzen100.de",
				apiBaseUrl: "https://stage-chart.widget.finanzen100.de"
			},
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "week"
				},
				image: {
					isEnabled: !0,
					interval: "week"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			},
			specialChannelSettings: {
				defaultColor: Dd.AQUA,
				availableColors: [
					Dd.AQUA,
					Dd.RED,
					Dd.BLUE
				]
			},
			articleFeedbackButtonPath: "/static/kontaktformular_59b8c454-2196-4c3d-9446-c67bd4a0dde7.html",
			appView: { isEnabled: !0 },
			cacheTTL: Ad,
			pagination: { hubPages: {
				pageLimit: 10,
				startOffset: 40,
				teasersPerPage: 40
			} }
		},
		chip: {
			hostname: "chip.de",
			brandPrefix: "chip",
			brandTitle: "CHIP",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			},
			specialChannelSettings: {
				defaultColor: Dd.GRAY,
				availableColors: [Dd.GRAY, Dd.TRANSPARENT]
			},
			cacheTTL: {
				...Ad,
				byArticleType: { download: jd }
			}
		},
		bunte: {
			hostname: "bunte.de",
			brandDescription: "Exklusive Promi-News, VIP-News und Videos aus der Welt der Stars und Royals. Auf BUNTE.de bekommst du Entertainment pur und die neusten Lifestyle-Trends.",
			brandPrefix: "bunte",
			brandTitle: "BUNTE",
			brandLogo: {
				url: "/ctf/bunte/favicon/logo-bunte-1000.png",
				width: 1e3,
				height: 1e3
			},
			appView: { isEnabled: !0 },
			brandSocialLinks: [
				"https://www.instagram.com/bunte",
				"https://www.pinterest.de/buntede/",
				"https://www.facebook.com/bunte.de",
				"https://www.youtube.com/user/BUNTEtv",
				"https://www.tiktok.com/@bunte "
			],
			brandAboutText: "Exklusive Promi-News, VIP-News und Videos aus der Welt der Stars und Royals. Auf BUNTE.de bekommst du Entertainment pur und die neusten Lifestyle-Trends.",
			pagination: {
				author: { pageLimit: 200 },
				channel: {
					isEnabled: !0,
					pageLimit: 200,
					teasersPerPage: 50,
					paginationButtonName: Ed.PageNavigation
				},
				tags: {
					isEnabled: !0,
					pageLimit: 200
				},
				hubPages: {
					pageLimit: 200,
					startOffset: 8
				}
			},
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			},
			specialChannelSettings: { defaultColor: Dd.BLACK },
			cacheTTL: Ad
		},
		fitforfun: {
			hostname: "fitforfun.de",
			brandPrefix: "fitforfun",
			brandTitle: "FIT FOR FUN",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			},
			specialChannelSettings: { defaultColor: Dd.BRAND }
		},
		finanzen100: {
			hostname: "finanzen100.de",
			brandPrefix: "f100",
			brandTitle: "Finanzen100",
			brandDescription: "Aktuelle Finanznachrichten und Informationen rund um das Thema Börse finden Sie auf Deutschlands innovativstem Finanzportal Finanzen100.",
			brandSocialLinks: [
				"https://www.facebook.com/Finanzen100",
				"https://x.com/Finanzen100",
				"https://www.youtube.com/@Finanzen100",
				"https://www.instagram.com/finanzen100.de"
			],
			brandAboutText: "Finanznachrichten und Infos zu Börse und Aktien - Finanzen100",
			appView: { isEnabled: !0 },
			brandLogo: {
				url: "/ctf/finanzen100/favicon/finanzen100-logo.png",
				width: 512,
				height: 240
			},
			f100ChartWidget: {
				isEnabled: !0,
				webBaseUrl: "https://stage-www.finanzen100.de",
				apiBaseUrl: "https://stage-chart.widget.finanzen100.de"
			},
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		mittier: {
			hostname: "mit-tier.de",
			brandPrefix: "mittier",
			brandTitle: "mit Tier",
			brandDescription: "Das digitale Magazin rund um Haustiere – Wissen, News und Ratgeber zu Hund und Katze",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		mitsternen: {
			hostname: "mit-sternen.de",
			brandPrefix: "mitsternen",
			brandTitle: "mit Sternen",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 }
			}
		},
		mitbeziehung: {
			hostname: "mit-beziehung.de",
			brandPrefix: "mitbeziehung",
			brandTitle: "mit Beziehung"
		},
		tvtoday: {
			hostname: "tvtoday.de",
			brandPrefix: "tvtoday",
			brandTitle: "TV Today",
			appView: { isEnabled: !0 },
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 }
			}
		},
		tvspielfilm: {
			hostname: "tvspielfilm.de",
			brandPrefix: "tvspielfilm",
			brandTitle: "TV Spielfilm",
			appView: { isEnabled: !0 },
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 }
			}
		}
	},
	local: {
		bunte: {
			origin: "https://ctf-local.bunte.de",
			legacyOrigin: "https://ctf-local.bunte.de",
			CWCUrl: "https://widget-stg.bunte.de/"
		},
		chip: {
			origin: "https://ctf-local.chip.de",
			legacyOrigin: "https://ctf-local.chip.de",
			CWCUrl: "https://widget-stg.chip.de/"
		},
		focus: {
			origin: "https://ctf-local.focus.de",
			legacyOrigin: "https://ctf-local.focus.de",
			CWCUrl: "https://widget-stg.focus.de/"
		},
		fitforfun: {
			origin: "https://ctf-local.fitforfun.de",
			legacyOrigin: "https://ctf-local.fitforfun.de",
			CWCUrl: "https://widget-stg.fitforfun.de/"
		},
		finanzen100: {
			origin: "https://ctf-local.finanzen100.de",
			legacyOrigin: "https://ctf-local.finanzen100.de",
			CWCUrl: "https://widget-stg.finanzen100.de/"
		},
		mittier: {
			origin: "https://ctf-local.mit-tier.de",
			legacyOrigin: "https://ctf-local.mit-tier.de",
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		mitsternen: {
			origin: "https://ctf-local.mit-sternen.de",
			legacyOrigin: "https://ctf-local.mit-sternen.de",
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://ctf-local.mit-beziehung.de",
			legacyOrigin: "https://ctf-local.mit-beziehung.de",
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://ctf-local.tvtoday.de",
			legacyOrigin: "https://ctf-local.tvtoday.de",
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://ctf-local.tvspielfilm.de",
			legacyOrigin: "https://ctf-local.tvspielfilm.de",
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	local_k8s: {
		bunte: {
			origin: "https://ctf-local.bunte.de",
			legacyOrigin: "https://ctf-local.bunte.de",
			CWCUrl: "https://widget-stg.bunte.de/"
		},
		chip: {
			origin: "https://ctf-local.chip.de",
			legacyOrigin: "https://ctf-local.chip.de",
			CWCUrl: "https://widget-stg.chip.de/"
		},
		focus: {
			origin: "https://ctf-local.focus.de",
			legacyOrigin: "https://ctf-local.focus.de",
			CWCUrl: "https://widget-stg.focus.de/"
		},
		fitforfun: {
			origin: "https://ctf-local.fitforfun.de",
			legacyOrigin: "https://ctf-local.fitforfun.de",
			CWCUrl: "https://widget-stg.fitforfun.de/"
		},
		finanzen100: {
			origin: "https://ctf-local.finanzen100.de",
			legacyOrigin: "https://ctf-local.finanzen100.de",
			CWCUrl: "https://widget-stg.finanzen100.de/"
		},
		mittier: {
			origin: "https://ctf-local.mit-tier.de",
			legacyOrigin: "https://ctf-local.mit-tier.de",
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		mitsternen: {
			origin: "https://ctf-local.mit-sternen.de",
			legacyOrigin: "https://ctf-local.mit-sternen.de",
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://ctf-local.mit-beziehung.de",
			legacyOrigin: "https://ctf-local.mit-beziehung.de",
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://ctf-local.tvtoday.de",
			legacyOrigin: "https://ctf-local.tvtoday.de",
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://ctf-local.tvspielfilm.de",
			legacyOrigin: "https://ctf-local.tvspielfilm.de",
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	local_e2e: {
		bunte: {
			origin: "https://ctf-local.bunte.de",
			legacyOrigin: "https://ctf-local.bunte.de",
			CWCUrl: "https://widget-stg.bunte.de/"
		},
		chip: {
			origin: "https://ctf-local.chip.de",
			legacyOrigin: "https://ctf-local.chip.de",
			CWCUrl: "https://widget-stg.chip.de/"
		},
		focus: {
			origin: "https://ctf-local.focus.de",
			legacyOrigin: "https://ctf-local.focus.de",
			CWCUrl: "https://widget-stg.focus.de/"
		},
		fitforfun: {
			origin: "https://ctf-local.fitforfun.de",
			legacyOrigin: "https://ctf-local.fitforfun.de",
			CWCUrl: "https://widget-stg.fitforfun.de/"
		},
		mittier: {
			origin: "https://ctf-local.mit-tier.de",
			legacyOrigin: "https://ctf-local.mit-tier.de",
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		finanzen100: {
			origin: "https://ctf-local.finanzen100.de",
			legacyOrigin: "https://ctf-local.finanzen100.de",
			CWCUrl: "https://widget-stg.finanzen100.de/"
		},
		mitsternen: {
			origin: "https://ctf-local.mit-sternen.de",
			legacyOrigin: "https://ctf-local.mit-sternen.de",
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://ctf-local.mit-beziehung.de",
			legacyOrigin: "https://ctf-local.mit-beziehung.de",
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://ctf-local.tvtoday.de",
			legacyOrigin: "https://ctf-local.tvtoday.de",
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://ctf-local.tvspielfilm.de",
			legacyOrigin: "https://ctf-local.tvspielfilm.de",
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	test: {
		bunte: {
			origin: "https://ctf-local.bunte.de",
			legacyOrigin: "https://ctf-local.bunte.de",
			CWCUrl: "https://widget-stg.bunte.de/",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		chip: {
			origin: "https://ctf-local.chip.de",
			legacyOrigin: "https://ctf-local.chip.de",
			CWCUrl: "https://widget-stg.chip.de/",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		focus: {
			origin: "https://ctf-local.focus.de",
			legacyOrigin: "https://ctf-local.focus.de",
			CWCUrl: "https://widget-stg.focus.de/",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "week"
				},
				image: {
					isEnabled: !0,
					interval: "week"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		fitforfun: {
			origin: "https://ctf-local.fitforfun.de",
			legacyOrigin: "https://ctf-local.fitforfun.de",
			CWCUrl: "https://widget-stg.fitforfun.de/",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		finanzen100: {
			origin: "https://ctf-local.finanzen100.de",
			legacyOrigin: "https://ctf-local.finanzen100.de",
			CWCUrl: "https://widget-stg.finanzen100.de/",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		mittier: {
			origin: "https://ctf-local.mit-tier.de",
			legacyOrigin: "https://ctf-local.mit-tier.de",
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		mitsternen: {
			origin: "https://ctf-local.mit-sternen.de",
			legacyOrigin: "https://ctf-local.mit-sternen.de",
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://ctf-local.mit-beziehung.de",
			legacyOrigin: "https://ctf-local.mit-beziehung.de",
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://ctf-local.tvtoday.de",
			legacyOrigin: "https://ctf-local.tvtoday.de",
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://ctf-local.tvspielfilm.de",
			legacyOrigin: "https://ctf-local.tvspielfilm.de",
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	sandbox: {
		bunte: {
			origin: `https://${X()}bunte.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}bunte.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.bunte.de/"
		},
		chip: {
			origin: `https://${X()}chip.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}chip.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.chip.de/"
		},
		focus: {
			origin: `https://${X()}focus.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}focus.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.focus.de/"
		},
		fitforfun: {
			origin: `https://${X()}fitforfun.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}fitforfun.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.fitforfun.de/"
		},
		finanzen100: {
			origin: `https://${X()}finanzen100.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}finanzen100.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.finanzen100.de/"
		},
		mittier: {
			origin: `https://${X()}mit-tier.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}mit-tier.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		mitsternen: {
			origin: `https://${X()}mit-sternen.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}mit-sternen.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: `https://${X()}mit-beziehung.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}mit-beziehung.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: `https://${X()}tvtoday.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}tvtoday.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: `https://${X()}tvspielfilm.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}tvspielfilm.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	development: {
		bunte: {
			origin: "https://bunte.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://www.dev.bunte.de",
			CWCUrl: "https://widget-stg.bunte.de/"
		},
		chip: {
			origin: "https://chip.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://www-staging.chip.de",
			CWCUrl: "https://widget-stg.chip.de/"
		},
		focus: {
			origin: "https://focus.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://www-stg.focus.de",
			CWCUrl: "https://widget-stg.focus.de/"
		},
		fitforfun: {
			origin: "https://fitforfun.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://fitforfun.bf-ctf-development.aws.bfops.io",
			CWCUrl: "https://widget-stg.fitforfun.de/"
		},
		mittier: {
			origin: "https://mit-tier.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://mit-tier.bf-ctf-development.aws.bfops.io",
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		finanzen100: {
			origin: "https://finanzen100.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://stage-www.finanzen100.de",
			CWCUrl: "https://widget-stg.finanzen100.de/"
		},
		mitsternen: {
			origin: "https://mit-sternen.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://mit-sternen.bf-ctf-development.aws.bfops.io",
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://mit-beziehung.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://mit-beziehung.bf-ctf-development.aws.bfops.io",
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://tvtoday.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://tvtoday.bf-ctf-development.aws.bfops.io",
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://tvspielfilm.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://tvspielfilm.bf-ctf-development.aws.bfops.io",
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	staging: {
		bunte: {
			origin: "https://bunte.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://www.stage.bunte.de",
			CWCUrl: "https://widget-stg.bunte.de/"
		},
		chip: {
			origin: "https://chip.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://chip.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.chip.de/"
		},
		focus: {
			origin: "https://focus.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://focus.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.focus.de/"
		},
		fitforfun: {
			origin: "https://fitforfun.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://fitforfun.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.fitforfun.de/"
		},
		mittier: {
			origin: "https://mit-tier.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://mit-tier.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		finanzen100: {
			origin: "https://finanzen100.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://finanzen100.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.finanzen100.de/"
		},
		mitsternen: {
			origin: "https://mit-sternen.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://mit-sternen.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://mit-beziehung.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://mit-beziehung.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://tvtoday.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://tvtoday.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://tvspielfilm.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://tvspielfilm.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	production: {
		_: { newsletterSubscriptionApi: "https://api.bf-bfnewsletter-production.aws.bfops.io" },
		bunte: {
			origin: "https://www.bunte.de",
			legacyOrigin: "https://www.bunte.de",
			CWCUrl: "https://widget.bunte.de/"
		},
		chip: {
			origin: "https://www.chip.de",
			legacyOrigin: "https://www.chip.de",
			CWCUrl: "https://widget.chip.de/"
		},
		focus: {
			origin: "https://www.focus.de",
			legacyOrigin: "https://www.focus.de",
			CWCUrl: "https://widget.focus.de/",
			f100ChartWidget: {
				isEnabled: !0,
				webBaseUrl: "https://www.finanzen100.de",
				apiBaseUrl: "https://chart.widget.finanzen100.de"
			}
		},
		fitforfun: {
			origin: "https://www.fitforfun.de",
			legacyOrigin: "https://www.fitforfun.de",
			CWCUrl: "https://widget.fitforfun.de/"
		},
		finanzen100: {
			origin: "https://www.finanzen100.de",
			legacyOrigin: "https://www.finanzen100.de",
			CWCUrl: "https://widget.finanzen100.de/",
			f100ChartWidget: {
				isEnabled: !0,
				webBaseUrl: "https://www.finanzen100.de",
				apiBaseUrl: "https://chart.widget.finanzen100.de"
			}
		},
		mittier: {
			origin: "https://www.mit-tier.de",
			legacyOrigin: "https://www.mit-tier.de",
			CWCUrl: "https://widget.mit-tier.de/"
		},
		mitsternen: {
			origin: "https://www.mit-sternen.de",
			legacyOrigin: "https://www.mit-sternen.de",
			CWCUrl: "https://widget.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://www.mit-beziehung.de",
			legacyOrigin: "https://www.mit-beziehung.de",
			CWCUrl: "https://widget.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://www.tvtoday.de",
			legacyOrigin: "https://www.tvtoday.de",
			CWCUrl: "https://widget.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://www.tvspielfilm.de",
			legacyOrigin: "https://www.tvspielfilm.de",
			CWCUrl: "https://widget.tvspielfilm.de/"
		}
	}
}, Nd = (e) => Td(Md, e), Pd = {
	key: 1,
	class: "row items-center no-wrap q-gutter-x-xs"
}, Fd = { key: 1 }, Id = /* @__PURE__ */ Tc(/* @__PURE__ */ A({
	__name: "brand-dropdown.selector",
	props: {
		modelValue: { default: "" },
		label: { default: void 0 },
		labelKey: { default: "common.brand" },
		multiple: { type: Boolean },
		rules: { default: void 0 },
		allowBlankOption: {
			type: Boolean,
			default: !0
		},
		blankOptionLabelKey: { default: "common.all" },
		blankOptionValue: { default: "" },
		onlyBrands: { type: Boolean },
		disabledBrands: { default: void 0 },
		disable: {
			type: Boolean,
			default: !1
		},
		showBrandIcon: {
			type: Boolean,
			default: !1
		},
		iconOnly: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = () => Object.values(Y).map((e) => ({
			label: be.capitalize(Nd(e).hostname || e),
			value: e,
			brandIcon: e
		})), { t: r } = it(), i = e, a = t, o = C({
			get() {
				return i.multiple && typeof i.modelValue == "string" ? i.modelValue ? (a("update:modelValue", [i.modelValue]), [i.modelValue]) : [] : i.modelValue;
			},
			set(e) {
				a("update:modelValue", e);
			}
		}), s = (e) => {
			let t = i.disabledBrands;
			return t ? e.filter((e) => {
				let n = e.value;
				return typeof n == "string" ? !t.some((e) => e === n) : !0;
			}) : e;
		}, c = C(() => {
			let e = n();
			return !i.multiple && i.allowBlankOption ? [{
				label: r(i.blankOptionLabelKey),
				value: i.blankOptionValue
			}, ...s(e)] : (i.onlyBrands, s(e));
		});
		return (t, n) => (j(), w(P(re), {
			modelValue: o.value,
			"onUpdate:modelValue": n[0] ||= (e) => o.value = e,
			"data-qa-brand-dropDown": o.value,
			options: c.value,
			label: e.label ?? P(r)(e.labelKey),
			multiple: e.multiple,
			"use-chips": e.multiple,
			rules: e.rules,
			"emit-value": "",
			"map-options": "",
			dense: "",
			flat: "",
			"dropdown-icon": "expand_more",
			outlined: "",
			disable: e.disable
		}, {
			option: F((t) => [k(P(_), je(t.itemProps, { "data-qa-brand-dropdown-option": t.opt.value }), {
				default: F(() => [e.showBrandIcon && t.opt.brandIcon ? (j(), w(P(y), {
					key: 0,
					avatar: "",
					class: "brand-dropdown-selector__icon-section"
				}, {
					default: F(() => [k(Yu, {
						brand: t.opt.brandIcon,
						small: ""
					}, null, 8, ["brand"])]),
					_: 2
				}, 1024)) : T("", !0), !e.iconOnly || !t.opt.brandIcon ? (j(), w(P(y), { key: 1 }, {
					default: F(() => [k(P(v), null, {
						default: F(() => [O(N(t.opt.label), 1)]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024)) : T("", !0)]),
				_: 2
			}, 1040, ["data-qa-brand-dropdown-option"])]),
			"selected-item": F((t) => [e.multiple ? (j(), w(P(d), {
				key: 0,
				"data-qa-pages-brand": "",
				removable: "",
				dense: "",
				tabindex: t.tabindex,
				color: "cyan-1",
				"text-color": "dark",
				class: "capitalize",
				onRemove: (e) => t.removeAtIndex(t.index)
			}, {
				default: F(() => [O(N(t.opt.label), 1)]),
				_: 2
			}, 1032, ["tabindex", "onRemove"])) : e.showBrandIcon ? (j(), E("div", Pd, [t.opt.brandIcon ? (j(), w(Yu, {
				key: 0,
				brand: t.opt.brandIcon,
				small: "",
				class: "brand-dropdown-selector__selected-icon"
			}, null, 8, ["brand"])) : T("", !0), !e.iconOnly || !t.opt.brandIcon ? (j(), E("span", Fd, N(t.opt.label), 1)) : T("", !0)])) : (j(), E(Ce, { key: 2 }, [O(N(t.opt.label), 1)], 64))]),
			_: 1
		}, 8, [
			"modelValue",
			"data-qa-brand-dropDown",
			"options",
			"label",
			"multiple",
			"use-chips",
			"rules",
			"disable"
		]));
	}
}), [["__scopeId", "data-v-7fa2219a"]]), Ld = ["data-qa-card-item-maintitle", "textContent"], Rd = ["data-qa-card-item-subtitle", "textContent"], zd = /* @__PURE__ */ Tc(/* @__PURE__ */ A({
	__name: "card-item",
	props: {
		item: {},
		hideButton: { type: Boolean },
		isClickable: { type: Boolean },
		disable: { type: Boolean }
	},
	emits: ["remove-item"],
	setup(e, { emit: t }) {
		let n = t;
		return (t, r) => (j(), w(P(s), {
			flat: "",
			bordered: "",
			class: Ne({ clickable: e.isClickable }),
			"data-qa-card-item": e.item._id
		}, {
			default: F(() => [e.item._id ? (j(), w(P(l), {
				key: 0,
				horizontal: "",
				class: "justify-between"
			}, {
				default: F(() => [
					He(t.$slots, "image", { item: e.item }, void 0, !0),
					k(P(l), { class: "q-pa-sm text-crop-container" }, {
						default: F(() => [D("p", {
							class: "q-my-none text-primary text-crop",
							"data-qa-card-item-maintitle": e.item._id,
							textContent: N(e.item.kicker)
						}, null, 8, Ld), D("p", {
							class: "q-my-none text-crop",
							"data-qa-card-item-subtitle": e.item._id,
							textContent: N(e.item.title)
						}, null, 8, Rd)]),
						_: 1
					}),
					e.hideButton ? T("", !0) : (j(), w(P(c), {
						key: 0,
						align: "right"
					}, {
						default: F(() => [k(P(a), {
							icon: "close",
							class: "text-primary",
							outline: "",
							"data-qa-card-item-remove-button": e.item._id,
							disable: e.disable,
							onClick: r[0] ||= Ze((t) => n("remove-item", e.item._id), ["stop"])
						}, null, 8, ["data-qa-card-item-remove-button", "disable"])]),
						_: 1
					}))
				]),
				_: 3
			})) : T("", !0)]),
			_: 3
		}, 8, ["class", "data-qa-card-item"]));
	}
}), [["__scopeId", "data-v-db3bd77f"]]), Bd = /* @__PURE__ */ A({
	__name: "card-list",
	props: {
		items: {},
		hideImage: { type: Boolean },
		hideButton: { type: Boolean },
		isClickable: { type: Boolean },
		disable: { type: Boolean }
	},
	emits: ["card-click", "remove-item"],
	setup(e, { emit: t }) {
		let n = t;
		return (t, r) => (j(!0), E(Ce, null, Ve(e.items, (i, a) => (j(), w(zd, {
			key: i._id,
			item: i,
			class: Ne({ "q-mt-md": a }),
			"hide-image": e.hideImage,
			"hide-button": e.hideButton,
			"is-clickable": e.isClickable,
			disable: e.disable,
			onRemoveItem: r[0] ||= (e) => n("remove-item", e),
			onClick: () => n("card-click", i._id)
		}, {
			image: F(() => [He(t.$slots, "image", { item: i })]),
			_: 2
		}, 1032, [
			"item",
			"class",
			"hide-image",
			"hide-button",
			"is-clickable",
			"disable",
			"onClick"
		]))), 128));
	}
}), Vd = /* @__PURE__ */ A({
	__name: "cms-selector",
	props: /* @__PURE__ */ Ae({
		label: {},
		rules: {},
		multiple: { type: Boolean }
	}, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = [
			"vibe",
			"bunte-stack",
			"escenic",
			"interred",
			"fff-cms",
			"praxistipps"
		], n = e, r = Ke(e, "modelValue", { get: (e) => n.multiple && typeof e == "string" ? [e] : e }), { t: i } = it(), a = t.map((e) => ({
			label: e.charAt(0).toUpperCase() + e.slice(1),
			value: e
		})), o = C(() => n.multiple ? a : [{
			label: i("cmsSelector.dpAll"),
			value: ""
		}, ...a]);
		return (t, n) => (j(), w(P(re), {
			modelValue: r.value,
			"onUpdate:modelValue": n[0] ||= (e) => r.value = e,
			"data-qa-managed-by-dropdown": "",
			options: o.value,
			label: e.label || P(i)("cmsSelector.label"),
			rules: e.rules,
			multiple: e.multiple,
			"use-chips": e.multiple,
			"emit-value": "",
			"map-options": "",
			dense: "",
			flat: "",
			"dropdown-icon": "expand_more",
			outlined: ""
		}, we({
			default: F(() => [k(P(ge), {
				anchor: "top middle",
				self: "top middle",
				offset: [0, 35],
				class: "bg-grey-10 text-white shadow-4 text-caption"
			}, {
				default: F(() => [O(N(P(i)("cmsSelector.hint")), 1)]),
				_: 1
			})]),
			_: 2
		}, [e.multiple ? {
			name: "selected-item",
			fn: F((e) => [k(P(d), {
				"data-qa-managed-by-tag": "",
				removable: "",
				dense: "",
				tabindex: e.tabindex,
				color: "cyan-1",
				"text-color": "dark",
				onRemove: (t) => e.removeAtIndex(e.index)
			}, {
				default: F(() => [O(N(e.opt.label), 1)]),
				_: 2
			}, 1032, ["tabindex", "onRemove"])]),
			key: "0"
		} : void 0]), 1032, [
			"modelValue",
			"options",
			"label",
			"rules",
			"multiple",
			"use-chips"
		]));
	}
}), Hd = /* @__PURE__ */ A({
	__name: "date-range.selector",
	props: {
		modelValue: {},
		min: { default: void 0 },
		max: { default: void 0 },
		label: { default: "Date" },
		required: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = t, r = e, i = C(() => r.min ? ms(new Date(r.min), "yyyy-MM-dd") : null), a = C(() => r.max ? ms(new Date(r.max), "yyyy-MM-dd") : null), o = C({
			get() {
				return r.modelValue.length === 2 ? {
					from: ms(new Date(r.modelValue[0]), "yyyy-MM-dd"),
					to: ms(new Date(r.modelValue[1]), "yyyy-MM-dd")
				} : {
					from: "",
					to: ""
				};
			},
			set(e) {
				if (typeof e == "string") return n("update:modelValue", [vo(new Date(e)), xo(new Date(e))]);
				if (e.from === "" && e.to === "") return n("update:modelValue", []);
				n("update:modelValue", [vo(new Date(e.from)), xo(new Date(e.to))]);
			}
		}), s = C(() => typeof o.value == "string" ? ms(new Date(o.value), "dd.MM.yyyy") : o.value.from !== "" && o.value.to !== "" ? o.value.from === o.value.to ? ms(new Date(o.value.from), "dd.MM.yyyy") : `${ms(new Date(o.value.from), "dd.MM.yyyy")}-${ms(new Date(o.value.to), "dd.MM.yyyy")}` : ""), c = () => {
			n("update:modelValue", []);
		};
		return (t, n) => (j(), w(P(ee), je({
			"data-qa-date-range-selector": "",
			class: e.required ? "required" : "",
			label: e.label,
			"model-value": s.value,
			"background-color": "white",
			flat: "",
			outlined: ""
		}, t.$attrs, { onClear: c }), {
			append: F(() => [s.value ? (j(), w(P(h), {
				key: 0,
				name: "clear",
				onClick: c
			})) : (j(), w(P(h), {
				key: 1,
				name: "calendar"
			}))]),
			default: F(() => [k(P(x), {
				"transition-show": "scale",
				"transition-hide": "scale"
			}, {
				default: F(() => [k(P(f), {
					modelValue: o.value,
					"onUpdate:modelValue": n[0] ||= (e) => o.value = e,
					"data-qa-date-input": "",
					minimal: "",
					min: i.value,
					max: a.value,
					range: ""
				}, null, 8, [
					"modelValue",
					"min",
					"max"
				])]),
				_: 1
			})]),
			_: 1
		}, 16, [
			"class",
			"label",
			"model-value"
		]));
	}
}), Ud = "dd.MM.yyyy", Wd = "dd.MM.yyyy HH:mm", Gd = "DD.MM.YYYY", Kd = "DD.MM.YYYY HH:mm", qd = /* @__PURE__ */ Tc(/* @__PURE__ */ A({
	__name: "datetime-selector",
	props: {
		modelValue: { default: void 0 },
		min: { default: void 0 },
		max: { default: void 0 },
		label: { default: "Date" },
		icon: { default: "" },
		rules: { default: () => [] },
		required: {
			type: Boolean,
			default: !1
		},
		dateOnly: {
			type: Boolean,
			default: !1
		},
		dense: {
			type: Boolean,
			default: !1
		},
		outlined: {
			type: Boolean,
			default: !1
		},
		disable: {
			type: Boolean,
			default: !1
		},
		noClearButton: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(t, { emit: n }) {
		let r = n, i = t, { t: o } = it(), l = (e) => e ? ms(e, i.dateOnly ? Ud : Wd) : "", u = (e) => ms(e, "yyyy/MM/dd"), d = (e) => !(i.min && e < u(i.min) || i.max && e > u(i.max)), p = M(l(i.modelValue)), m = (e, t, n) => {
			let [r] = p.value.split(" ");
			if (i.min && r === ms(i.min, Ud)) {
				let r = i.min.getHours(), a = i.min.getMinutes(), o = i.min.getSeconds();
				return e > r ? !0 : e === r ? t === null || t > a || t === a && (n === null || n >= o) : !1;
			}
			if (i.max && r === ms(i.max, Ud)) {
				let r = i.max.getHours(), a = i.max.getMinutes(), o = i.max.getSeconds();
				return e < r ? !0 : e === r ? t === null || t < a || t === a && (n === null || n <= o) : !1;
			}
			return !0;
		}, g = M("date"), _ = (e) => e.required ? [i.dateOnly ? Ml.validDate : Ml.validDateTime, ...i.rules] : e.rules, v = M(_(i));
		return Je(p, (e) => {
			if (e === "") return r("update:modelValue");
			if (i.dateOnly) {
				let [t, n, i] = e.split(".").map((e) => parseInt(e)), a = i !== void 0 && n !== void 0 ? new Date(i, n - 1, t) : void 0;
				if (bo(a)) return r("update:modelValue", a);
			}
			let t = /([0-9]{2})\.([0-9]{2})\.([0-9]{4}) ([0-9]{2}):([0-9]{2})/[Symbol.match](e)?.map((e) => parseInt(e));
			if (!t) return;
			t.shift();
			let [n, a, o, s, c] = t, l = o !== void 0 && a !== void 0 ? new Date(o, a - 1, n, s, c) : void 0;
			if (bo(l)) return r("update:modelValue", l);
		}), Je(i, (e) => {
			p.value = l(e.modelValue), v.value = _(e);
		}), (n, r) => (j(), w(P(ee), {
			modelValue: p.value,
			"onUpdate:modelValue": r[5] ||= (e) => p.value = e,
			"data-qa-dateTime-selector": "",
			dense: t.dense,
			label: t.label,
			required: t.required,
			rules: v.value,
			outlined: t.outlined,
			class: "q-mr-sm",
			disable: t.disable,
			readonly: t.disable
		}, {
			append: F(() => [p.value === "" && t.icon ? (j(), w(P(h), {
				key: 0,
				name: t.icon
			}, null, 8, ["name"])) : T("", !0), p.value !== "" && !t.noClearButton ? (j(), w(P(h), {
				key: 1,
				name: "close",
				"cursor-pointer": "",
				onClick: r[4] ||= (e) => p.value = ""
			})) : T("", !0)]),
			default: F(() => [t.disable ? T("", !0) : (j(), w(P(x), {
				key: 0,
				"transition-show": "jump-up",
				"transition-hide": "jump-down"
			}, {
				default: F(() => [k(P(s), null, {
					default: F(() => [
						k(P(ue), {
							modelValue: g.value,
							"onUpdate:modelValue": r[0] ||= (e) => g.value = e
						}, {
							default: F(() => [k(P(se), {
								name: "date",
								label: P(o)("components.date")
							}, null, 8, ["label"]), t.dateOnly ? T("", !0) : (j(), w(P(se), {
								key: 0,
								name: "time",
								label: P(o)("components.time")
							}, null, 8, ["label"]))]),
							_: 1
						}, 8, ["modelValue"]),
						k(P(le), {
							modelValue: g.value,
							"onUpdate:modelValue": r[3] ||= (e) => g.value = e,
							class: Ne({ "datetime-picker-wrapper": !t.dateOnly }),
							animated: ""
						}, {
							default: F(() => [k(P(ce), {
								name: "date",
								class: "q-pa-none"
							}, {
								default: F(() => [k(P(ie)), k(P(f), {
									modelValue: p.value,
									"onUpdate:modelValue": r[1] ||= (e) => p.value = e,
									minimal: "",
									mask: t.dateOnly ? Gd : Kd,
									options: d,
									flat: ""
								}, null, 8, ["modelValue", "mask"])]),
								_: 1
							}), t.dateOnly ? T("", !0) : (j(), w(P(ce), {
								key: 0,
								class: "q-pa-none",
								name: "time"
							}, {
								default: F(() => [k(P(pe), {
									modelValue: p.value,
									"onUpdate:modelValue": r[2] ||= (e) => p.value = e,
									mask: Kd,
									options: m,
									flat: "",
									format24h: ""
								}, null, 8, ["modelValue"])]),
								_: 1
							}))]),
							_: 1
						}, 8, ["modelValue", "class"]),
						k(P(c), { align: "right" }, {
							default: F(() => [Ye(k(P(a), {
								label: P(o)("common.close"),
								color: "primary",
								flat: ""
							}, null, 8, ["label"]), [[P(e)]])]),
							_: 1
						})
					]),
					_: 1
				})]),
				_: 1
			}))]),
			_: 1
		}, 8, [
			"modelValue",
			"dense",
			"label",
			"required",
			"rules",
			"outlined",
			"disable",
			"readonly"
		]));
	}
}), [["__scopeId", "data-v-a8addc32"]]), Jd = /* @__PURE__ */ A({
	__name: "item-count-field",
	props: /* @__PURE__ */ Ae({
		max: {},
		min: {},
		label: {}
	}, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = e, n = Ke(e, "modelValue", { set: (e) => t.min && e < t.min ? t.min : t.max && e > t.max ? t.max : e });
		return (t, r) => (j(), w(P(ee), je(t.$attrs, {
			modelValue: n.value,
			"onUpdate:modelValue": r[0] ||= (e) => n.value = e,
			modelModifiers: { number: !0 },
			type: "number",
			label: e.label,
			class: "required",
			outlined: "",
			dense: ""
		}), null, 16, ["modelValue", "label"]));
	}
}), Yd = /* @__PURE__ */ A({
	__name: "legacy-selector",
	props: /* @__PURE__ */ Ae({
		label: {},
		rules: {}
	}, {
		modelValue: { type: Boolean },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = Ke(e, "modelValue"), { t: n } = it(), r = [
			{
				label: n("legacySelector.dpAll"),
				value: void 0
			},
			{
				label: n("legacySelector.yes"),
				value: !0
			},
			{
				label: n("legacySelector.no"),
				value: !1
			}
		];
		return (i, a) => (j(), w(P(re), {
			modelValue: t.value,
			"onUpdate:modelValue": a[0] ||= (e) => t.value = e,
			"data-qa-legacy-dropdown": "",
			options: r,
			label: e.label || P(n)("legacySelector.label"),
			rules: e.rules,
			"emit-value": "",
			"map-options": "",
			dense: "",
			flat: "",
			"dropdown-icon": "expand_more",
			outlined: ""
		}, {
			default: F(() => [k(P(ge), {
				anchor: "top middle",
				self: "top middle",
				offset: [0, 35],
				class: "bg-grey-10 text-white shadow-4 text-caption"
			}, {
				default: F(() => [O(N(P(n)("legacySelector.hint")), 1)]),
				_: 1
			})]),
			_: 1
		}, 8, [
			"modelValue",
			"label",
			"rules"
		]));
	}
}), Xd = class {
	id;
	options;
	constructor(e, t) {
		switch (this.id = t || co(), e) {
			case "confirm-remove-block":
				this.options = {
					title: B().t("components.blockRemoveTitle"),
					message: B().t("components.blockRemoveDescription"),
					persistent: !0,
					cancel: {
						label: B().t("common.cancel"),
						color: "secondary",
						flat: !0
					},
					ok: B().t("common.yesRemove"),
					class: "text-center"
				};
				break;
			default: this.options = e;
		}
	}
};
function Zd(e, t) {
	let n = e.dialogs.findIndex((e) => e.id === t);
	if (n !== -1) {
		let t = e.dialogs[n];
		if (!t) {
			let t = /* @__PURE__ */ Error(`Attempted to hide dialog on index ${n} that does not exist in dialog store ${JSON.stringify(e.dialogs)}`);
			throw t.name = "DialogStoreError:hideDialog", t;
		}
		t.isVisible = !1, e.dialogs.splice(n, 1);
	}
}
function Qd(e, t) {
	t.hasDismissHandlerAttached ||= (t.actions.onDismiss(() => Zd(e, t.id)), !0);
}
function $d(e, n, r) {
	return n.options = r, n.actions.update(r), n.isVisible ? n.actions : (n.isVisible = !0, n.actions = t.create(r), Qd(e, n), n.actions);
}
function ef(e, n, r) {
	let i = t.create(r), a = {
		id: n,
		isVisible: !0,
		hasDismissHandlerAttached: !1,
		options: r,
		actions: i
	};
	return Qd(e, a), e.dialogs.push(a), i;
}
var tf = Be({
	dialogs: [],
	showDialog(e) {
		let { id: t, options: n } = e, r = this.dialogs.find((e) => e.id === t);
		return r ? $d(this, r, n) : ef(this, t, n);
	},
	updateDialog(e) {
		let { id: t, options: n } = e, r = this.dialogs.find((e) => e.id === t);
		if (!r) {
			let t = /* @__PURE__ */ Error(`Attempted to update non existing dialog with id ${e.id} in dialog store ${JSON.stringify(this.dialogs)}`);
			throw t.name = "DialogStoreError:updateDialog", t;
		}
		return $d(this, r, n);
	},
	isDialogVisible(e) {
		if (!e && this.dialogs.length) return !0;
		if (!e) return !1;
		let t = typeof e == "string" ? e : e.id;
		return this.dialogs.some((e) => e.id === t && e.isVisible);
	}
});
tf.showDialog = tf.showDialog.bind(tf), tf.updateDialog = tf.updateDialog.bind(tf), tf.isDialogVisible = tf.isDialogVisible.bind(tf);
var nf = () => tf, rf = {
	key: 0,
	"data-qa-article-schedule-banner": "",
	class: "banner q-py-sm q-px-md align-center q-mb-lg"
}, af = { class: "banner-icon" }, of = {
	class: "q-pa-sm",
	"data-qa-article-schedule-common-banner": ""
}, sf = { class: "button-group" }, cf = {
	key: 1,
	class: "banner q-pa-sm align-center q-mb-lg"
}, lf = { class: "banner-icon" }, uf = {
	"data-qa-article-schedule-edit-banner": "",
	class: "q-pa-sm"
}, df = /* @__PURE__ */ Tc(/* @__PURE__ */ A({
	__name: "schedule-change-info-banner",
	props: {
		scheduleDate: {},
		changedBy: { default: "" },
		disableButtonsInBanner: { type: Boolean },
		showBasicsBanner: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["remove-schedule", "edit-schedule"],
	setup(e, { emit: t }) {
		let { t: n } = it(), r = t, { showDialog: i } = nf(), o = e, s = () => {
			i(new Xd({
				title: n("scheduledChanges.remove.changesTitle"),
				message: n("scheduledChanges.remove.changesText"),
				ok: {
					class: "text-center",
					label: n("common.yes")
				},
				cancel: {
					title: n("common.cancel"),
					color: "secondary",
					flat: !0
				},
				focus: "cancel"
			})).onOk(() => {
				r("remove-schedule");
			});
		}, c = async () => {
			i(new Xd({
				title: n("scheduledChanges.edit.changesTitle"),
				html: !0,
				message: `
        ${n("scheduledChanges.edit.changesText.articleScheduledOn")} ${o.scheduleDate} ${n("common.doneBy")} ${o.changedBy}.
        ${n("scheduledChanges.edit.changesText.warningScheduledChangesPresent")}<br><br>
        ${n("scheduledChanges.edit.changesText.questionScheduledChangesWillBeOverwritten")}
      `,
				ok: {
					label: n("common.yes"),
					class: "text-center"
				},
				cancel: {
					title: n("common.cancel"),
					color: "secondary",
					flat: !0
				},
				focus: "cancel"
			})).onOk(async () => {
				r("edit-schedule");
			});
		};
		return (t, r) => e.showBasicsBanner ? (j(), E("div", rf, [
			D("div", af, [k(P(h), { name: "info" })]),
			D("div", of, N(P(n)("common.scheduleBannerText")) + " " + N(o.scheduleDate) + " " + N(P(n)("common.doneBy")) + " " + N(o.changedBy), 1),
			D("div", sf, [k(P(a), {
				"data-qa-article-remove-changes": "",
				class: "custom-button",
				outline: "",
				disable: e.disableButtonsInBanner,
				label: P(n)("common.removeChange"),
				onClick: s
			}, null, 8, ["disable", "label"]), k(P(a), {
				disable: e.disableButtonsInBanner,
				"data-qa-article-edit-changes": "",
				class: "custom-button",
				outline: "",
				label: P(n)("common.editChange"),
				onClick: c
			}, null, 8, ["disable", "label"])])
		])) : (j(), E("div", cf, [D("div", lf, [k(P(h), { name: "info" })]), D("div", uf, N(P(n)("scheduledChanges.edit.changesText.editingBannerInfo")) + " " + N(o.scheduleDate), 1)]));
	}
}), [["__scopeId", "data-v-1df95484"]]), ff = 6, pf = /* @__PURE__ */ A({
	__name: "list-pagination",
	props: { pagination: {} },
	setup(e) {
		let t = e, n = C({
			get() {
				return t.pagination?.currentPage ?? 1;
			},
			set(e) {
				t.pagination?.goToPage(e);
			}
		}), r = C(() => {
			let e = t.pagination?.currentPage ?? 1, n = t.pagination?.nextPageLink;
			return e + (n && Number(new URL(n).searchParams.get("page")) > e ? 1 : 0);
		}), i = C(() => r.value >= ff ? ff : r.value);
		return (t, a) => (j(), w(P(ne), {
			modelValue: n.value,
			"onUpdate:modelValue": a[0] ||= (e) => n.value = e,
			max: r.value,
			"max-pages": i.value,
			disable: e.pagination?.loading,
			"direction-links": "",
			"icon-prev": "fast_rewind",
			"icon-next": "fast_forward",
			"active-color": "primary"
		}, null, 8, [
			"modelValue",
			"max",
			"max-pages",
			"disable"
		]));
	}
}), mf = (e) => {
	let t = cl();
	return Je(() => t.loggedIn, (n, r) => {
		r === !1 && n === !0 && t.wasLoggedIn && e();
	}, { deep: !0 }), {};
}, hf = (e) => e instanceof Date ? e.toISOString() : typeof e == "boolean" ? e ? "true" : "false" : typeof e == "number" ? String(e) : e, gf = (e) => Array.isArray(e) ? e.map(hf) : hf(e), _f = (e) => e != null, vf = (e, t) => {
	let n = {};
	for (let [r, i] of Object.entries(e)) t.includes(r) && (n[r] = i);
	return n;
};
function yf(e, t) {
	return t in e;
}
var bf = (e, t) => [...new Set([...Object.keys(e ?? {}), ...Object.keys(t)])].filter((e) => e !== "page"), xf = (e, t, n, r) => {
	let i = Object.entries(e).filter(([e]) => !t.has(e)), a = Object.fromEntries(i), o = Object.entries(n).filter(([e, t]) => e !== "page" && _f(t)).map(([e, t]) => [e, gf(t)]);
	for (let [e, t] of o) a[e] = t;
	return r > 1 && (a.page = String(r)), a;
}, Sf = (e) => JSON.stringify(Object.keys(e).sort().map((t) => {
	let n = e[t];
	return Array.isArray(n) ? [t, [...n].map(String)] : [t, n === void 0 ? void 0 : String(n)];
})), Cf = (e, t) => Sf(e) === Sf(t), wf = () => {
	let e = ut().currentRoute.value.query.page;
	return Array.isArray(e) ? 1 : parseInt(e ?? "1");
};
function Tf(e, t, n = {}) {
	let r = ut(), i = r.currentRoute.value, a = bf(t.defaultParameters, i.query), o = vf(i.query, a), s = new Set([...a, "page"]), c, l = 0, u = ye((e) => e(), 350), d, f = async (e) => {
		if (!t.updateUrl) return !0;
		for (let e of Object.keys(d.parameters)) s.add(e);
		let n = r.currentRoute.value, i = xf(n.query, s, d.parameters, e);
		if (Cf(n.query, i)) return !0;
		let a = r.resolve({
			query: i,
			hash: n.hash
		});
		c = a.fullPath;
		let o = await r.replace({
			query: i,
			hash: n.hash
		});
		if (ct(o, st.aborted) || ct(o, st.cancelled)) return c = void 0, !1;
		let l = r.currentRoute.value;
		return l.name === n.name && l.fullPath === a.fullPath ? (c = void 0, !0) : (c = void 0, !1);
	};
	d = Be({
		loading: !1,
		searchFields: t.searchFields,
		parameters: t.defaultParameters ? {
			...t.defaultParameters,
			...o
		} : { ...o },
		results: [],
		currentPage: n.currentPage ?? wf(),
		previousPageLink: void 0,
		nextPageLink: void 0,
		changedParameters: 0,
		activeFiltersCount: 0,
		async loadResults(n = !1) {
			this.loading = !0;
			let r = ++l;
			try {
				let i = Object.fromEntries(Object.entries(this.parameters).filter(([, e]) => _f(e))), { list: a, page: o, previous: s, next: c } = await e.listEntities({ params: {
					...i,
					page: n ? 1 : this.currentPage || 1,
					size: t.pageSize
				} });
				if (r !== l) return;
				this.results = a, this.currentPage = a.length && o || 1, this.previousPageLink = s, this.nextPageLink = c;
			} finally {
				r === l && (this.loading = !1);
			}
		},
		async clearSearch() {
			u.cancel();
			for (let e of Object.keys(this.parameters)) s.add(e);
			this.parameters = t.defaultParameters ? { ...t.defaultParameters } : {}, this.currentPage = 1, await f(1) && await this.loadResults(!0);
		},
		async updateUrl() {
			await f(d.currentPage);
		},
		goToPage(e) {
			this.currentPage = e, (async () => {
				await f(e) && await this.loadResults();
			})();
		}
	});
	let p = C(() => {
		let e = 0, { dateFrom: t, dateTo: n, ...r } = d.parameters;
		t && n && e++;
		let i = Object.entries(r);
		return e += i.reduce((e, [t, n]) => t === "page" ? e : typeof n == "object" && n ? Object.keys(n).length === 0 ? e : e + 1 : typeof n == "string" ? n.length === 0 ? e : e + 1 : _f(n) ? e + 1 : e, 0);
	}), m = (e = !1) => d.loadResults(e);
	return mf(m), Je([() => d.parameters], async () => {
		let e = t.defaultPageReset ?? !0, n = e ? 1 : d.currentPage;
		e && (d.currentPage = 1), await f(n) && u(() => d.loadResults(e));
	}, { deep: !0 }), Je(r.currentRoute, (e, n) => {
		if (c && e.fullPath === c) {
			c = void 0;
			return;
		}
		n.name === e.name && Object.values(e.query).length === 0 && (d.parameters = t.defaultParameters ? { ...t.defaultParameters } : {}, d.currentPage = 1);
	}), Je(p, (e) => {
		d.activeFiltersCount = e;
	}), Fe(m), Ie(() => {
		l += 1, u.cancel();
	}), d;
}
function Ef(e, t, n = {}) {
	let r = ut(), i = r.currentRoute.value, a = bf(t.defaultParameters, i.query), o = vf(i.query, a), s = new Set([...a, "page"]), c, l = 0, u = ye((e) => e(), 350), d, f = async (e) => {
		if (!t.updateUrl) return !0;
		for (let e of Object.keys(d.parameters)) s.add(e);
		let n = r.currentRoute.value, i = xf(n.query, s, d.parameters, e);
		if (Cf(n.query, i)) return !0;
		let a = r.resolve({
			query: i,
			hash: n.hash
		});
		c = a.fullPath;
		let o = await r.replace({
			query: i,
			hash: n.hash
		});
		if (ct(o, st.aborted) || ct(o, st.cancelled)) return c = void 0, !1;
		let l = r.currentRoute.value;
		return l.name === n.name && l.fullPath === a.fullPath ? (c = void 0, !0) : (c = void 0, !1);
	};
	d = Be({
		loading: !1,
		searchFields: t.searchFields,
		parameters: t.defaultParameters ? {
			...t.defaultParameters,
			...o
		} : { ...o },
		results: [],
		coreResults: [],
		companions: t.initialCompanions,
		currentPage: n.currentPage ?? wf(),
		previousPageLink: void 0,
		nextPageLink: void 0,
		changedParameters: 0,
		activeFiltersCount: 0,
		async loadResults(n = !1) {
			this.loading = !0;
			let r = ++l;
			try {
				let i = Object.fromEntries(Object.entries(this.parameters).filter(([, e]) => _f(e))), { list: a, page: o, previous: s, next: c } = await e.listEntities({ params: {
					...i,
					page: n ? 1 : this.currentPage || 1,
					size: t.pageSize
				} });
				if (r !== l) return;
				let u = Object.assign({}, t.initialCompanions);
				if (await Promise.all(Object.keys(t.companionFetchers).map(async (e) => {
					yf(t.companionFetchers, e) && (u[e] = await t.companionFetchers[e]({
						coreResults: a,
						currentPage: o || 1,
						parameters: this.parameters
					}));
				})), r !== l) return;
				this.coreResults = a, this.companions = u, this.results = t.mapResults ? t.mapResults(a, u) : a, this.currentPage = a.length && o || 1, this.previousPageLink = s, this.nextPageLink = c;
			} finally {
				r === l && (this.loading = !1);
			}
		},
		async clearSearch() {
			u.cancel();
			for (let e of Object.keys(this.parameters)) s.add(e);
			this.parameters = t.defaultParameters ? { ...t.defaultParameters } : {}, this.currentPage = 1, await f(1) && await this.loadResults(!0);
		},
		async updateUrl() {
			await f(d.currentPage);
		},
		goToPage(e) {
			this.currentPage = e, (async () => {
				await f(e) && await this.loadResults();
			})();
		}
	});
	let p = C(() => {
		let e = 0, { dateFrom: t, dateTo: n, ...r } = d.parameters;
		t && n && e++;
		let i = Object.entries(r);
		return e += i.reduce((e, [t, n]) => t === "page" ? e : typeof n == "object" && n ? Object.keys(n).length === 0 ? e : e + 1 : typeof n == "string" ? n.length === 0 ? e : e + 1 : _f(n) ? e + 1 : e, 0);
	}), m = (e = !1) => d.loadResults(e);
	return mf(m), Je([() => d.parameters], async () => {
		let e = t.defaultPageReset ?? !0, n = e ? 1 : d.currentPage;
		e && (d.currentPage = 1), await f(n) && u(() => d.loadResults(e));
	}, { deep: !0 }), Je(r.currentRoute, (e, n) => {
		if (c && e.fullPath === c) {
			c = void 0;
			return;
		}
		n.name === e.name && Object.values(e.query).length === 0 && (d.parameters = t.defaultParameters ? { ...t.defaultParameters } : {}, d.currentPage = 1);
	}), Je(p, (e) => {
		d.activeFiltersCount = e;
	}), Fe(m), Ie(() => {
		l += 1, u.cancel();
	}), d;
}
var Df = {
	dialog: !1,
	multi: !1
}, Of = "History", kf = bc(Of), { listEntities: Af } = kf, jf = async (e) => ((await Af({ params: {
	entityId: e,
	page: 1,
	size: 1
} })).list ?? []).pop(), Mf = (e) => {
	e.use(_e, {
		plugins: {
			Notify: r,
			Dialog: t,
			Loading: n
		},
		lang: Qa()
	});
}, Nf = () => !0, Pf = {
	date: Nf,
	time: Nf,
	fulltime: Nf,
	timeOrFulltime: Nf,
	email: Nf,
	hexColor: Nf,
	hexaColor: Nf,
	hexOrHexaColor: Nf,
	rgbColor: Nf,
	rgbaColor: Nf,
	rgbOrRgbaColor: Nf,
	hexOrRgbColor: Nf,
	hexaOrRgbaColor: Nf,
	anyColor: Nf
}, Ff = (e, t) => {
	if (!t) return "";
	let n;
	return t.reverse().forEach((t) => {
		if (typeof t == "function") {
			let r = t(e, Pf);
			typeof r == "string" && r.length && (n = r);
		}
	}), n || "";
};
function If(e) {
	return (t) => e?.(t) ? "background: var(--app-bg); cursor: not-allowed" : "";
}
function Lf(e, t) {
	let n = If(t);
	return e.map((e) => ({
		...e,
		style: n
	}));
}
//#endregion
//#region src/components/tab/history-tab.vue?vue&type=script&setup=true&lang.ts
var Rf = {
	class: "self-center full-width no-outline text-black",
	"data-qa-history-entity-create-date": ""
}, zf = {
	class: "self-center full-width no-outline text-black",
	"data-qa-history-entity-first-published-date": ""
}, Bf = ["data-qa-history-last-change-by-row"], Vf = ["data-qa-history-action-row"], Hf = ["data-qa-history-description-row"], Uf = ["data-qa-history-modifiedAt-row"], Wf = /* @__PURE__ */ A({
	__name: "history-tab",
	props: {
		entity: {},
		entityId: {},
		entityCreateDate: {},
		entityFirstPublishedDate: {},
		dateFormat: {}
	},
	setup(e, { expose: t }) {
		let n = e, { t: r } = it(), i = Tf(kf, {
			updateUrl: !1,
			defaultPageReset: !1,
			defaultParameters: { entityId: n.entityId }
		});
		t({ search: i });
		let a = (e) => e ? n.dateFormat ? ms(new Date(e), n.dateFormat) : Gs(e) : "-", o = a(n.entityCreateDate), s = a(n.entityFirstPublishedDate), c = (e) => {
			if (!e) return "";
			let t = "";
			return e.state ? t = e.state ? `${e.state.oldValue} => ${e.state.newValue}` : "" : e._description && (t = r(`historyEntryDescriptions.${e._description}`)), t;
		}, l = Lf([
			{
				name: "modifiedBy",
				align: "left",
				label: r("articlesVersions.modifiedBy"),
				field: (e) => e.actorLabel
			},
			{
				name: "action",
				align: "left",
				label: r("common.action"),
				field: (e) => e.action
			},
			{
				name: "description",
				align: "left",
				label: r("common.description"),
				field: (e) => e.changes
			},
			{
				name: "modifiedAt",
				align: "left",
				label: r("articlesVersions.modifiedAt"),
				field: (e) => e.createDate
			}
		]);
		return (t, n) => (j(), E(Ce, null, [
			e.entityCreateDate ? (j(), w(P(m), {
				key: 0,
				class: "q-mb-sm",
				standout: "bg-teal-1",
				dense: ""
			}, {
				default: F(() => [D("div", Rf, N(P(r)("historyEntryDescriptions.createDate", { date: P(o) })), 1)]),
				_: 1
			})) : T("", !0),
			e.entityFirstPublishedDate ? (j(), w(P(m), {
				key: 1,
				class: "q-mb-sm",
				standout: "bg-teal-1",
				dense: ""
			}, {
				default: F(() => [D("div", zf, N(P(r)("historyEntryDescriptions.firstPublishedDate", { date: P(s) })), 1)]),
				_: 1
			})) : T("", !0),
			k(P(S), {
				columns: P(l),
				rows: P(i).results,
				"rows-per-page-options": [0],
				flat: "",
				"hide-bottom": "",
				"row-key": "name",
				"table-header-class": "text-grey-8"
			}, {
				"header-cell": F((e) => [k(P(fe), {
					props: e,
					"data-qa-column-header": e.col.name
				}, {
					default: F(() => [O(N(e.col.label), 1)]),
					_: 2
				}, 1032, ["props", "data-qa-column-header"])]),
				"body-cell-modifiedBy": F((e) => [k(P(de), { props: e }, {
					default: F(() => [D("span", { "data-qa-history-last-change-by-row": e?.rowIndex }, N(e.row.actorLabel), 9, Bf)]),
					_: 2
				}, 1032, ["props"])]),
				"body-cell-action": F((t) => [k(P(de), { props: t }, {
					default: F(() => [D("span", { "data-qa-history-action-row": t?.rowIndex }, N(e.entity + " " + t.row.action), 9, Vf)]),
					_: 2
				}, 1032, ["props"])]),
				"body-cell-description": F((e) => [k(P(de), { props: e }, {
					default: F(() => [D("span", { "data-qa-history-description-row": e?.rowIndex }, N(c(e.row.changes)), 9, Hf)]),
					_: 2
				}, 1032, ["props"])]),
				"body-cell-modifiedAt": F((e) => [k(P(de), { props: e }, {
					default: F(() => [D("span", { "data-qa-history-modifiedAt-row": e?.rowIndex }, N(a(e.row.createDate)), 9, Uf)]),
					_: 2
				}, 1032, ["props"])]),
				_: 1
			}, 8, ["columns", "rows"]),
			Ye(k(pf, {
				pagination: P(i),
				class: "justify-center"
			}, null, 8, ["pagination"]), [[qe, P(i).nextPageLink || P(i).previousPageLink]])
		], 64));
	}
}), Gf = /* @__PURE__ */ A({
	__name: "tag-input",
	props: /* @__PURE__ */ Ae({
		name: {},
		label: {},
		disable: {
			type: Boolean,
			default: !1
		},
		readonly: {
			type: Boolean,
			default: !1
		},
		rules: { default: () => [] }
	}, {
		modelValue: { default: () => [] },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = Ke(e, "modelValue"), n = M(), r = (e) => {
			if (e.includes(" ") || e.includes(",")) {
				let r = e.replace(/[,\s]/g, "");
				t.value.includes(r) || t.value.push(r), n.value && n.value.updateInputValue("");
			}
		};
		return (i, a) => (j(), w(P(re), je({
			ref_key: "clearTags",
			ref: n
		}, i.$attrs, {
			modelValue: t.value,
			"onUpdate:modelValue": a[0] ||= (e) => t.value = e,
			"use-input": "",
			"use-chips": "",
			multiple: "",
			"new-value-mode": "add-unique",
			dense: "",
			outlined: "",
			"hide-dropdown-icon": "",
			"dropdown-icon": "expand_more",
			label: e.label,
			"data-qa": `${e.name}-input`,
			rules: e.rules,
			disable: e.disable,
			readonly: e.readonly,
			onInputValue: r
		}), {
			"selected-item": F((t) => [k(P(d), {
				"data-qa": e.name,
				removable: "",
				dense: "",
				tabindex: t.tabindex,
				color: "cyan-1",
				"text-color": "dark",
				onRemove: (e) => t.removeAtIndex(t.index)
			}, {
				default: F(() => [O(N(t.opt), 1)]),
				_: 2
			}, 1032, [
				"data-qa",
				"tabindex",
				"onRemove"
			])]),
			_: 1
		}, 16, [
			"modelValue",
			"label",
			"data-qa",
			"rules",
			"disable",
			"readonly"
		]));
	}
}), Kf = /* @__PURE__ */ A({
	__name: "tag-selector",
	props: /* @__PURE__ */ Ae({
		name: { default: "" },
		label: {},
		options: { default: () => [] },
		fetchLabel: {
			type: Function,
			default: void 0
		},
		autocomplete: {
			type: Boolean,
			default: !1
		},
		filterFnAsync: {
			type: Function,
			default: void 0
		},
		loading: {
			type: Boolean,
			default: !1
		},
		disable: {
			type: Boolean,
			default: !1
		},
		readonly: {
			type: Boolean,
			default: !1
		},
		rules: { default: () => [] }
	}, {
		modelValue: {
			required: !0,
			default: () => []
		},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = e, n = Ke(e, "modelValue"), r = M([]), i = M(), a = async (e) => {
			let n = t.options.find((t) => t.value === e)?.label;
			return n ||= await t.fetchLabel?.(e), n || e;
		}, o = (e, n) => {
			let r = t.options.find((t) => t.label === e);
			r && (i.value?.updateInputValue(""), n(r));
		}, s = (e, n) => {
			n(async () => {
				if (t.autocomplete) {
					if (t.filterFnAsync) {
						r.value = await t.filterFnAsync(e);
						return;
					}
					r.value = t.options.filter((t) => t.label.includes(e));
				}
			});
		}, c = () => {
			i.value?.updateInputValue("");
		}, l = () => {
			i.value?.setOptionIndex(-1);
		};
		return Je(() => t.options, (e) => {
			r.value = e;
		}), (t, u) => (j(), w(P(re), je({
			ref_key: "selectRef",
			ref: i
		}, t.$attrs, {
			modelValue: n.value,
			"onUpdate:modelValue": u[0] ||= (e) => n.value = e,
			options: r.value,
			"use-input": "",
			"use-chips": "",
			multiple: "",
			"new-value-mode": "add-unique",
			dense: "",
			outlined: "",
			label: e.label,
			"hide-dropdown-icon": "",
			"dropdown-icon": "expand_more",
			"map-options": "",
			[`data-qa-${e.name}-selector` || ""]: e.name,
			loading: e.loading,
			rules: e.rules,
			disable: e.disable,
			readonly: e.readonly,
			onNewValue: o,
			onFilter: s,
			onAdd: c,
			onInputValue: l
		}), we({
			"selected-item": F((t) => [k(P(d), {
				"data-qa-tag": "",
				removable: !e.disable && !e.readonly,
				dense: "",
				tabindex: t.tabindex,
				color: "cyan-1",
				"text-color": "dark",
				onRemove: (e) => t.removeAtIndex(t.index)
			}, {
				default: F(() => [O(N(t.opt.label || a(t)), 1)]),
				_: 2
			}, 1032, [
				"removable",
				"tabindex",
				"onRemove"
			])]),
			_: 2
		}, [Ve(t.$slots, (e, n) => ({
			name: n,
			fn: F((e) => [He(t.$slots, n, Pe(Ee(e ?? {})))])
		}))]), 1040, [
			"modelValue",
			"options",
			"label",
			"loading",
			"rules",
			"disable",
			"readonly"
		]));
	}
}), qf = /* @__PURE__ */ Tc(/* @__PURE__ */ A({
	__name: "toggle-button",
	props: /* @__PURE__ */ Ae({
		options: {},
		disable: {
			type: Boolean,
			default: !1
		}
	}, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = e, n = C(() => t.options.filter((e) => e.slot && e.tooltip)), r = Ke(e, "modelValue");
		return (t, i) => (j(), w(P(o), je(t.$attrs, {
			modelValue: r.value,
			"onUpdate:modelValue": i[0] ||= (e) => r.value = e,
			unelevated: "",
			outline: "",
			options: e.options,
			disable: e.disable,
			class: "toggle-button"
		}), we({ _: 2 }, [Ve(n.value, (e) => ({
			name: e.slot,
			fn: F(() => [k(P(ge), null, {
				default: F(() => [O(N(e.tooltip), 1)]),
				_: 2
			}, 1024)])
		}))]), 1040, [
			"modelValue",
			"options",
			"disable"
		]));
	}
}), [["__scopeId", "data-v-5d75c462"]]), Jf = (e) => {
	let t = M(null), n = M(null), r = M(!0);
	return {
		dragOverId: n,
		insertBefore: r,
		onDragStart: (e) => t.value = e,
		onDragOver: (e, i) => {
			if (e.preventDefault(), !t.value || t.value === i) return;
			n.value = i;
			let a = e.currentTarget;
			if (!(a instanceof HTMLElement)) return;
			let { left: o, width: s } = a.getBoundingClientRect();
			r.value = e.clientX < o + s / 2;
		},
		onDragLeave: () => n.value = null,
		onDrop: (n) => {
			if (!t.value || t.value === n) return;
			let i = [...e.value], a = i.indexOf(t.value);
			if (a === -1) return;
			i.splice(a, 1);
			let o = i.indexOf(n);
			o !== -1 && (i.splice(r.value ? o : o + 1, 0, t.value), e.value = i);
		},
		onDragEnd: () => {
			t.value = null, n.value = null;
		}
	};
}, Yf = typeof global == "object" && global && global.Object === Object && global, Xf = typeof self == "object" && self && self.Object === Object && self, Zf = Yf || Xf || Function("return this")(), Qf = Zf.Symbol, $f = Object.prototype, ep = $f.hasOwnProperty, tp = $f.toString, np = Qf ? Qf.toStringTag : void 0;
function rp(e) {
	var t = ep.call(e, np), n = e[np];
	try {
		e[np] = void 0;
		var r = !0;
	} catch {}
	var i = tp.call(e);
	return r && (t ? e[np] = n : delete e[np]), i;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_objectToString.js
var ip = Object.prototype.toString;
function ap(e) {
	return ip.call(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseGetTag.js
var op = "[object Null]", sp = "[object Undefined]", cp = Qf ? Qf.toStringTag : void 0;
function lp(e) {
	return e == null ? e === void 0 ? sp : op : cp && cp in Object(e) ? rp(e) : ap(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isObjectLike.js
function up(e) {
	return typeof e == "object" && !!e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isSymbol.js
var dp = "[object Symbol]";
function fp(e) {
	return typeof e == "symbol" || up(e) && lp(e) == dp;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_arrayMap.js
function pp(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
	return i;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isArray.js
var mp = Array.isArray, hp = Infinity, gp = Qf ? Qf.prototype : void 0, _p = gp ? gp.toString : void 0;
function vp(e) {
	if (typeof e == "string") return e;
	if (mp(e)) return pp(e, vp) + "";
	if (fp(e)) return _p ? _p.call(e) : "";
	var t = e + "";
	return t == "0" && 1 / e == -hp ? "-0" : t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isObject.js
function yp(e) {
	var t = typeof e;
	return e != null && (t == "object" || t == "function");
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/identity.js
function bp(e) {
	return e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isFunction.js
var xp = "[object AsyncFunction]", Sp = "[object Function]", Cp = "[object GeneratorFunction]", wp = "[object Proxy]";
function Tp(e) {
	if (!yp(e)) return !1;
	var t = lp(e);
	return t == Sp || t == Cp || t == xp || t == wp;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_coreJsData.js
var Ep = Zf["__core-js_shared__"], Dp = function() {
	var e = /[^.]+$/.exec(Ep && Ep.keys && Ep.keys.IE_PROTO || "");
	return e ? "Symbol(src)_1." + e : "";
}();
function Op(e) {
	return !!Dp && Dp in e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_toSource.js
var kp = Function.prototype.toString;
function Ap(e) {
	if (e != null) {
		try {
			return kp.call(e);
		} catch {}
		try {
			return e + "";
		} catch {}
	}
	return "";
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseIsNative.js
var jp = /[\\^$.*+?()[\]{}|]/g, Mp = /^\[object .+?Constructor\]$/, Np = Function.prototype, Pp = Object.prototype, Fp = Np.toString, Ip = Pp.hasOwnProperty, Lp = RegExp("^" + Fp.call(Ip).replace(jp, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function Rp(e) {
	return !yp(e) || Op(e) ? !1 : (Tp(e) ? Lp : Mp).test(Ap(e));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getValue.js
function zp(e, t) {
	return e?.[t];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getNative.js
function Bp(e, t) {
	var n = zp(e, t);
	return Rp(n) ? n : void 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_WeakMap.js
var Vp = Bp(Zf, "WeakMap"), Hp = Object.create, Up = function() {
	function e() {}
	return function(t) {
		if (!yp(t)) return {};
		if (Hp) return Hp(t);
		e.prototype = t;
		var n = new e();
		return e.prototype = void 0, n;
	};
}();
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_apply.js
function Wp(e, t, n) {
	switch (n.length) {
		case 0: return e.call(t);
		case 1: return e.call(t, n[0]);
		case 2: return e.call(t, n[0], n[1]);
		case 3: return e.call(t, n[0], n[1], n[2]);
	}
	return e.apply(t, n);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_copyArray.js
function Gp(e, t) {
	var n = -1, r = e.length;
	for (t ||= Array(r); ++n < r;) t[n] = e[n];
	return t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_shortOut.js
var Kp = 800, qp = 16, Jp = Date.now;
function Yp(e) {
	var t = 0, n = 0;
	return function() {
		var r = Jp(), i = qp - (r - n);
		if (n = r, i > 0) {
			if (++t >= Kp) return arguments[0];
		} else t = 0;
		return e.apply(void 0, arguments);
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/constant.js
function Xp(e) {
	return function() {
		return e;
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_defineProperty.js
var Zp = function() {
	try {
		var e = Bp(Object, "defineProperty");
		return e({}, "", {}), e;
	} catch {}
}(), Qp = Yp(Zp ? function(e, t) {
	return Zp(e, "toString", {
		configurable: !0,
		enumerable: !1,
		value: Xp(t),
		writable: !0
	});
} : bp);
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_arrayEach.js
function $p(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1;);
	return e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_isIndex.js
var em = 9007199254740991, tm = /^(?:0|[1-9]\d*)$/;
function nm(e, t) {
	var n = typeof e;
	return t ??= em, !!t && (n == "number" || n != "symbol" && tm.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseAssignValue.js
function rm(e, t, n) {
	t == "__proto__" && Zp ? Zp(e, t, {
		configurable: !0,
		enumerable: !0,
		value: n,
		writable: !0
	}) : e[t] = n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/eq.js
function im(e, t) {
	return e === t || e !== e && t !== t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_assignValue.js
var am = Object.prototype.hasOwnProperty;
function om(e, t, n) {
	var r = e[t];
	(!(am.call(e, t) && im(r, n)) || n === void 0 && !(t in e)) && rm(e, t, n);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_copyObject.js
function sm(e, t, n, r) {
	var i = !n;
	n ||= {};
	for (var a = -1, o = t.length; ++a < o;) {
		var s = t[a], c = r ? r(n[s], e[s], s, n, e) : void 0;
		c === void 0 && (c = e[s]), i ? rm(n, s, c) : om(n, s, c);
	}
	return n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_overRest.js
var cm = Math.max;
function lm(e, t, n) {
	return t = cm(t === void 0 ? e.length - 1 : t, 0), function() {
		for (var r = arguments, i = -1, a = cm(r.length - t, 0), o = Array(a); ++i < a;) o[i] = r[t + i];
		i = -1;
		for (var s = Array(t + 1); ++i < t;) s[i] = r[i];
		return s[t] = n(o), Wp(e, this, s);
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isLength.js
var um = 9007199254740991;
function dm(e) {
	return typeof e == "number" && e > -1 && e % 1 == 0 && e <= um;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isArrayLike.js
function fm(e) {
	return e != null && dm(e.length) && !Tp(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_isPrototype.js
var pm = Object.prototype;
function mm(e) {
	var t = e && e.constructor;
	return e === (typeof t == "function" && t.prototype || pm);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseTimes.js
function hm(e, t) {
	for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
	return r;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseIsArguments.js
var gm = "[object Arguments]";
function _m(e) {
	return up(e) && lp(e) == gm;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isArguments.js
var vm = Object.prototype, ym = vm.hasOwnProperty, bm = vm.propertyIsEnumerable, xm = _m(function() {
	return arguments;
}()) ? _m : function(e) {
	return up(e) && ym.call(e, "callee") && !bm.call(e, "callee");
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/stubFalse.js
function Sm() {
	return !1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isBuffer.js
var Cm = typeof exports == "object" && exports && !exports.nodeType && exports, wm = Cm && typeof module == "object" && module && !module.nodeType && module, Tm = wm && wm.exports === Cm ? Zf.Buffer : void 0, Em = (Tm ? Tm.isBuffer : void 0) || Sm, Dm = "[object Arguments]", Om = "[object Array]", km = "[object Boolean]", Am = "[object Date]", jm = "[object Error]", Mm = "[object Function]", Nm = "[object Map]", Pm = "[object Number]", Fm = "[object Object]", Im = "[object RegExp]", Lm = "[object Set]", Rm = "[object String]", zm = "[object WeakMap]", Bm = "[object ArrayBuffer]", Vm = "[object DataView]", Hm = "[object Float32Array]", Um = "[object Float64Array]", Wm = "[object Int8Array]", Gm = "[object Int16Array]", Km = "[object Int32Array]", qm = "[object Uint8Array]", Jm = "[object Uint8ClampedArray]", Ym = "[object Uint16Array]", Xm = "[object Uint32Array]", Z = {};
Z[Hm] = Z[Um] = Z[Wm] = Z[Gm] = Z[Km] = Z[qm] = Z[Jm] = Z[Ym] = Z[Xm] = !0, Z[Dm] = Z[Om] = Z[Bm] = Z[km] = Z[Vm] = Z[Am] = Z[jm] = Z[Mm] = Z[Nm] = Z[Pm] = Z[Fm] = Z[Im] = Z[Lm] = Z[Rm] = Z[zm] = !1;
function Zm(e) {
	return up(e) && dm(e.length) && !!Z[lp(e)];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseUnary.js
function Qm(e) {
	return function(t) {
		return e(t);
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_nodeUtil.js
var $m = typeof exports == "object" && exports && !exports.nodeType && exports, eh = $m && typeof module == "object" && module && !module.nodeType && module, th = eh && eh.exports === $m && Yf.process, nh = function() {
	try {
		return eh && eh.require && eh.require("util").types || th && th.binding && th.binding("util");
	} catch {}
}(), rh = nh && nh.isTypedArray, ih = rh ? Qm(rh) : Zm, ah = Object.prototype.hasOwnProperty;
function oh(e, t) {
	var n = mp(e), r = !n && xm(e), i = !n && !r && Em(e), a = !n && !r && !i && ih(e), o = n || r || i || a, s = o ? hm(e.length, String) : [], c = s.length;
	for (var l in e) (t || ah.call(e, l)) && !(o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || nm(l, c))) && s.push(l);
	return s;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_overArg.js
function sh(e, t) {
	return function(n) {
		return e(t(n));
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_nativeKeys.js
var ch = sh(Object.keys, Object), lh = Object.prototype.hasOwnProperty;
function uh(e) {
	if (!mm(e)) return ch(e);
	var t = [];
	for (var n in Object(e)) lh.call(e, n) && n != "constructor" && t.push(n);
	return t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/keys.js
function dh(e) {
	return fm(e) ? oh(e) : uh(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_nativeKeysIn.js
function fh(e) {
	var t = [];
	if (e != null) for (var n in Object(e)) t.push(n);
	return t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseKeysIn.js
var ph = Object.prototype.hasOwnProperty;
function mh(e) {
	if (!yp(e)) return fh(e);
	var t = mm(e), n = [];
	for (var r in e) r == "constructor" && (t || !ph.call(e, r)) || n.push(r);
	return n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/keysIn.js
function hh(e) {
	return fm(e) ? oh(e, !0) : mh(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_isKey.js
var gh = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, _h = /^\w*$/;
function vh(e, t) {
	if (mp(e)) return !1;
	var n = typeof e;
	return n == "number" || n == "symbol" || n == "boolean" || e == null || fp(e) ? !0 : _h.test(e) || !gh.test(e) || t != null && e in Object(t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_nativeCreate.js
var yh = Bp(Object, "create");
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_hashClear.js
function bh() {
	this.__data__ = yh ? yh(null) : {}, this.size = 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_hashDelete.js
function xh(e) {
	var t = this.has(e) && delete this.__data__[e];
	return this.size -= +!!t, t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_hashGet.js
var Sh = "__lodash_hash_undefined__", Ch = Object.prototype.hasOwnProperty;
function wh(e) {
	var t = this.__data__;
	if (yh) {
		var n = t[e];
		return n === Sh ? void 0 : n;
	}
	return Ch.call(t, e) ? t[e] : void 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_hashHas.js
var Th = Object.prototype.hasOwnProperty;
function Eh(e) {
	var t = this.__data__;
	return yh ? t[e] !== void 0 : Th.call(t, e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_hashSet.js
var Dh = "__lodash_hash_undefined__";
function Oh(e, t) {
	var n = this.__data__;
	return this.size += +!this.has(e), n[e] = yh && t === void 0 ? Dh : t, this;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_Hash.js
function kh(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
kh.prototype.clear = bh, kh.prototype.delete = xh, kh.prototype.get = wh, kh.prototype.has = Eh, kh.prototype.set = Oh;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_listCacheClear.js
function Ah() {
	this.__data__ = [], this.size = 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_assocIndexOf.js
function jh(e, t) {
	for (var n = e.length; n--;) if (im(e[n][0], t)) return n;
	return -1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_listCacheDelete.js
var Mh = Array.prototype.splice;
function Nh(e) {
	var t = this.__data__, n = jh(t, e);
	return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : Mh.call(t, n, 1), --this.size, !0);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_listCacheGet.js
function Ph(e) {
	var t = this.__data__, n = jh(t, e);
	return n < 0 ? void 0 : t[n][1];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_listCacheHas.js
function Fh(e) {
	return jh(this.__data__, e) > -1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_listCacheSet.js
function Ih(e, t) {
	var n = this.__data__, r = jh(n, e);
	return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_ListCache.js
function Lh(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
Lh.prototype.clear = Ah, Lh.prototype.delete = Nh, Lh.prototype.get = Ph, Lh.prototype.has = Fh, Lh.prototype.set = Ih;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_Map.js
var Rh = Bp(Zf, "Map");
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_mapCacheClear.js
function zh() {
	this.size = 0, this.__data__ = {
		hash: new kh(),
		map: new (Rh || Lh)(),
		string: new kh()
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_isKeyable.js
function Bh(e) {
	var t = typeof e;
	return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getMapData.js
function Vh(e, t) {
	var n = e.__data__;
	return Bh(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_mapCacheDelete.js
function Hh(e) {
	var t = Vh(this, e).delete(e);
	return this.size -= +!!t, t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_mapCacheGet.js
function Uh(e) {
	return Vh(this, e).get(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_mapCacheHas.js
function Wh(e) {
	return Vh(this, e).has(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_mapCacheSet.js
function Gh(e, t) {
	var n = Vh(this, e), r = n.size;
	return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_MapCache.js
function Kh(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
Kh.prototype.clear = zh, Kh.prototype.delete = Hh, Kh.prototype.get = Uh, Kh.prototype.has = Wh, Kh.prototype.set = Gh;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/memoize.js
var qh = "Expected a function";
function Jh(e, t) {
	if (typeof e != "function" || t != null && typeof t != "function") throw TypeError(qh);
	var n = function() {
		var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
		if (a.has(i)) return a.get(i);
		var o = e.apply(this, r);
		return n.cache = a.set(i, o) || a, o;
	};
	return n.cache = new (Jh.Cache || Kh)(), n;
}
Jh.Cache = Kh;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_memoizeCapped.js
var Yh = 500;
function Xh(e) {
	var t = Jh(e, function(e) {
		return n.size === Yh && n.clear(), e;
	}), n = t.cache;
	return t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_stringToPath.js
var Zh = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Qh = /\\(\\)?/g, $h = Xh(function(e) {
	var t = [];
	return e.charCodeAt(0) === 46 && t.push(""), e.replace(Zh, function(e, n, r, i) {
		t.push(r ? i.replace(Qh, "$1") : n || e);
	}), t;
});
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/toString.js
function eg(e) {
	return e == null ? "" : vp(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_castPath.js
function tg(e, t) {
	return mp(e) ? e : vh(e, t) ? [e] : $h(eg(e));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_toKey.js
var ng = Infinity;
function rg(e) {
	if (typeof e == "string" || fp(e)) return e;
	var t = e + "";
	return t == "0" && 1 / e == -ng ? "-0" : t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseGet.js
function ig(e, t) {
	t = tg(t, e);
	for (var n = 0, r = t.length; e != null && n < r;) e = e[rg(t[n++])];
	return n && n == r ? e : void 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_arrayPush.js
function ag(e, t) {
	for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
	return e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_isFlattenable.js
var og = Qf ? Qf.isConcatSpreadable : void 0;
function sg(e) {
	return mp(e) || xm(e) || !!(og && e && e[og]);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseFlatten.js
function cg(e, t, n, r, i) {
	var a = -1, o = e.length;
	for (n ||= sg, i ||= []; ++a < o;) {
		var s = e[a];
		t > 0 && n(s) ? t > 1 ? cg(s, t - 1, n, r, i) : ag(i, s) : r || (i[i.length] = s);
	}
	return i;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/flatten.js
function lg(e) {
	return e != null && e.length ? cg(e, 1) : [];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_flatRest.js
function ug(e) {
	return Qp(lm(e, void 0, lg), e + "");
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getPrototype.js
var dg = sh(Object.getPrototypeOf, Object), fg = "[object Object]", pg = Function.prototype, mg = Object.prototype, hg = pg.toString, gg = mg.hasOwnProperty, _g = hg.call(Object);
function vg(e) {
	if (!up(e) || lp(e) != fg) return !1;
	var t = dg(e);
	if (t === null) return !0;
	var n = gg.call(t, "constructor") && t.constructor;
	return typeof n == "function" && n instanceof n && hg.call(n) == _g;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseSlice.js
function yg(e, t, n) {
	var r = -1, i = e.length;
	t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
	for (var a = Array(i); ++r < i;) a[r] = e[r + t];
	return a;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_stackClear.js
function bg() {
	this.__data__ = new Lh(), this.size = 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_stackDelete.js
function xg(e) {
	var t = this.__data__, n = t.delete(e);
	return this.size = t.size, n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_stackGet.js
function Sg(e) {
	return this.__data__.get(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_stackHas.js
function Cg(e) {
	return this.__data__.has(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_stackSet.js
var wg = 200;
function Tg(e, t) {
	var n = this.__data__;
	if (n instanceof Lh) {
		var r = n.__data__;
		if (!Rh || r.length < wg - 1) return r.push([e, t]), this.size = ++n.size, this;
		n = this.__data__ = new Kh(r);
	}
	return n.set(e, t), this.size = n.size, this;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_Stack.js
function Eg(e) {
	var t = this.__data__ = new Lh(e);
	this.size = t.size;
}
Eg.prototype.clear = bg, Eg.prototype.delete = xg, Eg.prototype.get = Sg, Eg.prototype.has = Cg, Eg.prototype.set = Tg;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseAssign.js
function Dg(e, t) {
	return e && sm(t, dh(t), e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseAssignIn.js
function Og(e, t) {
	return e && sm(t, hh(t), e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cloneBuffer.js
var kg = typeof exports == "object" && exports && !exports.nodeType && exports, Ag = kg && typeof module == "object" && module && !module.nodeType && module, jg = Ag && Ag.exports === kg ? Zf.Buffer : void 0, Mg = jg ? jg.allocUnsafe : void 0;
function Ng(e, t) {
	if (t) return e.slice();
	var n = e.length, r = Mg ? Mg(n) : new e.constructor(n);
	return e.copy(r), r;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_arrayFilter.js
function Pg(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
		var o = e[n];
		t(o, n, e) && (a[i++] = o);
	}
	return a;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/stubArray.js
function Fg() {
	return [];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getSymbols.js
var Ig = Object.prototype.propertyIsEnumerable, Lg = Object.getOwnPropertySymbols, Rg = Lg ? function(e) {
	return e == null ? [] : (e = Object(e), Pg(Lg(e), function(t) {
		return Ig.call(e, t);
	}));
} : Fg;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_copySymbols.js
function zg(e, t) {
	return sm(e, Rg(e), t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getSymbolsIn.js
var Bg = Object.getOwnPropertySymbols ? function(e) {
	for (var t = []; e;) ag(t, Rg(e)), e = dg(e);
	return t;
} : Fg;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_copySymbolsIn.js
function Vg(e, t) {
	return sm(e, Bg(e), t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseGetAllKeys.js
function Hg(e, t, n) {
	var r = t(e);
	return mp(e) ? r : ag(r, n(e));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getAllKeys.js
function Ug(e) {
	return Hg(e, dh, Rg);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getAllKeysIn.js
function Wg(e) {
	return Hg(e, hh, Bg);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_DataView.js
var Gg = Bp(Zf, "DataView"), Kg = Bp(Zf, "Promise"), qg = Bp(Zf, "Set"), Jg = "[object Map]", Yg = "[object Object]", Xg = "[object Promise]", Zg = "[object Set]", Qg = "[object WeakMap]", $g = "[object DataView]", e_ = Ap(Gg), t_ = Ap(Rh), n_ = Ap(Kg), r_ = Ap(qg), i_ = Ap(Vp), a_ = lp;
(Gg && a_(new Gg(/* @__PURE__ */ new ArrayBuffer(1))) != $g || Rh && a_(new Rh()) != Jg || Kg && a_(Kg.resolve()) != Xg || qg && a_(new qg()) != Zg || Vp && a_(new Vp()) != Qg) && (a_ = function(e) {
	var t = lp(e), n = t == Yg ? e.constructor : void 0, r = n ? Ap(n) : "";
	if (r) switch (r) {
		case e_: return $g;
		case t_: return Jg;
		case n_: return Xg;
		case r_: return Zg;
		case i_: return Qg;
	}
	return t;
});
var o_ = a_, s_ = Object.prototype.hasOwnProperty;
function c_(e) {
	var t = e.length, n = new e.constructor(t);
	return t && typeof e[0] == "string" && s_.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_Uint8Array.js
var l_ = Zf.Uint8Array;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cloneArrayBuffer.js
function u_(e) {
	var t = new e.constructor(e.byteLength);
	return new l_(t).set(new l_(e)), t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cloneDataView.js
function d_(e, t) {
	var n = t ? u_(e.buffer) : e.buffer;
	return new e.constructor(n, e.byteOffset, e.byteLength);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cloneRegExp.js
var f_ = /\w*$/;
function p_(e) {
	var t = new e.constructor(e.source, f_.exec(e));
	return t.lastIndex = e.lastIndex, t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cloneSymbol.js
var m_ = Qf ? Qf.prototype : void 0, h_ = m_ ? m_.valueOf : void 0;
function g_(e) {
	return h_ ? Object(h_.call(e)) : {};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cloneTypedArray.js
function __(e, t) {
	var n = t ? u_(e.buffer) : e.buffer;
	return new e.constructor(n, e.byteOffset, e.length);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_initCloneByTag.js
var v_ = "[object Boolean]", y_ = "[object Date]", b_ = "[object Map]", x_ = "[object Number]", S_ = "[object RegExp]", C_ = "[object Set]", w_ = "[object String]", T_ = "[object Symbol]", E_ = "[object ArrayBuffer]", D_ = "[object DataView]", O_ = "[object Float32Array]", k_ = "[object Float64Array]", A_ = "[object Int8Array]", j_ = "[object Int16Array]", M_ = "[object Int32Array]", N_ = "[object Uint8Array]", P_ = "[object Uint8ClampedArray]", F_ = "[object Uint16Array]", I_ = "[object Uint32Array]";
function L_(e, t, n) {
	var r = e.constructor;
	switch (t) {
		case E_: return u_(e);
		case v_:
		case y_: return new r(+e);
		case D_: return d_(e, n);
		case O_:
		case k_:
		case A_:
		case j_:
		case M_:
		case N_:
		case P_:
		case F_:
		case I_: return __(e, n);
		case b_: return new r();
		case x_:
		case w_: return new r(e);
		case S_: return p_(e);
		case C_: return new r();
		case T_: return g_(e);
	}
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_initCloneObject.js
function R_(e) {
	return typeof e.constructor == "function" && !mm(e) ? Up(dg(e)) : {};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseIsMap.js
var z_ = "[object Map]";
function B_(e) {
	return up(e) && o_(e) == z_;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isMap.js
var V_ = nh && nh.isMap, H_ = V_ ? Qm(V_) : B_, U_ = "[object Set]";
function W_(e) {
	return up(e) && o_(e) == U_;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isSet.js
var G_ = nh && nh.isSet, K_ = G_ ? Qm(G_) : W_, q_ = 1, J_ = 2, Y_ = 4, X_ = "[object Arguments]", Z_ = "[object Array]", Q_ = "[object Boolean]", $_ = "[object Date]", ev = "[object Error]", tv = "[object Function]", nv = "[object GeneratorFunction]", rv = "[object Map]", iv = "[object Number]", av = "[object Object]", ov = "[object RegExp]", sv = "[object Set]", cv = "[object String]", lv = "[object Symbol]", uv = "[object WeakMap]", dv = "[object ArrayBuffer]", fv = "[object DataView]", pv = "[object Float32Array]", mv = "[object Float64Array]", hv = "[object Int8Array]", gv = "[object Int16Array]", _v = "[object Int32Array]", vv = "[object Uint8Array]", yv = "[object Uint8ClampedArray]", bv = "[object Uint16Array]", xv = "[object Uint32Array]", Q = {};
Q[X_] = Q[Z_] = Q[dv] = Q[fv] = Q[Q_] = Q[$_] = Q[pv] = Q[mv] = Q[hv] = Q[gv] = Q[_v] = Q[rv] = Q[iv] = Q[av] = Q[ov] = Q[sv] = Q[cv] = Q[lv] = Q[vv] = Q[yv] = Q[bv] = Q[xv] = !0, Q[ev] = Q[tv] = Q[uv] = !1;
function Sv(e, t, n, r, i, a) {
	var o, s = t & q_, c = t & J_, l = t & Y_;
	if (n && (o = i ? n(e, r, i, a) : n(e)), o !== void 0) return o;
	if (!yp(e)) return e;
	var u = mp(e);
	if (u) {
		if (o = c_(e), !s) return Gp(e, o);
	} else {
		var d = o_(e), f = d == tv || d == nv;
		if (Em(e)) return Ng(e, s);
		if (d == av || d == X_ || f && !i) {
			if (o = c || f ? {} : R_(e), !s) return c ? Vg(e, Og(o, e)) : zg(e, Dg(o, e));
		} else {
			if (!Q[d]) return i ? e : {};
			o = L_(e, d, s);
		}
	}
	a ||= new Eg();
	var p = a.get(e);
	if (p) return p;
	a.set(e, o), K_(e) ? e.forEach(function(r) {
		o.add(Sv(r, t, n, r, e, a));
	}) : H_(e) && e.forEach(function(r, i) {
		o.set(i, Sv(r, t, n, i, e, a));
	});
	var m = u ? void 0 : (l ? c ? Wg : Ug : c ? hh : dh)(e);
	return $p(m || e, function(r, i) {
		m && (i = r, r = e[i]), om(o, i, Sv(r, t, n, i, e, a));
	}), o;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/cloneDeep.js
var Cv = 1, wv = 4;
function Tv(e) {
	return Sv(e, Cv | wv);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_setCacheAdd.js
var Ev = "__lodash_hash_undefined__";
function Dv(e) {
	return this.__data__.set(e, Ev), this;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_setCacheHas.js
function Ov(e) {
	return this.__data__.has(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_SetCache.js
function kv(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.__data__ = new Kh(); ++t < n;) this.add(e[t]);
}
kv.prototype.add = kv.prototype.push = Dv, kv.prototype.has = Ov;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_arraySome.js
function Av(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
	return !1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cacheHas.js
function jv(e, t) {
	return e.has(t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_equalArrays.js
var Mv = 1, Nv = 2;
function Pv(e, t, n, r, i, a) {
	var o = n & Mv, s = e.length, c = t.length;
	if (s != c && !(o && c > s)) return !1;
	var l = a.get(e), u = a.get(t);
	if (l && u) return l == t && u == e;
	var d = -1, f = !0, p = n & Nv ? new kv() : void 0;
	for (a.set(e, t), a.set(t, e); ++d < s;) {
		var m = e[d], h = t[d];
		if (r) var g = o ? r(h, m, d, t, e, a) : r(m, h, d, e, t, a);
		if (g !== void 0) {
			if (g) continue;
			f = !1;
			break;
		}
		if (p) {
			if (!Av(t, function(e, t) {
				if (!jv(p, t) && (m === e || i(m, e, n, r, a))) return p.push(t);
			})) {
				f = !1;
				break;
			}
		} else if (!(m === h || i(m, h, n, r, a))) {
			f = !1;
			break;
		}
	}
	return a.delete(e), a.delete(t), f;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_mapToArray.js
function Fv(e) {
	var t = -1, n = Array(e.size);
	return e.forEach(function(e, r) {
		n[++t] = [r, e];
	}), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_setToArray.js
function Iv(e) {
	var t = -1, n = Array(e.size);
	return e.forEach(function(e) {
		n[++t] = e;
	}), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_equalByTag.js
var Lv = 1, Rv = 2, zv = "[object Boolean]", Bv = "[object Date]", Vv = "[object Error]", Hv = "[object Map]", Uv = "[object Number]", Wv = "[object RegExp]", Gv = "[object Set]", Kv = "[object String]", qv = "[object Symbol]", Jv = "[object ArrayBuffer]", Yv = "[object DataView]", Xv = Qf ? Qf.prototype : void 0, Zv = Xv ? Xv.valueOf : void 0;
function Qv(e, t, n, r, i, a, o) {
	switch (n) {
		case Yv:
			if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
			e = e.buffer, t = t.buffer;
		case Jv: return !(e.byteLength != t.byteLength || !a(new l_(e), new l_(t)));
		case zv:
		case Bv:
		case Uv: return im(+e, +t);
		case Vv: return e.name == t.name && e.message == t.message;
		case Wv:
		case Kv: return e == t + "";
		case Hv: var s = Fv;
		case Gv:
			var c = r & Lv;
			if (s ||= Iv, e.size != t.size && !c) return !1;
			var l = o.get(e);
			if (l) return l == t;
			r |= Rv, o.set(e, t);
			var u = Pv(s(e), s(t), r, i, a, o);
			return o.delete(e), u;
		case qv: if (Zv) return Zv.call(e) == Zv.call(t);
	}
	return !1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_equalObjects.js
var $v = 1, ey = Object.prototype.hasOwnProperty;
function ty(e, t, n, r, i, a) {
	var o = n & $v, s = Ug(e), c = s.length;
	if (c != Ug(t).length && !o) return !1;
	for (var l = c; l--;) {
		var u = s[l];
		if (!(o ? u in t : ey.call(t, u))) return !1;
	}
	var d = a.get(e), f = a.get(t);
	if (d && f) return d == t && f == e;
	var p = !0;
	a.set(e, t), a.set(t, e);
	for (var m = o; ++l < c;) {
		u = s[l];
		var h = e[u], g = t[u];
		if (r) var ee = o ? r(g, h, u, t, e, a) : r(h, g, u, e, t, a);
		if (!(ee === void 0 ? h === g || i(h, g, n, r, a) : ee)) {
			p = !1;
			break;
		}
		m ||= u == "constructor";
	}
	if (p && !m) {
		var _ = e.constructor, v = t.constructor;
		_ != v && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof v == "function" && v instanceof v) && (p = !1);
	}
	return a.delete(e), a.delete(t), p;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseIsEqualDeep.js
var ny = 1, ry = "[object Arguments]", iy = "[object Array]", ay = "[object Object]", oy = Object.prototype.hasOwnProperty;
function sy(e, t, n, r, i, a) {
	var o = mp(e), s = mp(t), c = o ? iy : o_(e), l = s ? iy : o_(t);
	c = c == ry ? ay : c, l = l == ry ? ay : l;
	var u = c == ay, d = l == ay, f = c == l;
	if (f && Em(e)) {
		if (!Em(t)) return !1;
		o = !0, u = !1;
	}
	if (f && !u) return a ||= new Eg(), o || ih(e) ? Pv(e, t, n, r, i, a) : Qv(e, t, c, n, r, i, a);
	if (!(n & ny)) {
		var p = u && oy.call(e, "__wrapped__"), m = d && oy.call(t, "__wrapped__");
		if (p || m) {
			var h = p ? e.value() : e, g = m ? t.value() : t;
			return a ||= new Eg(), i(h, g, n, r, a);
		}
	}
	return f ? (a ||= new Eg(), ty(e, t, n, r, i, a)) : !1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseIsEqual.js
function cy(e, t, n, r, i) {
	return e === t ? !0 : e == null || t == null || !up(e) && !up(t) ? e !== e && t !== t : sy(e, t, n, r, cy, i);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/last.js
function ly(e) {
	var t = e == null ? 0 : e.length;
	return t ? e[t - 1] : void 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_parent.js
function uy(e, t) {
	return t.length < 2 ? e : ig(e, yg(t, 0, -1));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isEqual.js
function dy(e, t) {
	return cy(e, t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseUnset.js
var fy = Object.prototype.hasOwnProperty;
function py(e, t) {
	t = tg(t, e);
	var n = -1, r = t.length;
	if (!r) return !0;
	for (var i = e == null || typeof e != "object" && typeof e != "function"; ++n < r;) {
		var a = t[n];
		if (typeof a == "string") {
			if (a === "__proto__" && !fy.call(e, "__proto__")) return !1;
			if (a === "constructor" && n + 1 < r && typeof t[n + 1] == "string" && t[n + 1] === "prototype") {
				if (i && n === 0) continue;
				return !1;
			}
		}
	}
	var o = uy(e, t);
	return o == null || delete o[rg(ly(t))];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_customOmitClone.js
function my(e) {
	return vg(e) ? void 0 : e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/omit.js
var hy = 1, gy = 2, _y = 4, vy = ug(function(e, t) {
	var n = {};
	if (e == null) return n;
	var r = !1;
	t = pp(t, function(t) {
		return t = tg(t, e), r ||= t.length > 1, t;
	}), sm(e, Wg(e), n), r && (n = Sv(n, hy | gy | _y, my));
	for (var i = t.length; i--;) py(n, t[i]);
	return n;
});
//#endregion
//#region src/composables/useChangesWatch.ts
function yy({ watchedValue: e, ignoredRootKeys: t = [], onValueChange: n }) {
	let r = (e) => vy(e, t), i = We(Tv(r(e.value))), a = M(!1);
	Je(() => r(e.value), (e, t) => {
		let r = !dy(i.value, e);
		a.value = r, n && n({
			isChanged: r,
			newValue: e,
			oldValue: t,
			initValue: i
		});
	}, { deep: !0 });
	function o(t = e) {
		a.value = !1, i.value = Tv(r(t.value));
	}
	return {
		initValue: i,
		isWatchedValueChanged: a,
		resetChangesWatcher: o
	};
}
//#endregion
//#region src/components/dialogs/changes-watch.dialog.vue?vue&type=script&setup=true&lang.ts
var by = {
	key: 0,
	class: "text-center"
}, xy = ["textContent"], Sy = ["textContent"], Cy = /* @__PURE__ */ Tc(/* @__PURE__ */ A({
	__name: "changes-watch.dialog",
	props: {
		initValue: {},
		currentValue: {},
		ignoredRootKeys: {}
	},
	emits: [...xe.emits],
	setup(e) {
		let t = cl(), n = M(!1), r = C(() => t.hasRight("changes-diff:read")), i = C(() => n.value && r.value), { dialogRef: o, onDialogCancel: u, onDialogOK: d } = xe(), f = e;
		function m(e) {
			return JSON.stringify(e ?? {}, null, 2);
		}
		function h(e, t) {
			let n = new Blob([t], { type: "application/json" }), r = URL.createObjectURL(n), i = document.createElement("a");
			i.href = r, i.download = e, i.click(), URL.revokeObjectURL(r);
		}
		async function g(e) {
			e === "initial" && h("initial.json", m(f.initValue?.value)), e === "current" && h("current.json", m(f.currentValue?.value));
		}
		return (t, f) => (j(), w(P(p), {
			ref_key: "dialogRef",
			ref: o,
			persistent: ""
		}, {
			default: F(() => [k(P(s), { class: Ne(["changes-dialog", { "changes-dialog--diff-shown": i.value }]) }, {
				default: F(() => [
					k(P(l), { class: "changes-header" }, {
						default: F(() => [i.value ? T("", !0) : (j(), E("div", by, [D("h6", {
							class: "text-h6 q-pb-md",
							textContent: N(t.$t("changesWatch.dialog.title"))
						}, null, 8, xy), D("p", { textContent: N(t.$t("changesWatch.dialog.text")) }, null, 8, Sy)])), i.value ? (j(), w(P(c), {
							key: 1,
							align: "between"
						}, {
							default: F(() => [k(P(a), {
								dense: "",
								flat: "",
								icon: "download",
								label: t.$t("changesWatch.dialog.downloadInitial"),
								onClick: f[0] ||= (e) => g("initial")
							}, null, 8, ["label"]), k(P(a), {
								dense: "",
								flat: "",
								icon: "download",
								label: t.$t("changesWatch.dialog.downloadCurrent"),
								onClick: f[1] ||= (e) => g("current")
							}, null, 8, ["label"])]),
							_: 1
						})) : T("", !0)]),
						_: 1
					}),
					i.value ? (j(), w(P(l), {
						key: 0,
						class: "changes-body q-pa-none"
					}, {
						default: F(() => [(j(), w(Ue(P(cS)), {
							"old-value": e.initValue,
							"new-value": e.currentValue,
							"ignored-root-keys": e.ignoredRootKeys
						}, null, 8, [
							"old-value",
							"new-value",
							"ignored-root-keys"
						]))]),
						_: 1
					})) : T("", !0),
					k(P(c), {
						class: "changes-footer",
						align: "right"
					}, {
						default: F(() => [
							r.value ? (j(), w(P(a), {
								key: 0,
								icon: n.value ? "eye-off" : "eye",
								flat: "",
								label: t.$t("changesWatch.dialog.inspect"),
								color: "warning",
								onClick: f[2] ||= () => n.value = !n.value
							}, null, 8, ["icon", "label"])) : T("", !0),
							k(P(a), {
								flat: "",
								label: t.$t("changesWatch.dialog.stay"),
								color: "secondary",
								onClick: P(u)
							}, null, 8, ["label", "onClick"]),
							k(P(a), {
								flat: "",
								label: t.$t("changesWatch.dialog.leave"),
								color: "primary",
								onClick: P(d)
							}, null, 8, ["label", "onClick"])
						]),
						_: 1
					})
				]),
				_: 1
			}, 8, ["class"])]),
			_: 1
		}, 512));
	}
}), [["__scopeId", "data-v-20203376"]]);
//#endregion
//#region src/composables/useConfirmChangesDialog.ts
function wy({ watchedValue: e, ignoredRootKeys: n = [], onValueChange: r }) {
	let i = ut(), a = !1, o = (e) => {
		a = e;
	}, s = (e) => {
		window.onbeforeunload = e ? () => e : null;
	}, { resetChangesWatcher: c, isWatchedValueChanged: l, initValue: u } = yy({
		watchedValue: e,
		ignoredRootKeys: n,
		onValueChange: (e) => {
			r && r(e), s(e.isChanged);
		}
	});
	function d(e) {
		s(!1), c(e);
	}
	return lt((r, o, c) => {
		if (a) {
			c();
			return;
		}
		if (!l.value || o.name === r.name) {
			s(l.value), c();
			return;
		}
		c(!1), t.create({
			component: Cy,
			componentProps: {
				initValue: u,
				currentValue: e,
				ignoredRootKeys: n
			}
		}).onOk(async () => {
			d(e), await i.push(r);
		});
	}), {
		initValue: u,
		isWatchedValueChanged: l,
		resetChangesWatcher: d,
		setPreventOnLeaveAlert: o
	};
}
//#endregion
//#region src/composables/useDetectOutsideClick.ts
var Ty = (e, t) => {
	if (!e) return { listener: () => {} };
	let n = (n) => {
		n.target !== e.value && n.composedPath().includes(e.value) || typeof t == "function" && t();
	};
	return Le(() => {
		window.addEventListener("click", n);
	}), Ie(() => {
		window.removeEventListener("click", n);
	}), { listener: n };
};
//#endregion
//#region src/composables/useEntityQuery.ts
function Ey(e) {
	return typeof e != "object" || !e ? !1 : "keyword" in e && "instancePath" in e && "schemaPath" in e && "params" in e;
}
async function Dy(e, t) {
	e?.length && await Promise.all(e.map((e) => e(t)));
}
function Oy(e) {
	let { entityId: t, entityEndpoint: n, api: r, entityStore: i, entityStoreDefaults: a, resetStoreOnComponentUnmount: o = !0, resetCachedDataOnBeforeRouteLeave: s = !0, serverResponseCallbacks: c } = e, l = pt(), u = (e) => P(t) === e, d = (e, t = i) => !!e?.changeDate && !!t?.value?.changeDate && e._id === t.value._id && new Date(e?.changeDate).getTime() === new Date(t.value?.changeDate).getTime(), f = (e) => {
		e && i?.value && (i.value = e);
	}, p = (e) => {
		e && i?.value && (i.value = {
			...i.value,
			...e
		});
	}, m = C(() => [n, P(t)]), { data: h, isLoading: g, refetch: ee } = ft({
		queryKey: m,
		enabled: C(() => !!P(t)),
		queryFn: async ({ signal: e }) => {
			let n = P(t);
			if (!n) throw Error("Query tried to fetch entity with unknown id");
			try {
				let t = await r.getEntity(n, { signal: e });
				return u(n) && (d(t) || (f(t), await Dy(c, {
					method: "GET",
					status: "success",
					payload: t
				}))), t;
			} catch (e) {
				throw await Dy(c, {
					method: "GET",
					status: "error",
					payload: Ey(e) ? e : void 0
				}), e;
			}
		}
	}), { isPending: _, mutateAsync: v } = dt({
		mutationKey: m,
		mutationFn: r.postEntity,
		onSuccess: async (e) => {
			l.setQueryData(m.value, e), f(e), await Dy(c, {
				method: "POST",
				status: "success",
				payload: e
			});
		},
		onError: async (e) => {
			await Dy(c, {
				method: "POST",
				status: "error",
				payload: e
			});
		}
	}), { isPending: y, mutateAsync: b } = dt({
		mutationKey: m,
		mutationFn: (e) => {
			let i = P(t);
			if (!i) throw Error(`Attempted ${n} PUT request with undefined uuid!`);
			return r.putEntity(i, e);
		},
		onSuccess: async (e) => {
			u(e._id) && (l.setQueryData(m.value, e), f(e), await Dy(c, {
				method: "PUT",
				status: "success",
				payload: e
			}));
		},
		onError: async (e) => {
			await Dy(c, {
				method: "PUT",
				status: "error",
				payload: e
			});
		}
	}), { isPending: te, mutateAsync: ne } = dt({
		mutationKey: m,
		mutationFn: (e) => r.deleteEntity(e),
		onSuccess: async () => {
			l.removeQueries({
				queryKey: m.value,
				exact: !0
			}), p(Tv(a)), await Dy(c, {
				method: "DELETE",
				status: "success",
				payload: void 0
			});
		},
		onError: async (e) => {
			await Dy(c, {
				method: "DELETE",
				status: "error",
				payload: e
			});
		}
	}), x = C(() => _.value || y.value || te.value), re = C(() => g.value || x.value), ie = async (e) => await v(e), ae = async (e) => await b(e), oe = async (e) => {
		await ne(e);
	}, se = async () => {
		let e = P(t);
		if (!e) throw Error("Query tried to fetch and sync entity with unknown id");
		try {
			let t = await r.getEntity(e);
			return l.setQueryData([n, e], t), u(e) ? (f(t), await Dy(c, {
				method: "GET",
				status: "success",
				payload: t
			}), t) : t;
		} catch (e) {
			throw await Dy(c, {
				method: "GET",
				status: "error",
				payload: Ey(e) ? e : void 0
			}), e;
		}
	}, ce = () => {
		P(t) && (l.removeQueries({
			queryKey: m.value,
			exact: !0
		}), l.setQueryData(m.value, void 0));
	};
	return Re(() => {
		o && (ce(), p(Tv(a)));
	}), lt(() => {
		s && ce();
	}), {
		fetchedEntity: h,
		clearFetchedEntityCache: ce,
		createEntity: ie,
		updateEntity: ae,
		fetchEntity: ee,
		enforcedFetchAndSyncEntityStore: se,
		deleteEntity: oe,
		isFetchingEntity: g,
		isPendingEntityCreation: _,
		isPendingEntityUpdate: y,
		isPendingEntityDelete: te,
		isPendingEntityChangeRequest: x,
		isPendingEntityRequest: re
	};
}
//#endregion
//#region src/composables/useGermanQuoteTransform.ts
function ky(e, t = 100) {
	return ye((t) => {
		if (typeof t != "string" || !at(t)) return;
		let n = ot(t);
		n !== t && e(n);
	}, t);
}
//#endregion
//#region src/composables/useInfiniteSearch.ts
var Ay = (e) => e instanceof Date ? e.toISOString() : typeof e == "boolean" ? e ? "true" : "false" : e, jy = (e) => Array.isArray(e) ? e.map(Ay) : Ay(e), My = (e) => {
	let t = {};
	for (let [n, r] of Object.entries(e)) t[n] = r;
	return t;
}, Ny = () => {
	let e = ut().currentRoute.value.query.page;
	return Array.isArray(e) ? 1 : parseInt(e ?? "1");
};
function Py(e, t, n = {}) {
	let r = n.currentPage ?? Ny(), i = ut(), a = My(i.currentRoute.value.query), o = null, s = Be({
		loading: !1,
		searchFields: t.searchFields,
		parameters: t.defaultParameters ? {
			...t.defaultParameters,
			...a
		} : { ...a },
		hiddenParameters: t.hiddenParameters,
		results: [],
		resultIds: /* @__PURE__ */ new Set(),
		lastPollResults: [],
		previousPage: r ? r - 1 : 0,
		currentPage: r,
		nextPage: r ? r + 1 : 0,
		previousPageLink: void 0,
		nextPageLink: void 0,
		changedParameters: 0,
		activeFiltersCount: 0,
		lastPollDateTime: void 0,
		isPolling: !1,
		isPollingActive: !1,
		async loadResults(n = !1) {
			if (!this.loading) {
				this.loading = !0, n && (this.resultIds = /* @__PURE__ */ new Set(), this.lastPollResults = [], this.results = [], this.lastPollDateTime = void 0);
				let { list: r, page: i, previous: a, next: o } = await e.listEntities({
					params: {
						...this.parameters,
						page: n ? 1 : this.currentPage || 1,
						size: t.pageSize
					},
					...this.reqPayload ? { data: this.reqPayload } : {}
				});
				this.dedupAndStoreNewResults(r), this.previousPage = i - 1 || 0, this.currentPage = i || 1, this.nextPage = i + 1 || 2, this.previousPageLink = a, this.nextPageLink = o, await this.updateUrl(), this.loading = !1;
			}
		},
		clearSearch() {
			return this.parameters = t.defaultParameters ? { ...t.defaultParameters } : {}, this.loadResults(!0);
		},
		async updateUrl() {
			if (t.updateUrl) {
				let e = Object.assign({}, s.parameters), t = Object.fromEntries(Object.entries(e).filter(([, e]) => e !== void 0).map(([e, t]) => [e, jy(t)]));
				s.hiddenParameters?.length && s.hiddenParameters.forEach((e) => {
					delete t[e];
				}), await i.replace({ query: t });
			}
		},
		async goToPage(e) {
			this.currentPage = e, await this.loadResults();
		},
		dedupAndStoreNewResults(e, t = !1) {
			let n = e.filter((e) => e._id && !this.resultIds.has(e._id));
			this.results = t ? [...n, ...this.results] : [...this.results, ...n], t && (this.lastPollResults = n);
			let r = n.map((e) => e._id).filter((e) => typeof e == "string");
			this.resultIds = new Set(Array.from(this.resultIds).concat(r));
		},
		async pollForNewResults(t, n, r) {
			if (!(this.loading || this.isPolling)) {
				if (n !== i.currentRoute.value.path) {
					this.stopPolling();
					return;
				}
				this.isPolling = !0;
				try {
					let { list: n } = await e.listEntities({
						params: {
							...this.parameters,
							page: 1,
							size: t,
							...r ? { [r]: this.lastPollDateTime } : {}
						},
						...this.reqPayload ? { data: this.reqPayload } : {}
					}), i = n.findIndex((e) => e._id === this.results[0]?._id);
					i >= 0 && n.splice(i), this.dedupAndStoreNewResults(n, !0), this.lastPollDateTime = /* @__PURE__ */ new Date(), this.isPolling = !1;
				} catch (e) {
					console.error(e), this.stopPolling();
				}
			}
		},
		startPolling(e, n = t.pageSize || 20, r) {
			if (o || !e) return;
			let a = i.currentRoute.value.path;
			o = setInterval(() => {
				s.pollForNewResults(n, a, r).catch((e) => console.error(e));
			}, e), this.isPollingActive = !0;
		},
		stopPolling() {
			o && (clearInterval(o), o = null, this.isPollingActive = !1, this.lastPollResults = [], this.isPolling = !1);
		},
		removeRecordByUuid(e) {
			let t = this.results.findIndex((t) => t._id === e);
			t !== -1 && (this.results.splice(t, 1), this.resultIds.delete(e));
		}
	}), c = C(() => {
		let e = 0, { dateFrom: t, dateTo: n, ...r } = s.parameters;
		t && n && e++;
		let i = Object.entries(r);
		return e += i.reduce((e, [t, n]) => t === "page" ? e : typeof n == "object" && n ? Object.keys(n).length === 0 ? e : e + 1 : typeof n == "string" ? n.length === 0 ? e : e + 1 : n === void 0 ? e : e + 1, 0);
	}), l = ye((e = !1) => s.loadResults(e), 350);
	return mf(l), Je([() => s.parameters, () => s.reqPayload], () => (s.results = [], s.currentPage = 1, s.previousPage = 0, l(!0)), { deep: !0 }), Je(i.currentRoute, (e, t) => {
		t.name === e.name && Object.values(e.query).length === 0 && (s.parameters = {});
	}), Je(c, (e) => {
		s.activeFiltersCount = e;
	}), l(), s;
}
//#endregion
//#region src/composables/usePublishStates.ts
var { showDialog: Fy } = nf(), Iy = (e) => {
	let t = {
		publish: [],
		unpublish: [],
		draft: [],
		schedule: [],
		rePublishInFuture: []
	}, n = (e, n) => (t[e].push(n), () => {
		t[e] = t[e].filter((e) => e !== n);
	}), r = (e, t) => n(e, () => new Promise((e) => Fy(t).onOk(() => e(!0)).onCancel(() => e(!1)))), i = async (n) => {
		for (let r of t[n]) if (!await r(e.value)) return !1;
		return !0;
	}, a = async (t) => e.value.state === t ? !0 : await i(t) ? (e.value.state = t === "rePublishInFuture" ? "schedule" : t, t === "schedule" && !e.value.displayDate && (e.value.displayDate = e.value.publishDate), !0) : !1;
	return {
		async checkTransition() {
			let { publishDate: t, unpublishDate: n, state: r } = e.value;
			return r === "publish" && t && t > /* @__PURE__ */ new Date() ? a("rePublishInFuture") : t ? t ? a(n && n < /* @__PURE__ */ new Date() ? "unpublish" : t <= /* @__PURE__ */ new Date() ? "publish" : "schedule") : !0 : a("draft");
		},
		onDraft(e) {
			return n("draft", e), this;
		},
		onSchedule(e) {
			return n("schedule", e), this;
		},
		onPublish(e) {
			return n("publish", e), this;
		},
		onUnpublish(e) {
			return n("draft", e), this;
		},
		onRePublishInFuture(e) {
			return n("rePublishInFuture", e), this;
		},
		onDraftDialog(e) {
			return r("draft", e), this;
		},
		onScheduleDialog(e) {
			return r("schedule", e), this;
		},
		onPublishDialog(e) {
			return r("publish", e), this;
		},
		onUnpublishDialog(e) {
			return r("unpublish", e), this;
		},
		onRePublishInFutureDialog(e) {
			return r("rePublishInFuture", e), this;
		},
		saveDraft: () => a("draft"),
		schedule: () => a("schedule"),
		publish: () => a("publish"),
		unpublish: () => a("unpublish")
	};
}, Ly = (e, t) => new Promise(async (n) => {
	await Me(async () => {
		let r = await e.value?.validate(!0) || !1;
		if (!r) {
			n({
				canProceed: !1,
				isFormValid: r
			});
			return;
		}
		n({
			canProceed: await t(),
			isFormValid: r
		});
	});
}), Ry = (e, t, n) => ({
	async saveDraft(r = !1) {
		return Ly(e, () => new Promise((e) => {
			Fy(n.draft()).onOk(async () => {
				r && (t.value.publishDate = void 0, t.value.displayDate = void 0, t.value.unpublishDate = void 0), t.value.state = "draft", e(!0);
			}).onCancel(() => e(!1)).onDismiss(() => e(!1));
		}));
	},
	async schedule() {
		return Ly(e, () => new Promise((e) => {
			Fy(n.schedule()).onOk(async () => {
				t.value.state = "schedule", t.value.displayDate || (t.value.displayDate = t.value.publishDate), e(!0);
			}).onCancel(() => e(!1)).onDismiss(() => e(!1));
		}));
	},
	async publish(r = !1) {
		return Ly(e, () => new Promise((e) => {
			Fy(n.publish()).onOk(async () => {
				r && ((!t.value.publishDate || t.value.publishDate < /* @__PURE__ */ new Date()) && (t.value.publishDate = /* @__PURE__ */ new Date()), t.value.displayDate || (t.value.displayDate = t.value.type === "GALLERY" ? void 0 : /* @__PURE__ */ new Date()), t.value.unpublishDate && t.value.unpublishDate <= /* @__PURE__ */ new Date() && (t.value.unpublishDate = void 0)), t.value.state = "publish", e(!0);
			}).onCancel(() => e(!1)).onDismiss(() => e(!1));
		}));
	},
	async unpublish(r = !1) {
		return Ly(e, () => new Promise((e) => {
			Fy(n.unpublish()).onOk(async () => {
				r && (t.value.unpublishDate = /* @__PURE__ */ new Date()), t.value.state = "unpublish", e(!0);
			}).onCancel(() => e(!1)).onDismiss(() => e(!1));
		}));
	}
}), zy = (e) => {
	let t = () => {
		document.title = `${B().t(e)} - Burda Forward Editor`;
	};
	Le(t), Je(B().locale, t);
}, By = Object.create(null);
By.open = "0", By.close = "1", By.ping = "2", By.pong = "3", By.message = "4", By.upgrade = "5", By.noop = "6";
var Vy = Object.create(null);
Object.keys(By).forEach((e) => {
	Vy[By[e]] = e;
});
var Hy = {
	type: "error",
	data: "parser error"
}, Uy = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", Wy = typeof ArrayBuffer == "function", Gy = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer, Ky = ({ type: e, data: t }, n, r) => Uy && t instanceof Blob ? n ? r(t) : qy(t, r) : Wy && (t instanceof ArrayBuffer || Gy(t)) ? n ? r(t) : qy(new Blob([t]), r) : r(By[e] + (t || "")), qy = (e, t) => {
	let n = new FileReader();
	return n.onload = function() {
		let e = n.result.split(",")[1];
		t("b" + (e || ""));
	}, n.readAsDataURL(e);
};
function Jy(e) {
	return e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
}
var Yy;
function Xy(e, t) {
	if (Uy && e.data instanceof Blob) return e.data.arrayBuffer().then(Jy).then(t);
	if (Wy && (e.data instanceof ArrayBuffer || Gy(e.data))) return t(Jy(e.data));
	Ky(e, !1, (e) => {
		Yy ||= new TextEncoder(), t(Yy.encode(e));
	});
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-parser@5.2.3/node_modules/engine.io-parser/build/esm/contrib/base64-arraybuffer.js
var Zy = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Qy = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let e = 0; e < 64; e++) Qy[Zy.charCodeAt(e)] = e;
var $y = (e) => {
	let t = e.length * .75, n = e.length, r, i = 0, a, o, s, c;
	e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
	let l = new ArrayBuffer(t), u = new Uint8Array(l);
	for (r = 0; r < n; r += 4) a = Qy[e.charCodeAt(r)], o = Qy[e.charCodeAt(r + 1)], s = Qy[e.charCodeAt(r + 2)], c = Qy[e.charCodeAt(r + 3)], u[i++] = a << 2 | o >> 4, u[i++] = (o & 15) << 4 | s >> 2, u[i++] = (s & 3) << 6 | c & 63;
	return l;
}, eb = typeof ArrayBuffer == "function", tb = (e, t) => {
	if (typeof e != "string") return {
		type: "message",
		data: rb(e, t)
	};
	let n = e.charAt(0);
	return n === "b" ? {
		type: "message",
		data: nb(e.substring(1), t)
	} : Vy[n] ? e.length > 1 ? {
		type: Vy[n],
		data: e.substring(1)
	} : { type: Vy[n] } : Hy;
}, nb = (e, t) => eb ? rb($y(e), t) : {
	base64: !0,
	data: e
}, rb = (e, t) => {
	switch (t) {
		case "blob": return e instanceof Blob ? e : new Blob([e]);
		default: return e instanceof ArrayBuffer ? e : e.buffer;
	}
}, ib = "", ab = (e, t) => {
	let n = e.length, r = Array(n), i = 0;
	e.forEach((e, a) => {
		Ky(e, !1, (e) => {
			r[a] = e, ++i === n && t(r.join(ib));
		});
	});
}, ob = (e, t) => {
	let n = e.split(ib), r = [];
	for (let e = 0; e < n.length; e++) {
		let i = tb(n[e], t);
		if (r.push(i), i.type === "error") break;
	}
	return r;
};
function sb() {
	return new TransformStream({ transform(e, t) {
		Xy(e, (n) => {
			let r = n.length, i;
			if (r < 126) i = new Uint8Array(1), new DataView(i.buffer).setUint8(0, r);
			else if (r < 65536) {
				i = new Uint8Array(3);
				let e = new DataView(i.buffer);
				e.setUint8(0, 126), e.setUint16(1, r);
			} else {
				i = new Uint8Array(9);
				let e = new DataView(i.buffer);
				e.setUint8(0, 127), e.setBigUint64(1, BigInt(r));
			}
			e.data && typeof e.data != "string" && (i[0] |= 128), t.enqueue(i), t.enqueue(n);
		});
	} });
}
var cb;
function lb(e) {
	return e.reduce((e, t) => e + t.length, 0);
}
function ub(e, t) {
	if (e[0].length === t) return e.shift();
	let n = new Uint8Array(t), r = 0;
	for (let i = 0; i < t; i++) n[i] = e[0][r++], r === e[0].length && (e.shift(), r = 0);
	return e.length && r < e[0].length && (e[0] = e[0].slice(r)), n;
}
function db(e, t) {
	cb ||= new TextDecoder();
	let n = [], r = 0, i = -1, a = !1;
	return new TransformStream({ transform(o, s) {
		for (n.push(o);;) {
			if (r === 0) {
				if (lb(n) < 1) break;
				let e = ub(n, 1);
				a = (e[0] & 128) == 128, i = e[0] & 127, r = i < 126 ? 3 : i === 126 ? 1 : 2;
			} else if (r === 1) {
				if (lb(n) < 2) break;
				let e = ub(n, 2);
				i = new DataView(e.buffer, e.byteOffset, e.length).getUint16(0), r = 3;
			} else if (r === 2) {
				if (lb(n) < 8) break;
				let e = ub(n, 8), t = new DataView(e.buffer, e.byteOffset, e.length), a = t.getUint32(0);
				if (a > 2 ** 21 - 1) {
					s.enqueue(Hy);
					break;
				}
				i = a * 2 ** 32 + t.getUint32(4), r = 3;
			} else {
				if (lb(n) < i) break;
				let e = ub(n, i);
				s.enqueue(tb(a ? e : cb.decode(e), t)), r = 0;
			}
			if (i === 0 || i > e) {
				s.enqueue(Hy);
				break;
			}
		}
	} });
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/@socket.io+component-emitter@3.1.2/node_modules/@socket.io/component-emitter/lib/esm/index.js
function fb(e) {
	if (e) return pb(e);
}
function pb(e) {
	for (var t in fb.prototype) e[t] = fb.prototype[t];
	return e;
}
fb.prototype.on = fb.prototype.addEventListener = function(e, t) {
	return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
}, fb.prototype.once = function(e, t) {
	function n() {
		this.off(e, n), t.apply(this, arguments);
	}
	return n.fn = t, this.on(e, n), this;
}, fb.prototype.off = fb.prototype.removeListener = fb.prototype.removeAllListeners = fb.prototype.removeEventListener = function(e, t) {
	if (this._callbacks = this._callbacks || {}, arguments.length == 0) return this._callbacks = {}, this;
	var n = this._callbacks["$" + e];
	if (!n) return this;
	if (arguments.length == 1) return delete this._callbacks["$" + e], this;
	for (var r, i = 0; i < n.length; i++) if (r = n[i], r === t || r.fn === t) {
		n.splice(i, 1);
		break;
	}
	return n.length === 0 && delete this._callbacks["$" + e], this;
}, fb.prototype.emit = function(e) {
	this._callbacks = this._callbacks || {};
	for (var t = Array(arguments.length - 1), n = this._callbacks["$" + e], r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
	if (n) {
		n = n.slice(0);
		for (var r = 0, i = n.length; r < i; ++r) n[r].apply(this, t);
	}
	return this;
}, fb.prototype.emitReserved = fb.prototype.emit, fb.prototype.listeners = function(e) {
	return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
}, fb.prototype.hasListeners = function(e) {
	return !!this.listeners(e).length;
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/globalThis.browser.js
var mb = typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")();
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/util.js
function hb(e, ...t) {
	return t.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {});
}
var gb = mb.setTimeout, _b = mb.clearTimeout;
function vb(e, t) {
	t.useNativeTimers ? (e.setTimeoutFn = gb.bind(mb), e.clearTimeoutFn = _b.bind(mb)) : (e.setTimeoutFn = mb.setTimeout.bind(mb), e.clearTimeoutFn = mb.clearTimeout.bind(mb));
}
var yb = 1.33;
function bb(e) {
	return typeof e == "string" ? xb(e) : Math.ceil((e.byteLength || e.size) * yb);
}
function xb(e) {
	let t = 0, n = 0;
	for (let r = 0, i = e.length; r < i; r++) t = e.charCodeAt(r), t < 128 ? n += 1 : t < 2048 ? n += 2 : t < 55296 || t >= 57344 ? n += 3 : (r++, n += 4);
	return n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/contrib/parseqs.js
function Sb(e) {
	let t = "";
	for (let n in e) e.hasOwnProperty(n) && (t.length && (t += "&"), t += encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
	return t;
}
function Cb(e) {
	let t = {}, n = e.split("&");
	for (let e = 0, r = n.length; e < r; e++) {
		let r = n[e].split("=");
		t[decodeURIComponent(r[0])] = decodeURIComponent(r[1]);
	}
	return t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/transport.js
var wb = class extends Error {
	constructor(e, t, n) {
		super(e), this.description = t, this.context = n, this.type = "TransportError";
	}
}, Tb = class extends fb {
	constructor(e) {
		super(), this.writable = !1, vb(this, e), this.opts = e, this.query = e.query, this.socket = e.socket;
	}
	onError(e, t, n) {
		return super.emitReserved("error", new wb(e, t, n)), this;
	}
	open() {
		return this.readyState = "opening", this.doOpen(), this;
	}
	close() {
		return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
	}
	send(e) {
		this.readyState === "open" && this.write(e);
	}
	onOpen() {
		this.readyState = "open", this.writable = !0, super.emitReserved("open");
	}
	onData(e) {
		let t = tb(e, this.socket.binaryType);
		this.onPacket(t);
	}
	onPacket(e) {
		super.emitReserved("packet", e);
	}
	onClose(e) {
		this.readyState = "closed", super.emitReserved("close", e);
	}
	pause(e) {}
	createUri(e, t = {}) {
		return e + "://" + this._hostname() + this._port() + this.opts.path + this._query(t);
	}
	_hostname() {
		let e = this.opts.hostname;
		return e.indexOf(":") === -1 ? e : "[" + e + "]";
	}
	_port() {
		return this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
	}
	_query(e) {
		let t = Sb(e);
		return t.length ? "?" + t : "";
	}
}, Eb = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), Db = 64, Ob = {}, kb = 0, Ab = 0, jb;
function Mb(e) {
	let t = "";
	do
		t = Eb[e % Db] + t, e = Math.floor(e / Db);
	while (e > 0);
	return t;
}
function Nb() {
	let e = Mb(+/* @__PURE__ */ new Date());
	return e === jb ? e + "." + Mb(kb++) : (kb = 0, jb = e);
}
for (; Ab < Db; Ab++) Ob[Eb[Ab]] = Ab;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/contrib/has-cors.js
var Pb = !1;
try {
	Pb = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {}
var Fb = Pb;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/transports/xmlhttprequest.browser.js
function Ib(e) {
	let t = e.xdomain;
	try {
		if (typeof XMLHttpRequest < "u" && (!t || Fb)) return new XMLHttpRequest();
	} catch {}
	if (!t) try {
		return new mb[["Active", "Object"].join("X")]("Microsoft.XMLHTTP");
	} catch {}
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/transports/polling.js
function Lb() {}
var Rb = (function() {
	return new Ib({ xdomain: !1 }).responseType != null;
})(), zb = class extends Tb {
	constructor(e) {
		if (super(e), this.polling = !1, typeof location < "u") {
			let t = location.protocol === "https:", n = location.port;
			n ||= t ? "443" : "80", this.xd = typeof location < "u" && e.hostname !== location.hostname || n !== e.port;
		}
		let t = e && e.forceBase64;
		this.supportsBinary = Rb && !t, this.opts.withCredentials && (this.cookieJar = void 0);
	}
	get name() {
		return "polling";
	}
	doOpen() {
		this.poll();
	}
	pause(e) {
		this.readyState = "pausing";
		let t = () => {
			this.readyState = "paused", e();
		};
		if (this.polling || !this.writable) {
			let e = 0;
			this.polling && (e++, this.once("pollComplete", function() {
				--e || t();
			})), this.writable || (e++, this.once("drain", function() {
				--e || t();
			}));
		} else t();
	}
	poll() {
		this.polling = !0, this.doPoll(), this.emitReserved("poll");
	}
	onData(e) {
		ob(e, this.socket.binaryType).forEach((e) => {
			if (this.readyState === "opening" && e.type === "open" && this.onOpen(), e.type === "close") return this.onClose({ description: "transport closed by the server" }), !1;
			this.onPacket(e);
		}), this.readyState !== "closed" && (this.polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this.poll());
	}
	doClose() {
		let e = () => {
			this.write([{ type: "close" }]);
		};
		this.readyState === "open" ? e() : this.once("open", e);
	}
	write(e) {
		this.writable = !1, ab(e, (e) => {
			this.doWrite(e, () => {
				this.writable = !0, this.emitReserved("drain");
			});
		});
	}
	uri() {
		let e = this.opts.secure ? "https" : "http", t = this.query || {};
		return !1 !== this.opts.timestampRequests && (t[this.opts.timestampParam] = Nb()), !this.supportsBinary && !t.sid && (t.b64 = 1), this.createUri(e, t);
	}
	request(e = {}) {
		return Object.assign(e, {
			xd: this.xd,
			cookieJar: this.cookieJar
		}, this.opts), new Bb(this.uri(), e);
	}
	doWrite(e, t) {
		let n = this.request({
			method: "POST",
			data: e
		});
		n.on("success", t), n.on("error", (e, t) => {
			this.onError("xhr post error", e, t);
		});
	}
	doPoll() {
		let e = this.request();
		e.on("data", this.onData.bind(this)), e.on("error", (e, t) => {
			this.onError("xhr poll error", e, t);
		}), this.pollXhr = e;
	}
}, Bb = class e extends fb {
	constructor(e, t) {
		super(), vb(this, t), this.opts = t, this.method = t.method || "GET", this.uri = e, this.data = t.data === void 0 ? null : t.data, this.create();
	}
	create() {
		var t;
		let n = hb(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
		n.xdomain = !!this.opts.xd;
		let r = this.xhr = new Ib(n);
		try {
			r.open(this.method, this.uri, !0);
			try {
				if (this.opts.extraHeaders) {
					r.setDisableHeaderCheck && r.setDisableHeaderCheck(!0);
					for (let e in this.opts.extraHeaders) this.opts.extraHeaders.hasOwnProperty(e) && r.setRequestHeader(e, this.opts.extraHeaders[e]);
				}
			} catch {}
			if (this.method === "POST") try {
				r.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
			} catch {}
			try {
				r.setRequestHeader("Accept", "*/*");
			} catch {}
			(t = this.opts.cookieJar) == null || t.addCookies(r), "withCredentials" in r && (r.withCredentials = this.opts.withCredentials), this.opts.requestTimeout && (r.timeout = this.opts.requestTimeout), r.onreadystatechange = () => {
				var e;
				r.readyState === 3 && ((e = this.opts.cookieJar) == null || e.parseCookies(r)), r.readyState === 4 && (r.status === 200 || r.status === 1223 ? this.onLoad() : this.setTimeoutFn(() => {
					this.onError(typeof r.status == "number" ? r.status : 0);
				}, 0));
			}, r.send(this.data);
		} catch (e) {
			this.setTimeoutFn(() => {
				this.onError(e);
			}, 0);
			return;
		}
		typeof document < "u" && (this.index = e.requestsCount++, e.requests[this.index] = this);
	}
	onError(e) {
		this.emitReserved("error", e, this.xhr), this.cleanup(!0);
	}
	cleanup(t) {
		if (!(this.xhr === void 0 || this.xhr === null)) {
			if (this.xhr.onreadystatechange = Lb, t) try {
				this.xhr.abort();
			} catch {}
			typeof document < "u" && delete e.requests[this.index], this.xhr = null;
		}
	}
	onLoad() {
		let e = this.xhr.responseText;
		e !== null && (this.emitReserved("data", e), this.emitReserved("success"), this.cleanup());
	}
	abort() {
		this.cleanup();
	}
};
if (Bb.requestsCount = 0, Bb.requests = {}, typeof document < "u") {
	if (typeof attachEvent == "function") attachEvent("onunload", Vb);
	else if (typeof addEventListener == "function") {
		let e = "onpagehide" in mb ? "pagehide" : "unload";
		addEventListener(e, Vb, !1);
	}
}
function Vb() {
	for (let e in Bb.requests) Bb.requests.hasOwnProperty(e) && Bb.requests[e].abort();
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/transports/websocket-constructor.browser.js
var Hb = typeof Promise == "function" && typeof Promise.resolve == "function" ? (e) => Promise.resolve().then(e) : (e, t) => t(e, 0), Ub = mb.WebSocket || mb.MozWebSocket, Wb = "arraybuffer", Gb = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative", Kb = {
	websocket: class extends Tb {
		constructor(e) {
			super(e), this.supportsBinary = !e.forceBase64;
		}
		get name() {
			return "websocket";
		}
		doOpen() {
			if (!this.check()) return;
			let e = this.uri(), t = this.opts.protocols, n = Gb ? {} : hb(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
			this.opts.extraHeaders && (n.headers = this.opts.extraHeaders);
			try {
				this.ws = Gb ? new Ub(e, t, n) : t ? new Ub(e, t) : new Ub(e);
			} catch (e) {
				return this.emitReserved("error", e);
			}
			this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
		}
		addEventListeners() {
			this.ws.onopen = () => {
				this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
			}, this.ws.onclose = (e) => this.onClose({
				description: "websocket connection closed",
				context: e
			}), this.ws.onmessage = (e) => this.onData(e.data), this.ws.onerror = (e) => this.onError("websocket error", e);
		}
		write(e) {
			this.writable = !1;
			for (let t = 0; t < e.length; t++) {
				let n = e[t], r = t === e.length - 1;
				Ky(n, this.supportsBinary, (e) => {
					try {
						this.ws.send(e);
					} catch {}
					r && Hb(() => {
						this.writable = !0, this.emitReserved("drain");
					}, this.setTimeoutFn);
				});
			}
		}
		doClose() {
			this.ws !== void 0 && (this.ws.close(), this.ws = null);
		}
		uri() {
			let e = this.opts.secure ? "wss" : "ws", t = this.query || {};
			return this.opts.timestampRequests && (t[this.opts.timestampParam] = Nb()), this.supportsBinary || (t.b64 = 1), this.createUri(e, t);
		}
		check() {
			return !!Ub;
		}
	},
	webtransport: class extends Tb {
		get name() {
			return "webtransport";
		}
		doOpen() {
			typeof WebTransport == "function" && (this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]), this.transport.closed.then(() => {
				this.onClose();
			}).catch((e) => {
				this.onError("webtransport error", e);
			}), this.transport.ready.then(() => {
				this.transport.createBidirectionalStream().then((e) => {
					let t = db(2 ** 53 - 1, this.socket.binaryType), n = e.readable.pipeThrough(t).getReader(), r = sb();
					r.readable.pipeTo(e.writable), this.writer = r.writable.getWriter();
					let i = () => {
						n.read().then(({ done: e, value: t }) => {
							e || (this.onPacket(t), i());
						}).catch((e) => {});
					};
					i();
					let a = { type: "open" };
					this.query.sid && (a.data = `{"sid":"${this.query.sid}"}`), this.writer.write(a).then(() => this.onOpen());
				});
			}));
		}
		write(e) {
			this.writable = !1;
			for (let t = 0; t < e.length; t++) {
				let n = e[t], r = t === e.length - 1;
				this.writer.write(n).then(() => {
					r && Hb(() => {
						this.writable = !0, this.emitReserved("drain");
					}, this.setTimeoutFn);
				});
			}
		}
		doClose() {
			var e;
			(e = this.transport) == null || e.close();
		}
	},
	polling: zb
}, qb = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, Jb = [
	"source",
	"protocol",
	"authority",
	"userInfo",
	"user",
	"password",
	"host",
	"port",
	"relative",
	"path",
	"directory",
	"file",
	"query",
	"anchor"
];
function Yb(e) {
	if (e.length > 2e3) throw "URI too long";
	let t = e, n = e.indexOf("["), r = e.indexOf("]");
	n != -1 && r != -1 && (e = e.substring(0, n) + e.substring(n, r).replace(/:/g, ";") + e.substring(r, e.length));
	let i = qb.exec(e || ""), a = {}, o = 14;
	for (; o--;) a[Jb[o]] = i[o] || "";
	return n != -1 && r != -1 && (a.source = t, a.host = a.host.substring(1, a.host.length - 1).replace(/;/g, ":"), a.authority = a.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), a.ipv6uri = !0), a.pathNames = Xb(a, a.path), a.queryKey = Zb(a, a.query), a;
}
function Xb(e, t) {
	let n = t.replace(/\/{2,9}/g, "/").split("/");
	return (t.slice(0, 1) == "/" || t.length === 0) && n.splice(0, 1), t.slice(-1) == "/" && n.splice(n.length - 1, 1), n;
}
function Zb(e, t) {
	let n = {};
	return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(e, t, r) {
		t && (n[t] = r);
	}), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/socket.js
var Qb = class e extends fb {
	constructor(e, t = {}) {
		super(), this.binaryType = Wb, this.writeBuffer = [], e && typeof e == "object" && (t = e, e = null), e ? (e = Yb(e), t.hostname = e.host, t.secure = e.protocol === "https" || e.protocol === "wss", t.port = e.port, e.query && (t.query = e.query)) : t.host && (t.hostname = Yb(t.host).host), vb(this, t), this.secure = t.secure == null ? typeof location < "u" && location.protocol === "https:" : t.secure, t.hostname && !t.port && (t.port = this.secure ? "443" : "80"), this.hostname = t.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = t.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = t.transports || [
			"polling",
			"websocket",
			"webtransport"
		], this.writeBuffer = [], this.prevBufferLen = 0, this.opts = Object.assign({
			path: "/engine.io",
			agent: !1,
			withCredentials: !1,
			upgrade: !0,
			timestampParam: "t",
			rememberUpgrade: !1,
			addTrailingSlash: !0,
			rejectUnauthorized: !0,
			perMessageDeflate: { threshold: 1024 },
			transportOptions: {},
			closeOnBeforeunload: !1
		}, t), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = Cb(this.opts.query)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingTimeoutTimer = null, typeof addEventListener == "function" && (this.opts.closeOnBeforeunload && (this.beforeunloadEventListener = () => {
			this.transport && (this.transport.removeAllListeners(), this.transport.close());
		}, addEventListener("beforeunload", this.beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this.offlineEventListener = () => {
			this.onClose("transport close", { description: "network connection lost" });
		}, addEventListener("offline", this.offlineEventListener, !1))), this.open();
	}
	createTransport(e) {
		let t = Object.assign({}, this.opts.query);
		t.EIO = 4, t.transport = e, this.id && (t.sid = this.id);
		let n = Object.assign({}, this.opts, {
			query: t,
			socket: this,
			hostname: this.hostname,
			secure: this.secure,
			port: this.port
		}, this.opts.transportOptions[e]);
		return new Kb[e](n);
	}
	open() {
		let t;
		if (this.opts.rememberUpgrade && e.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) t = "websocket";
		else if (this.transports.length === 0) {
			this.setTimeoutFn(() => {
				this.emitReserved("error", "No transports available");
			}, 0);
			return;
		} else t = this.transports[0];
		this.readyState = "opening";
		try {
			t = this.createTransport(t);
		} catch {
			this.transports.shift(), this.open();
			return;
		}
		t.open(), this.setTransport(t);
	}
	setTransport(e) {
		this.transport && this.transport.removeAllListeners(), this.transport = e, e.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (e) => this.onClose("transport close", e));
	}
	probe(t) {
		let n = this.createTransport(t), r = !1;
		e.priorWebsocketSuccess = !1;
		let i = () => {
			r || (n.send([{
				type: "ping",
				data: "probe"
			}]), n.once("packet", (t) => {
				if (!r) if (t.type === "pong" && t.data === "probe") {
					if (this.upgrading = !0, this.emitReserved("upgrading", n), !n) return;
					e.priorWebsocketSuccess = n.name === "websocket", this.transport.pause(() => {
						r || this.readyState !== "closed" && (u(), this.setTransport(n), n.send([{ type: "upgrade" }]), this.emitReserved("upgrade", n), n = null, this.upgrading = !1, this.flush());
					});
				} else {
					let e = /* @__PURE__ */ Error("probe error");
					e.transport = n.name, this.emitReserved("upgradeError", e);
				}
			}));
		};
		function a() {
			r || (r = !0, u(), n.close(), n = null);
		}
		let o = (e) => {
			let t = /* @__PURE__ */ Error("probe error: " + e);
			t.transport = n.name, a(), this.emitReserved("upgradeError", t);
		};
		function s() {
			o("transport closed");
		}
		function c() {
			o("socket closed");
		}
		function l(e) {
			n && e.name !== n.name && a();
		}
		let u = () => {
			n.removeListener("open", i), n.removeListener("error", o), n.removeListener("close", s), this.off("close", c), this.off("upgrading", l);
		};
		n.once("open", i), n.once("error", o), n.once("close", s), this.once("close", c), this.once("upgrading", l), this.upgrades.indexOf("webtransport") !== -1 && t !== "webtransport" ? this.setTimeoutFn(() => {
			r || n.open();
		}, 200) : n.open();
	}
	onOpen() {
		if (this.readyState = "open", e.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush(), this.readyState === "open" && this.opts.upgrade) {
			let e = 0, t = this.upgrades.length;
			for (; e < t; e++) this.probe(this.upgrades[e]);
		}
	}
	onPacket(e) {
		if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") switch (this.emitReserved("packet", e), this.emitReserved("heartbeat"), this.resetPingTimeout(), e.type) {
			case "open":
				this.onHandshake(JSON.parse(e.data));
				break;
			case "ping":
				this.sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong");
				break;
			case "error":
				let t = /* @__PURE__ */ Error("server error");
				t.code = e.data, this.onError(t);
				break;
			case "message":
				this.emitReserved("data", e.data), this.emitReserved("message", e.data);
				break;
		}
	}
	onHandshake(e) {
		this.emitReserved("handshake", e), this.id = e.sid, this.transport.query.sid = e.sid, this.upgrades = this.filterUpgrades(e.upgrades), this.pingInterval = e.pingInterval, this.pingTimeout = e.pingTimeout, this.maxPayload = e.maxPayload, this.onOpen(), this.readyState !== "closed" && this.resetPingTimeout();
	}
	resetPingTimeout() {
		this.clearTimeoutFn(this.pingTimeoutTimer), this.pingTimeoutTimer = this.setTimeoutFn(() => {
			this.onClose("ping timeout");
		}, this.pingInterval + this.pingTimeout), this.opts.autoUnref && this.pingTimeoutTimer.unref();
	}
	onDrain() {
		this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
	}
	flush() {
		if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
			let e = this.getWritablePackets();
			this.transport.send(e), this.prevBufferLen = e.length, this.emitReserved("flush");
		}
	}
	getWritablePackets() {
		if (!(this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1)) return this.writeBuffer;
		let e = 1;
		for (let t = 0; t < this.writeBuffer.length; t++) {
			let n = this.writeBuffer[t].data;
			if (n && (e += bb(n)), t > 0 && e > this.maxPayload) return this.writeBuffer.slice(0, t);
			e += 2;
		}
		return this.writeBuffer;
	}
	write(e, t, n) {
		return this.sendPacket("message", e, t, n), this;
	}
	send(e, t, n) {
		return this.sendPacket("message", e, t, n), this;
	}
	sendPacket(e, t, n, r) {
		if (typeof t == "function" && (r = t, t = void 0), typeof n == "function" && (r = n, n = null), this.readyState === "closing" || this.readyState === "closed") return;
		n ||= {}, n.compress = !1 !== n.compress;
		let i = {
			type: e,
			data: t,
			options: n
		};
		this.emitReserved("packetCreate", i), this.writeBuffer.push(i), r && this.once("flush", r), this.flush();
	}
	close() {
		let e = () => {
			this.onClose("forced close"), this.transport.close();
		}, t = () => {
			this.off("upgrade", t), this.off("upgradeError", t), e();
		}, n = () => {
			this.once("upgrade", t), this.once("upgradeError", t);
		};
		return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
			this.upgrading ? n() : e();
		}) : this.upgrading ? n() : e()), this;
	}
	onError(t) {
		e.priorWebsocketSuccess = !1, this.emitReserved("error", t), this.onClose("transport error", t);
	}
	onClose(e, t) {
		(this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") && (this.clearTimeoutFn(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), typeof removeEventListener == "function" && (removeEventListener("beforeunload", this.beforeunloadEventListener, !1), removeEventListener("offline", this.offlineEventListener, !1)), this.readyState = "closed", this.id = null, this.emitReserved("close", e, t), this.writeBuffer = [], this.prevBufferLen = 0);
	}
	filterUpgrades(e) {
		let t = [], n = 0, r = e.length;
		for (; n < r; n++) ~this.transports.indexOf(e[n]) && t.push(e[n]);
		return t;
	}
};
Qb.protocol = 4, Qb.protocol;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-client@4.7.4_supports-color@8.1.1/node_modules/socket.io-client/build/esm/url.js
function $b(e, t = "", n) {
	let r = e;
	n ||= typeof location < "u" && location, e ??= n.protocol + "//" + n.host, typeof e == "string" && (e.charAt(0) === "/" && (e = e.charAt(1) === "/" ? n.protocol + e : n.host + e), /^(https?|wss?):\/\//.test(e) || (e = n === void 0 ? "https://" + e : n.protocol + "//" + e), r = Yb(e)), r.port || (/^(http|ws)$/.test(r.protocol) ? r.port = "80" : /^(http|ws)s$/.test(r.protocol) && (r.port = "443")), r.path = r.path || "/";
	let i = r.host.indexOf(":") === -1 ? r.host : "[" + r.host + "]";
	return r.id = r.protocol + "://" + i + ":" + r.port + t, r.href = r.protocol + "://" + i + (n && n.port === r.port ? "" : ":" + r.port), r;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-parser@4.2.7_supports-color@8.1.1/node_modules/socket.io-parser/build/esm/is-binary.js
var ex = typeof ArrayBuffer == "function", tx = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer, nx = Object.prototype.toString, rx = typeof Blob == "function" || typeof Blob < "u" && nx.call(Blob) === "[object BlobConstructor]", ix = typeof File == "function" || typeof File < "u" && nx.call(File) === "[object FileConstructor]";
function ax(e) {
	return ex && (e instanceof ArrayBuffer || tx(e)) || rx && e instanceof Blob || ix && e instanceof File;
}
function ox(e, t) {
	if (!e || typeof e != "object") return !1;
	if (Array.isArray(e)) {
		for (let t = 0, n = e.length; t < n; t++) if (ox(e[t])) return !0;
		return !1;
	}
	if (ax(e)) return !0;
	if (e.toJSON && typeof e.toJSON == "function" && arguments.length === 1) return ox(e.toJSON(), !0);
	for (let t in e) if (Object.prototype.hasOwnProperty.call(e, t) && ox(e[t])) return !0;
	return !1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-parser@4.2.7_supports-color@8.1.1/node_modules/socket.io-parser/build/esm/binary.js
function sx(e) {
	let t = [], n = e.data, r = e;
	return r.data = cx(n, t), r.attachments = t.length, {
		packet: r,
		buffers: t
	};
}
function cx(e, t, n) {
	if (!e) return e;
	if (ax(e)) {
		let n = {
			_placeholder: !0,
			num: t.length
		};
		return t.push(e), n;
	} else if (Array.isArray(e)) {
		let n = Array(e.length);
		for (let r = 0; r < e.length; r++) n[r] = cx(e[r], t);
		return n;
	} else if (typeof e == "object" && !(e instanceof Date)) {
		if (e.toJSON && typeof e.toJSON == "function" && !n) return cx(e.toJSON(), t, !0);
		let r = {};
		for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && (r[n] = cx(e[n], t));
		return r;
	}
	return e;
}
function lx(e, t) {
	return e.data = ux(e.data, t), delete e.attachments, e;
}
function ux(e, t) {
	if (!e) return e;
	if (e && e._placeholder === !0) {
		if (typeof e.num == "number" && e.num >= 0 && e.num < t.length) return t[e.num];
		throw Error("illegal attachments");
	} else if (Array.isArray(e)) for (let n = 0; n < e.length; n++) e[n] = ux(e[n], t);
	else if (typeof e == "object") for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && (e[n] = ux(e[n], t));
	return e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-parser@4.2.7_supports-color@8.1.1/node_modules/socket.io-parser/build/esm/index.js
var dx = /* @__PURE__ */ xt({
	Decoder: () => mx,
	Encoder: () => px,
	PacketType: () => $,
	isPacketValid: () => xx,
	protocol: () => 5
}), fx = [
	"connect",
	"connect_error",
	"disconnect",
	"disconnecting",
	"newListener",
	"removeListener"
], $;
(function(e) {
	e[e.CONNECT = 0] = "CONNECT", e[e.DISCONNECT = 1] = "DISCONNECT", e[e.EVENT = 2] = "EVENT", e[e.ACK = 3] = "ACK", e[e.CONNECT_ERROR = 4] = "CONNECT_ERROR", e[e.BINARY_EVENT = 5] = "BINARY_EVENT", e[e.BINARY_ACK = 6] = "BINARY_ACK";
})($ ||= {});
var px = class {
	constructor(e) {
		this.replacer = e;
	}
	encode(e) {
		return (e.type === $.EVENT || e.type === $.ACK) && ox(e) ? this.encodeAsBinary({
			type: e.type === $.EVENT ? $.BINARY_EVENT : $.BINARY_ACK,
			nsp: e.nsp,
			data: e.data,
			id: e.id
		}) : [this.encodeAsString(e)];
	}
	encodeAsString(e) {
		let t = "" + e.type;
		return (e.type === $.BINARY_EVENT || e.type === $.BINARY_ACK) && (t += e.attachments + "-"), e.nsp && e.nsp !== "/" && (t += e.nsp + ","), e.id != null && (t += e.id), e.data != null && (t += JSON.stringify(e.data, this.replacer)), t;
	}
	encodeAsBinary(e) {
		let t = sx(e), n = this.encodeAsString(t.packet), r = t.buffers;
		return r.unshift(n), r;
	}
}, mx = class e extends fb {
	constructor(e) {
		super(), this.opts = Object.assign({
			reviver: void 0,
			maxAttachments: 10
		}, typeof e == "function" ? { reviver: e } : e);
	}
	add(e) {
		let t;
		if (typeof e == "string") {
			if (this.reconstructor) throw Error("got plaintext data when reconstructing a packet");
			t = this.decodeString(e);
			let n = t.type === $.BINARY_EVENT;
			n || t.type === $.BINARY_ACK ? (t.type = n ? $.EVENT : $.ACK, this.reconstructor = new hx(t)) : super.emitReserved("decoded", t);
		} else if (ax(e) || e.base64) if (this.reconstructor) t = this.reconstructor.takeBinaryData(e), t && (this.reconstructor = null, super.emitReserved("decoded", t));
		else throw Error("got binary data when not reconstructing a packet");
		else throw Error("Unknown type: " + e);
	}
	decodeString(t) {
		let n = 0, r = { type: Number(t.charAt(0)) };
		if ($[r.type] === void 0) throw Error("unknown packet type " + r.type);
		if (r.type === $.BINARY_EVENT || r.type === $.BINARY_ACK) {
			let e = n + 1;
			for (; t.charAt(++n) !== "-" && n != t.length;);
			let i = t.substring(e, n);
			if (i != Number(i) || t.charAt(n) !== "-") throw Error("Illegal attachments");
			let a = Number(i);
			if (!_x(a) || a < 1) throw Error("Illegal attachments");
			if (a > this.opts.maxAttachments) throw Error("too many attachments");
			r.attachments = a;
		}
		if (t.charAt(n + 1) === "/") {
			let e = n + 1;
			for (; ++n && !(t.charAt(n) === "," || n === t.length););
			r.nsp = t.substring(e, n);
		} else r.nsp = "/";
		let i = t.charAt(n + 1);
		if (i !== "" && Number(i) == i) {
			let e = n + 1;
			for (; ++n;) {
				let e = t.charAt(n);
				if (e == null || Number(e) != e) {
					--n;
					break;
				}
				if (n === t.length) break;
			}
			r.id = Number(t.substring(e, n + 1));
		}
		if (t.charAt(++n)) {
			let i = this.tryParse(t.substr(n));
			if (e.isPayloadValid(r.type, i)) r.data = i;
			else throw Error("invalid payload");
		}
		return r;
	}
	tryParse(e) {
		try {
			return JSON.parse(e, this.opts.reviver);
		} catch {
			return !1;
		}
	}
	static isPayloadValid(e, t) {
		switch (e) {
			case $.CONNECT: return yx(t);
			case $.DISCONNECT: return t === void 0;
			case $.CONNECT_ERROR: return typeof t == "string" || yx(t);
			case $.EVENT:
			case $.BINARY_EVENT: return Array.isArray(t) && (typeof t[0] == "number" || typeof t[0] == "string" && fx.indexOf(t[0]) === -1);
			case $.ACK:
			case $.BINARY_ACK: return Array.isArray(t);
		}
	}
	destroy() {
		this.reconstructor &&= (this.reconstructor.finishedReconstruction(), null);
	}
}, hx = class {
	constructor(e) {
		this.packet = e, this.buffers = [], this.reconPack = e;
	}
	takeBinaryData(e) {
		if (this.buffers.push(e), this.buffers.length === this.reconPack.attachments) {
			let e = lx(this.reconPack, this.buffers);
			return this.finishedReconstruction(), e;
		}
		return null;
	}
	finishedReconstruction() {
		this.reconPack = null, this.buffers = [];
	}
};
function gx(e) {
	return typeof e == "string";
}
var _x = Number.isInteger || function(e) {
	return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
};
function vx(e) {
	return e === void 0 || _x(e);
}
function yx(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function bx(e, t) {
	switch (e) {
		case $.CONNECT: return t === void 0 || yx(t);
		case $.DISCONNECT: return t === void 0;
		case $.EVENT: return Array.isArray(t) && (typeof t[0] == "number" || typeof t[0] == "string" && fx.indexOf(t[0]) === -1);
		case $.ACK: return Array.isArray(t);
		case $.CONNECT_ERROR: return typeof t == "string" || yx(t);
		default: return !1;
	}
}
function xx(e) {
	return gx(e.nsp) && vx(e.id) && bx(e.type, e.data);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-client@4.7.4_supports-color@8.1.1/node_modules/socket.io-client/build/esm/on.js
function Sx(e, t, n) {
	return e.on(t, n), function() {
		e.off(t, n);
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-client@4.7.4_supports-color@8.1.1/node_modules/socket.io-client/build/esm/socket.js
var Cx = Object.freeze({
	connect: 1,
	connect_error: 1,
	disconnect: 1,
	disconnecting: 1,
	newListener: 1,
	removeListener: 1
}), wx = class extends fb {
	constructor(e, t, n) {
		super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = e, this.nsp = t, n && n.auth && (this.auth = n.auth), this._opts = Object.assign({}, n), this.io._autoConnect && this.open();
	}
	get disconnected() {
		return !this.connected;
	}
	subEvents() {
		if (this.subs) return;
		let e = this.io;
		this.subs = [
			Sx(e, "open", this.onopen.bind(this)),
			Sx(e, "packet", this.onpacket.bind(this)),
			Sx(e, "error", this.onerror.bind(this)),
			Sx(e, "close", this.onclose.bind(this))
		];
	}
	get active() {
		return !!this.subs;
	}
	connect() {
		return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
	}
	open() {
		return this.connect();
	}
	send(...e) {
		return e.unshift("message"), this.emit.apply(this, e), this;
	}
	emit(e, ...t) {
		if (Cx.hasOwnProperty(e)) throw Error("\"" + e.toString() + "\" is a reserved event name");
		if (t.unshift(e), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) return this._addToQueue(t), this;
		let n = {
			type: $.EVENT,
			data: t
		};
		if (n.options = {}, n.options.compress = this.flags.compress !== !1, typeof t[t.length - 1] == "function") {
			let e = this.ids++, r = t.pop();
			this._registerAckCallback(e, r), n.id = e;
		}
		let r = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
		return this.flags.volatile && (!r || !this.connected) || (this.connected ? (this.notifyOutgoingListeners(n), this.packet(n)) : this.sendBuffer.push(n)), this.flags = {}, this;
	}
	_registerAckCallback(e, t) {
		let n = this.flags.timeout ?? this._opts.ackTimeout;
		if (n === void 0) {
			this.acks[e] = t;
			return;
		}
		let r = this.io.setTimeoutFn(() => {
			delete this.acks[e];
			for (let t = 0; t < this.sendBuffer.length; t++) this.sendBuffer[t].id === e && this.sendBuffer.splice(t, 1);
			t.call(this, /* @__PURE__ */ Error("operation has timed out"));
		}, n);
		this.acks[e] = (...e) => {
			this.io.clearTimeoutFn(r), t.apply(this, [null, ...e]);
		};
	}
	emitWithAck(e, ...t) {
		let n = this.flags.timeout !== void 0 || this._opts.ackTimeout !== void 0;
		return new Promise((r, i) => {
			t.push((e, t) => n ? e ? i(e) : r(t) : r(e)), this.emit(e, ...t);
		});
	}
	_addToQueue(e) {
		let t;
		typeof e[e.length - 1] == "function" && (t = e.pop());
		let n = {
			id: this._queueSeq++,
			tryCount: 0,
			pending: !1,
			args: e,
			flags: Object.assign({ fromQueue: !0 }, this.flags)
		};
		e.push((e, ...r) => {
			if (n === this._queue[0]) return e === null ? (this._queue.shift(), t && t(null, ...r)) : n.tryCount > this._opts.retries && (this._queue.shift(), t && t(e)), n.pending = !1, this._drainQueue();
		}), this._queue.push(n), this._drainQueue();
	}
	_drainQueue(e = !1) {
		if (!this.connected || this._queue.length === 0) return;
		let t = this._queue[0];
		t.pending && !e || (t.pending = !0, t.tryCount++, this.flags = t.flags, this.emit.apply(this, t.args));
	}
	packet(e) {
		e.nsp = this.nsp, this.io._packet(e);
	}
	onopen() {
		typeof this.auth == "function" ? this.auth((e) => {
			this._sendConnectPacket(e);
		}) : this._sendConnectPacket(this.auth);
	}
	_sendConnectPacket(e) {
		this.packet({
			type: $.CONNECT,
			data: this._pid ? Object.assign({
				pid: this._pid,
				offset: this._lastOffset
			}, e) : e
		});
	}
	onerror(e) {
		this.connected || this.emitReserved("connect_error", e);
	}
	onclose(e, t) {
		this.connected = !1, delete this.id, this.emitReserved("disconnect", e, t);
	}
	onpacket(e) {
		if (e.nsp === this.nsp) switch (e.type) {
			case $.CONNECT:
				e.data && e.data.sid ? this.onconnect(e.data.sid, e.data.pid) : this.emitReserved("connect_error", /* @__PURE__ */ Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
				break;
			case $.EVENT:
			case $.BINARY_EVENT:
				this.onevent(e);
				break;
			case $.ACK:
			case $.BINARY_ACK:
				this.onack(e);
				break;
			case $.DISCONNECT:
				this.ondisconnect();
				break;
			case $.CONNECT_ERROR:
				this.destroy();
				let t = Error(e.data.message);
				t.data = e.data.data, this.emitReserved("connect_error", t);
				break;
		}
	}
	onevent(e) {
		let t = e.data || [];
		e.id != null && t.push(this.ack(e.id)), this.connected ? this.emitEvent(t) : this.receiveBuffer.push(Object.freeze(t));
	}
	emitEvent(e) {
		if (this._anyListeners && this._anyListeners.length) {
			let t = this._anyListeners.slice();
			for (let n of t) n.apply(this, e);
		}
		super.emit.apply(this, e), this._pid && e.length && typeof e[e.length - 1] == "string" && (this._lastOffset = e[e.length - 1]);
	}
	ack(e) {
		let t = this, n = !1;
		return function(...r) {
			n || (n = !0, t.packet({
				type: $.ACK,
				id: e,
				data: r
			}));
		};
	}
	onack(e) {
		let t = this.acks[e.id];
		typeof t == "function" && (t.apply(this, e.data), delete this.acks[e.id]);
	}
	onconnect(e, t) {
		this.id = e, this.recovered = t && this._pid === t, this._pid = t, this.connected = !0, this.emitBuffered(), this.emitReserved("connect"), this._drainQueue(!0);
	}
	emitBuffered() {
		this.receiveBuffer.forEach((e) => this.emitEvent(e)), this.receiveBuffer = [], this.sendBuffer.forEach((e) => {
			this.notifyOutgoingListeners(e), this.packet(e);
		}), this.sendBuffer = [];
	}
	ondisconnect() {
		this.destroy(), this.onclose("io server disconnect");
	}
	destroy() {
		this.subs &&= (this.subs.forEach((e) => e()), void 0), this.io._destroy(this);
	}
	disconnect() {
		return this.connected && this.packet({ type: $.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
	}
	close() {
		return this.disconnect();
	}
	compress(e) {
		return this.flags.compress = e, this;
	}
	get volatile() {
		return this.flags.volatile = !0, this;
	}
	timeout(e) {
		return this.flags.timeout = e, this;
	}
	onAny(e) {
		return this._anyListeners = this._anyListeners || [], this._anyListeners.push(e), this;
	}
	prependAny(e) {
		return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(e), this;
	}
	offAny(e) {
		if (!this._anyListeners) return this;
		if (e) {
			let t = this._anyListeners;
			for (let n = 0; n < t.length; n++) if (e === t[n]) return t.splice(n, 1), this;
		} else this._anyListeners = [];
		return this;
	}
	listenersAny() {
		return this._anyListeners || [];
	}
	onAnyOutgoing(e) {
		return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(e), this;
	}
	prependAnyOutgoing(e) {
		return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(e), this;
	}
	offAnyOutgoing(e) {
		if (!this._anyOutgoingListeners) return this;
		if (e) {
			let t = this._anyOutgoingListeners;
			for (let n = 0; n < t.length; n++) if (e === t[n]) return t.splice(n, 1), this;
		} else this._anyOutgoingListeners = [];
		return this;
	}
	listenersAnyOutgoing() {
		return this._anyOutgoingListeners || [];
	}
	notifyOutgoingListeners(e) {
		if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
			let t = this._anyOutgoingListeners.slice();
			for (let n of t) n.apply(this, e.data);
		}
	}
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-client@4.7.4_supports-color@8.1.1/node_modules/socket.io-client/build/esm/contrib/backo2.js
function Tx(e) {
	e ||= {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
}
Tx.prototype.duration = function() {
	var e = this.ms * this.factor ** + this.attempts++;
	if (this.jitter) {
		var t = Math.random(), n = Math.floor(t * this.jitter * e);
		e = Math.floor(t * 10) & 1 ? e + n : e - n;
	}
	return Math.min(e, this.max) | 0;
}, Tx.prototype.reset = function() {
	this.attempts = 0;
}, Tx.prototype.setMin = function(e) {
	this.ms = e;
}, Tx.prototype.setMax = function(e) {
	this.max = e;
}, Tx.prototype.setJitter = function(e) {
	this.jitter = e;
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-client@4.7.4_supports-color@8.1.1/node_modules/socket.io-client/build/esm/manager.js
var Ex = class extends fb {
	constructor(e, t) {
		super(), this.nsps = {}, this.subs = [], e && typeof e == "object" && (t = e, e = void 0), t ||= {}, t.path = t.path || "/socket.io", this.opts = t, vb(this, t), this.reconnection(t.reconnection !== !1), this.reconnectionAttempts(t.reconnectionAttempts || Infinity), this.reconnectionDelay(t.reconnectionDelay || 1e3), this.reconnectionDelayMax(t.reconnectionDelayMax || 5e3), this.randomizationFactor(t.randomizationFactor ?? .5), this.backoff = new Tx({
			min: this.reconnectionDelay(),
			max: this.reconnectionDelayMax(),
			jitter: this.randomizationFactor()
		}), this.timeout(t.timeout == null ? 2e4 : t.timeout), this._readyState = "closed", this.uri = e;
		let n = t.parser || dx;
		this.encoder = new n.Encoder(), this.decoder = new n.Decoder(), this._autoConnect = t.autoConnect !== !1, this._autoConnect && this.open();
	}
	reconnection(e) {
		return arguments.length ? (this._reconnection = !!e, this) : this._reconnection;
	}
	reconnectionAttempts(e) {
		return e === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = e, this);
	}
	reconnectionDelay(e) {
		var t;
		return e === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = e, (t = this.backoff) == null || t.setMin(e), this);
	}
	randomizationFactor(e) {
		var t;
		return e === void 0 ? this._randomizationFactor : (this._randomizationFactor = e, (t = this.backoff) == null || t.setJitter(e), this);
	}
	reconnectionDelayMax(e) {
		var t;
		return e === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = e, (t = this.backoff) == null || t.setMax(e), this);
	}
	timeout(e) {
		return arguments.length ? (this._timeout = e, this) : this._timeout;
	}
	maybeReconnectOnOpen() {
		!this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
	}
	open(e) {
		if (~this._readyState.indexOf("open")) return this;
		this.engine = new Qb(this.uri, this.opts);
		let t = this.engine, n = this;
		this._readyState = "opening", this.skipReconnect = !1;
		let r = Sx(t, "open", function() {
			n.onopen(), e && e();
		}), i = (t) => {
			this.cleanup(), this._readyState = "closed", this.emitReserved("error", t), e ? e(t) : this.maybeReconnectOnOpen();
		}, a = Sx(t, "error", i);
		if (!1 !== this._timeout) {
			let e = this._timeout, n = this.setTimeoutFn(() => {
				r(), i(/* @__PURE__ */ Error("timeout")), t.close();
			}, e);
			this.opts.autoUnref && n.unref(), this.subs.push(() => {
				this.clearTimeoutFn(n);
			});
		}
		return this.subs.push(r), this.subs.push(a), this;
	}
	connect(e) {
		return this.open(e);
	}
	onopen() {
		this.cleanup(), this._readyState = "open", this.emitReserved("open");
		let e = this.engine;
		this.subs.push(Sx(e, "ping", this.onping.bind(this)), Sx(e, "data", this.ondata.bind(this)), Sx(e, "error", this.onerror.bind(this)), Sx(e, "close", this.onclose.bind(this)), Sx(this.decoder, "decoded", this.ondecoded.bind(this)));
	}
	onping() {
		this.emitReserved("ping");
	}
	ondata(e) {
		try {
			this.decoder.add(e);
		} catch (e) {
			this.onclose("parse error", e);
		}
	}
	ondecoded(e) {
		Hb(() => {
			this.emitReserved("packet", e);
		}, this.setTimeoutFn);
	}
	onerror(e) {
		this.emitReserved("error", e);
	}
	socket(e, t) {
		let n = this.nsps[e];
		return n ? this._autoConnect && !n.active && n.connect() : (n = new wx(this, e, t), this.nsps[e] = n), n;
	}
	_destroy(e) {
		let t = Object.keys(this.nsps);
		for (let e of t) if (this.nsps[e].active) return;
		this._close();
	}
	_packet(e) {
		let t = this.encoder.encode(e);
		for (let n = 0; n < t.length; n++) this.engine.write(t[n], e.options);
	}
	cleanup() {
		this.subs.forEach((e) => e()), this.subs.length = 0, this.decoder.destroy();
	}
	_close() {
		this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close"), this.engine && this.engine.close();
	}
	disconnect() {
		return this._close();
	}
	onclose(e, t) {
		this.cleanup(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", e, t), this._reconnection && !this.skipReconnect && this.reconnect();
	}
	reconnect() {
		if (this._reconnecting || this.skipReconnect) return this;
		let e = this;
		if (this.backoff.attempts >= this._reconnectionAttempts) this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
		else {
			let t = this.backoff.duration();
			this._reconnecting = !0;
			let n = this.setTimeoutFn(() => {
				e.skipReconnect || (this.emitReserved("reconnect_attempt", e.backoff.attempts), !e.skipReconnect && e.open((t) => {
					t ? (e._reconnecting = !1, e.reconnect(), this.emitReserved("reconnect_error", t)) : e.onreconnect();
				}));
			}, t);
			this.opts.autoUnref && n.unref(), this.subs.push(() => {
				this.clearTimeoutFn(n);
			});
		}
	}
	onreconnect() {
		let e = this.backoff.attempts;
		this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", e);
	}
}, Dx = {};
function Ox(e, t) {
	typeof e == "object" && (t = e, e = void 0), t ||= {};
	let n = $b(e, t.path || "/socket.io"), r = n.source, i = n.id, a = n.path, o = Dx[i] && a in Dx[i].nsps, s = t.forceNew || t["force new connection"] || !1 === t.multiplex || o, c;
	return s ? c = new Ex(r, t) : (Dx[i] || (Dx[i] = new Ex(r, t)), c = Dx[i]), n.query && !t.query && (t.query = n.queryKey), c.socket(n.path, t);
}
Object.assign(Ox, {
	Manager: Ex,
	Socket: wx,
	io: Ox,
	connect: Ox
});
//#endregion
//#region src/composables/useWebsockets.ts
var kx = M(!1), Ax, jx = (e) => {
	e.on("reconnect_error", (e) => {
		console.warn("[socket] reconnect_error", { errMessage: e instanceof Error ? e.message : String(e) });
	}), e.on("reconnect_failed", () => {
		console.warn("[socket] reconnect_failed");
	});
}, Mx = async (e, t, n = !0) => {
	let r = new Ex(e, t);
	return Ax = r, jx(r), new Promise((e, t) => {
		r.once("open", () => e(void 0)), n && r.once("error", t), r.on("open", () => {
			kx.value = !0;
		}), r.on("close", () => {
			kx.value = !1;
		});
	});
}, Nx = () => {
	if (!Ax) throw Error("Sockets are not connected");
	return Ax;
}, Px = () => kx, Fx = (e) => "statusCode" in e && e.statusCode >= 400, Ix = (e) => "code" in e && e.code < 400, Lx = async (e, t) => (await mc().get(`/cms/${e}`, { params: t })).data, Rx = Be({
	modules: /* @__PURE__ */ new Set(),
	addModule(e) {
		if (e.contentBlocks) for (let t of e.contentBlocks) t.component = ke(t.component);
		this.modules.add(e);
	},
	getModules() {
		return Array.from(this.modules);
	}
}), zx = () => Rx, Bx = Be({
	refs: /* @__PURE__ */ new Set(),
	onMount(e) {
		this.refs.add(e);
	},
	onUnmount(e) {
		this.refs.delete(e);
	},
	words: C(() => Array.from(Bx.refs).reduce((e, t) => e + (t.value.wordCharCount?.words || 0), 0)),
	characters: C(() => Array.from(Bx.refs).reduce((e, t) => e + (t.value.wordCharCount?.characters || 0), 0))
}), Vx = () => Bx, Hx = (e) => typeof e != "object" || !e ? !1 : typeof Reflect.get(e, "getValidationErrorAnchor") == "function", Ux = (e, t) => {
	let n = GLOBAL_CONFIG.APP_ENV === "sandbox" || GLOBAL_CONFIG.APP_ENV === "sandboxes", r = t?.toUpperCase() === "PUBLISH" && !n ? "_PUBLISH" : "", i = `URL_${e.toUpperCase()}${r}`;
	if (!((e) => e in GLOBAL_CONFIG)(i)) throw Error(`Base URL for brand "${e}" (key: ${i}) is not defined in GLOBAL_CONFIG.`);
	return GLOBAL_CONFIG[i];
}, Wx = "00000000-0000-0000-0000-000000000000", Gx = 300, Kx = new Set(/* @__PURE__ */ "api-teasers:navigate.api-teasers:read.api-users:edit.api-users:navigate.api-users:read.article-lists:edit.article-lists:navigate.article-lists:read.article-lists:special-edit.article-pushes:edit.article-pushes:navigate.article-pushes:read.articles-boxes:edit.articles-boxes:navigate.articles-boxes:read.articles:edit.articles:migrate.articles:navigate.articles:read.articles:read:versions.assemblers:edit.assemblers:navigate.assemblers:read.authors:edit.authors:merge.authors:navigate.authors:read.cat-tool:navigate.changes-diff:read.channelizers:edit.channelizers:navigate.channelizers:read.channels:delete.channels:edit.channels:edit:config.channels:migrate.channels:navigate.channels:read.channels:read:config.chip-widgets:delete.chip-widgets:edit.chip-widgets:read.complex-modules:edit.complex-modules:navigate.complex-modules:read.complex-pages:edit.complex-pages:navigate.complex-pages:read.cta-buttons:edit.cta-buttons:navigate.cta-buttons:read.cwc-widgets:edit.cwc-widgets:navigate.cwc-widgets:read.experts-cockpits:navigate.experts-cockpits:read.external-tools:navigate.finanzen-100-chart-widgets:delete.finanzen-100-chart-widgets:edit.finanzen-100-chart-widgets:navigate.finanzen-100-chart-widgets:read.galleries:edit.galleries:navigate.galleries:read.galleries:read:list.history:read.hub-pages:edit.hub-pages:navigate.hub-pages:read.images:edit.images:navigate.images:read.inpage-widgets:delete.inpage-widgets:edit.inpage-widgets:navigate.inpage-widgets:read.jobs:edit.jobs:navigate.jobs:read.kim:navigate.linkout-teasers:edit.linkout-teasers:navigate.linkout-teasers:read.links-boxes:edit.links-boxes:navigate.links-boxes:read.menu-tree:create.menu-tree:edit.menu-tree:navigate.menu-tree:read.movies:navigate.movies:read.newsletters:edit.newsletters:navigate.newsletters:read.partners:edit.partners:manage.partners:navigate.partners:read.recipes:edit.recipes:navigate.recipes:read.redirect-management:edit.redirect-management:navigate.redirect-management:read.reusable-texts:edit.reusable-texts:navigate.reusable-texts:read.sport-live:read.static-pages:edit.static-pages:navigate.static-pages:read.tag-entities:edit.tag-entities:navigate.tag-entities:read.tags:edit.tags:migrate.tags:navigate.tags:read.testreport-generator:navigate.users:block.users:create.users:edit.users:edit:self.users:navigate.users:read.users:reset:otp.users:reset:password.users:unblock.video-pages:edit.video-pages:navigate.video-pages:read.videos:navigate.videos:read.videos:read:list.whitelists:edit.whitelists:navigate.whitelists:read".split(".")), qx = (e) => Kx.has(e), Jx = cl(), Yx = (e) => Jx.hasRight(e), Xx = {
	api_user: "api-users",
	article: "articles",
	articles_box: "articles-boxes",
	author: "authors",
	channel: "channels",
	channelizer: "channelizers",
	complex_module: "complex-modules",
	complex_page: "complex-pages",
	cta_button: "cta-buttons",
	gallery: "galleries",
	hub_pages: "hub-pages",
	image: "images",
	job: "jobs",
	linkout_teaser: "linkout-teasers",
	links_box: "links-boxes",
	newsletter: "newsletters",
	redirect_management: "redirect-management",
	static_page: "static-pages",
	video_page: "video-pages"
}, Zx = (e, t) => {
	if (t === "author_merge") return "authors:merge";
	let n = `${Xx[t]}:${e}`;
	if (qx(n)) return n;
	throw Error(`Unknown document right ${n}`);
}, Qx = (e, t, n) => {
	let r = Zx(e, t);
	return n && n.legacy && e === "edit" ? n.legacy.isEditableInCTF && Yx(r) : Yx(r);
}, $x = (e, t) => Qx("edit", e, t), eS = (e, t) => Qx("navigate", e, t), tS = window.safari !== void 0, nS = [
	"http://",
	"https://",
	"mailto:"
], rS = (e) => {
	if (!e) return "";
	let t = e;
	return t = e.trim(), nS.some((e) => t.toLowerCase().startsWith(e)) ? t : (t.includes(":"), "https://" + t);
}, iS = (e, t = !1) => {
	switch (e) {
		case typeof e == "boolean": return e;
		case "true": return !0;
		case "false": return !1;
	}
	return t;
}, aS = fl("bunte.svg"), oS = fl("chip.svg"), sS = fl("focus.svg");
dc(ll);
var cS = Te({
	loader: () => import("./json-diff.view-Dj8rKFaF.js"),
	loadingComponent: () => De("div", { class: "row items-center justify-center q-pa-lg" }, [De(ae, {
		color: "primary",
		size: "3em"
	})])
});
//#endregion
export { nu as AI_FIELD_ACTIONS, qc as AUTHENTIK_OAUTH_STATE_PREFIX, Fu as AiAssistButton, ju as AiContextResolverInjectionKey, Ou as AiEngineInjectionKey, xc as BCheckbox, Xu as BfBrandBasedState, Yu as BfBrandIcon, Zu as BfEntityNoEditIcon, Qu as BfEntityStateIcon, $u as BfEntityStateSelector, sd as BfLimitedTextInput, ud as BfLogoIcon, dd as BfScheduledChangeIcon, Id as BrandDropdownSelector, aS as BunteLogo, Xd as CMSDialog, lo as CMSNotification, zd as CardItem, Bd as CardList, oS as ChipLogo, Vd as CmsSelector, Ua as DEFAULT_SHRUNK_SIDEBAR_NAV_WIDTH, Ha as DEFAULT_SIDEBAR_NAV_WIDTH, qd as DatetimeSelector, Hd as DayRangeSelector, jc as EmailForm, jc as ModalReload, Df as EntityListSearchDefaultProps, sS as FocusLogo, Of as HistoryModelName, kf as HistoryService, Wf as HistoryTab, Jd as ItemCountField, cS as JsonDiffView, Ec as LanguageSelector, Yd as LegacySelector, pf as ListPagination, Wx as PLACEHOLDER_UUID, z as ROUTES, Gx as SEARCH_DEBOUNCE, Qc as SSO_CODE_IN_FLIGHT_AT_KEY, Zc as SSO_CODE_IN_FLIGHT_KEY, Xc as SSO_OAUTH_STATE_STORAGE_KEY, Jc as SSO_PROVIDER_STORAGE_KEY, Yc as SSO_REDIRECT_URI_STORAGE_KEY, df as ScheduleChangeInfoBanner, Gf as TagInput, Kf as TagSelector, qf as ToggleButton, Lc as UserService, Ml as VuetifyValidationRules, nl as authenticate, La as browserLang, Ku as buildConstraints, zu as buildFieldAssistSystemPrompt, Gu as collectAiHints, tu as computeRichDiff, Wl as computeWordDiff, Mx as connectSockets, iS as convertToBool, Uu as createAiFieldEngine, $c as createAuthentikOAuthState, to as createVueI18n, Ws as dateRegex, vc as deleteEntity, ec as deserializeDatesInObject, Lf as extendTableColumnsWithDisabledStyle, Kc as fetchRightsMeta, Gs as formatDate, Ks as formatDateDots, Xs as formatDateTimeSeconds, qs as formatDateddMMyy, Js as formatDateddMMyyyy, tc as formatDuration, Ys as formatTime, Ux as getBaseUrlForBrand, mc as getClient, Uc as getCurrentUser, hc as getEntity, pc as getEntityAPIClient, B as getI18n, jf as getLastHistoryEntry, Qa as getQuasarLocale, Vc as getUser, Hc as getUsers, Bl as htmlToPlainText, Nu as injectAiContextResolver, Au as injectAiEngine, Yx as isAllowed, Fx as isApiError, Ix as isApiResponse, el as isAuthentikOAuthState, $x as isDocumentEditable, eS as isDocumentVisitable, tS as isSafari, yc as listEntities, rl as logout, Ct as n, $s as omitDateTimeSeconds, Zl as parseMarkedTokens, gc as postEntity, Mu as provideAiContextResolver, ku as provideAiEngine, Hx as providesValidationErrorAnchor, _c as putEntity, Xa as quasarLocales, Pf as quasarRulesStub, Ff as quasarValidateRules, bc as registerEntityEndpoint, dc as registerErrorInterceptor, Mf as registerQuasar, Qs as resetDateTimeUnits, Lx as restSearch, Ll as sanitizeHtml, rS as sanitizeLink, pl as sanitizePathUrl, Zs as serializeDates, Gc as setAdditionalRights, Fc as setDefaultRouter, bt as t, Wc as updateUser, Pu as useAiAssist, qu as useAiFieldDescriptor, Jf as useCardDragSort, yy as useChangesWatch, wy as useConfirmChangesDialog, Ic as useDefaultRouter, Ty as useDetectOutsideClick, nf as useDialogStore, Py as useEntityInfiniteSearchList, Oy as useEntityQuery, Tf as useEntitySearchList, Ef as useEntitySearchListWithCompanions, ky as useGermanQuoteTransform, qa as useGlobalStore, zx as useModuleStore, mo as useNotificationStore, Iy as usePublishStates, Ry as usePublishableForm, Px as useSocketConnected, Nx as useSockets, zy as useTitle, cl as useUserStore, Vx as useWordCountStore, ad as vGermanQuotes, tl as validateStoredAuthentikOAuthState, J as withAiHint };

//# sourceMappingURL=index.es.js.map